//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export module LmsApi {
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class MetaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    info(api_version: string | null | undefined): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/info?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getUserConnectionHistorySummary(startDate: string | null | undefined, endDate: string | null | undefined, accountId: number | null | undefined, includeIPInfo: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/userConnections/summary?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (includeIPInfo === null)
            throw new Error("The parameter 'includeIPInfo' cannot be null.");
        else if (includeIPInfo !== undefined)
            url_ += "includeIPInfo=" + encodeURIComponent("" + includeIPInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserConnectionHistorySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserConnectionHistorySummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUserConnectionHistorySummary(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getUserConnectionsByTenant(tenantId: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/userConnections/byTenant?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserConnectionsByTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserConnectionsByTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUserConnectionsByTenant(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getUserConnectionsByUser(accountId: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/userConnections/byUser?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserConnectionsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserConnectionsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUserConnectionsByUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    asignSignature(id: string, command: AsignSignatureCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/signature/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsignSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsignSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAsignSignature(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getSignature(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/signature/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetSignature(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    asignInitials(id: string, command: AsignInitialsCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/initials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsignInitials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsignInitials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAsignInitials(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getInitials(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/initials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetInitials(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    asignProfilePicture(command: AsignProfilePictureCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/profile-picture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsignProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsignProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAsignProfilePicture(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    forgotPassword(model: ForgotPasswordRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    refreshToken(request: RefreshTokenRequest): Observable<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResponse>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTokenResponse>(null as any);
    }

    revokeToken(model: RevokeTokenRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Account/revoke-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRevokeToken(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccreditedProviderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    get(qualificationType: QualificationType | null | undefined): Observable<ResponseOfIEnumerableOfAccreditedProvider> {
        let url_ = this.baseUrl + "/api/v1/AccreditedProvider?";
        if (qualificationType !== undefined && qualificationType !== null)
            url_ += "qualificationType=" + encodeURIComponent("" + qualificationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfIEnumerableOfAccreditedProvider>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfIEnumerableOfAccreditedProvider>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResponseOfIEnumerableOfAccreditedProvider> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfIEnumerableOfAccreditedProvider.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfIEnumerableOfAccreditedProvider>(null as any);
    }

    create(command: CreateAccreditedProviderCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/AccreditedProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    get2(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/AccreditedProvider/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/AccreditedProvider/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChatHubClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getAnnouncementsByType(announcementType: AnnouncementMessageTypes | undefined, newAnnouncementsClientSide: number | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/announcements?";
        if (announcementType === null)
            throw new Error("The parameter 'announcementType' cannot be null.");
        else if (announcementType !== undefined)
            url_ += "AnnouncementType=" + encodeURIComponent("" + announcementType) + "&";
        if (newAnnouncementsClientSide === null)
            throw new Error("The parameter 'newAnnouncementsClientSide' cannot be null.");
        else if (newAnnouncementsClientSide !== undefined)
            url_ += "NewAnnouncementsClientSide=" + encodeURIComponent("" + newAnnouncementsClientSide) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnouncementsByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnouncementsByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAnnouncementsByType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getChatRoomMessages(chatRoomType: ChatRoomTypes | undefined, chatRoomGroupName: string | null | undefined, newMessagesClientSide: number | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/chatRoomMessages?";
        if (chatRoomType === null)
            throw new Error("The parameter 'chatRoomType' cannot be null.");
        else if (chatRoomType !== undefined)
            url_ += "ChatRoomType=" + encodeURIComponent("" + chatRoomType) + "&";
        if (chatRoomGroupName !== undefined && chatRoomGroupName !== null)
            url_ += "ChatRoomGroupName=" + encodeURIComponent("" + chatRoomGroupName) + "&";
        if (newMessagesClientSide === null)
            throw new Error("The parameter 'newMessagesClientSide' cannot be null.");
        else if (newMessagesClientSide !== undefined)
            url_ += "NewMessagesClientSide=" + encodeURIComponent("" + newMessagesClientSide) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRoomMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRoomMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetChatRoomMessages(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getChatRoomNameByStudentLearnership(id: number): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/student-learnership/{id}/chat-room-name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRoomNameByStudentLearnership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRoomNameByStudentLearnership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processGetChatRoomNameByStudentLearnership(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    downloadAnnouncementAttachment(attachmentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/announcement-attachment/download/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAnnouncementAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAnnouncementAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAnnouncementAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadAllAnnouncementAttachments(announcementId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/announcement-attachment/download-all/{announcementId}";
        if (announcementId === undefined || announcementId === null)
            throw new Error("The parameter 'announcementId' must be defined.");
        url_ = url_.replace("{announcementId}", encodeURIComponent("" + announcementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAllAnnouncementAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAllAnnouncementAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAllAnnouncementAttachments(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sendUserSpecificAnnouncement(command: SendUserSpecificAnnouncementCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/send-user-specific-announcement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendUserSpecificAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendUserSpecificAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSendUserSpecificAnnouncement(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sendAnnouncement(command: SendAnnouncementCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/send-announcement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSendAnnouncement(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sendInternshipGroupMessage(command: SendInternshipGroupMessageCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/send-internship-group-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInternshipGroupMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInternshipGroupMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSendInternshipGroupMessage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sendLearnershipGroupMessage(command: SendLearnershipGroupMessageCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ChatHub/send-learnership-group-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendLearnershipGroupMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendLearnershipGroupMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSendLearnershipGroupMessage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getDashboardTileInfo(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/tileInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardTileInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardTileInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDashboardTileInfo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getAllDocumentTypes(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/DocType/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAllDocumentTypes(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getDocumentTypes(documentTypeCatagory: DocTypeCatagories | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/DocType?";
        if (documentTypeCatagory === null)
            throw new Error("The parameter 'documentTypeCatagory' cannot be null.");
        else if (documentTypeCatagory !== undefined)
            url_ += "documentTypeCatagory=" + encodeURIComponent("" + documentTypeCatagory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDocumentTypes(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    createPOEDocumentType(command: CreateDocumentTypeCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/DocType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePOEDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePOEDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreatePOEDocumentType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    delete(id: number, documentTypeCatagory: DocTypeCatagories | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/DocType/archive/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentTypeCatagory === null)
            throw new Error("The parameter 'documentTypeCatagory' cannot be null.");
        else if (documentTypeCatagory !== undefined)
            url_ += "documentTypeCatagory=" + encodeURIComponent("" + documentTypeCatagory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Employer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    post(command: CreateEmployerCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Employer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    get2(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Employer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Employer/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FacilityGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getFacility(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFacility(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    putFacility(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPutFacility(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deleteFacility(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteFacility(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getFaclities(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaclities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaclities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFaclities(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    postFacility(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPostFacility(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getBuilding(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup/building/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetBuilding(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    putBuilding(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup/building/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPutBuilding(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deleteBuilding(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup/building/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteBuilding(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getBuildings(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup/building";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetBuildings(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    postBuilding(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FacilityGroup/building";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPostBuilding(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InternshipClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    post(command: CreateProductCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Internship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    put(id: number, command: UpdateProductCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Internship/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Internship/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InternshipPlanClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    get(pageNumber: number | undefined, pageSize: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/InternshipPlan?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    post(command: CreateProductCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/InternshipPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    get2(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/InternshipPlan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    put(id: number, command: UpdateProductCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/InternshipPlan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/InternshipPlan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LearnershipClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getLearnerships(active: boolean | null | undefined): Observable<ResponseOfIEnumerableOfGetAllLearnershipsViewModel> {
        let url_ = this.baseUrl + "/api/v1/Learnership?";
        if (active !== undefined && active !== null)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnerships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnerships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfIEnumerableOfGetAllLearnershipsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfIEnumerableOfGetAllLearnershipsViewModel>;
        }));
    }

    protected processGetLearnerships(response: HttpResponseBase): Observable<ResponseOfIEnumerableOfGetAllLearnershipsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfIEnumerableOfGetAllLearnershipsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfIEnumerableOfGetAllLearnershipsViewModel>(null as any);
    }

    post(command: CreateLearnershipCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getById(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    put(id: number, command: UpdateLearnershipCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getByStudentLearnershipId(id: number): Observable<ResponseOfLearnershipDto> {
        let url_ = this.baseUrl + "/api/v1/Learnership/student-learnership/{id}/learnership";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStudentLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStudentLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfLearnershipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfLearnershipDto>;
        }));
    }

    protected processGetByStudentLearnershipId(response: HttpResponseBase): Observable<ResponseOfLearnershipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfLearnershipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfLearnershipDto>(null as any);
    }

    getByLearnershipId(id: number): Observable<ResponseOfLearnershipDto> {
        let url_ = this.baseUrl + "/api/v1/Learnership/{id}/v2";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfLearnershipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfLearnershipDto>;
        }));
    }

    protected processGetByLearnershipId(response: HttpResponseBase): Observable<ResponseOfLearnershipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfLearnershipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfLearnershipDto>(null as any);
    }

    getFacilitatorsByQualificationId(learnershipId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/facilitators/by-learnership/{learnershipId}";
        if (learnershipId === undefined || learnershipId === null)
            throw new Error("The parameter 'learnershipId' must be defined.");
        url_ = url_.replace("{learnershipId}", encodeURIComponent("" + learnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilitatorsByQualificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilitatorsByQualificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFacilitatorsByQualificationId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearnershipGroupsByQualificationId(learnershipId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/groups/by-learnership/{learnershipId}";
        if (learnershipId === undefined || learnershipId === null)
            throw new Error("The parameter 'learnershipId' must be defined.");
        url_ = url_.replace("{learnershipId}", encodeURIComponent("" + learnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnershipGroupsByQualificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnershipGroupsByQualificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearnershipGroupsByQualificationId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearnershipGeneralDocAnnotationDataByDocId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/document/annotations/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnershipGeneralDocAnnotationDataByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnershipGeneralDocAnnotationDataByDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearnershipGeneralDocAnnotationDataByDocId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearnershipGeneralDocInputsByDocId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/document/inputs/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnershipGeneralDocInputsByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnershipGeneralDocInputsByDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearnershipGeneralDocInputsByDocId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearnershipDocsByLearnershipId(learnershipId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/documents/byLearnership/{learnershipId}";
        if (learnershipId === undefined || learnershipId === null)
            throw new Error("The parameter 'learnershipId' must be defined.");
        url_ = url_.replace("{learnershipId}", encodeURIComponent("" + learnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnershipDocsByLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnershipDocsByLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearnershipDocsByLearnershipId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadStudentLearnershipGeneralDocumentsById(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/documents/download/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStudentLearnershipGeneralDocumentsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStudentLearnershipGeneralDocumentsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadStudentLearnershipGeneralDocumentsById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearnershipDocInfoByDocId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/documents/doc-info/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnershipDocInfoByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnershipDocInfoByDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearnershipDocInfoByDocId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getCurrentStaffMemberLearnershipRoles(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/currentStaffLearnershipRoles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentStaffMemberLearnershipRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentStaffMemberLearnershipRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCurrentStaffMemberLearnershipRoles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getCurrentStaffMemberLearnershipRolesByStudentLearnershipId(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/current-staff-learnership-roles-by-student-learnership/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentStaffMemberLearnershipRolesByStudentLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentStaffMemberLearnershipRolesByStudentLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCurrentStaffMemberLearnershipRolesByStudentLearnershipId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearnershipAttendanceRegisterByLearnershipId(learnershipId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/attendance-registers/by-learnership/{learnershipId}";
        if (learnershipId === undefined || learnershipId === null)
            throw new Error("The parameter 'learnershipId' must be defined.");
        url_ = url_.replace("{learnershipId}", encodeURIComponent("" + learnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnershipAttendanceRegisterByLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnershipAttendanceRegisterByLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearnershipAttendanceRegisterByLearnershipId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearnershipAttendanceRegisterById(attendanceRegisterId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/attendance-register-items/by-attendance-register/{attendanceRegisterId}";
        if (attendanceRegisterId === undefined || attendanceRegisterId === null)
            throw new Error("The parameter 'attendanceRegisterId' must be defined.");
        url_ = url_.replace("{attendanceRegisterId}", encodeURIComponent("" + attendanceRegisterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnershipAttendanceRegisterById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnershipAttendanceRegisterById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearnershipAttendanceRegisterById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearnershipAttendanceRegisterStudentInfoById(learnershipAttendanceRegisterId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/attendance-register-export-info/{learnershipAttendanceRegisterId}";
        if (learnershipAttendanceRegisterId === undefined || learnershipAttendanceRegisterId === null)
            throw new Error("The parameter 'learnershipAttendanceRegisterId' must be defined.");
        url_ = url_.replace("{learnershipAttendanceRegisterId}", encodeURIComponent("" + learnershipAttendanceRegisterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnershipAttendanceRegisterStudentInfoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnershipAttendanceRegisterStudentInfoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearnershipAttendanceRegisterStudentInfoById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadLearnershipAttendanceRegisterFileById(learnershipAttendanceRegisterId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/attendance-register-file/download/{learnershipAttendanceRegisterId}";
        if (learnershipAttendanceRegisterId === undefined || learnershipAttendanceRegisterId === null)
            throw new Error("The parameter 'learnershipAttendanceRegisterId' must be defined.");
        url_ = url_.replace("{learnershipAttendanceRegisterId}", encodeURIComponent("" + learnershipAttendanceRegisterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLearnershipAttendanceRegisterFileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLearnershipAttendanceRegisterFileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadLearnershipAttendanceRegisterFileById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * Search list of all learnerships.
     */
    search(request: SearchLearnershipsRequest): Observable<PaginationResponseOfLearnershipDto> {
        let url_ = this.baseUrl + "/api/v1/Learnership/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginationResponseOfLearnershipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginationResponseOfLearnershipDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PaginationResponseOfLearnershipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfLearnershipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfLearnershipDto>(null as any);
    }

    post2(learnerhipId: number, fileData: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/{learnerhipId}/documents";
        if (learnerhipId === undefined || learnerhipId === null)
            throw new Error("The parameter 'learnerhipId' must be defined.");
        url_ = url_.replace("{learnerhipId}", encodeURIComponent("" + learnerhipId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            fileData.forEach(item_ => content_.append("fileData", item_.data, item_.fileName ? item_.fileName : "fileData") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    post3(command: CreateLearnershipAttendanceRegisterCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/attendance-register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost3(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    post4(learnershipAttendanceRegisterId: string, command: CreateLearnershipAttendanceRegisterFileCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/create-learnership-attendance-register-pdf/{learnershipAttendanceRegisterId}";
        if (learnershipAttendanceRegisterId === undefined || learnershipAttendanceRegisterId === null)
            throw new Error("The parameter 'learnershipAttendanceRegisterId' must be defined.");
        url_ = url_.replace("{learnershipAttendanceRegisterId}", encodeURIComponent("" + learnershipAttendanceRegisterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost4(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addCandidatesToLearnership(command: AddCandidatesToLearnershipCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/add-candidates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCandidatesToLearnership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCandidatesToLearnership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddCandidatesToLearnership(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    endDateLearnership(command: EndLearnershipCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/end-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndDateLearnership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndDateLearnership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processEndDateLearnership(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    removeStudentFromLearnership(command: RemoveStudentFromLearnershipCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/remove-student";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveStudentFromLearnership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveStudentFromLearnership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRemoveStudentFromLearnership(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    removeStudentFromLearnership2(command: RemoveStaffMemberFromLearnershipCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/remove-staff-member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveStudentFromLearnership2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveStudentFromLearnership2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRemoveStudentFromLearnership2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    assignStaffToLearnerhsip(command: AssignStaffToLearnershipCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/assign-staff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignStaffToLearnerhsip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignStaffToLearnerhsip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAssignStaffToLearnerhsip(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reInstateStudentIntoLearnership(command: ReinstateStudentIntoLearnershipCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/re-instate-student";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReInstateStudentIntoLearnership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReInstateStudentIntoLearnership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReInstateStudentIntoLearnership(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    put2(attendanceRegisterItemId: number, command: UpdateLearnershipAttendanceRegisterItemStatusCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/attendance-register-item/{attendanceRegisterItemId}";
        if (attendanceRegisterItemId === undefined || attendanceRegisterItemId === null)
            throw new Error("The parameter 'attendanceRegisterItemId' must be defined.");
        url_ = url_.replace("{attendanceRegisterItemId}", encodeURIComponent("" + attendanceRegisterItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPut2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archiveGeneralLearnershipDoc(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Learnership/documents/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveGeneralLearnershipDoc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveGeneralLearnershipDoc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchiveGeneralLearnershipDoc(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deleteAttendanceRegister(attendanceRegisterId: number): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/Learnership/attendance-register-item/delete/{attendanceRegisterId}";
        if (attendanceRegisterId === undefined || attendanceRegisterId === null)
            throw new Error("The parameter 'attendanceRegisterId' must be defined.");
        url_ = url_.replace("{attendanceRegisterId}", encodeURIComponent("" + attendanceRegisterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttendanceRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttendanceRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processDeleteAttendanceRegister(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    post(fileData: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Organization/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            fileData.forEach(item_ => content_.append("fileData", item_.data, item_.fileName ? item_.fileName : "fileData") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getOrganizationalDocument(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Organization/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationalDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetOrganizationalDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getOrganizationalDocumentById(docId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Organization/documents/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationalDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalDocumentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetOrganizationalDocumentById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadOrganizationalDocument(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Organization/documents/download/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOrganizationalDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOrganizationalDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOrganizationalDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archiveOrganizationalDocument(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Organization/documents/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveOrganizationalDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveOrganizationalDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchiveOrganizationalDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    /**
     * Gets the student learnership records for the current user.
     */
    getMyStudentLearnerships(): Observable<ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel> {
        let url_ = this.baseUrl + "/api/v1/Personal/student/my-learnerships";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyStudentLearnerships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyStudentLearnerships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel>;
        }));
    }

    protected processGetMyStudentLearnerships(response: HttpResponseBase): Observable<ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PoeActivityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    searchActivities(request: SearchActivitiesRequest): Observable<ResponseOfICollectionOfSearchActivitiesViewModel> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfSearchActivitiesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfSearchActivitiesViewModel>;
        }));
    }

    protected processSearchActivities(response: HttpResponseBase): Observable<ResponseOfICollectionOfSearchActivitiesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfSearchActivitiesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfSearchActivitiesViewModel>(null as any);
    }

    getPoeActivities(request: GetPoeActivitiesRequest): Observable<ResponseOfICollectionOfPoeActivityDto> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/filter-by-document-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoeActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoeActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfPoeActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfPoeActivityDto>;
        }));
    }

    protected processGetPoeActivities(response: HttpResponseBase): Observable<ResponseOfICollectionOfPoeActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfPoeActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfPoeActivityDto>(null as any);
    }

    getPoeActivitiesForALearnership(request: GetPoeActivitiesByLearnershipIdRequest): Observable<ResponseOfICollectionOfPoeActivityDto> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/activities-by-learnership-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoeActivitiesForALearnership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoeActivitiesForALearnership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfPoeActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfPoeActivityDto>;
        }));
    }

    protected processGetPoeActivitiesForALearnership(response: HttpResponseBase): Observable<ResponseOfICollectionOfPoeActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfPoeActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfPoeActivityDto>(null as any);
    }

    getLearnerActivityStatusesByLearnership(request: GetLearnerActivityStatusesByLearnershipIdRequest): Observable<ResponseOfICollectionOfPoeActivityWithLearnerStatusDto> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/activity-statuses-by-learnership-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnerActivityStatusesByLearnership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnerActivityStatusesByLearnership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfPoeActivityWithLearnerStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfPoeActivityWithLearnerStatusDto>;
        }));
    }

    protected processGetLearnerActivityStatusesByLearnership(response: HttpResponseBase): Observable<ResponseOfICollectionOfPoeActivityWithLearnerStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfPoeActivityWithLearnerStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfPoeActivityWithLearnerStatusDto>(null as any);
    }

    openAnActivityForAllLearners(request: OpenAnActivityForAllLearnersRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/open-all-learner-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenAnActivityForAllLearners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenAnActivityForAllLearners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processOpenAnActivityForAllLearners(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    resetAnActivityForAllLearners(request: ResetAnActivityForAllLearnersRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/reset-all-learner-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetAnActivityForAllLearners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetAnActivityForAllLearners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processResetAnActivityForAllLearners(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    reOpenAnActivityForAllLearners(request: ReOpenAnActivityForAllLearnersRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/re-open-all-learner-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReOpenAnActivityForAllLearners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReOpenAnActivityForAllLearners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processReOpenAnActivityForAllLearners(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    closeAnActivityForAllLearners(request: CloseAnActivityForAllLearnersRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/close-all-learner-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseAnActivityForAllLearners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseAnActivityForAllLearners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processCloseAnActivityForAllLearners(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    markAnActivityForAllLearners(request: MarkAnActivityForAllLearnersRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/mark-all-learner-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAnActivityForAllLearners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAnActivityForAllLearners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processMarkAnActivityForAllLearners(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    openActivityForALearner(request: OpenAnActivityForALearnerRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/open-learner-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenActivityForALearner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenActivityForALearner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processOpenActivityForALearner(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    resetActivityForALearner(request: ResetAnActivityForALearnerRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/reset-learner-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetActivityForALearner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetActivityForALearner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processResetActivityForALearner(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    reOpenActivityForALearner(request: ReOpenAnActivityForALearnerRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/re-open-learner-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReOpenActivityForALearner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReOpenActivityForALearner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processReOpenActivityForALearner(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    closeActivityForALearner(request: CloseAnActivityForALearnerRequest): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/close-learner-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseActivityForALearner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseActivityForALearner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processCloseActivityForALearner(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    markActivityForALearner(request: MarkAnActivityForALearnerRequest): Observable<ResponseOfDecimal> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/mark-learner-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkActivityForALearner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkActivityForALearner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfDecimal>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfDecimal>;
        }));
    }

    protected processMarkActivityForALearner(response: HttpResponseBase): Observable<ResponseOfDecimal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfDecimal.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfDecimal>(null as any);
    }

    canMarkActivityForALearner(request: CanMarkActivityForLearnerRequest): Observable<CanMarkViewModel> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/can-mark-learner-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanMarkActivityForALearner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanMarkActivityForALearner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanMarkViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanMarkViewModel>;
        }));
    }

    protected processCanMarkActivityForALearner(response: HttpResponseBase): Observable<CanMarkViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanMarkViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CanMarkViewModel>(null as any);
    }

    canMarkActivityForAllLearners(request: CanMarkActivityForLearnersRequest): Observable<CanMarkAllViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/PoeActivity/can-mark-all-learners-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanMarkActivityForAllLearners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanMarkActivityForAllLearners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanMarkAllViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanMarkAllViewModel[]>;
        }));
    }

    protected processCanMarkActivityForAllLearners(response: HttpResponseBase): Observable<CanMarkAllViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CanMarkAllViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CanMarkAllViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class POEClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getQualPOEById(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/qualPOE/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualPOEById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualPOEById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetQualPOEById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getQualPOEByLearnershipId(learnershipId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/qualPOE/byLearnership/{learnershipId}";
        if (learnershipId === undefined || learnershipId === null)
            throw new Error("The parameter 'learnershipId' must be defined.");
        url_ = url_.replace("{learnershipId}", encodeURIComponent("" + learnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualPOEByLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualPOEByLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetQualPOEByLearnershipId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getProgrammePOEById(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgrammePOEById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgrammePOEById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProgrammePOEById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentPOEById(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/studentPOE/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentPOEById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentPOEById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStudentPOEById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getQualPOEByQualificationId(qualificationId: number): Observable<ResponseOfGetQualPOEByQualificationIdViewModel> {
        let url_ = this.baseUrl + "/api/v1/POE/qualPOE/byQual/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualPOEByQualificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualPOEByQualificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfGetQualPOEByQualificationIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfGetQualPOEByQualificationIdViewModel>;
        }));
    }

    protected processGetQualPOEByQualificationId(response: HttpResponseBase): Observable<ResponseOfGetQualPOEByQualificationIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfGetQualPOEByQualificationIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfGetQualPOEByQualificationIdViewModel>(null as any);
    }

    getProgrammePOEByProgrammeId(programmeId: number): Observable<ResponseOfGetProgrammePOEByProgrammeIdViewModel> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/byProgramme/{programmeId}";
        if (programmeId === undefined || programmeId === null)
            throw new Error("The parameter 'programmeId' must be defined.");
        url_ = url_.replace("{programmeId}", encodeURIComponent("" + programmeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgrammePOEByProgrammeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgrammePOEByProgrammeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfGetProgrammePOEByProgrammeIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfGetProgrammePOEByProgrammeIdViewModel>;
        }));
    }

    protected processGetProgrammePOEByProgrammeId(response: HttpResponseBase): Observable<ResponseOfGetProgrammePOEByProgrammeIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfGetProgrammePOEByProgrammeIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfGetProgrammePOEByProgrammeIdViewModel>(null as any);
    }

    getProgrammePOEScheduleEvents(poeId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/schedule/events/{poeId}";
        if (poeId === undefined || poeId === null)
            throw new Error("The parameter 'poeId' must be defined.");
        url_ = url_.replace("{poeId}", encodeURIComponent("" + poeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgrammePOEScheduleEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgrammePOEScheduleEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProgrammePOEScheduleEvents(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPOEProgrammeScheduleDocuments(poeId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/schedule/{poeId}";
        if (poeId === undefined || poeId === null)
            throw new Error("The parameter 'poeId' must be defined.");
        url_ = url_.replace("{poeId}", encodeURIComponent("" + poeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPOEProgrammeScheduleDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPOEProgrammeScheduleDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPOEProgrammeScheduleDocuments(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadProgrammePOEScheduleDocumentById(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/schedule/download/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProgrammePOEScheduleDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProgrammePOEScheduleDocumentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProgrammePOEScheduleDocumentById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentPOEScheduleDocuments(poeId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/studentPOE/schedule/{poeId}";
        if (poeId === undefined || poeId === null)
            throw new Error("The parameter 'poeId' must be defined.");
        url_ = url_.replace("{poeId}", encodeURIComponent("" + poeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentPOEScheduleDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentPOEScheduleDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStudentPOEScheduleDocuments(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadStudentPOEScheduleDocumentById(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/studentPOE/schedule/download/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStudentPOEScheduleDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStudentPOEScheduleDocumentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadStudentPOEScheduleDocumentById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentPOEByStudentId(studentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/studentPOE/byStudent/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentPOEByStudentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentPOEByStudentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStudentPOEByStudentId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentPOEByStudentLearnershipId(id: number): Observable<ResponseOfGetStudentPOEByIdViewModel> {
        let url_ = this.baseUrl + "/api/v1/POE/student-poe/by-student-learnership/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentPOEByStudentLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentPOEByStudentLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfGetStudentPOEByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfGetStudentPOEByIdViewModel>;
        }));
    }

    protected processGetStudentPOEByStudentLearnershipId(response: HttpResponseBase): Observable<ResponseOfGetStudentPOEByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfGetStudentPOEByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfGetStudentPOEByIdViewModel>(null as any);
    }

    getCurrentStudentsPOE(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/studentPOE/myPOE";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentStudentsPOE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentStudentsPOE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCurrentStudentsPOE(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentPOEByAccountId(accountId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/studentPOE/byAccount/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentPOEByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentPOEByAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStudentPOEByAccountId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPOEDocumentsByPOEId(poeId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/documents/{poeId}?";
        if (poeId === undefined || poeId === null)
            throw new Error("The parameter 'poeId' must be defined.");
        url_ = url_.replace("{poeId}", encodeURIComponent("" + poeId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPOEDocumentsByPOEId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPOEDocumentsByPOEId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPOEDocumentsByPOEId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPOEDocumentsByPOEId2(poeId: number, groupId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/documents/{poeId}/{groupId}?";
        if (poeId === undefined || poeId === null)
            throw new Error("The parameter 'poeId' must be defined.");
        url_ = url_.replace("{poeId}", encodeURIComponent("" + poeId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPOEDocumentsByPOEId2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPOEDocumentsByPOEId2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPOEDocumentsByPOEId2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPOEDocumentById(docId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/document/{docId}?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPOEDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPOEDocumentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPOEDocumentById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deletePOEDocument(docId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/document/{docId}?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePOEDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePOEDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeletePOEDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadPOEDocumentById(docId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/document/download/{docId}?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPOEDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPOEDocumentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPOEDocumentById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPOEPDFViewerDocumentInfoById(docId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/document/pdfViewerInfo/{docId}?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPOEPDFViewerDocumentInfoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPOEPDFViewerDocumentInfoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPOEPDFViewerDocumentInfoById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getProgrammePOESchedulePDFViewerDocumentById(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/schedule/pdfViewer/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgrammePOESchedulePDFViewerDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgrammePOESchedulePDFViewerDocumentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProgrammePOESchedulePDFViewerDocumentById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getProgrammePOESchedulePDFViewerDocumentInfoById(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/scheduleInfo/pdfViewer/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgrammePOESchedulePDFViewerDocumentInfoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgrammePOESchedulePDFViewerDocumentInfoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProgrammePOESchedulePDFViewerDocumentInfoById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPOEDocAnnotations(docId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/document/annotations/{docId}?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPOEDocAnnotations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPOEDocAnnotations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPOEDocAnnotations(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPOEDocInputs(docId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<ResponseOfICollectionOfGetPOEInputsViewModel> {
        let url_ = this.baseUrl + "/api/v1/POE/document/inputs/{docId}?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPOEDocInputs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPOEDocInputs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfGetPOEInputsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfGetPOEInputsViewModel>;
        }));
    }

    protected processGetPOEDocInputs(response: HttpResponseBase): Observable<ResponseOfICollectionOfGetPOEInputsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfGetPOEInputsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfGetPOEInputsViewModel>(null as any);
    }

    downloadStudentPoe(poeId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/download-all/{poeId}";
        if (poeId === undefined || poeId === null)
            throw new Error("The parameter 'poeId' must be defined.");
        url_ = url_.replace("{poeId}", encodeURIComponent("" + poeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStudentPoe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStudentPoe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadStudentPoe(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getQuestionsByDocId(docId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<ResponseOfICollectionOfPoeQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/POE/document/questions/{docId}?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionsByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionsByDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfPoeQuestionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfPoeQuestionDto>;
        }));
    }

    protected processGetQuestionsByDocId(response: HttpResponseBase): Observable<ResponseOfICollectionOfPoeQuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfPoeQuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfPoeQuestionDto>(null as any);
    }

    fixPOE(command: FixPOECommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/fix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixPOE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixPOE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processFixPOE(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    postPOEDocument(pOEId: number | undefined, pOEGroupId: number | null | undefined, pOEType: POETypes | undefined, pOEFolder: POEFolders | undefined, fileData: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/documents?";
        if (pOEId === null)
            throw new Error("The parameter 'pOEId' cannot be null.");
        else if (pOEId !== undefined)
            url_ += "POEId=" + encodeURIComponent("" + pOEId) + "&";
        if (pOEGroupId !== undefined && pOEGroupId !== null)
            url_ += "POEGroupId=" + encodeURIComponent("" + pOEGroupId) + "&";
        if (pOEType === null)
            throw new Error("The parameter 'pOEType' cannot be null.");
        else if (pOEType !== undefined)
            url_ += "POEType=" + encodeURIComponent("" + pOEType) + "&";
        if (pOEFolder === null)
            throw new Error("The parameter 'pOEFolder' cannot be null.");
        else if (pOEFolder !== undefined)
            url_ += "POEFolder=" + encodeURIComponent("" + pOEFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            fileData.forEach(item_ => content_.append("fileData", item_.data, item_.fileName ? item_.fileName : "fileData") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPOEDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPOEDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPostPOEDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    configureQualPOE(command: CreateQualPOEGroupsCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/qualPOE/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigureQualPOE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigureQualPOE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfigureQualPOE(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addProgrammePOEScheduleEvents(command: AddProgrammePOEScheduleEventCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/schedule/events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProgrammePOEScheduleEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProgrammePOEScheduleEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddProgrammePOEScheduleEvents(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updateProgrammePOEScheduleEvent(command: UpdateProgrammePOEScheduleEventsCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/schedule/events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProgrammePOEScheduleEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProgrammePOEScheduleEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateProgrammePOEScheduleEvent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addPOESchedule(programmePOEId: number, fileData: FileParameter | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/{programmePOEId}/schedule";
        if (programmePOEId === undefined || programmePOEId === null)
            throw new Error("The parameter 'programmePOEId' must be defined.");
        url_ = url_.replace("{programmePOEId}", encodeURIComponent("" + programmePOEId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            content_.append("fileData", fileData.data, fileData.fileName ? fileData.fileName : "fileData");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPOESchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPOESchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddPOESchedule(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    unlockPoe(command: UnlockPOECommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/unlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockPoe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockPoe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUnlockPoe(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    lockPoe(command: LockPOECommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/lock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockPoe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockPoe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLockPoe(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updateQualPOEInputData(command: SaveQualPOEInputDataCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/qualPOE/inputData/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQualPOEInputData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQualPOEInputData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateQualPOEInputData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updatePOEDocumentContentAndAnnotationData(command: SavePOEDocumentChangesByIdCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/document/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePOEDocumentContentAndAnnotationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePOEDocumentContentAndAnnotationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdatePOEDocumentContentAndAnnotationData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deleteProgrammePOEScheduleEvents(eventId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/programmePOE/schedule/events/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProgrammePOEScheduleEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProgrammePOEScheduleEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteProgrammePOEScheduleEvents(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archivePOEDocument(docId: number, poeType: POETypes | undefined, poeFolder: POEFolders | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/POE/document/archive/{docId}?";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeFolder === null)
            throw new Error("The parameter 'poeFolder' cannot be null.");
        else if (poeFolder !== undefined)
            url_ += "poeFolder=" + encodeURIComponent("" + poeFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivePOEDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivePOEDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchivePOEDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class QualificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getAllQualifications(): Observable<ResponseOfIEnumerableOfGetAllQualificationsViewModel> {
        let url_ = this.baseUrl + "/api/v1/Qualification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQualifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQualifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfIEnumerableOfGetAllQualificationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfIEnumerableOfGetAllQualificationsViewModel>;
        }));
    }

    protected processGetAllQualifications(response: HttpResponseBase): Observable<ResponseOfIEnumerableOfGetAllQualificationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfIEnumerableOfGetAllQualificationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfIEnumerableOfGetAllQualificationsViewModel>(null as any);
    }

    getPoeGroupsByQualificationId(qualificationId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/poe-groups/by-qualification/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoeGroupsByQualificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoeGroupsByQualificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPoeGroupsByQualificationId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPoeGroupsForCurrentUser(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/poe-groups/current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoeGroupsForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoeGroupsForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPoeGroupsForCurrentUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getQualDocsByQualificationId(qualificationId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/documents/byQualification/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualDocsByQualificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualDocsByQualificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetQualDocsByQualificationId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadQualDocByQualificationId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/documents/download/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadQualDocByQualificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadQualDocByQualificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadQualDocByQualificationId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getQualificationGeneralDocInfoByDocId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/documents/doc-info/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualificationGeneralDocInfoByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualificationGeneralDocInfoByDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetQualificationGeneralDocInfoByDocId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getQualificationGeneralDocInputsByDocId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/document/inputs/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualificationGeneralDocInputsByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualificationGeneralDocInputsByDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetQualificationGeneralDocInputsByDocId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearningMaterialByQualificationId(qualificationId: number, qualPoeGroupId: number | null | undefined, staffOnly: boolean | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/learning-material/byQualification/{qualificationId}?";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        if (qualPoeGroupId !== undefined && qualPoeGroupId !== null)
            url_ += "QualPoeGroupId=" + encodeURIComponent("" + qualPoeGroupId) + "&";
        if (staffOnly !== undefined && staffOnly !== null)
            url_ += "StaffOnly=" + encodeURIComponent("" + staffOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearningMaterialByQualificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearningMaterialByQualificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearningMaterialByQualificationId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLearningMaterialByStudentId(qualPoeGroupId: number | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/learning-material/forCurrentUser?";
        if (qualPoeGroupId !== undefined && qualPoeGroupId !== null)
            url_ += "QualPoeGroupId=" + encodeURIComponent("" + qualPoeGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearningMaterialByStudentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearningMaterialByStudentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLearningMaterialByStudentId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPoeGroupsByStudentLearnershipId(studentLearnershipId: number): Observable<ResponseOfLearningMaterialResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/student-learnership/{studentLearnershipId}/poe-groups";
        if (studentLearnershipId === undefined || studentLearnershipId === null)
            throw new Error("The parameter 'studentLearnershipId' must be defined.");
        url_ = url_.replace("{studentLearnershipId}", encodeURIComponent("" + studentLearnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoeGroupsByStudentLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoeGroupsByStudentLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfLearningMaterialResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfLearningMaterialResponse>;
        }));
    }

    protected processGetPoeGroupsByStudentLearnershipId(response: HttpResponseBase): Observable<ResponseOfLearningMaterialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfLearningMaterialResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfLearningMaterialResponse>(null as any);
    }

    getLearningMaterialByStudentLearnershipId(studentLearnershipId: number, qualPoeGroupId: number | null | undefined): Observable<ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel> {
        let url_ = this.baseUrl + "/api/v1/Qualification/student-learnership/{studentLearnershipId}/learning-material?";
        if (studentLearnershipId === undefined || studentLearnershipId === null)
            throw new Error("The parameter 'studentLearnershipId' must be defined.");
        url_ = url_.replace("{studentLearnershipId}", encodeURIComponent("" + studentLearnershipId));
        if (qualPoeGroupId !== undefined && qualPoeGroupId !== null)
            url_ += "QualPoeGroupId=" + encodeURIComponent("" + qualPoeGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearningMaterialByStudentLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearningMaterialByStudentLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel>;
        }));
    }

    protected processGetLearningMaterialByStudentLearnershipId(response: HttpResponseBase): Observable<ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel>(null as any);
    }

    downloadLearningMaterialByQualificationId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/learning-material/download/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLearningMaterialByQualificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLearningMaterialByQualificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadLearningMaterialByQualificationId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getUnitStandards(qualificationId: number, type: UnitStandardType | null | undefined): Observable<ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel> {
        let url_ = this.baseUrl + "/api/v1/Qualification/unitStandards/{qualificationId}?";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnitStandards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnitStandards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel>;
        }));
    }

    protected processGetUnitStandards(response: HttpResponseBase): Observable<ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel>(null as any);
    }

    getWithUnitStandards(): Observable<ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel> {
        let url_ = this.baseUrl + "/api/v1/Qualification/withUnitStandards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithUnitStandards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithUnitStandards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel>;
        }));
    }

    protected processGetWithUnitStandards(response: HttpResponseBase): Observable<ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel>(null as any);
    }

    get(id: number): Observable<ResponseOfQualification> {
        let url_ = this.baseUrl + "/api/v1/Qualification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfQualification>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfQualification>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResponseOfQualification> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfQualification.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfQualification>(null as any);
    }

    getPOEGroupUnitStandards(poeType: POETypes | undefined, poeGroupId: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/poeGroupUnitStandards?";
        if (poeType === null)
            throw new Error("The parameter 'poeType' cannot be null.");
        else if (poeType !== undefined)
            url_ += "poeType=" + encodeURIComponent("" + poeType) + "&";
        if (poeGroupId === null)
            throw new Error("The parameter 'poeGroupId' cannot be null.");
        else if (poeGroupId !== undefined)
            url_ += "poeGroupId=" + encodeURIComponent("" + poeGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPOEGroupUnitStandards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPOEGroupUnitStandards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPOEGroupUnitStandards(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * Search list of all qualifications.
     */
    search(request: SearchQualificationsRequest): Observable<PaginationResponseOfQualificationDto> {
        let url_ = this.baseUrl + "/api/v1/Qualification/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginationResponseOfQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginationResponseOfQualificationDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PaginationResponseOfQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfQualificationDto>(null as any);
    }

    createSetaQualification(command: CreateQualificationCommand): Observable<ResponseOfInteger> {
        let url_ = this.baseUrl + "/api/v1/Qualification/seta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSetaQualification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSetaQualification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfInteger>;
        }));
    }

    protected processCreateSetaQualification(response: HttpResponseBase): Observable<ResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfInteger>(null as any);
    }

    createQctoQualification(command: CreateQctoQualificationCommand): Observable<ResponseOfInteger> {
        let url_ = this.baseUrl + "/api/v1/Qualification/qcto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQctoQualification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQctoQualification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfInteger>;
        }));
    }

    protected processCreateQctoQualification(response: HttpResponseBase): Observable<ResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfInteger>(null as any);
    }

    postQualDocs(qualificaitonId: number, fileData: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/{qualificaitonId}/documents";
        if (qualificaitonId === undefined || qualificaitonId === null)
            throw new Error("The parameter 'qualificaitonId' must be defined.");
        url_ = url_.replace("{qualificaitonId}", encodeURIComponent("" + qualificaitonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            fileData.forEach(item_ => content_.append("fileData", item_.data, item_.fileName ? item_.fileName : "fileData") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostQualDocs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostQualDocs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPostQualDocs(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    post(qualificaitonId: number, fileData: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/{qualificaitonId}/learning-material";
        if (qualificaitonId === undefined || qualificaitonId === null)
            throw new Error("The parameter 'qualificaitonId' must be defined.");
        url_ = url_.replace("{qualificaitonId}", encodeURIComponent("" + qualificaitonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            fileData.forEach(item_ => content_.append("fileData", item_.data, item_.fileName ? item_.fileName : "fileData") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updateSetaQualification(id: number, command: UpdateQualificationCommand): Observable<ResponseOfInteger> {
        let url_ = this.baseUrl + "/api/v1/Qualification/seta/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSetaQualification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSetaQualification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfInteger>;
        }));
    }

    protected processUpdateSetaQualification(response: HttpResponseBase): Observable<ResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfInteger>(null as any);
    }

    updateQctoQualification(id: number, command: UpdateQctoQualificationCommand): Observable<ResponseOfInteger> {
        let url_ = this.baseUrl + "/api/v1/Qualification/qcto/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQctoQualification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQctoQualification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfInteger>;
        }));
    }

    protected processUpdateQctoQualification(response: HttpResponseBase): Observable<ResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfInteger>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archiveQualGeneralDocument(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/documents/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveQualGeneralDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveQualGeneralDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchiveQualGeneralDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archiveQualLearningMaterial(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Qualification/learning-material/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveQualLearningMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveQualLearningMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchiveQualLearningMaterial(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getStackedStudentsByAge(request: GetStackedStudentsByAgeRequest): Observable<GetStackedStudentsByAgeResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Reports/stacked-students-by-age";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStackedStudentsByAge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStackedStudentsByAge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStackedStudentsByAgeResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStackedStudentsByAgeResponse[]>;
        }));
    }

    protected processGetStackedStudentsByAge(response: HttpResponseBase): Observable<GetStackedStudentsByAgeResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetStackedStudentsByAgeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStackedStudentsByAgeResponse[]>(null as any);
    }

    getPieChartDisabilities(request: GetPieChartRatingsRequest): Observable<GetPieChartRatingsResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Reports/pie-chart-by-disability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPieChartDisabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPieChartDisabilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPieChartRatingsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPieChartRatingsResponse[]>;
        }));
    }

    protected processGetPieChartDisabilities(response: HttpResponseBase): Observable<GetPieChartRatingsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPieChartRatingsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPieChartRatingsResponse[]>(null as any);
    }

    getLineGraphAttendance(request: GetLineGraphAttendanceRequest): Observable<GetLineGraphAttendanceResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Reports/line-graph-attendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLineGraphAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLineGraphAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLineGraphAttendanceResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLineGraphAttendanceResponse[]>;
        }));
    }

    protected processGetLineGraphAttendance(response: HttpResponseBase): Observable<GetLineGraphAttendanceResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLineGraphAttendanceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLineGraphAttendanceResponse[]>(null as any);
    }

    exportReport(request: ExportReportRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Reports/export-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StaffClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    post(command: CreateStaffMemberCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    get2(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    put(id: number, command: UpdateStaffMemberCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPersonalFiles(staffId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/personalFiles/{staffId}";
        if (staffId === undefined || staffId === null)
            throw new Error("The parameter 'staffId' must be defined.");
        url_ = url_.replace("{staffId}", encodeURIComponent("" + staffId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPersonalFiles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadPersonalFile(fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/personalFiles/download/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPersonalFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPersonalFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPersonalFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStaffTypesByUserId(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/types/userId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffTypesByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffTypesByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStaffTypesByUserId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPDFViewerDetails(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/pdfViewerDetails/userId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPDFViewerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPDFViewerDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPDFViewerDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getByUserId(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/userId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * Search list of all staff.
     */
    search(request: SearchStaffRequest): Observable<PaginationResponseOfStaffDto> {
        let url_ = this.baseUrl + "/api/v1/Staff/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginationResponseOfStaffDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginationResponseOfStaffDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PaginationResponseOfStaffDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfStaffDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfStaffDto>(null as any);
    }

    postPersonalFIles(staffId: number, fileData: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/{staffId}/personalFiles";
        if (staffId === undefined || staffId === null)
            throw new Error("The parameter 'staffId' must be defined.");
        url_ = url_.replace("{staffId}", encodeURIComponent("" + staffId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            fileData.forEach(item_ => content_.append("fileData", item_.data, item_.fileName ? item_.fileName : "fileData") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPersonalFIles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPersonalFIles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPostPersonalFIles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archive(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archivePersonalFile(fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Staff/personalFiles/archive/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivePersonalFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivePersonalFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchivePersonalFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StudentCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getAllStudentCodeByLearnershipId(learnershipId: number): Observable<ResponseOfICollectionOfStudentCode> {
        let url_ = this.baseUrl + "/api/v1/StudentCode/{learnershipId}";
        if (learnershipId === undefined || learnershipId === null)
            throw new Error("The parameter 'learnershipId' must be defined.");
        url_ = url_.replace("{learnershipId}", encodeURIComponent("" + learnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStudentCodeByLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStudentCodeByLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfStudentCode>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfStudentCode>;
        }));
    }

    protected processGetAllStudentCodeByLearnershipId(response: HttpResponseBase): Observable<ResponseOfICollectionOfStudentCode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfStudentCode.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfStudentCode>(null as any);
    }

    getStudentCodeByStudentLearnershipId(studentLearnershipId: number): Observable<ResponseOfICollectionOfStudentCode> {
        let url_ = this.baseUrl + "/api/v1/StudentCode/studentCode/{studentLearnershipId}";
        if (studentLearnershipId === undefined || studentLearnershipId === null)
            throw new Error("The parameter 'studentLearnershipId' must be defined.");
        url_ = url_.replace("{studentLearnershipId}", encodeURIComponent("" + studentLearnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentCodeByStudentLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentCodeByStudentLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfStudentCode>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfStudentCode>;
        }));
    }

    protected processGetStudentCodeByStudentLearnershipId(response: HttpResponseBase): Observable<ResponseOfICollectionOfStudentCode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfStudentCode.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfStudentCode>(null as any);
    }

    downloadStudentCodeFile(fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/StudentCode/files/download/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStudentCodeFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStudentCodeFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadStudentCodeFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    postStudentCode(request: PostStudentLinkCommand): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/StudentCode/upload/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostStudentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostStudentCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processPostStudentCode(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    postStudentFile(studentLearnershipId: number, fileData: FileParameter[] | null | undefined): Observable<ResponseOfString> {
        let url_ = this.baseUrl + "/api/v1/StudentCode/upload/file/{studentLearnershipId}";
        if (studentLearnershipId === undefined || studentLearnershipId === null)
            throw new Error("The parameter 'studentLearnershipId' must be defined.");
        url_ = url_.replace("{studentLearnershipId}", encodeURIComponent("" + studentLearnershipId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            fileData.forEach(item_ => content_.append("fileData", item_.data, item_.fileName ? item_.fileName : "fileData") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostStudentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostStudentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfString>;
        }));
    }

    protected processPostStudentFile(response: HttpResponseBase): Observable<ResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfString>(null as any);
    }

    deleteStudentCodeLink(id: number): Observable<ResponseOfInteger> {
        let url_ = this.baseUrl + "/api/v1/StudentCode/delete/studentCodeLink/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStudentCodeLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStudentCodeLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfInteger>;
        }));
    }

    protected processDeleteStudentCodeLink(response: HttpResponseBase): Observable<ResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfInteger>(null as any);
    }

    deleteStudentCodeFile(id: number): Observable<ResponseOfInteger> {
        let url_ = this.baseUrl + "/api/v1/StudentCode/delete/studentCodeFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStudentCodeFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStudentCodeFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfInteger>;
        }));
    }

    protected processDeleteStudentCodeFile(response: HttpResponseBase): Observable<ResponseOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfInteger>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StudentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    post(command: CreateStudentCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentsByType(type: StudentTypes | undefined, active: boolean | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/byType?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (active !== undefined && active !== null)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentsByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentsByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStudentsByType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getProgrammeInfoByStudentId(studentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/programmeInfo/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgrammeInfoByStudentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgrammeInfoByStudentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProgrammeInfoByStudentId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPersonalFiles(studentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/personalFiles/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPersonalFiles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadPersonalFile(fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/personalFiles/download/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPersonalFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPersonalFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPersonalFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    get2(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    put(id: number, command: UpdateStudentCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentTypeByUserId(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/type/userId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentTypeByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentTypeByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStudentTypeByUserId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getByUserId(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/userId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getGeneralStudentDocInfoById(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/document/doc-info/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStudentDocInfoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStudentDocInfoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetGeneralStudentDocInfoById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadStudentLearnershipGeneralDocumentsById(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/documents/download/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStudentLearnershipGeneralDocumentsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStudentLearnershipGeneralDocumentsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadStudentLearnershipGeneralDocumentsById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentGeneralDocAnnotationDataByDocId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/document/annotations/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentGeneralDocAnnotationDataByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentGeneralDocAnnotationDataByDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStudentGeneralDocAnnotationDataByDocId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStudentGeneralDocInputsByDocId(docId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/document/inputs/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentGeneralDocInputsByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentGeneralDocInputsByDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStudentGeneralDocInputsByDocId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getGeneralStudentDocumentsForStudent(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/documents/general-student-documents/current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStudentDocumentsForStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStudentDocumentsForStudent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetGeneralStudentDocumentsForStudent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getGeneralStudentDocumentsByStudentLearnershipId(studentLearnershipId: number): Observable<ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel> {
        let url_ = this.baseUrl + "/api/v1/Student/student-learnership/{studentLearnershipId}/general-student-documents";
        if (studentLearnershipId === undefined || studentLearnershipId === null)
            throw new Error("The parameter 'studentLearnershipId' must be defined.");
        url_ = url_.replace("{studentLearnershipId}", encodeURIComponent("" + studentLearnershipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStudentDocumentsByStudentLearnershipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStudentDocumentsByStudentLearnershipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel>;
        }));
    }

    protected processGetGeneralStudentDocumentsByStudentLearnershipId(response: HttpResponseBase): Observable<ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel>(null as any);
    }

    /**
     * Search list of all students.
     */
    search(request: SearchStudentsRequest): Observable<PaginationResponseOfStudentDto> {
        let url_ = this.baseUrl + "/api/v1/Student/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginationResponseOfStudentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginationResponseOfStudentDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PaginationResponseOfStudentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfStudentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfStudentDto>(null as any);
    }

    registerCandidate(command: RegisterCandidateCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/register/candidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRegisterCandidate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    uploadCandidatePersonalFiles(candidateId: number, tenantId: number, fileData: FileParameter | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/register/{tenantId}/candidate/{candidateId}/personal-files";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            content_.append("fileData", fileData.data, fileData.fileName ? fileData.fileName : "fileData");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCandidatePersonalFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCandidatePersonalFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUploadCandidatePersonalFiles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    registerCandidateAsStudent(id: number, command: RegisterCandidateAsStudentCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/register/candidateAsStudent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterCandidateAsStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterCandidateAsStudent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRegisterCandidateAsStudent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    postPersonalFIles(studentId: number, fileData: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/{studentId}/personalFiles";
        if (studentId === undefined || studentId === null)
            throw new Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData !== null && fileData !== undefined)
            fileData.forEach(item_ => content_.append("fileData", item_.data, item_.fileName ? item_.fileName : "fileData") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPersonalFIles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPersonalFIles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPostPersonalFIles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archive(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    archivePersonalFile(fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Student/personalFiles/archive/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivePersonalFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivePersonalFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchivePersonalFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    getConfirmRegistrationInfoByToken(secondsUntilUpdate: number | undefined, updateToken: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/announce-update?";
        if (secondsUntilUpdate === null)
            throw new Error("The parameter 'secondsUntilUpdate' cannot be null.");
        else if (secondsUntilUpdate !== undefined)
            url_ += "secondsUntilUpdate=" + encodeURIComponent("" + secondsUntilUpdate) + "&";
        if (updateToken !== undefined && updateToken !== null)
            url_ += "updateToken=" + encodeURIComponent("" + updateToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfirmRegistrationInfoByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfirmRegistrationInfoByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetConfirmRegistrationInfoByToken(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getConfirmRegistrationInfoByToken2(request: GetConfirmRegistrationInfoByTokenRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/confirm-registration-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfirmRegistrationInfoByToken2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfirmRegistrationInfoByToken2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetConfirmRegistrationInfoByToken2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    confirmRegistration(command: ConfirmRegistrationCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/confirm-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfirmRegistration(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getResetPasswordInfo(request: GetResetPasswordInfoRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/reset-password-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResetPasswordInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResetPasswordInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetResetPasswordInfo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    resetPassword(command: ResetPasswordCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    authenticateTenantUser(request: AuthenticateByTenantRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/authenticateTenantUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateTenantUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateTenantUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAuthenticateTenantUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    logInAsStaff(request: LogInAsUserRequest): Observable<ResponseOfAuthenticateResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/log-in-as-staff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogInAsStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogInAsStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfAuthenticateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfAuthenticateResponse>;
        }));
    }

    protected processLogInAsStaff(response: HttpResponseBase): Observable<ResponseOfAuthenticateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfAuthenticateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfAuthenticateResponse>(null as any);
    }

    logInAsStudent(request: LogInAsUserRequest): Observable<ResponseOfAuthenticateResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/log-in-as-student";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogInAsStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogInAsStudent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseOfAuthenticateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseOfAuthenticateResponse>;
        }));
    }

    protected processLogInAsStudent(response: HttpResponseBase): Observable<ResponseOfAuthenticateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseOfAuthenticateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOfAuthenticateResponse>(null as any);
    }

    getTenantBySubDomain(subDomainName: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/subDomain/{subDomainName}";
        if (subDomainName === undefined || subDomainName === null)
            throw new Error("The parameter 'subDomainName' must be defined.");
        url_ = url_.replace("{subDomainName}", encodeURIComponent("" + subDomainName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantBySubDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantBySubDomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetTenantBySubDomain(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addTenant(request: RegisterTenantRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddTenant(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addTenant2(command: ResendVerificationEmailCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Tenant/resendVerficationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTenant2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTenant2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddTenant2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VisitorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:9001";
    }

    create(command: CreateSetaVisitorCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Visitor/seta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    createTester(command: CreateVisitorTesterCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Visitor/tester";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTester(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTester(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateTester(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export class ResponseOfString implements IResponseOfString {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: string | undefined;

    constructor(data?: IResponseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfString {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: string | undefined;
}

export class AsignSignatureCommand implements IAsignSignatureCommand {
    accountId?: number;
    svgString?: string | undefined;

    constructor(data?: IAsignSignatureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.svgString = _data["svgString"];
        }
    }

    static fromJS(data: any): AsignSignatureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AsignSignatureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["svgString"] = this.svgString;
        return data;
    }
}

export interface IAsignSignatureCommand {
    accountId?: number;
    svgString?: string | undefined;
}

export class AsignInitialsCommand implements IAsignInitialsCommand {
    accountId?: number;
    svgString?: string | undefined;

    constructor(data?: IAsignInitialsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.svgString = _data["svgString"];
        }
    }

    static fromJS(data: any): AsignInitialsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AsignInitialsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["svgString"] = this.svgString;
        return data;
    }
}

export interface IAsignInitialsCommand {
    accountId?: number;
    svgString?: string | undefined;
}

export class AsignProfilePictureCommand implements IAsignProfilePictureCommand {
    profileImage?: CreateDocumentDTO | undefined;

    constructor(data?: IAsignProfilePictureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileImage = _data["profileImage"] ? CreateDocumentDTO.fromJS(_data["profileImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AsignProfilePictureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AsignProfilePictureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAsignProfilePictureCommand {
    profileImage?: CreateDocumentDTO | undefined;
}

export class CreateDocumentDTO implements ICreateDocumentDTO {
    base64File?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: ICreateDocumentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64File = _data["base64File"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): CreateDocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64File"] = this.base64File;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface ICreateDocumentDTO {
    base64File?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;
    tenantId!: number;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email: string;
    tenantId: number;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    canLogInAs?: AuthenticateResponse[] | undefined;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["canLogInAs"])) {
                this.canLogInAs = [] as any;
                for (let item of _data["canLogInAs"])
                    this.canLogInAs!.push(AuthenticateResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.canLogInAs)) {
            data["canLogInAs"] = [];
            for (let item of this.canLogInAs)
                data["canLogInAs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRefreshTokenResponse {
    canLogInAs?: AuthenticateResponse[] | undefined;
}

export class AuthenticateResponse implements IAuthenticateResponse {
    id?: number;
    tawkHash?: string | undefined;
    tenantId?: number;
    tenant?: TenantDTO | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date;
    cellNumber?: string | undefined;
    email?: string | undefined;
    signatureSvg?: string | undefined;
    initialsSvg?: string | undefined;
    role?: Roles;
    created?: Date;
    updated?: Date | undefined;
    jwtToken?: string | undefined;
    profileImageBase64?: string | undefined;
    address?: string | undefined;
    moderatorNumber?: string | undefined;
    assessorNumber?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IAuthenticateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tawkHash = _data["tawkHash"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? TenantDTO.fromJS(_data["tenant"]) : <any>undefined;
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.idNumber = _data["idNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.cellNumber = _data["cellNumber"];
            this.email = _data["email"];
            this.signatureSvg = _data["signatureSvg"];
            this.initialsSvg = _data["initialsSvg"];
            this.role = _data["role"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.jwtToken = _data["jwtToken"];
            this.profileImageBase64 = _data["profileImageBase64"];
            this.address = _data["address"];
            this.moderatorNumber = _data["moderatorNumber"];
            this.assessorNumber = _data["assessorNumber"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): AuthenticateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tawkHash"] = this.tawkHash;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["idNumber"] = this.idNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["cellNumber"] = this.cellNumber;
        data["email"] = this.email;
        data["signatureSvg"] = this.signatureSvg;
        data["initialsSvg"] = this.initialsSvg;
        data["role"] = this.role;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["jwtToken"] = this.jwtToken;
        data["profileImageBase64"] = this.profileImageBase64;
        data["address"] = this.address;
        data["moderatorNumber"] = this.moderatorNumber;
        data["assessorNumber"] = this.assessorNumber;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IAuthenticateResponse {
    id?: number;
    tawkHash?: string | undefined;
    tenantId?: number;
    tenant?: TenantDTO | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date;
    cellNumber?: string | undefined;
    email?: string | undefined;
    signatureSvg?: string | undefined;
    initialsSvg?: string | undefined;
    role?: Roles;
    created?: Date;
    updated?: Date | undefined;
    jwtToken?: string | undefined;
    profileImageBase64?: string | undefined;
    address?: string | undefined;
    moderatorNumber?: string | undefined;
    assessorNumber?: string | undefined;
    refreshToken?: string | undefined;
}

export class TenantDTO implements ITenantDTO {
    id?: number;
    name?: string | undefined;
    subDomainName?: string | undefined;
    email?: string | undefined;
    branding?: TenantBrandingDTO | undefined;

    constructor(data?: ITenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subDomainName = _data["subDomainName"];
            this.email = _data["email"];
            this.branding = _data["branding"] ? TenantBrandingDTO.fromJS(_data["branding"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subDomainName"] = this.subDomainName;
        data["email"] = this.email;
        data["branding"] = this.branding ? this.branding.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantDTO {
    id?: number;
    name?: string | undefined;
    subDomainName?: string | undefined;
    email?: string | undefined;
    branding?: TenantBrandingDTO | undefined;
}

export class TenantBrandingDTO implements ITenantBrandingDTO {
    id?: number;
    primaryColorHex?: string | undefined;
    secondaryColorHex?: string | undefined;
    tertiaryColorHex?: string | undefined;
    primaryLogo?: string | undefined;
    smallLogo?: string | undefined;
    websiteUrl?: string | undefined;

    constructor(data?: ITenantBrandingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryColorHex = _data["primaryColorHex"];
            this.secondaryColorHex = _data["secondaryColorHex"];
            this.tertiaryColorHex = _data["tertiaryColorHex"];
            this.primaryLogo = _data["primaryLogo"];
            this.smallLogo = _data["smallLogo"];
            this.websiteUrl = _data["websiteUrl"];
        }
    }

    static fromJS(data: any): TenantBrandingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBrandingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryColorHex"] = this.primaryColorHex;
        data["secondaryColorHex"] = this.secondaryColorHex;
        data["tertiaryColorHex"] = this.tertiaryColorHex;
        data["primaryLogo"] = this.primaryLogo;
        data["smallLogo"] = this.smallLogo;
        data["websiteUrl"] = this.websiteUrl;
        return data;
    }
}

export interface ITenantBrandingDTO {
    id?: number;
    primaryColorHex?: string | undefined;
    secondaryColorHex?: string | undefined;
    tertiaryColorHex?: string | undefined;
    primaryLogo?: string | undefined;
    smallLogo?: string | undefined;
    websiteUrl?: string | undefined;
}

export enum Titles {
    Mr = 0,
    Mrs = 1,
    Miss = 2,
    DrMd = 3,
    DrPhD = 4,
}

export enum Roles {
    TenantManager = 0,
    SuperAdmin = 1,
    Admin = 2,
    Staff = 3,
    Student = 4,
    SetaVisitor = 5,
    Geust = 6,
    Tester = 7,
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    accountId?: number | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IRefreshTokenRequest {
    accountId?: number | undefined;
}

export class RevokeTokenRequest implements IRevokeTokenRequest {
    token?: string | undefined;
    accountId?: number;

    constructor(data?: IRevokeTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): RevokeTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IRevokeTokenRequest {
    token?: string | undefined;
    accountId?: number;
}

export class ResponseOfIEnumerableOfAccreditedProvider implements IResponseOfIEnumerableOfAccreditedProvider {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: AccreditedProvider[] | undefined;

    constructor(data?: IResponseOfIEnumerableOfAccreditedProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AccreditedProvider.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfIEnumerableOfAccreditedProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIEnumerableOfAccreditedProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfIEnumerableOfAccreditedProvider {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: AccreditedProvider[] | undefined;
}

export class BaseEntity implements IBaseEntity {
    id?: number;
    domainEvents?: DomainEvent[] | undefined;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                this.domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    this.domainEvents!.push(DomainEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaseEntity {
    id?: number;
    domainEvents?: DomainEvent[] | undefined;
}

export class AuditableBaseEntity extends BaseEntity implements IAuditableBaseEntity {
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    state?: ObjectState;

    constructor(data?: IAuditableBaseEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static override fromJS(data: any): AuditableBaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AuditableBaseEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditableBaseEntity extends IBaseEntity {
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    state?: ObjectState;
}

export class AccreditedProvider extends AuditableBaseEntity implements IAccreditedProvider {
    name?: string | undefined;
    accreditationNumber?: string | undefined;
    setaRegisteredWith?: SETATypes | undefined;
    learnerships?: Learnership[] | undefined;
    internships?: Internship[] | undefined;
    isSeta?: boolean;

    constructor(data?: IAccreditedProvider) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.accreditationNumber = _data["accreditationNumber"];
            this.setaRegisteredWith = _data["setaRegisteredWith"];
            if (Array.isArray(_data["learnerships"])) {
                this.learnerships = [] as any;
                for (let item of _data["learnerships"])
                    this.learnerships!.push(Learnership.fromJS(item));
            }
            if (Array.isArray(_data["internships"])) {
                this.internships = [] as any;
                for (let item of _data["internships"])
                    this.internships!.push(Internship.fromJS(item));
            }
            this.isSeta = _data["isSeta"];
        }
    }

    static override fromJS(data: any): AccreditedProvider {
        data = typeof data === 'object' ? data : {};
        let result = new AccreditedProvider();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accreditationNumber"] = this.accreditationNumber;
        data["setaRegisteredWith"] = this.setaRegisteredWith;
        if (Array.isArray(this.learnerships)) {
            data["learnerships"] = [];
            for (let item of this.learnerships)
                data["learnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.internships)) {
            data["internships"] = [];
            for (let item of this.internships)
                data["internships"].push(item.toJSON());
        }
        data["isSeta"] = this.isSeta;
        super.toJSON(data);
        return data;
    }
}

export interface IAccreditedProvider extends IAuditableBaseEntity {
    name?: string | undefined;
    accreditationNumber?: string | undefined;
    setaRegisteredWith?: SETATypes | undefined;
    learnerships?: Learnership[] | undefined;
    internships?: Internship[] | undefined;
    isSeta?: boolean;
}

export enum SETATypes {
    AgriSETA = 0,
    BankSETA = 1,
    Chieta = 2,
    Ceta = 3,
    CathsSETA = 4,
    EtdpSETA = 5,
    EwsSeta = 6,
    FpmSETA = 7,
    Fasset = 8,
    FoodBevSETA = 9,
    HwSETA = 10,
    InSETA = 11,
    LgSETA = 12,
    MerSETA = 13,
    MictSETA = 14,
    Mqa = 15,
    PSETA = 16,
    SasSETA = 17,
    SSeta = 18,
    Teta = 19,
    WrSeta = 20,
}

export abstract class ProgrammeEntity extends AuditableBaseEntity implements IProgrammeEntity {
    contractNumber?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    accreditedProviderId?: number;
    accreditedProvider?: AccreditedProvider | undefined;

    constructor(data?: IProgrammeEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractNumber = _data["contractNumber"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.accreditedProviderId = _data["accreditedProviderId"];
            this.accreditedProvider = _data["accreditedProvider"] ? AccreditedProvider.fromJS(_data["accreditedProvider"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammeEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ProgrammeEntity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractNumber"] = this.contractNumber;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["accreditedProviderId"] = this.accreditedProviderId;
        data["accreditedProvider"] = this.accreditedProvider ? this.accreditedProvider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammeEntity extends IAuditableBaseEntity {
    contractNumber?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    accreditedProviderId?: number;
    accreditedProvider?: AccreditedProvider | undefined;
}

export class Learnership extends ProgrammeEntity implements ILearnership {
    credits?: number;
    staff?: StaffLearnership[] | undefined;
    students?: StudentLearnership[] | undefined;
    groups?: LearnershipGroup[] | undefined;
    customElectives?: CustomElective[] | undefined;
    programmePOE?: ProgrammePOE | undefined;
    studentPOEs?: StudentPOE[] | undefined;
    chatRoom?: LearnershipChatRoom | undefined;
    attendanceRegisters?: LearnershipAttendanceRegister[] | undefined;
    generalDocuments?: GeneralLearnershipDocument[] | undefined;
    programmeAssessorFile?: ProgrammeAssessorFile | undefined;
    programmeModeratorFile?: ProgrammeModeratorFile | undefined;
    isDev?: boolean;
    qualificationId?: number;
    qualification?: Qualification | undefined;

    constructor(data?: ILearnership) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.credits = _data["credits"];
            if (Array.isArray(_data["staff"])) {
                this.staff = [] as any;
                for (let item of _data["staff"])
                    this.staff!.push(StaffLearnership.fromJS(item));
            }
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(StudentLearnership.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(LearnershipGroup.fromJS(item));
            }
            if (Array.isArray(_data["customElectives"])) {
                this.customElectives = [] as any;
                for (let item of _data["customElectives"])
                    this.customElectives!.push(CustomElective.fromJS(item));
            }
            this.programmePOE = _data["programmePOE"] ? ProgrammePOE.fromJS(_data["programmePOE"]) : <any>undefined;
            if (Array.isArray(_data["studentPOEs"])) {
                this.studentPOEs = [] as any;
                for (let item of _data["studentPOEs"])
                    this.studentPOEs!.push(StudentPOE.fromJS(item));
            }
            this.chatRoom = _data["chatRoom"] ? LearnershipChatRoom.fromJS(_data["chatRoom"]) : <any>undefined;
            if (Array.isArray(_data["attendanceRegisters"])) {
                this.attendanceRegisters = [] as any;
                for (let item of _data["attendanceRegisters"])
                    this.attendanceRegisters!.push(LearnershipAttendanceRegister.fromJS(item));
            }
            if (Array.isArray(_data["generalDocuments"])) {
                this.generalDocuments = [] as any;
                for (let item of _data["generalDocuments"])
                    this.generalDocuments!.push(GeneralLearnershipDocument.fromJS(item));
            }
            this.programmeAssessorFile = _data["programmeAssessorFile"] ? ProgrammeAssessorFile.fromJS(_data["programmeAssessorFile"]) : <any>undefined;
            this.programmeModeratorFile = _data["programmeModeratorFile"] ? ProgrammeModeratorFile.fromJS(_data["programmeModeratorFile"]) : <any>undefined;
            this.isDev = _data["isDev"];
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Learnership {
        data = typeof data === 'object' ? data : {};
        let result = new Learnership();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["credits"] = this.credits;
        if (Array.isArray(this.staff)) {
            data["staff"] = [];
            for (let item of this.staff)
                data["staff"].push(item.toJSON());
        }
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.customElectives)) {
            data["customElectives"] = [];
            for (let item of this.customElectives)
                data["customElectives"].push(item.toJSON());
        }
        data["programmePOE"] = this.programmePOE ? this.programmePOE.toJSON() : <any>undefined;
        if (Array.isArray(this.studentPOEs)) {
            data["studentPOEs"] = [];
            for (let item of this.studentPOEs)
                data["studentPOEs"].push(item.toJSON());
        }
        data["chatRoom"] = this.chatRoom ? this.chatRoom.toJSON() : <any>undefined;
        if (Array.isArray(this.attendanceRegisters)) {
            data["attendanceRegisters"] = [];
            for (let item of this.attendanceRegisters)
                data["attendanceRegisters"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocuments)) {
            data["generalDocuments"] = [];
            for (let item of this.generalDocuments)
                data["generalDocuments"].push(item.toJSON());
        }
        data["programmeAssessorFile"] = this.programmeAssessorFile ? this.programmeAssessorFile.toJSON() : <any>undefined;
        data["programmeModeratorFile"] = this.programmeModeratorFile ? this.programmeModeratorFile.toJSON() : <any>undefined;
        data["isDev"] = this.isDev;
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILearnership extends IProgrammeEntity {
    credits?: number;
    staff?: StaffLearnership[] | undefined;
    students?: StudentLearnership[] | undefined;
    groups?: LearnershipGroup[] | undefined;
    customElectives?: CustomElective[] | undefined;
    programmePOE?: ProgrammePOE | undefined;
    studentPOEs?: StudentPOE[] | undefined;
    chatRoom?: LearnershipChatRoom | undefined;
    attendanceRegisters?: LearnershipAttendanceRegister[] | undefined;
    generalDocuments?: GeneralLearnershipDocument[] | undefined;
    programmeAssessorFile?: ProgrammeAssessorFile | undefined;
    programmeModeratorFile?: ProgrammeModeratorFile | undefined;
    isDev?: boolean;
    qualificationId?: number;
    qualification?: Qualification | undefined;
}

export class StaffLearnership extends AuditableBaseEntity implements IStaffLearnership {
    programmeRole?: LearnershipStaffRoles;
    isLead?: boolean;
    staffId?: number;
    staff?: Staff | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    dateJoined?: Date;
    dateLeft?: Date | undefined;
    reasonLeft?: string | undefined;

    constructor(data?: IStaffLearnership) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmeRole = _data["programmeRole"];
            this.isLead = _data["isLead"];
            this.staffId = _data["staffId"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            this.dateJoined = _data["dateJoined"] ? new Date(_data["dateJoined"].toString()) : <any>undefined;
            this.dateLeft = _data["dateLeft"] ? new Date(_data["dateLeft"].toString()) : <any>undefined;
            this.reasonLeft = _data["reasonLeft"];
        }
    }

    static override fromJS(data: any): StaffLearnership {
        data = typeof data === 'object' ? data : {};
        let result = new StaffLearnership();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmeRole"] = this.programmeRole;
        data["isLead"] = this.isLead;
        data["staffId"] = this.staffId;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        data["dateJoined"] = this.dateJoined ? this.dateJoined.toISOString() : <any>undefined;
        data["dateLeft"] = this.dateLeft ? this.dateLeft.toISOString() : <any>undefined;
        data["reasonLeft"] = this.reasonLeft;
        super.toJSON(data);
        return data;
    }
}

export interface IStaffLearnership extends IAuditableBaseEntity {
    programmeRole?: LearnershipStaffRoles;
    isLead?: boolean;
    staffId?: number;
    staff?: Staff | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    dateJoined?: Date;
    dateLeft?: Date | undefined;
    reasonLeft?: string | undefined;
}

export enum LearnershipStaffRoles {
    Assessor = 0,
    Moderator = 1,
    Facilitator = 2,
    Mentor = 3,
}

export class Staff extends AuditableBaseEntity implements IStaff {
    moderatorNumber?: string | undefined;
    assessorNumber?: string | undefined;
    types?: StaffType[] | undefined;
    learnerships?: StaffLearnership[] | undefined;
    internships?: StaffInternship[] | undefined;
    personalFiles?: StaffPersonalFile[] | undefined;
    recievedEmails?: EmailNotification[] | undefined;
    personId?: number;
    person?: Person | undefined;

    constructor(data?: IStaff) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.moderatorNumber = _data["moderatorNumber"];
            this.assessorNumber = _data["assessorNumber"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(StaffType.fromJS(item));
            }
            if (Array.isArray(_data["learnerships"])) {
                this.learnerships = [] as any;
                for (let item of _data["learnerships"])
                    this.learnerships!.push(StaffLearnership.fromJS(item));
            }
            if (Array.isArray(_data["internships"])) {
                this.internships = [] as any;
                for (let item of _data["internships"])
                    this.internships!.push(StaffInternship.fromJS(item));
            }
            if (Array.isArray(_data["personalFiles"])) {
                this.personalFiles = [] as any;
                for (let item of _data["personalFiles"])
                    this.personalFiles!.push(StaffPersonalFile.fromJS(item));
            }
            if (Array.isArray(_data["recievedEmails"])) {
                this.recievedEmails = [] as any;
                for (let item of _data["recievedEmails"])
                    this.recievedEmails!.push(EmailNotification.fromJS(item));
            }
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Staff {
        data = typeof data === 'object' ? data : {};
        let result = new Staff();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moderatorNumber"] = this.moderatorNumber;
        data["assessorNumber"] = this.assessorNumber;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        if (Array.isArray(this.learnerships)) {
            data["learnerships"] = [];
            for (let item of this.learnerships)
                data["learnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.internships)) {
            data["internships"] = [];
            for (let item of this.internships)
                data["internships"].push(item.toJSON());
        }
        if (Array.isArray(this.personalFiles)) {
            data["personalFiles"] = [];
            for (let item of this.personalFiles)
                data["personalFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.recievedEmails)) {
            data["recievedEmails"] = [];
            for (let item of this.recievedEmails)
                data["recievedEmails"].push(item.toJSON());
        }
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStaff extends IAuditableBaseEntity {
    moderatorNumber?: string | undefined;
    assessorNumber?: string | undefined;
    types?: StaffType[] | undefined;
    learnerships?: StaffLearnership[] | undefined;
    internships?: StaffInternship[] | undefined;
    personalFiles?: StaffPersonalFile[] | undefined;
    recievedEmails?: EmailNotification[] | undefined;
    personId?: number;
    person?: Person | undefined;
}

export class StaffType extends AuditableBaseEntity implements IStaffType {
    type?: StaffTypes;
    staffId?: number;
    staff?: Staff | undefined;

    constructor(data?: IStaffType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.staffId = _data["staffId"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StaffType {
        data = typeof data === 'object' ? data : {};
        let result = new StaffType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["staffId"] = this.staffId;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStaffType extends IAuditableBaseEntity {
    type?: StaffTypes;
    staffId?: number;
    staff?: Staff | undefined;
}

export enum StaffTypes {
    Assessor = 0,
    Moderator = 1,
    Facilitator = 2,
    Mentor = 3,
}

export enum ObjectState {
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export abstract class DomainEvent implements IDomainEvent {
    triggeredOn?: Date;

    constructor(data?: IDomainEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.triggeredOn = _data["triggeredOn"] ? new Date(_data["triggeredOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DomainEvent {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DomainEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["triggeredOn"] = this.triggeredOn ? this.triggeredOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDomainEvent {
    triggeredOn?: Date;
}

export class StaffInternship extends AuditableBaseEntity implements IStaffInternship {
    programmeRole?: LearnershipStaffRoles;
    isLead?: boolean;
    staffId?: number;
    staff?: Staff | undefined;
    internshipId?: number;
    internship?: Internship | undefined;
    dateJoined?: Date;
    dateLeft?: Date | undefined;
    reasonLeft?: string | undefined;

    constructor(data?: IStaffInternship) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmeRole = _data["programmeRole"];
            this.isLead = _data["isLead"];
            this.staffId = _data["staffId"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
            this.internshipId = _data["internshipId"];
            this.internship = _data["internship"] ? Internship.fromJS(_data["internship"]) : <any>undefined;
            this.dateJoined = _data["dateJoined"] ? new Date(_data["dateJoined"].toString()) : <any>undefined;
            this.dateLeft = _data["dateLeft"] ? new Date(_data["dateLeft"].toString()) : <any>undefined;
            this.reasonLeft = _data["reasonLeft"];
        }
    }

    static override fromJS(data: any): StaffInternship {
        data = typeof data === 'object' ? data : {};
        let result = new StaffInternship();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmeRole"] = this.programmeRole;
        data["isLead"] = this.isLead;
        data["staffId"] = this.staffId;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["internshipId"] = this.internshipId;
        data["internship"] = this.internship ? this.internship.toJSON() : <any>undefined;
        data["dateJoined"] = this.dateJoined ? this.dateJoined.toISOString() : <any>undefined;
        data["dateLeft"] = this.dateLeft ? this.dateLeft.toISOString() : <any>undefined;
        data["reasonLeft"] = this.reasonLeft;
        super.toJSON(data);
        return data;
    }
}

export interface IStaffInternship extends IAuditableBaseEntity {
    programmeRole?: LearnershipStaffRoles;
    isLead?: boolean;
    staffId?: number;
    staff?: Staff | undefined;
    internshipId?: number;
    internship?: Internship | undefined;
    dateJoined?: Date;
    dateLeft?: Date | undefined;
    reasonLeft?: string | undefined;
}

export class Internship extends ProgrammeEntity implements IInternship {
    staff?: StaffInternship[] | undefined;
    students?: StudentInternship[] | undefined;
    groups?: InternshipGroup[] | undefined;
    chatRoom?: InternshipChatRoom | undefined;
    attendanceRegisters?: InternshipAttendanceRegister[] | undefined;
    generalDocuments?: GeneralInternshipDocument[] | undefined;
    internshipPlanId?: number;
    internshipPlan?: InternshipPlan | undefined;

    constructor(data?: IInternship) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["staff"])) {
                this.staff = [] as any;
                for (let item of _data["staff"])
                    this.staff!.push(StaffInternship.fromJS(item));
            }
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(StudentInternship.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(InternshipGroup.fromJS(item));
            }
            this.chatRoom = _data["chatRoom"] ? InternshipChatRoom.fromJS(_data["chatRoom"]) : <any>undefined;
            if (Array.isArray(_data["attendanceRegisters"])) {
                this.attendanceRegisters = [] as any;
                for (let item of _data["attendanceRegisters"])
                    this.attendanceRegisters!.push(InternshipAttendanceRegister.fromJS(item));
            }
            if (Array.isArray(_data["generalDocuments"])) {
                this.generalDocuments = [] as any;
                for (let item of _data["generalDocuments"])
                    this.generalDocuments!.push(GeneralInternshipDocument.fromJS(item));
            }
            this.internshipPlanId = _data["internshipPlanId"];
            this.internshipPlan = _data["internshipPlan"] ? InternshipPlan.fromJS(_data["internshipPlan"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Internship {
        data = typeof data === 'object' ? data : {};
        let result = new Internship();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.staff)) {
            data["staff"] = [];
            for (let item of this.staff)
                data["staff"].push(item.toJSON());
        }
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["chatRoom"] = this.chatRoom ? this.chatRoom.toJSON() : <any>undefined;
        if (Array.isArray(this.attendanceRegisters)) {
            data["attendanceRegisters"] = [];
            for (let item of this.attendanceRegisters)
                data["attendanceRegisters"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocuments)) {
            data["generalDocuments"] = [];
            for (let item of this.generalDocuments)
                data["generalDocuments"].push(item.toJSON());
        }
        data["internshipPlanId"] = this.internshipPlanId;
        data["internshipPlan"] = this.internshipPlan ? this.internshipPlan.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInternship extends IProgrammeEntity {
    staff?: StaffInternship[] | undefined;
    students?: StudentInternship[] | undefined;
    groups?: InternshipGroup[] | undefined;
    chatRoom?: InternshipChatRoom | undefined;
    attendanceRegisters?: InternshipAttendanceRegister[] | undefined;
    generalDocuments?: GeneralInternshipDocument[] | undefined;
    internshipPlanId?: number;
    internshipPlan?: InternshipPlan | undefined;
}

export class StudentInternship extends AuditableBaseEntity implements IStudentInternship {
    studentId?: number;
    student?: Student | undefined;
    internshipId?: number;
    internship?: Internship | undefined;
    dateJoined?: Date;
    dateLeft?: Date | undefined;
    reasonLeft?: string | undefined;

    constructor(data?: IStudentInternship) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.internshipId = _data["internshipId"];
            this.internship = _data["internship"] ? Internship.fromJS(_data["internship"]) : <any>undefined;
            this.dateJoined = _data["dateJoined"] ? new Date(_data["dateJoined"].toString()) : <any>undefined;
            this.dateLeft = _data["dateLeft"] ? new Date(_data["dateLeft"].toString()) : <any>undefined;
            this.reasonLeft = _data["reasonLeft"];
        }
    }

    static override fromJS(data: any): StudentInternship {
        data = typeof data === 'object' ? data : {};
        let result = new StudentInternship();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["internshipId"] = this.internshipId;
        data["internship"] = this.internship ? this.internship.toJSON() : <any>undefined;
        data["dateJoined"] = this.dateJoined ? this.dateJoined.toISOString() : <any>undefined;
        data["dateLeft"] = this.dateLeft ? this.dateLeft.toISOString() : <any>undefined;
        data["reasonLeft"] = this.reasonLeft;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentInternship extends IAuditableBaseEntity {
    studentId?: number;
    student?: Student | undefined;
    internshipId?: number;
    internship?: Internship | undefined;
    dateJoined?: Date;
    dateLeft?: Date | undefined;
    reasonLeft?: string | undefined;
}

export class Student extends AuditableBaseEntity implements IStudent {
    type?: StudentTypes;
    learnerships?: StudentLearnership[] | undefined;
    recievedEmails?: EmailNotification[] | undefined;
    internships?: StudentInternship[] | undefined;
    learnershipGroups?: StudentLearnershipGroup[] | undefined;
    internshipGroups?: StudentInternshipGroup[] | undefined;
    poEs?: StudentPOE[] | undefined;
    personalFiles?: StudentPersonalFile[] | undefined;
    internshipAttendance?: StudentInternshipAttendance[] | undefined;
    personId?: number;
    person?: Person | undefined;

    constructor(data?: IStudent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["learnerships"])) {
                this.learnerships = [] as any;
                for (let item of _data["learnerships"])
                    this.learnerships!.push(StudentLearnership.fromJS(item));
            }
            if (Array.isArray(_data["recievedEmails"])) {
                this.recievedEmails = [] as any;
                for (let item of _data["recievedEmails"])
                    this.recievedEmails!.push(EmailNotification.fromJS(item));
            }
            if (Array.isArray(_data["internships"])) {
                this.internships = [] as any;
                for (let item of _data["internships"])
                    this.internships!.push(StudentInternship.fromJS(item));
            }
            if (Array.isArray(_data["learnershipGroups"])) {
                this.learnershipGroups = [] as any;
                for (let item of _data["learnershipGroups"])
                    this.learnershipGroups!.push(StudentLearnershipGroup.fromJS(item));
            }
            if (Array.isArray(_data["internshipGroups"])) {
                this.internshipGroups = [] as any;
                for (let item of _data["internshipGroups"])
                    this.internshipGroups!.push(StudentInternshipGroup.fromJS(item));
            }
            if (Array.isArray(_data["poEs"])) {
                this.poEs = [] as any;
                for (let item of _data["poEs"])
                    this.poEs!.push(StudentPOE.fromJS(item));
            }
            if (Array.isArray(_data["personalFiles"])) {
                this.personalFiles = [] as any;
                for (let item of _data["personalFiles"])
                    this.personalFiles!.push(StudentPersonalFile.fromJS(item));
            }
            if (Array.isArray(_data["internshipAttendance"])) {
                this.internshipAttendance = [] as any;
                for (let item of _data["internshipAttendance"])
                    this.internshipAttendance!.push(StudentInternshipAttendance.fromJS(item));
            }
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Student {
        data = typeof data === 'object' ? data : {};
        let result = new Student();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.learnerships)) {
            data["learnerships"] = [];
            for (let item of this.learnerships)
                data["learnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.recievedEmails)) {
            data["recievedEmails"] = [];
            for (let item of this.recievedEmails)
                data["recievedEmails"].push(item.toJSON());
        }
        if (Array.isArray(this.internships)) {
            data["internships"] = [];
            for (let item of this.internships)
                data["internships"].push(item.toJSON());
        }
        if (Array.isArray(this.learnershipGroups)) {
            data["learnershipGroups"] = [];
            for (let item of this.learnershipGroups)
                data["learnershipGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.internshipGroups)) {
            data["internshipGroups"] = [];
            for (let item of this.internshipGroups)
                data["internshipGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.poEs)) {
            data["poEs"] = [];
            for (let item of this.poEs)
                data["poEs"].push(item.toJSON());
        }
        if (Array.isArray(this.personalFiles)) {
            data["personalFiles"] = [];
            for (let item of this.personalFiles)
                data["personalFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.internshipAttendance)) {
            data["internshipAttendance"] = [];
            for (let item of this.internshipAttendance)
                data["internshipAttendance"].push(item.toJSON());
        }
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudent extends IAuditableBaseEntity {
    type?: StudentTypes;
    learnerships?: StudentLearnership[] | undefined;
    recievedEmails?: EmailNotification[] | undefined;
    internships?: StudentInternship[] | undefined;
    learnershipGroups?: StudentLearnershipGroup[] | undefined;
    internshipGroups?: StudentInternshipGroup[] | undefined;
    poEs?: StudentPOE[] | undefined;
    personalFiles?: StudentPersonalFile[] | undefined;
    internshipAttendance?: StudentInternshipAttendance[] | undefined;
    personId?: number;
    person?: Person | undefined;
}

export enum StudentTypes {
    Candidate = 0,
    Learner = 1,
    Intern = 2,
}

export class StudentLearnership extends AuditableBaseEntity implements IStudentLearnership {
    generalStudentDocuments?: GeneralStudentDocument[] | undefined;
    studentLearnershipGeneralDocActivityStatus?: StudentLearnershipGeneralDocActivityStatus[] | undefined;
    studentLearnershipAssessmentGuideDocActivityStatus?: StudentLearnershipAssessmentGuideDocActivityStatus[] | undefined;
    studentLearnershipFeedbackDocActivityStatus?: StudentLearnershipFeedbackDocActivityStatus[] | undefined;
    studentLearnershipWorkplaceDocActivityStatus?: StudentLearnershipWorkplaceDocActivityStatus[] | undefined;
    studentLearnershipFormativeActivityStatus?: StudentLearnershipFormativeActivityStatus[] | undefined;
    studentLearnershipSummativeActivityStatus?: StudentLearnershipSummativeActivityStatus[] | undefined;
    studentLearnershipSaqaDocActivityStatus?: StudentLearnershipSaqaDocActivityStatus[] | undefined;
    studentLearnershipGroupGeneralDocActivityStatus?: StudentLearnershipGroupGeneralDocActivityStatus[] | undefined;
    studentId?: number;
    student?: Student | undefined;
    daysAbsent?: number;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    dateJoined?: Date;
    dateLeft?: Date | undefined;
    reasonLeft?: string | undefined;
    learnershipAttendanceRegisterItems?: LearnershipAttendanceRegisterItem[] | undefined;
    studentCodes?: StudentCode[] | undefined;

    constructor(data?: IStudentLearnership) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["generalStudentDocuments"])) {
                this.generalStudentDocuments = [] as any;
                for (let item of _data["generalStudentDocuments"])
                    this.generalStudentDocuments!.push(GeneralStudentDocument.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipGeneralDocActivityStatus"])) {
                this.studentLearnershipGeneralDocActivityStatus = [] as any;
                for (let item of _data["studentLearnershipGeneralDocActivityStatus"])
                    this.studentLearnershipGeneralDocActivityStatus!.push(StudentLearnershipGeneralDocActivityStatus.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipAssessmentGuideDocActivityStatus"])) {
                this.studentLearnershipAssessmentGuideDocActivityStatus = [] as any;
                for (let item of _data["studentLearnershipAssessmentGuideDocActivityStatus"])
                    this.studentLearnershipAssessmentGuideDocActivityStatus!.push(StudentLearnershipAssessmentGuideDocActivityStatus.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipFeedbackDocActivityStatus"])) {
                this.studentLearnershipFeedbackDocActivityStatus = [] as any;
                for (let item of _data["studentLearnershipFeedbackDocActivityStatus"])
                    this.studentLearnershipFeedbackDocActivityStatus!.push(StudentLearnershipFeedbackDocActivityStatus.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipWorkplaceDocActivityStatus"])) {
                this.studentLearnershipWorkplaceDocActivityStatus = [] as any;
                for (let item of _data["studentLearnershipWorkplaceDocActivityStatus"])
                    this.studentLearnershipWorkplaceDocActivityStatus!.push(StudentLearnershipWorkplaceDocActivityStatus.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipFormativeActivityStatus"])) {
                this.studentLearnershipFormativeActivityStatus = [] as any;
                for (let item of _data["studentLearnershipFormativeActivityStatus"])
                    this.studentLearnershipFormativeActivityStatus!.push(StudentLearnershipFormativeActivityStatus.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipSummativeActivityStatus"])) {
                this.studentLearnershipSummativeActivityStatus = [] as any;
                for (let item of _data["studentLearnershipSummativeActivityStatus"])
                    this.studentLearnershipSummativeActivityStatus!.push(StudentLearnershipSummativeActivityStatus.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipSaqaDocActivityStatus"])) {
                this.studentLearnershipSaqaDocActivityStatus = [] as any;
                for (let item of _data["studentLearnershipSaqaDocActivityStatus"])
                    this.studentLearnershipSaqaDocActivityStatus!.push(StudentLearnershipSaqaDocActivityStatus.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipGroupGeneralDocActivityStatus"])) {
                this.studentLearnershipGroupGeneralDocActivityStatus = [] as any;
                for (let item of _data["studentLearnershipGroupGeneralDocActivityStatus"])
                    this.studentLearnershipGroupGeneralDocActivityStatus!.push(StudentLearnershipGroupGeneralDocActivityStatus.fromJS(item));
            }
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.daysAbsent = _data["daysAbsent"];
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            this.dateJoined = _data["dateJoined"] ? new Date(_data["dateJoined"].toString()) : <any>undefined;
            this.dateLeft = _data["dateLeft"] ? new Date(_data["dateLeft"].toString()) : <any>undefined;
            this.reasonLeft = _data["reasonLeft"];
            if (Array.isArray(_data["learnershipAttendanceRegisterItems"])) {
                this.learnershipAttendanceRegisterItems = [] as any;
                for (let item of _data["learnershipAttendanceRegisterItems"])
                    this.learnershipAttendanceRegisterItems!.push(LearnershipAttendanceRegisterItem.fromJS(item));
            }
            if (Array.isArray(_data["studentCodes"])) {
                this.studentCodes = [] as any;
                for (let item of _data["studentCodes"])
                    this.studentCodes!.push(StudentCode.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): StudentLearnership {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnership();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generalStudentDocuments)) {
            data["generalStudentDocuments"] = [];
            for (let item of this.generalStudentDocuments)
                data["generalStudentDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipGeneralDocActivityStatus)) {
            data["studentLearnershipGeneralDocActivityStatus"] = [];
            for (let item of this.studentLearnershipGeneralDocActivityStatus)
                data["studentLearnershipGeneralDocActivityStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipAssessmentGuideDocActivityStatus)) {
            data["studentLearnershipAssessmentGuideDocActivityStatus"] = [];
            for (let item of this.studentLearnershipAssessmentGuideDocActivityStatus)
                data["studentLearnershipAssessmentGuideDocActivityStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipFeedbackDocActivityStatus)) {
            data["studentLearnershipFeedbackDocActivityStatus"] = [];
            for (let item of this.studentLearnershipFeedbackDocActivityStatus)
                data["studentLearnershipFeedbackDocActivityStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipWorkplaceDocActivityStatus)) {
            data["studentLearnershipWorkplaceDocActivityStatus"] = [];
            for (let item of this.studentLearnershipWorkplaceDocActivityStatus)
                data["studentLearnershipWorkplaceDocActivityStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipFormativeActivityStatus)) {
            data["studentLearnershipFormativeActivityStatus"] = [];
            for (let item of this.studentLearnershipFormativeActivityStatus)
                data["studentLearnershipFormativeActivityStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipSummativeActivityStatus)) {
            data["studentLearnershipSummativeActivityStatus"] = [];
            for (let item of this.studentLearnershipSummativeActivityStatus)
                data["studentLearnershipSummativeActivityStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipSaqaDocActivityStatus)) {
            data["studentLearnershipSaqaDocActivityStatus"] = [];
            for (let item of this.studentLearnershipSaqaDocActivityStatus)
                data["studentLearnershipSaqaDocActivityStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipGroupGeneralDocActivityStatus)) {
            data["studentLearnershipGroupGeneralDocActivityStatus"] = [];
            for (let item of this.studentLearnershipGroupGeneralDocActivityStatus)
                data["studentLearnershipGroupGeneralDocActivityStatus"].push(item.toJSON());
        }
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["daysAbsent"] = this.daysAbsent;
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        data["dateJoined"] = this.dateJoined ? this.dateJoined.toISOString() : <any>undefined;
        data["dateLeft"] = this.dateLeft ? this.dateLeft.toISOString() : <any>undefined;
        data["reasonLeft"] = this.reasonLeft;
        if (Array.isArray(this.learnershipAttendanceRegisterItems)) {
            data["learnershipAttendanceRegisterItems"] = [];
            for (let item of this.learnershipAttendanceRegisterItems)
                data["learnershipAttendanceRegisterItems"].push(item.toJSON());
        }
        if (Array.isArray(this.studentCodes)) {
            data["studentCodes"] = [];
            for (let item of this.studentCodes)
                data["studentCodes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnership extends IAuditableBaseEntity {
    generalStudentDocuments?: GeneralStudentDocument[] | undefined;
    studentLearnershipGeneralDocActivityStatus?: StudentLearnershipGeneralDocActivityStatus[] | undefined;
    studentLearnershipAssessmentGuideDocActivityStatus?: StudentLearnershipAssessmentGuideDocActivityStatus[] | undefined;
    studentLearnershipFeedbackDocActivityStatus?: StudentLearnershipFeedbackDocActivityStatus[] | undefined;
    studentLearnershipWorkplaceDocActivityStatus?: StudentLearnershipWorkplaceDocActivityStatus[] | undefined;
    studentLearnershipFormativeActivityStatus?: StudentLearnershipFormativeActivityStatus[] | undefined;
    studentLearnershipSummativeActivityStatus?: StudentLearnershipSummativeActivityStatus[] | undefined;
    studentLearnershipSaqaDocActivityStatus?: StudentLearnershipSaqaDocActivityStatus[] | undefined;
    studentLearnershipGroupGeneralDocActivityStatus?: StudentLearnershipGroupGeneralDocActivityStatus[] | undefined;
    studentId?: number;
    student?: Student | undefined;
    daysAbsent?: number;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    dateJoined?: Date;
    dateLeft?: Date | undefined;
    reasonLeft?: string | undefined;
    learnershipAttendanceRegisterItems?: LearnershipAttendanceRegisterItem[] | undefined;
    studentCodes?: StudentCode[] | undefined;
}

export class FileEntity extends AuditableBaseEntity implements IFileEntity {
    filePath?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IFileEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static override fromJS(data: any): FileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FileEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        super.toJSON(data);
        return data;
    }
}

export interface IFileEntity extends IAuditableBaseEntity {
    filePath?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class GeneralStudentDocument extends FileEntity implements IGeneralStudentDocument {
    parentDocId?: number | undefined;
    parentDoc?: GeneralLearnershipDocument | undefined;
    docTypeId?: number;
    docType?: GeneralQualificationAndLearnershipDocumentType | undefined;
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    inputAnswers?: StudentDocInputAnswer[] | undefined;
    annotations?: StudentDocAnnotation[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IGeneralStudentDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? GeneralLearnershipDocument.fromJS(_data["parentDoc"]) : <any>undefined;
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? GeneralQualificationAndLearnershipDocumentType.fromJS(_data["docType"]) : <any>undefined;
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentDocInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentDocAnnotation.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): GeneralStudentDocument {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralStudentDocument();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralStudentDocument extends IFileEntity {
    parentDocId?: number | undefined;
    parentDoc?: GeneralLearnershipDocument | undefined;
    docTypeId?: number;
    docType?: GeneralQualificationAndLearnershipDocumentType | undefined;
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    inputAnswers?: StudentDocInputAnswer[] | undefined;
    annotations?: StudentDocAnnotation[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class GeneralLearnershipDocument extends FileEntity implements IGeneralLearnershipDocument {
    parentDocId?: number | undefined;
    parentDoc?: GeneralQualificationDocument | undefined;
    docTypeId?: number;
    docType?: GeneralQualificationAndLearnershipDocumentType | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    childrenDocs?: GeneralStudentDocument[] | undefined;
    inputs?: ProgrammeDocInput[] | undefined;
    annotations?: ProgrammeDocAnnotation[] | undefined;
    isTemplate?: boolean;

    constructor(data?: IGeneralLearnershipDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? GeneralQualificationDocument.fromJS(_data["parentDoc"]) : <any>undefined;
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? GeneralQualificationAndLearnershipDocumentType.fromJS(_data["docType"]) : <any>undefined;
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(GeneralStudentDocument.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammeDocInput.fromJS(item));
            }
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammeDocAnnotation.fromJS(item));
            }
            this.isTemplate = _data["isTemplate"];
        }
    }

    static override fromJS(data: any): GeneralLearnershipDocument {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralLearnershipDocument();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        data["isTemplate"] = this.isTemplate;
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralLearnershipDocument extends IFileEntity {
    parentDocId?: number | undefined;
    parentDoc?: GeneralQualificationDocument | undefined;
    docTypeId?: number;
    docType?: GeneralQualificationAndLearnershipDocumentType | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    childrenDocs?: GeneralStudentDocument[] | undefined;
    inputs?: ProgrammeDocInput[] | undefined;
    annotations?: ProgrammeDocAnnotation[] | undefined;
    isTemplate?: boolean;
}

export class GeneralQualificationDocument extends FileEntity implements IGeneralQualificationDocument {
    docTypeId?: number;
    docType?: GeneralQualificationAndLearnershipDocumentType | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    childrenDocs?: GeneralLearnershipDocument[] | undefined;
    inputs?: QualificationDocInput[] | undefined;
    isTemplate?: boolean;

    constructor(data?: IGeneralQualificationDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? GeneralQualificationAndLearnershipDocumentType.fromJS(_data["docType"]) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(GeneralLearnershipDocument.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualificationDocInput.fromJS(item));
            }
            this.isTemplate = _data["isTemplate"];
        }
    }

    static override fromJS(data: any): GeneralQualificationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralQualificationDocument();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        data["isTemplate"] = this.isTemplate;
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralQualificationDocument extends IFileEntity {
    docTypeId?: number;
    docType?: GeneralQualificationAndLearnershipDocumentType | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    childrenDocs?: GeneralLearnershipDocument[] | undefined;
    inputs?: QualificationDocInput[] | undefined;
    isTemplate?: boolean;
}

export class DocumentTypeEntity extends AuditableBaseEntity implements IDocumentTypeEntity {
    documentType?: string | undefined;
    multipleAllowed?: boolean;

    constructor(data?: IDocumentTypeEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentType = _data["documentType"];
            this.multipleAllowed = _data["multipleAllowed"];
        }
    }

    static override fromJS(data: any): DocumentTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["multipleAllowed"] = this.multipleAllowed;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentTypeEntity extends IAuditableBaseEntity {
    documentType?: string | undefined;
    multipleAllowed?: boolean;
}

export class GeneralQualificationAndLearnershipDocumentType extends DocumentTypeEntity implements IGeneralQualificationAndLearnershipDocumentType {
    generalQualificationDocuments?: GeneralQualificationDocument[] | undefined;
    generalLearnershipDocuments?: GeneralLearnershipDocument[] | undefined;
    generalStudentDocuments?: GeneralStudentDocument[] | undefined;

    constructor(data?: IGeneralQualificationAndLearnershipDocumentType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["generalQualificationDocuments"])) {
                this.generalQualificationDocuments = [] as any;
                for (let item of _data["generalQualificationDocuments"])
                    this.generalQualificationDocuments!.push(GeneralQualificationDocument.fromJS(item));
            }
            if (Array.isArray(_data["generalLearnershipDocuments"])) {
                this.generalLearnershipDocuments = [] as any;
                for (let item of _data["generalLearnershipDocuments"])
                    this.generalLearnershipDocuments!.push(GeneralLearnershipDocument.fromJS(item));
            }
            if (Array.isArray(_data["generalStudentDocuments"])) {
                this.generalStudentDocuments = [] as any;
                for (let item of _data["generalStudentDocuments"])
                    this.generalStudentDocuments!.push(GeneralStudentDocument.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GeneralQualificationAndLearnershipDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralQualificationAndLearnershipDocumentType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generalQualificationDocuments)) {
            data["generalQualificationDocuments"] = [];
            for (let item of this.generalQualificationDocuments)
                data["generalQualificationDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.generalLearnershipDocuments)) {
            data["generalLearnershipDocuments"] = [];
            for (let item of this.generalLearnershipDocuments)
                data["generalLearnershipDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.generalStudentDocuments)) {
            data["generalStudentDocuments"] = [];
            for (let item of this.generalStudentDocuments)
                data["generalStudentDocuments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralQualificationAndLearnershipDocumentType extends IDocumentTypeEntity {
    generalQualificationDocuments?: GeneralQualificationDocument[] | undefined;
    generalLearnershipDocuments?: GeneralLearnershipDocument[] | undefined;
    generalStudentDocuments?: GeneralStudentDocument[] | undefined;
}

export class Qualification extends AuditableBaseEntity implements IQualification {
    type?: QualificationType;
    saqaId?: number;
    title?: string | undefined;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    unitStandards?: UnitStandard[] | undefined;
    setaQualificationDetails?: SetaQualificationDetails | undefined;
    knowledgeModules?: KnowledgeModule[] | undefined;
    learnerships?: Learnership[] | undefined;
    qualPOE?: QualPOE | undefined;
    programmePOEs?: ProgrammePOE[] | undefined;
    studentPOEs?: StudentPOE[] | undefined;
    qualModeratorFile?: QualModeratorFile | undefined;
    programmeModeratorFiles?: ProgrammeModeratorFile[] | undefined;
    qualAssessorFile?: QualAssessorFile | undefined;
    programmeAssessorFiles?: ProgrammeAssessorFile[] | undefined;
    generalDocuments?: GeneralQualificationDocument[] | undefined;
    learningMaterial?: QualificationLearningMaterial[] | undefined;

    constructor(data?: IQualification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.saqaId = _data["saqaId"];
            this.title = _data["title"];
            this.purpose = _data["purpose"];
            this.nqfLevel = _data["nqfLevel"];
            this.minimumCredits = _data["minimumCredits"];
            if (Array.isArray(_data["unitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["unitStandards"])
                    this.unitStandards!.push(UnitStandard.fromJS(item));
            }
            this.setaQualificationDetails = _data["setaQualificationDetails"] ? SetaQualificationDetails.fromJS(_data["setaQualificationDetails"]) : <any>undefined;
            if (Array.isArray(_data["knowledgeModules"])) {
                this.knowledgeModules = [] as any;
                for (let item of _data["knowledgeModules"])
                    this.knowledgeModules!.push(KnowledgeModule.fromJS(item));
            }
            if (Array.isArray(_data["learnerships"])) {
                this.learnerships = [] as any;
                for (let item of _data["learnerships"])
                    this.learnerships!.push(Learnership.fromJS(item));
            }
            this.qualPOE = _data["qualPOE"] ? QualPOE.fromJS(_data["qualPOE"]) : <any>undefined;
            if (Array.isArray(_data["programmePOEs"])) {
                this.programmePOEs = [] as any;
                for (let item of _data["programmePOEs"])
                    this.programmePOEs!.push(ProgrammePOE.fromJS(item));
            }
            if (Array.isArray(_data["studentPOEs"])) {
                this.studentPOEs = [] as any;
                for (let item of _data["studentPOEs"])
                    this.studentPOEs!.push(StudentPOE.fromJS(item));
            }
            this.qualModeratorFile = _data["qualModeratorFile"] ? QualModeratorFile.fromJS(_data["qualModeratorFile"]) : <any>undefined;
            if (Array.isArray(_data["programmeModeratorFiles"])) {
                this.programmeModeratorFiles = [] as any;
                for (let item of _data["programmeModeratorFiles"])
                    this.programmeModeratorFiles!.push(ProgrammeModeratorFile.fromJS(item));
            }
            this.qualAssessorFile = _data["qualAssessorFile"] ? QualAssessorFile.fromJS(_data["qualAssessorFile"]) : <any>undefined;
            if (Array.isArray(_data["programmeAssessorFiles"])) {
                this.programmeAssessorFiles = [] as any;
                for (let item of _data["programmeAssessorFiles"])
                    this.programmeAssessorFiles!.push(ProgrammeAssessorFile.fromJS(item));
            }
            if (Array.isArray(_data["generalDocuments"])) {
                this.generalDocuments = [] as any;
                for (let item of _data["generalDocuments"])
                    this.generalDocuments!.push(GeneralQualificationDocument.fromJS(item));
            }
            if (Array.isArray(_data["learningMaterial"])) {
                this.learningMaterial = [] as any;
                for (let item of _data["learningMaterial"])
                    this.learningMaterial!.push(QualificationLearningMaterial.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Qualification {
        data = typeof data === 'object' ? data : {};
        let result = new Qualification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["saqaId"] = this.saqaId;
        data["title"] = this.title;
        data["purpose"] = this.purpose;
        data["nqfLevel"] = this.nqfLevel;
        data["minimumCredits"] = this.minimumCredits;
        if (Array.isArray(this.unitStandards)) {
            data["unitStandards"] = [];
            for (let item of this.unitStandards)
                data["unitStandards"].push(item.toJSON());
        }
        data["setaQualificationDetails"] = this.setaQualificationDetails ? this.setaQualificationDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.knowledgeModules)) {
            data["knowledgeModules"] = [];
            for (let item of this.knowledgeModules)
                data["knowledgeModules"].push(item.toJSON());
        }
        if (Array.isArray(this.learnerships)) {
            data["learnerships"] = [];
            for (let item of this.learnerships)
                data["learnerships"].push(item.toJSON());
        }
        data["qualPOE"] = this.qualPOE ? this.qualPOE.toJSON() : <any>undefined;
        if (Array.isArray(this.programmePOEs)) {
            data["programmePOEs"] = [];
            for (let item of this.programmePOEs)
                data["programmePOEs"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOEs)) {
            data["studentPOEs"] = [];
            for (let item of this.studentPOEs)
                data["studentPOEs"].push(item.toJSON());
        }
        data["qualModeratorFile"] = this.qualModeratorFile ? this.qualModeratorFile.toJSON() : <any>undefined;
        if (Array.isArray(this.programmeModeratorFiles)) {
            data["programmeModeratorFiles"] = [];
            for (let item of this.programmeModeratorFiles)
                data["programmeModeratorFiles"].push(item.toJSON());
        }
        data["qualAssessorFile"] = this.qualAssessorFile ? this.qualAssessorFile.toJSON() : <any>undefined;
        if (Array.isArray(this.programmeAssessorFiles)) {
            data["programmeAssessorFiles"] = [];
            for (let item of this.programmeAssessorFiles)
                data["programmeAssessorFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocuments)) {
            data["generalDocuments"] = [];
            for (let item of this.generalDocuments)
                data["generalDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.learningMaterial)) {
            data["learningMaterial"] = [];
            for (let item of this.learningMaterial)
                data["learningMaterial"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualification extends IAuditableBaseEntity {
    type?: QualificationType;
    saqaId?: number;
    title?: string | undefined;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    unitStandards?: UnitStandard[] | undefined;
    setaQualificationDetails?: SetaQualificationDetails | undefined;
    knowledgeModules?: KnowledgeModule[] | undefined;
    learnerships?: Learnership[] | undefined;
    qualPOE?: QualPOE | undefined;
    programmePOEs?: ProgrammePOE[] | undefined;
    studentPOEs?: StudentPOE[] | undefined;
    qualModeratorFile?: QualModeratorFile | undefined;
    programmeModeratorFiles?: ProgrammeModeratorFile[] | undefined;
    qualAssessorFile?: QualAssessorFile | undefined;
    programmeAssessorFiles?: ProgrammeAssessorFile[] | undefined;
    generalDocuments?: GeneralQualificationDocument[] | undefined;
    learningMaterial?: QualificationLearningMaterial[] | undefined;
}

export enum QualificationType {
    Seta = 0,
    Qcto = 1,
}

export class UnitStandard extends AuditableBaseEntity implements IUnitStandard {
    type?: UnitStandardType;
    unitStandardNumber?: number;
    prevUnitStandardNumber?: number | undefined;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
    qualPOESaqaDocs?: QualPOESaqaDoc[] | undefined;
    qualGroups?: QualPOEGroupUnitStandards[] | undefined;
    programmePOESaqaDocs?: ProgrammePOESaqaDoc[] | undefined;
    programmeGroups?: ProgrammePOEGroupUnitStandards[] | undefined;
    studentPOESaqaDocs?: StudentPOESaqaDoc[] | undefined;
    studentGroups?: StudentPOEGroupUnitStandards[] | undefined;
    customElectives?: CustomElective[] | undefined;
    learningMaterial?: QualificationLearningMaterial[] | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;

    constructor(data?: IUnitStandard) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.unitStandardNumber = _data["unitStandardNumber"];
            this.prevUnitStandardNumber = _data["prevUnitStandardNumber"];
            this.title = _data["title"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
            if (Array.isArray(_data["qualPOESaqaDocs"])) {
                this.qualPOESaqaDocs = [] as any;
                for (let item of _data["qualPOESaqaDocs"])
                    this.qualPOESaqaDocs!.push(QualPOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["qualGroups"])) {
                this.qualGroups = [] as any;
                for (let item of _data["qualGroups"])
                    this.qualGroups!.push(QualPOEGroupUnitStandards.fromJS(item));
            }
            if (Array.isArray(_data["programmePOESaqaDocs"])) {
                this.programmePOESaqaDocs = [] as any;
                for (let item of _data["programmePOESaqaDocs"])
                    this.programmePOESaqaDocs!.push(ProgrammePOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["programmeGroups"])) {
                this.programmeGroups = [] as any;
                for (let item of _data["programmeGroups"])
                    this.programmeGroups!.push(ProgrammePOEGroupUnitStandards.fromJS(item));
            }
            if (Array.isArray(_data["studentPOESaqaDocs"])) {
                this.studentPOESaqaDocs = [] as any;
                for (let item of _data["studentPOESaqaDocs"])
                    this.studentPOESaqaDocs!.push(StudentPOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["studentGroups"])) {
                this.studentGroups = [] as any;
                for (let item of _data["studentGroups"])
                    this.studentGroups!.push(StudentPOEGroupUnitStandards.fromJS(item));
            }
            if (Array.isArray(_data["customElectives"])) {
                this.customElectives = [] as any;
                for (let item of _data["customElectives"])
                    this.customElectives!.push(CustomElective.fromJS(item));
            }
            if (Array.isArray(_data["learningMaterial"])) {
                this.learningMaterial = [] as any;
                for (let item of _data["learningMaterial"])
                    this.learningMaterial!.push(QualificationLearningMaterial.fromJS(item));
            }
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UnitStandard {
        data = typeof data === 'object' ? data : {};
        let result = new UnitStandard();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["unitStandardNumber"] = this.unitStandardNumber;
        data["prevUnitStandardNumber"] = this.prevUnitStandardNumber;
        data["title"] = this.title;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        if (Array.isArray(this.qualPOESaqaDocs)) {
            data["qualPOESaqaDocs"] = [];
            for (let item of this.qualPOESaqaDocs)
                data["qualPOESaqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.qualGroups)) {
            data["qualGroups"] = [];
            for (let item of this.qualGroups)
                data["qualGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOESaqaDocs)) {
            data["programmePOESaqaDocs"] = [];
            for (let item of this.programmePOESaqaDocs)
                data["programmePOESaqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.programmeGroups)) {
            data["programmeGroups"] = [];
            for (let item of this.programmeGroups)
                data["programmeGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOESaqaDocs)) {
            data["studentPOESaqaDocs"] = [];
            for (let item of this.studentPOESaqaDocs)
                data["studentPOESaqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.studentGroups)) {
            data["studentGroups"] = [];
            for (let item of this.studentGroups)
                data["studentGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.customElectives)) {
            data["customElectives"] = [];
            for (let item of this.customElectives)
                data["customElectives"].push(item.toJSON());
        }
        if (Array.isArray(this.learningMaterial)) {
            data["learningMaterial"] = [];
            for (let item of this.learningMaterial)
                data["learningMaterial"].push(item.toJSON());
        }
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitStandard extends IAuditableBaseEntity {
    type?: UnitStandardType;
    unitStandardNumber?: number;
    prevUnitStandardNumber?: number | undefined;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
    qualPOESaqaDocs?: QualPOESaqaDoc[] | undefined;
    qualGroups?: QualPOEGroupUnitStandards[] | undefined;
    programmePOESaqaDocs?: ProgrammePOESaqaDoc[] | undefined;
    programmeGroups?: ProgrammePOEGroupUnitStandards[] | undefined;
    studentPOESaqaDocs?: StudentPOESaqaDoc[] | undefined;
    studentGroups?: StudentPOEGroupUnitStandards[] | undefined;
    customElectives?: CustomElective[] | undefined;
    learningMaterial?: QualificationLearningMaterial[] | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
}

export enum UnitStandardType {
    Core = 0,
    Elective = 1,
    Fundamental = 2,
}

export abstract class POEDocumentEntity extends FileEntity implements IPOEDocumentEntity {
    poeId?: number | undefined;
    docTypeId?: number | undefined;
    docType?: POEDocumentType | undefined;

    constructor(data?: IPOEDocumentEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeId = _data["poeId"];
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? POEDocumentType.fromJS(_data["docType"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEDocumentEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'POEDocumentEntity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeId"] = this.poeId;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEDocumentEntity extends IFileEntity {
    poeId?: number | undefined;
    docTypeId?: number | undefined;
    docType?: POEDocumentType | undefined;
}

export abstract class POEGroupDocumentEntityOfQualPOEGroup extends POEDocumentEntity implements IPOEGroupDocumentEntityOfQualPOEGroup {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;

    constructor(data?: IPOEGroupDocumentEntityOfQualPOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? QualPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupDocumentEntityOfQualPOEGroup {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'POEGroupDocumentEntityOfQualPOEGroup' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupDocumentEntityOfQualPOEGroup extends IPOEDocumentEntity {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
}

export class QualPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends POEGroupDocumentEntityOfQualPOEGroup implements IQualPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    childrenDocs?: ProgrammePOESaqaDoc[] | undefined;
    inputs?: QualPOESaqaDocInput[] | undefined;
    activities?: QualPOESaqaDocActivity[] | undefined;

    constructor(data?: IQualPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(ProgrammePOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualPOESaqaDocInput.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(QualPOESaqaDocActivity.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IPOEGroupDocumentEntityOfQualPOEGroup {
    childrenDocs?: ProgrammePOESaqaDoc[] | undefined;
    inputs?: QualPOESaqaDocInput[] | undefined;
    activities?: QualPOESaqaDocActivity[] | undefined;
}

export class QualPOESaqaDoc extends QualPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IQualPOESaqaDoc {
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;

    constructor(data?: IQualPOESaqaDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unitStandardId = _data["unitStandardId"];
            this.unitStandard = _data["unitStandard"] ? UnitStandard.fromJS(_data["unitStandard"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualPOESaqaDoc {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESaqaDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitStandardId"] = this.unitStandardId;
        data["unitStandard"] = this.unitStandard ? this.unitStandard.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESaqaDoc extends IQualPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;
}

export abstract class POEGroupDocumentEntityOfProgrammePOEGroup extends POEDocumentEntity implements IPOEGroupDocumentEntityOfProgrammePOEGroup {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;

    constructor(data?: IPOEGroupDocumentEntityOfProgrammePOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? ProgrammePOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupDocumentEntityOfProgrammePOEGroup {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'POEGroupDocumentEntityOfProgrammePOEGroup' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupDocumentEntityOfProgrammePOEGroup extends IPOEDocumentEntity {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
}

export class ProgrammePOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends POEGroupDocumentEntityOfProgrammePOEGroup implements IProgrammePOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    parentDocId?: number | undefined;
    parentDoc?: QualPOESaqaDoc | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    annotations?: ProgrammePOEGroupSaqaDocAnnotation[] | undefined;
    childrenDocs?: StudentPOESaqaDoc[] | undefined;
    inputs?: ProgrammePOESaqaDocInput[] | undefined;

    constructor(data?: IProgrammePOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? QualPOESaqaDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEGroupSaqaDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammePOESaqaDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IPOEGroupDocumentEntityOfProgrammePOEGroup {
    parentDocId?: number | undefined;
    parentDoc?: QualPOESaqaDoc | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    annotations?: ProgrammePOEGroupSaqaDocAnnotation[] | undefined;
    childrenDocs?: StudentPOESaqaDoc[] | undefined;
    inputs?: ProgrammePOESaqaDocInput[] | undefined;
}

export class ProgrammePOESaqaDoc extends ProgrammePOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IProgrammePOESaqaDoc {
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;

    constructor(data?: IProgrammePOESaqaDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unitStandardId = _data["unitStandardId"];
            this.unitStandard = _data["unitStandard"] ? UnitStandard.fromJS(_data["unitStandard"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammePOESaqaDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOESaqaDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitStandardId"] = this.unitStandardId;
        data["unitStandard"] = this.unitStandard ? this.unitStandard.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOESaqaDoc extends IProgrammePOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;
}

export class PageAndPosition extends AuditableBaseEntity implements IPageAndPosition {
    page?: number;
    height?: number;
    width?: number;
    left?: number;
    top?: number;
    heightPercentage?: number;
    widthPercentage?: number;
    xPercentage?: number;
    yPercentage?: number;

    constructor(data?: IPageAndPosition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.left = _data["left"];
            this.top = _data["top"];
            this.heightPercentage = _data["heightPercentage"];
            this.widthPercentage = _data["widthPercentage"];
            this.xPercentage = _data["xPercentage"];
            this.yPercentage = _data["yPercentage"];
        }
    }

    static override fromJS(data: any): PageAndPosition {
        data = typeof data === 'object' ? data : {};
        let result = new PageAndPosition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["height"] = this.height;
        data["width"] = this.width;
        data["left"] = this.left;
        data["top"] = this.top;
        data["heightPercentage"] = this.heightPercentage;
        data["widthPercentage"] = this.widthPercentage;
        data["xPercentage"] = this.xPercentage;
        data["yPercentage"] = this.yPercentage;
        super.toJSON(data);
        return data;
    }
}

export interface IPageAndPosition extends IAuditableBaseEntity {
    page?: number;
    height?: number;
    width?: number;
    left?: number;
    top?: number;
    heightPercentage?: number;
    widthPercentage?: number;
    xPercentage?: number;
    yPercentage?: number;
}

export class Annotation extends PageAndPosition implements IAnnotation {
    ownerId?: number;
    src?: string | undefined;
    staffType?: StaffTypes | undefined;
    type?: AnnotationTypes;
    initialsType?: InitialsTypes | undefined;

    constructor(data?: IAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.src = _data["src"];
            this.staffType = _data["staffType"];
            this.type = _data["type"];
            this.initialsType = _data["initialsType"];
        }
    }

    static override fromJS(data: any): Annotation {
        data = typeof data === 'object' ? data : {};
        let result = new Annotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["src"] = this.src;
        data["staffType"] = this.staffType;
        data["type"] = this.type;
        data["initialsType"] = this.initialsType;
        super.toJSON(data);
        return data;
    }
}

export interface IAnnotation extends IPageAndPosition {
    ownerId?: number;
    src?: string | undefined;
    staffType?: StaffTypes | undefined;
    type?: AnnotationTypes;
    initialsType?: InitialsTypes | undefined;
}

export class POEAnnotationOfProgrammePOE extends Annotation implements IPOEAnnotationOfProgrammePOE {
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEAnnotationOfProgrammePOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEAnnotationOfProgrammePOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEAnnotationOfProgrammePOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEAnnotationOfProgrammePOE extends IAnnotation {
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends POEAnnotationOfProgrammePOE implements IProgrammePOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    programmePOEGroupDocId?: number;
    programmePOEGroupDoc?: ProgrammePOESaqaDoc | undefined;
    childrenAnnotations?: StudentPOEGroupSaqaDocAnnotation[] | undefined;

    constructor(data?: IProgrammePOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEGroupId = _data["programmePOEGroupId"];
            this.programmePOEGroup = _data["programmePOEGroup"] ? ProgrammePOEGroup.fromJS(_data["programmePOEGroup"]) : <any>undefined;
            this.programmePOEGroupDocId = _data["programmePOEGroupDocId"];
            this.programmePOEGroupDoc = _data["programmePOEGroupDoc"] ? ProgrammePOESaqaDoc.fromJS(_data["programmePOEGroupDoc"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEGroupSaqaDocAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEGroupId"] = this.programmePOEGroupId;
        data["programmePOEGroup"] = this.programmePOEGroup ? this.programmePOEGroup.toJSON() : <any>undefined;
        data["programmePOEGroupDocId"] = this.programmePOEGroupDocId;
        data["programmePOEGroupDoc"] = this.programmePOEGroupDoc ? this.programmePOEGroupDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IPOEAnnotationOfProgrammePOE {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    programmePOEGroupDocId?: number;
    programmePOEGroupDoc?: ProgrammePOESaqaDoc | undefined;
    childrenAnnotations?: StudentPOEGroupSaqaDocAnnotation[] | undefined;
}

export class ProgrammePOEGroupSaqaDocAnnotation extends ProgrammePOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IProgrammePOEGroupSaqaDocAnnotation {

    constructor(data?: IProgrammePOEGroupSaqaDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGroupSaqaDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupSaqaDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupSaqaDocAnnotation extends IProgrammePOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export abstract class ProgrammePOEGroupEntityOfProgrammePOEGroupAndProgrammePOEAndProgrammePOEFormativeAssessmentAndProgrammePOESummativeAssessmentAndProgrammePOEGroupDocAndProgrammePOESaqaDocAndProgrammePOEFeedbackDocAndProgrammePOEGroupUnitStandardsAndProgrammePOEGroupKnowledgeModules extends AuditableBaseEntity implements IProgrammePOEGroupEntityOfProgrammePOEGroupAndProgrammePOEAndProgrammePOEFormativeAssessmentAndProgrammePOESummativeAssessmentAndProgrammePOEGroupDocAndProgrammePOESaqaDocAndProgrammePOEFeedbackDocAndProgrammePOEGroupUnitStandardsAndProgrammePOEGroupKnowledgeModules {
    name?: string | undefined;
    index?: number;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
    moduleType?: KnowledgeModuleType | undefined;
    formativeAssessments?: ProgrammePOEFormativeAssessment[] | undefined;
    summativeAssessments?: ProgrammePOESummativeAssessment[] | undefined;
    documents?: ProgrammePOEGroupDoc[] | undefined;
    saqaDocs?: ProgrammePOESaqaDoc[] | undefined;
    feedbackDocs?: ProgrammePOEFeedbackDoc[] | undefined;
    unitStandards?: ProgrammePOEGroupUnitStandards[] | undefined;
    knowledgeModules?: ProgrammePOEGroupKnowledgeModules[] | undefined;

    constructor(data?: IProgrammePOEGroupEntityOfProgrammePOEGroupAndProgrammePOEAndProgrammePOEFormativeAssessmentAndProgrammePOESummativeAssessmentAndProgrammePOEGroupDocAndProgrammePOESaqaDocAndProgrammePOEFeedbackDocAndProgrammePOEGroupUnitStandardsAndProgrammePOEGroupKnowledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.index = _data["index"];
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
            this.moduleType = _data["moduleType"];
            if (Array.isArray(_data["formativeAssessments"])) {
                this.formativeAssessments = [] as any;
                for (let item of _data["formativeAssessments"])
                    this.formativeAssessments!.push(ProgrammePOEFormativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessments"])) {
                this.summativeAssessments = [] as any;
                for (let item of _data["summativeAssessments"])
                    this.summativeAssessments!.push(ProgrammePOESummativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ProgrammePOEGroupDoc.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocs"])) {
                this.saqaDocs = [] as any;
                for (let item of _data["saqaDocs"])
                    this.saqaDocs!.push(ProgrammePOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(ProgrammePOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["unitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["unitStandards"])
                    this.unitStandards!.push(ProgrammePOEGroupUnitStandards.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeModules"])) {
                this.knowledgeModules = [] as any;
                for (let item of _data["knowledgeModules"])
                    this.knowledgeModules!.push(ProgrammePOEGroupKnowledgeModules.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupEntityOfProgrammePOEGroupAndProgrammePOEAndProgrammePOEFormativeAssessmentAndProgrammePOESummativeAssessmentAndProgrammePOEGroupDocAndProgrammePOESaqaDocAndProgrammePOEFeedbackDocAndProgrammePOEGroupUnitStandardsAndProgrammePOEGroupKnowledgeModules {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ProgrammePOEGroupEntityOfProgrammePOEGroupAndProgrammePOEAndProgrammePOEFormativeAssessmentAndProgrammePOESummativeAssessmentAndProgrammePOEGroupDocAndProgrammePOESaqaDocAndProgrammePOEFeedbackDocAndProgrammePOEGroupUnitStandardsAndProgrammePOEGroupKnowledgeModules' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["index"] = this.index;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        data["moduleType"] = this.moduleType;
        if (Array.isArray(this.formativeAssessments)) {
            data["formativeAssessments"] = [];
            for (let item of this.formativeAssessments)
                data["formativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessments)) {
            data["summativeAssessments"] = [];
            for (let item of this.summativeAssessments)
                data["summativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocs)) {
            data["saqaDocs"] = [];
            for (let item of this.saqaDocs)
                data["saqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandards)) {
            data["unitStandards"] = [];
            for (let item of this.unitStandards)
                data["unitStandards"].push(item.toJSON());
        }
        if (Array.isArray(this.knowledgeModules)) {
            data["knowledgeModules"] = [];
            for (let item of this.knowledgeModules)
                data["knowledgeModules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupEntityOfProgrammePOEGroupAndProgrammePOEAndProgrammePOEFormativeAssessmentAndProgrammePOESummativeAssessmentAndProgrammePOEGroupDocAndProgrammePOESaqaDocAndProgrammePOEFeedbackDocAndProgrammePOEGroupUnitStandardsAndProgrammePOEGroupKnowledgeModules extends IAuditableBaseEntity {
    name?: string | undefined;
    index?: number;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
    moduleType?: KnowledgeModuleType | undefined;
    formativeAssessments?: ProgrammePOEFormativeAssessment[] | undefined;
    summativeAssessments?: ProgrammePOESummativeAssessment[] | undefined;
    documents?: ProgrammePOEGroupDoc[] | undefined;
    saqaDocs?: ProgrammePOESaqaDoc[] | undefined;
    feedbackDocs?: ProgrammePOEFeedbackDoc[] | undefined;
    unitStandards?: ProgrammePOEGroupUnitStandards[] | undefined;
    knowledgeModules?: ProgrammePOEGroupKnowledgeModules[] | undefined;
}

export class ProgrammePOEGroup extends ProgrammePOEGroupEntityOfProgrammePOEGroupAndProgrammePOEAndProgrammePOEFormativeAssessmentAndProgrammePOESummativeAssessmentAndProgrammePOEGroupDocAndProgrammePOESaqaDocAndProgrammePOEFeedbackDocAndProgrammePOEGroupUnitStandardsAndProgrammePOEGroupKnowledgeModules implements IProgrammePOEGroup {
    childrenGroups?: StudentPOEGroup[] | undefined;
    events?: ProgrammePOEScheduleEvent[] | undefined;
    formativeAssessmentAnnotations?: ProgrammePOEGroupFormativeAssessmentAnnotation[] | undefined;
    summativeAssessmentAnnotations?: ProgrammePOEGroupSummativeAssessmentAnnotation[] | undefined;
    groupDocAnnotations?: ProgrammePOEGroupDocAnnotation[] | undefined;
    saqaDocAnnotations?: ProgrammePOEGroupSaqaDocAnnotation[] | undefined;
    formativeAssessmentInputs?: ProgrammePOEFormativeAssessmentInput[] | undefined;
    summativeAssessmentInputs?: ProgrammePOESummativeAssessmentInput[] | undefined;
    groupDocInputs?: ProgrammePOEGroupGeneralDocInput[] | undefined;
    saqaDocInputs?: ProgrammePOESaqaDocInput[] | undefined;
    parentGroupId?: number;
    qualPOEGroup?: QualPOEGroup | undefined;

    constructor(data?: IProgrammePOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["childrenGroups"])) {
                this.childrenGroups = [] as any;
                for (let item of _data["childrenGroups"])
                    this.childrenGroups!.push(StudentPOEGroup.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(ProgrammePOEScheduleEvent.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentAnnotations"])) {
                this.formativeAssessmentAnnotations = [] as any;
                for (let item of _data["formativeAssessmentAnnotations"])
                    this.formativeAssessmentAnnotations!.push(ProgrammePOEGroupFormativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentAnnotations"])) {
                this.summativeAssessmentAnnotations = [] as any;
                for (let item of _data["summativeAssessmentAnnotations"])
                    this.summativeAssessmentAnnotations!.push(ProgrammePOEGroupSummativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["groupDocAnnotations"])) {
                this.groupDocAnnotations = [] as any;
                for (let item of _data["groupDocAnnotations"])
                    this.groupDocAnnotations!.push(ProgrammePOEGroupDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocAnnotations"])) {
                this.saqaDocAnnotations = [] as any;
                for (let item of _data["saqaDocAnnotations"])
                    this.saqaDocAnnotations!.push(ProgrammePOEGroupSaqaDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentInputs"])) {
                this.formativeAssessmentInputs = [] as any;
                for (let item of _data["formativeAssessmentInputs"])
                    this.formativeAssessmentInputs!.push(ProgrammePOEFormativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentInputs"])) {
                this.summativeAssessmentInputs = [] as any;
                for (let item of _data["summativeAssessmentInputs"])
                    this.summativeAssessmentInputs!.push(ProgrammePOESummativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["groupDocInputs"])) {
                this.groupDocInputs = [] as any;
                for (let item of _data["groupDocInputs"])
                    this.groupDocInputs!.push(ProgrammePOEGroupGeneralDocInput.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocInputs"])) {
                this.saqaDocInputs = [] as any;
                for (let item of _data["saqaDocInputs"])
                    this.saqaDocInputs!.push(ProgrammePOESaqaDocInput.fromJS(item));
            }
            this.parentGroupId = _data["parentGroupId"];
            this.qualPOEGroup = _data["qualPOEGroup"] ? QualPOEGroup.fromJS(_data["qualPOEGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammePOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.childrenGroups)) {
            data["childrenGroups"] = [];
            for (let item of this.childrenGroups)
                data["childrenGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentAnnotations)) {
            data["formativeAssessmentAnnotations"] = [];
            for (let item of this.formativeAssessmentAnnotations)
                data["formativeAssessmentAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentAnnotations)) {
            data["summativeAssessmentAnnotations"] = [];
            for (let item of this.summativeAssessmentAnnotations)
                data["summativeAssessmentAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocAnnotations)) {
            data["groupDocAnnotations"] = [];
            for (let item of this.groupDocAnnotations)
                data["groupDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocAnnotations)) {
            data["saqaDocAnnotations"] = [];
            for (let item of this.saqaDocAnnotations)
                data["saqaDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentInputs)) {
            data["formativeAssessmentInputs"] = [];
            for (let item of this.formativeAssessmentInputs)
                data["formativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentInputs)) {
            data["summativeAssessmentInputs"] = [];
            for (let item of this.summativeAssessmentInputs)
                data["summativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocInputs)) {
            data["groupDocInputs"] = [];
            for (let item of this.groupDocInputs)
                data["groupDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocInputs)) {
            data["saqaDocInputs"] = [];
            for (let item of this.saqaDocInputs)
                data["saqaDocInputs"].push(item.toJSON());
        }
        data["parentGroupId"] = this.parentGroupId;
        data["qualPOEGroup"] = this.qualPOEGroup ? this.qualPOEGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroup extends IProgrammePOEGroupEntityOfProgrammePOEGroupAndProgrammePOEAndProgrammePOEFormativeAssessmentAndProgrammePOESummativeAssessmentAndProgrammePOEGroupDocAndProgrammePOESaqaDocAndProgrammePOEFeedbackDocAndProgrammePOEGroupUnitStandardsAndProgrammePOEGroupKnowledgeModules {
    childrenGroups?: StudentPOEGroup[] | undefined;
    events?: ProgrammePOEScheduleEvent[] | undefined;
    formativeAssessmentAnnotations?: ProgrammePOEGroupFormativeAssessmentAnnotation[] | undefined;
    summativeAssessmentAnnotations?: ProgrammePOEGroupSummativeAssessmentAnnotation[] | undefined;
    groupDocAnnotations?: ProgrammePOEGroupDocAnnotation[] | undefined;
    saqaDocAnnotations?: ProgrammePOEGroupSaqaDocAnnotation[] | undefined;
    formativeAssessmentInputs?: ProgrammePOEFormativeAssessmentInput[] | undefined;
    summativeAssessmentInputs?: ProgrammePOESummativeAssessmentInput[] | undefined;
    groupDocInputs?: ProgrammePOEGroupGeneralDocInput[] | undefined;
    saqaDocInputs?: ProgrammePOESaqaDocInput[] | undefined;
    parentGroupId?: number;
    qualPOEGroup?: QualPOEGroup | undefined;
}

export abstract class StudentPOEGroupEntityOfStudentPOEGroupAndStudentPOEAndStudentPOEFormativeAssessmentAndStudentPOESummativeAssessmentAndStudentPOEGroupDocAndStudentPOESaqaDocAndStudentPOEFeedbackDocAndStudentPOEGroupUnitStandardsAndStudentPOEGroupKnowledgeModules extends AuditableBaseEntity implements IStudentPOEGroupEntityOfStudentPOEGroupAndStudentPOEAndStudentPOEFormativeAssessmentAndStudentPOESummativeAssessmentAndStudentPOEGroupDocAndStudentPOESaqaDocAndStudentPOEFeedbackDocAndStudentPOEGroupUnitStandardsAndStudentPOEGroupKnowledgeModules {
    name?: string | undefined;
    index?: number;
    poeId?: number;
    poe?: StudentPOE | undefined;
    moduleType?: KnowledgeModuleType | undefined;
    formativeAssessments?: StudentPOEFormativeAssessment[] | undefined;
    summativeAssessments?: StudentPOESummativeAssessment[] | undefined;
    documents?: StudentPOEGroupDoc[] | undefined;
    saqaDocs?: StudentPOESaqaDoc[] | undefined;
    feedbackDocs?: StudentPOEFeedbackDoc[] | undefined;
    unitStandards?: StudentPOEGroupUnitStandards[] | undefined;
    knowledgeModules?: StudentPOEGroupKnowledgeModules[] | undefined;

    constructor(data?: IStudentPOEGroupEntityOfStudentPOEGroupAndStudentPOEAndStudentPOEFormativeAssessmentAndStudentPOESummativeAssessmentAndStudentPOEGroupDocAndStudentPOESaqaDocAndStudentPOEFeedbackDocAndStudentPOEGroupUnitStandardsAndStudentPOEGroupKnowledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.index = _data["index"];
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? StudentPOE.fromJS(_data["poe"]) : <any>undefined;
            this.moduleType = _data["moduleType"];
            if (Array.isArray(_data["formativeAssessments"])) {
                this.formativeAssessments = [] as any;
                for (let item of _data["formativeAssessments"])
                    this.formativeAssessments!.push(StudentPOEFormativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessments"])) {
                this.summativeAssessments = [] as any;
                for (let item of _data["summativeAssessments"])
                    this.summativeAssessments!.push(StudentPOESummativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(StudentPOEGroupDoc.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocs"])) {
                this.saqaDocs = [] as any;
                for (let item of _data["saqaDocs"])
                    this.saqaDocs!.push(StudentPOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(StudentPOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["unitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["unitStandards"])
                    this.unitStandards!.push(StudentPOEGroupUnitStandards.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeModules"])) {
                this.knowledgeModules = [] as any;
                for (let item of _data["knowledgeModules"])
                    this.knowledgeModules!.push(StudentPOEGroupKnowledgeModules.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): StudentPOEGroupEntityOfStudentPOEGroupAndStudentPOEAndStudentPOEFormativeAssessmentAndStudentPOESummativeAssessmentAndStudentPOEGroupDocAndStudentPOESaqaDocAndStudentPOEFeedbackDocAndStudentPOEGroupUnitStandardsAndStudentPOEGroupKnowledgeModules {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'StudentPOEGroupEntityOfStudentPOEGroupAndStudentPOEAndStudentPOEFormativeAssessmentAndStudentPOESummativeAssessmentAndStudentPOEGroupDocAndStudentPOESaqaDocAndStudentPOEFeedbackDocAndStudentPOEGroupUnitStandardsAndStudentPOEGroupKnowledgeModules' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["index"] = this.index;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        data["moduleType"] = this.moduleType;
        if (Array.isArray(this.formativeAssessments)) {
            data["formativeAssessments"] = [];
            for (let item of this.formativeAssessments)
                data["formativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessments)) {
            data["summativeAssessments"] = [];
            for (let item of this.summativeAssessments)
                data["summativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocs)) {
            data["saqaDocs"] = [];
            for (let item of this.saqaDocs)
                data["saqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandards)) {
            data["unitStandards"] = [];
            for (let item of this.unitStandards)
                data["unitStandards"].push(item.toJSON());
        }
        if (Array.isArray(this.knowledgeModules)) {
            data["knowledgeModules"] = [];
            for (let item of this.knowledgeModules)
                data["knowledgeModules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupEntityOfStudentPOEGroupAndStudentPOEAndStudentPOEFormativeAssessmentAndStudentPOESummativeAssessmentAndStudentPOEGroupDocAndStudentPOESaqaDocAndStudentPOEFeedbackDocAndStudentPOEGroupUnitStandardsAndStudentPOEGroupKnowledgeModules extends IAuditableBaseEntity {
    name?: string | undefined;
    index?: number;
    poeId?: number;
    poe?: StudentPOE | undefined;
    moduleType?: KnowledgeModuleType | undefined;
    formativeAssessments?: StudentPOEFormativeAssessment[] | undefined;
    summativeAssessments?: StudentPOESummativeAssessment[] | undefined;
    documents?: StudentPOEGroupDoc[] | undefined;
    saqaDocs?: StudentPOESaqaDoc[] | undefined;
    feedbackDocs?: StudentPOEFeedbackDoc[] | undefined;
    unitStandards?: StudentPOEGroupUnitStandards[] | undefined;
    knowledgeModules?: StudentPOEGroupKnowledgeModules[] | undefined;
}

export class StudentPOEGroup extends StudentPOEGroupEntityOfStudentPOEGroupAndStudentPOEAndStudentPOEFormativeAssessmentAndStudentPOESummativeAssessmentAndStudentPOEGroupDocAndStudentPOESaqaDocAndStudentPOEFeedbackDocAndStudentPOEGroupUnitStandardsAndStudentPOEGroupKnowledgeModules implements IStudentPOEGroup {
    parentGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    formativeAssessmentAnnotations?: StudentPOEGroupFormativeAssessmentAnnotation[] | undefined;
    summativeAssessmentAnnotations?: StudentPOEGroupSummativeAssessmentAnnotation[] | undefined;
    groupDocAnnotations?: StudentPOEGroupDocAnnotation[] | undefined;
    saqaDocAnnotations?: StudentPOEGroupSaqaDocAnnotation[] | undefined;
    formativeAssessmentInputs?: StudentPOEFormativeAssessmentInputAnswer[] | undefined;
    summativeAssessmentInputs?: StudentPOESummativeAssessmentInputAnswer[] | undefined;
    groupDocInputs?: StudentPOEGroupGeneralDocInputAnswer[] | undefined;
    saqaDocInputs?: StudentPOESaqaDocInputAnswer[] | undefined;

    constructor(data?: IStudentPOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentGroupId = _data["parentGroupId"];
            this.programmePOEGroup = _data["programmePOEGroup"] ? ProgrammePOEGroup.fromJS(_data["programmePOEGroup"]) : <any>undefined;
            if (Array.isArray(_data["formativeAssessmentAnnotations"])) {
                this.formativeAssessmentAnnotations = [] as any;
                for (let item of _data["formativeAssessmentAnnotations"])
                    this.formativeAssessmentAnnotations!.push(StudentPOEGroupFormativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentAnnotations"])) {
                this.summativeAssessmentAnnotations = [] as any;
                for (let item of _data["summativeAssessmentAnnotations"])
                    this.summativeAssessmentAnnotations!.push(StudentPOEGroupSummativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["groupDocAnnotations"])) {
                this.groupDocAnnotations = [] as any;
                for (let item of _data["groupDocAnnotations"])
                    this.groupDocAnnotations!.push(StudentPOEGroupDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocAnnotations"])) {
                this.saqaDocAnnotations = [] as any;
                for (let item of _data["saqaDocAnnotations"])
                    this.saqaDocAnnotations!.push(StudentPOEGroupSaqaDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentInputs"])) {
                this.formativeAssessmentInputs = [] as any;
                for (let item of _data["formativeAssessmentInputs"])
                    this.formativeAssessmentInputs!.push(StudentPOEFormativeAssessmentInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentInputs"])) {
                this.summativeAssessmentInputs = [] as any;
                for (let item of _data["summativeAssessmentInputs"])
                    this.summativeAssessmentInputs!.push(StudentPOESummativeAssessmentInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["groupDocInputs"])) {
                this.groupDocInputs = [] as any;
                for (let item of _data["groupDocInputs"])
                    this.groupDocInputs!.push(StudentPOEGroupGeneralDocInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocInputs"])) {
                this.saqaDocInputs = [] as any;
                for (let item of _data["saqaDocInputs"])
                    this.saqaDocInputs!.push(StudentPOESaqaDocInputAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): StudentPOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentGroupId"] = this.parentGroupId;
        data["programmePOEGroup"] = this.programmePOEGroup ? this.programmePOEGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.formativeAssessmentAnnotations)) {
            data["formativeAssessmentAnnotations"] = [];
            for (let item of this.formativeAssessmentAnnotations)
                data["formativeAssessmentAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentAnnotations)) {
            data["summativeAssessmentAnnotations"] = [];
            for (let item of this.summativeAssessmentAnnotations)
                data["summativeAssessmentAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocAnnotations)) {
            data["groupDocAnnotations"] = [];
            for (let item of this.groupDocAnnotations)
                data["groupDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocAnnotations)) {
            data["saqaDocAnnotations"] = [];
            for (let item of this.saqaDocAnnotations)
                data["saqaDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentInputs)) {
            data["formativeAssessmentInputs"] = [];
            for (let item of this.formativeAssessmentInputs)
                data["formativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentInputs)) {
            data["summativeAssessmentInputs"] = [];
            for (let item of this.summativeAssessmentInputs)
                data["summativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocInputs)) {
            data["groupDocInputs"] = [];
            for (let item of this.groupDocInputs)
                data["groupDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocInputs)) {
            data["saqaDocInputs"] = [];
            for (let item of this.saqaDocInputs)
                data["saqaDocInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroup extends IStudentPOEGroupEntityOfStudentPOEGroupAndStudentPOEAndStudentPOEFormativeAssessmentAndStudentPOESummativeAssessmentAndStudentPOEGroupDocAndStudentPOESaqaDocAndStudentPOEFeedbackDocAndStudentPOEGroupUnitStandardsAndStudentPOEGroupKnowledgeModules {
    parentGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    formativeAssessmentAnnotations?: StudentPOEGroupFormativeAssessmentAnnotation[] | undefined;
    summativeAssessmentAnnotations?: StudentPOEGroupSummativeAssessmentAnnotation[] | undefined;
    groupDocAnnotations?: StudentPOEGroupDocAnnotation[] | undefined;
    saqaDocAnnotations?: StudentPOEGroupSaqaDocAnnotation[] | undefined;
    formativeAssessmentInputs?: StudentPOEFormativeAssessmentInputAnswer[] | undefined;
    summativeAssessmentInputs?: StudentPOESummativeAssessmentInputAnswer[] | undefined;
    groupDocInputs?: StudentPOEGroupGeneralDocInputAnswer[] | undefined;
    saqaDocInputs?: StudentPOESaqaDocInputAnswer[] | undefined;
}

export class POEAnnotationOfStudentPOE extends Annotation implements IPOEAnnotationOfStudentPOE {
    poeId?: number;
    poe?: StudentPOE | undefined;

    constructor(data?: IPOEAnnotationOfStudentPOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? StudentPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEAnnotationOfStudentPOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEAnnotationOfStudentPOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEAnnotationOfStudentPOE extends IAnnotation {
    poeId?: number;
    poe?: StudentPOE | undefined;
}

export class StudentPOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends POEAnnotationOfStudentPOE implements IStudentPOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    studentPOEGroupDocId?: number;
    studentPOEGroupDoc?: StudentPOEFormativeAssessment | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGroupFormativeAssessmentAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEGroupId = _data["studentPOEGroupId"];
            this.studentPOEGroup = _data["studentPOEGroup"] ? StudentPOEGroup.fromJS(_data["studentPOEGroup"]) : <any>undefined;
            this.studentPOEGroupDocId = _data["studentPOEGroupDocId"];
            this.studentPOEGroupDoc = _data["studentPOEGroupDoc"] ? StudentPOEFormativeAssessment.fromJS(_data["studentPOEGroupDoc"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEGroupFormativeAssessmentAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEGroupId"] = this.studentPOEGroupId;
        data["studentPOEGroup"] = this.studentPOEGroup ? this.studentPOEGroup.toJSON() : <any>undefined;
        data["studentPOEGroupDocId"] = this.studentPOEGroupDocId;
        data["studentPOEGroupDoc"] = this.studentPOEGroupDoc ? this.studentPOEGroupDoc.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IPOEAnnotationOfStudentPOE {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    studentPOEGroupDocId?: number;
    studentPOEGroupDoc?: StudentPOEFormativeAssessment | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGroupFormativeAssessmentAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class StudentPOEGroupFormativeAssessmentAnnotation extends StudentPOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IStudentPOEGroupFormativeAssessmentAnnotation {

    constructor(data?: IStudentPOEGroupFormativeAssessmentAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGroupFormativeAssessmentAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupFormativeAssessmentAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupFormativeAssessmentAnnotation extends IStudentPOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export abstract class POEGroupDocumentEntityOfStudentPOEGroup extends POEDocumentEntity implements IPOEGroupDocumentEntityOfStudentPOEGroup {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;

    constructor(data?: IPOEGroupDocumentEntityOfStudentPOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? StudentPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupDocumentEntityOfStudentPOEGroup {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'POEGroupDocumentEntityOfStudentPOEGroup' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupDocumentEntityOfStudentPOEGroup extends IPOEDocumentEntity {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
}

export class StudentPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends POEGroupDocumentEntityOfStudentPOEGroup implements IStudentPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEFormativeAssessment | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGroupFormativeAssessmentAnnotation[] | undefined;
    inputAnswers?: StudentPOEFormativeAssessmentInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IStudentPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOEFormativeAssessment.fromJS(_data["parentDoc"]) : <any>undefined;
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEGroupFormativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentPOEFormativeAssessmentInputAnswer.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): StudentPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IPOEGroupDocumentEntityOfStudentPOEGroup {
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEFormativeAssessment | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGroupFormativeAssessmentAnnotation[] | undefined;
    inputAnswers?: StudentPOEFormativeAssessmentInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class StudentPOEFormativeAssessment extends StudentPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IStudentPOEFormativeAssessment {

    constructor(data?: IStudentPOEFormativeAssessment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEFormativeAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEFormativeAssessment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEFormativeAssessment extends IStudentPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class ProgrammePOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends POEGroupDocumentEntityOfProgrammePOEGroup implements IProgrammePOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    parentDocId?: number | undefined;
    parentDoc?: QualPOEFormativeAssessment | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    annotations?: ProgrammePOEGroupFormativeAssessmentAnnotation[] | undefined;
    childrenDocs?: StudentPOEFormativeAssessment[] | undefined;
    inputs?: ProgrammePOEFormativeAssessmentInput[] | undefined;

    constructor(data?: IProgrammePOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? QualPOEFormativeAssessment.fromJS(_data["parentDoc"]) : <any>undefined;
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEGroupFormativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOEFormativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammePOEFormativeAssessmentInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IPOEGroupDocumentEntityOfProgrammePOEGroup {
    parentDocId?: number | undefined;
    parentDoc?: QualPOEFormativeAssessment | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    annotations?: ProgrammePOEGroupFormativeAssessmentAnnotation[] | undefined;
    childrenDocs?: StudentPOEFormativeAssessment[] | undefined;
    inputs?: ProgrammePOEFormativeAssessmentInput[] | undefined;
}

export class ProgrammePOEFormativeAssessment extends ProgrammePOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IProgrammePOEFormativeAssessment {

    constructor(data?: IProgrammePOEFormativeAssessment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEFormativeAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEFormativeAssessment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEFormativeAssessment extends IProgrammePOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class QualPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends POEGroupDocumentEntityOfQualPOEGroup implements IQualPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    childrenDocs?: ProgrammePOEFormativeAssessment[] | undefined;
    inputs?: QualPOEFormativeAssessmentInput[] | undefined;
    activities?: QualPOEFormativeAssessmentActivity[] | undefined;

    constructor(data?: IQualPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(ProgrammePOEFormativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualPOEFormativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(QualPOEFormativeAssessmentActivity.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IPOEGroupDocumentEntityOfQualPOEGroup {
    childrenDocs?: ProgrammePOEFormativeAssessment[] | undefined;
    inputs?: QualPOEFormativeAssessmentInput[] | undefined;
    activities?: QualPOEFormativeAssessmentActivity[] | undefined;
}

export class QualPOEFormativeAssessment extends QualPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IQualPOEFormativeAssessment {

    constructor(data?: IQualPOEFormativeAssessment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFormativeAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFormativeAssessment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFormativeAssessment extends IQualPOEGroupDocumentEntityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class Input extends PageAndPosition implements IInput {
    name?: string | undefined;
    ownerId?: number;
    required?: boolean;
    disabled?: boolean;
    maxLength?: number | undefined;
    type?: InputTypes;
    autoFillType?: AutoFillInputTypes | undefined;
    autoFillInputOwner?: AutoFillInputOwners | undefined;
    activityTotalInputFormat?: ActivityTotalInputFormats | undefined;

    constructor(data?: IInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.required = _data["required"];
            this.disabled = _data["disabled"];
            this.maxLength = _data["maxLength"];
            this.type = _data["type"];
            this.autoFillType = _data["autoFillType"];
            this.autoFillInputOwner = _data["autoFillInputOwner"];
            this.activityTotalInputFormat = _data["activityTotalInputFormat"];
        }
    }

    static override fromJS(data: any): Input {
        data = typeof data === 'object' ? data : {};
        let result = new Input();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["required"] = this.required;
        data["disabled"] = this.disabled;
        data["maxLength"] = this.maxLength;
        data["type"] = this.type;
        data["autoFillType"] = this.autoFillType;
        data["autoFillInputOwner"] = this.autoFillInputOwner;
        data["activityTotalInputFormat"] = this.activityTotalInputFormat;
        super.toJSON(data);
        return data;
    }
}

export interface IInput extends IPageAndPosition {
    name?: string | undefined;
    ownerId?: number;
    required?: boolean;
    disabled?: boolean;
    maxLength?: number | undefined;
    type?: InputTypes;
    autoFillType?: AutoFillInputTypes | undefined;
    autoFillInputOwner?: AutoFillInputOwners | undefined;
    activityTotalInputFormat?: ActivityTotalInputFormats | undefined;
}

export class POEGroupInputOfQualPOEFormativeAssessmentAndQualPOEAndQualPOEGroup extends Input implements IPOEGroupInputOfQualPOEFormativeAssessmentAndQualPOEAndQualPOEGroup {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: QualPOEFormativeAssessment | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;

    constructor(data?: IPOEGroupInputOfQualPOEFormativeAssessmentAndQualPOEAndQualPOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? QualPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? QualPOEFormativeAssessment.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupInputOfQualPOEFormativeAssessmentAndQualPOEAndQualPOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new POEGroupInputOfQualPOEFormativeAssessmentAndQualPOEAndQualPOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupInputOfQualPOEFormativeAssessmentAndQualPOEAndQualPOEGroup extends IInput {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: QualPOEFormativeAssessment | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;
}

export class QualPOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends POEGroupInputOfQualPOEFormativeAssessmentAndQualPOEAndQualPOEGroup implements IQualPOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEFormativeAssessmentInput[] | undefined;

    constructor(data?: IQualPOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammePOEFormativeAssessmentInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IPOEGroupInputOfQualPOEFormativeAssessmentAndQualPOEAndQualPOEGroup {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEFormativeAssessmentInput[] | undefined;
}

export class QualPOEFormativeAssessmentInput extends QualPOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IQualPOEFormativeAssessmentInput {

    constructor(data?: IQualPOEFormativeAssessmentInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFormativeAssessmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFormativeAssessmentInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFormativeAssessmentInput extends IQualPOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class POEGroupInputOfProgrammePOEFormativeAssessmentAndProgrammePOEAndProgrammePOEGroup extends Input implements IPOEGroupInputOfProgrammePOEFormativeAssessmentAndProgrammePOEAndProgrammePOEGroup {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: ProgrammePOEFormativeAssessment | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEGroupInputOfProgrammePOEFormativeAssessmentAndProgrammePOEAndProgrammePOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? ProgrammePOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? ProgrammePOEFormativeAssessment.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupInputOfProgrammePOEFormativeAssessmentAndProgrammePOEAndProgrammePOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new POEGroupInputOfProgrammePOEFormativeAssessmentAndProgrammePOEAndProgrammePOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupInputOfProgrammePOEFormativeAssessmentAndProgrammePOEAndProgrammePOEGroup extends IInput {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: ProgrammePOEFormativeAssessment | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends POEGroupInputOfProgrammePOEFormativeAssessmentAndProgrammePOEAndProgrammePOEGroup implements IProgrammePOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    studentInputAnswers?: StudentPOEFormativeAssessmentInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEFormativeAssessmentInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammePOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentPOEFormativeAssessmentInputAnswer.fromJS(item));
            }
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualPOEFormativeAssessmentInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IPOEGroupInputOfProgrammePOEFormativeAssessmentAndProgrammePOEAndProgrammePOEGroup {
    studentInputAnswers?: StudentPOEFormativeAssessmentInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEFormativeAssessmentInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;
}

export class ProgrammePOEFormativeAssessmentInput extends ProgrammePOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IProgrammePOEFormativeAssessmentInput {

    constructor(data?: IProgrammePOEFormativeAssessmentInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEFormativeAssessmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEFormativeAssessmentInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEFormativeAssessmentInput extends IProgrammePOEGroupInputOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class StudentAnswer extends AuditableBaseEntity implements IStudentAnswer {
    value?: string | undefined;
    poeId?: number;
    poe?: StudentPOE | undefined;

    constructor(data?: IStudentAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? StudentPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentAnswer extends IAuditableBaseEntity {
    value?: string | undefined;
    poeId?: number;
    poe?: StudentPOE | undefined;
}

export class StudentPOEGroupInputAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends StudentAnswer implements IStudentPOEGroupInputAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: StudentPOEFormativeAssessment | undefined;
    programmePOEGroupInputId?: number;
    programmePOEGroupInput?: ProgrammePOEFormativeAssessmentInput | undefined;

    constructor(data?: IStudentPOEGroupInputAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? StudentPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? StudentPOEFormativeAssessment.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.programmePOEGroupInputId = _data["programmePOEGroupInputId"];
            this.programmePOEGroupInput = _data["programmePOEGroupInput"] ? ProgrammePOEFormativeAssessmentInput.fromJS(_data["programmePOEGroupInput"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEGroupInputAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupInputAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["programmePOEGroupInputId"] = this.programmePOEGroupInputId;
        data["programmePOEGroupInput"] = this.programmePOEGroupInput ? this.programmePOEGroupInput.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupInputAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IStudentAnswer {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: StudentPOEFormativeAssessment | undefined;
    programmePOEGroupInputId?: number;
    programmePOEGroupInput?: ProgrammePOEFormativeAssessmentInput | undefined;
}

export class StudentPOEFormativeAssessmentInputAnswer extends StudentPOEGroupInputAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IStudentPOEFormativeAssessmentInputAnswer {

    constructor(data?: IStudentPOEFormativeAssessmentInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEFormativeAssessmentInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEFormativeAssessmentInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEFormativeAssessmentInputAnswer extends IStudentPOEGroupInputAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class StudentPOE extends AuditableBaseEntity implements IStudentPOE {
    scheduleDocs?: StudentPOEScheduleDoc[] | undefined;
    generalDocs?: StudentPOEGeneralDoc[] | undefined;
    feedbackDocs?: StudentPOEFeedbackDoc[] | undefined;
    workplaceDocs?: StudentPOEWorkplaceDoc[] | undefined;
    assessmentGuideDocs?: StudentPOEAssessmentGuideDoc[] | undefined;
    groups?: StudentPOEGroup[] | undefined;
    generalDocAnnotations?: StudentPOEGeneralDocAnnotation[] | undefined;
    feedbackDocAnnotations?: StudentPOEFeedbackDocAnnotation[] | undefined;
    workplaceDocAnnotations?: StudentPOEWorkplaceDocAnnotation[] | undefined;
    assessmentGuideDocAnnotations?: StudentPOEAssessmentGuideDocAnnotation[] | undefined;
    formativeAssessmentAnnotations?: StudentPOEGroupFormativeAssessmentAnnotation[] | undefined;
    summativeAssessmentAnnotations?: StudentPOEGroupSummativeAssessmentAnnotation[] | undefined;
    groupDocAnnotations?: StudentPOEGroupDocAnnotation[] | undefined;
    saqaDocAnnotations?: StudentPOEGroupSaqaDocAnnotation[] | undefined;
    scheduleAnnotations?: StudentPOEScheduleAnnotation[] | undefined;
    generalDocInputAnswers?: StudentPOEGeneralDocInputAnswer[] | undefined;
    feedbackDocInputAnswers?: StudentPOEFeedbackDocInputAnswer[] | undefined;
    workplaceDocInputAnswers?: StudentPOEWorkplaceDocInputAnswer[] | undefined;
    assessmentGuideDocInputAnswers?: StudentPOEAssessmentGuideDocInputAnswer[] | undefined;
    formativeAssessmentInputAnswers?: StudentPOEFormativeAssessmentInputAnswer[] | undefined;
    summativeAssessmentInputAnswers?: StudentPOESummativeAssessmentInputAnswer[] | undefined;
    groupDocInputAnswers?: StudentPOEGroupGeneralDocInputAnswer[] | undefined;
    saqaDocInputAnswers?: StudentPOESaqaDocInputAnswer[] | undefined;
    studentGeneralDocQuestionAnswers?: StudentGeneralDocQuestionAnswer[] | undefined;
    studentFeedbackDocQuestionAnswers?: StudentFeedbackDocQuestionAnswer[] | undefined;
    studentWorkplaceDocQuestionAnswers?: StudentWorkplaceDocQuestionAnswer[] | undefined;
    studentAssessmentGuideDocQuestionAnswers?: StudentAssessmentGuideDocQuestionAnswer[] | undefined;
    studentSummativeQuestionAnswers?: StudentSummativeQuestionAnswer[] | undefined;
    studentFormativeQuestionAnswers?: StudentFormativeQuestionAnswer[] | undefined;
    studentSaqaDocQuestionAnswers?: StudentSaqaDocQuestionAnswer[] | undefined;
    studentGroupGeneralDocQuestionAnswers?: StudentGroupGeneralDocQuestionAnswer[] | undefined;
    studentId?: number;
    student?: Student | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    programmePOEId?: number;
    programmePOE?: ProgrammePOE | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    unlocked?: boolean;

    constructor(data?: IStudentPOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["scheduleDocs"])) {
                this.scheduleDocs = [] as any;
                for (let item of _data["scheduleDocs"])
                    this.scheduleDocs!.push(StudentPOEScheduleDoc.fromJS(item));
            }
            if (Array.isArray(_data["generalDocs"])) {
                this.generalDocs = [] as any;
                for (let item of _data["generalDocs"])
                    this.generalDocs!.push(StudentPOEGeneralDoc.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(StudentPOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocs"])) {
                this.workplaceDocs = [] as any;
                for (let item of _data["workplaceDocs"])
                    this.workplaceDocs!.push(StudentPOEWorkplaceDoc.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocs"])) {
                this.assessmentGuideDocs = [] as any;
                for (let item of _data["assessmentGuideDocs"])
                    this.assessmentGuideDocs!.push(StudentPOEAssessmentGuideDoc.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(StudentPOEGroup.fromJS(item));
            }
            if (Array.isArray(_data["generalDocAnnotations"])) {
                this.generalDocAnnotations = [] as any;
                for (let item of _data["generalDocAnnotations"])
                    this.generalDocAnnotations!.push(StudentPOEGeneralDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocAnnotations"])) {
                this.feedbackDocAnnotations = [] as any;
                for (let item of _data["feedbackDocAnnotations"])
                    this.feedbackDocAnnotations!.push(StudentPOEFeedbackDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocAnnotations"])) {
                this.workplaceDocAnnotations = [] as any;
                for (let item of _data["workplaceDocAnnotations"])
                    this.workplaceDocAnnotations!.push(StudentPOEWorkplaceDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocAnnotations"])) {
                this.assessmentGuideDocAnnotations = [] as any;
                for (let item of _data["assessmentGuideDocAnnotations"])
                    this.assessmentGuideDocAnnotations!.push(StudentPOEAssessmentGuideDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentAnnotations"])) {
                this.formativeAssessmentAnnotations = [] as any;
                for (let item of _data["formativeAssessmentAnnotations"])
                    this.formativeAssessmentAnnotations!.push(StudentPOEGroupFormativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentAnnotations"])) {
                this.summativeAssessmentAnnotations = [] as any;
                for (let item of _data["summativeAssessmentAnnotations"])
                    this.summativeAssessmentAnnotations!.push(StudentPOEGroupSummativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["groupDocAnnotations"])) {
                this.groupDocAnnotations = [] as any;
                for (let item of _data["groupDocAnnotations"])
                    this.groupDocAnnotations!.push(StudentPOEGroupDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocAnnotations"])) {
                this.saqaDocAnnotations = [] as any;
                for (let item of _data["saqaDocAnnotations"])
                    this.saqaDocAnnotations!.push(StudentPOEGroupSaqaDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["scheduleAnnotations"])) {
                this.scheduleAnnotations = [] as any;
                for (let item of _data["scheduleAnnotations"])
                    this.scheduleAnnotations!.push(StudentPOEScheduleAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["generalDocInputAnswers"])) {
                this.generalDocInputAnswers = [] as any;
                for (let item of _data["generalDocInputAnswers"])
                    this.generalDocInputAnswers!.push(StudentPOEGeneralDocInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocInputAnswers"])) {
                this.feedbackDocInputAnswers = [] as any;
                for (let item of _data["feedbackDocInputAnswers"])
                    this.feedbackDocInputAnswers!.push(StudentPOEFeedbackDocInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocInputAnswers"])) {
                this.workplaceDocInputAnswers = [] as any;
                for (let item of _data["workplaceDocInputAnswers"])
                    this.workplaceDocInputAnswers!.push(StudentPOEWorkplaceDocInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocInputAnswers"])) {
                this.assessmentGuideDocInputAnswers = [] as any;
                for (let item of _data["assessmentGuideDocInputAnswers"])
                    this.assessmentGuideDocInputAnswers!.push(StudentPOEAssessmentGuideDocInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentInputAnswers"])) {
                this.formativeAssessmentInputAnswers = [] as any;
                for (let item of _data["formativeAssessmentInputAnswers"])
                    this.formativeAssessmentInputAnswers!.push(StudentPOEFormativeAssessmentInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentInputAnswers"])) {
                this.summativeAssessmentInputAnswers = [] as any;
                for (let item of _data["summativeAssessmentInputAnswers"])
                    this.summativeAssessmentInputAnswers!.push(StudentPOESummativeAssessmentInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["groupDocInputAnswers"])) {
                this.groupDocInputAnswers = [] as any;
                for (let item of _data["groupDocInputAnswers"])
                    this.groupDocInputAnswers!.push(StudentPOEGroupGeneralDocInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocInputAnswers"])) {
                this.saqaDocInputAnswers = [] as any;
                for (let item of _data["saqaDocInputAnswers"])
                    this.saqaDocInputAnswers!.push(StudentPOESaqaDocInputAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentGeneralDocQuestionAnswers"])) {
                this.studentGeneralDocQuestionAnswers = [] as any;
                for (let item of _data["studentGeneralDocQuestionAnswers"])
                    this.studentGeneralDocQuestionAnswers!.push(StudentGeneralDocQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentFeedbackDocQuestionAnswers"])) {
                this.studentFeedbackDocQuestionAnswers = [] as any;
                for (let item of _data["studentFeedbackDocQuestionAnswers"])
                    this.studentFeedbackDocQuestionAnswers!.push(StudentFeedbackDocQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentWorkplaceDocQuestionAnswers"])) {
                this.studentWorkplaceDocQuestionAnswers = [] as any;
                for (let item of _data["studentWorkplaceDocQuestionAnswers"])
                    this.studentWorkplaceDocQuestionAnswers!.push(StudentWorkplaceDocQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentAssessmentGuideDocQuestionAnswers"])) {
                this.studentAssessmentGuideDocQuestionAnswers = [] as any;
                for (let item of _data["studentAssessmentGuideDocQuestionAnswers"])
                    this.studentAssessmentGuideDocQuestionAnswers!.push(StudentAssessmentGuideDocQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentSummativeQuestionAnswers"])) {
                this.studentSummativeQuestionAnswers = [] as any;
                for (let item of _data["studentSummativeQuestionAnswers"])
                    this.studentSummativeQuestionAnswers!.push(StudentSummativeQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentFormativeQuestionAnswers"])) {
                this.studentFormativeQuestionAnswers = [] as any;
                for (let item of _data["studentFormativeQuestionAnswers"])
                    this.studentFormativeQuestionAnswers!.push(StudentFormativeQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentSaqaDocQuestionAnswers"])) {
                this.studentSaqaDocQuestionAnswers = [] as any;
                for (let item of _data["studentSaqaDocQuestionAnswers"])
                    this.studentSaqaDocQuestionAnswers!.push(StudentSaqaDocQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentGroupGeneralDocQuestionAnswers"])) {
                this.studentGroupGeneralDocQuestionAnswers = [] as any;
                for (let item of _data["studentGroupGeneralDocQuestionAnswers"])
                    this.studentGroupGeneralDocQuestionAnswers!.push(StudentGroupGeneralDocQuestionAnswer.fromJS(item));
            }
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            this.programmePOEId = _data["programmePOEId"];
            this.programmePOE = _data["programmePOE"] ? ProgrammePOE.fromJS(_data["programmePOE"]) : <any>undefined;
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            this.unlocked = _data["unlocked"];
        }
    }

    static override fromJS(data: any): StudentPOE {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scheduleDocs)) {
            data["scheduleDocs"] = [];
            for (let item of this.scheduleDocs)
                data["scheduleDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocs)) {
            data["generalDocs"] = [];
            for (let item of this.generalDocs)
                data["generalDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocs)) {
            data["workplaceDocs"] = [];
            for (let item of this.workplaceDocs)
                data["workplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocs)) {
            data["assessmentGuideDocs"] = [];
            for (let item of this.assessmentGuideDocs)
                data["assessmentGuideDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocAnnotations)) {
            data["generalDocAnnotations"] = [];
            for (let item of this.generalDocAnnotations)
                data["generalDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocAnnotations)) {
            data["feedbackDocAnnotations"] = [];
            for (let item of this.feedbackDocAnnotations)
                data["feedbackDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocAnnotations)) {
            data["workplaceDocAnnotations"] = [];
            for (let item of this.workplaceDocAnnotations)
                data["workplaceDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocAnnotations)) {
            data["assessmentGuideDocAnnotations"] = [];
            for (let item of this.assessmentGuideDocAnnotations)
                data["assessmentGuideDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentAnnotations)) {
            data["formativeAssessmentAnnotations"] = [];
            for (let item of this.formativeAssessmentAnnotations)
                data["formativeAssessmentAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentAnnotations)) {
            data["summativeAssessmentAnnotations"] = [];
            for (let item of this.summativeAssessmentAnnotations)
                data["summativeAssessmentAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocAnnotations)) {
            data["groupDocAnnotations"] = [];
            for (let item of this.groupDocAnnotations)
                data["groupDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocAnnotations)) {
            data["saqaDocAnnotations"] = [];
            for (let item of this.saqaDocAnnotations)
                data["saqaDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.scheduleAnnotations)) {
            data["scheduleAnnotations"] = [];
            for (let item of this.scheduleAnnotations)
                data["scheduleAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocInputAnswers)) {
            data["generalDocInputAnswers"] = [];
            for (let item of this.generalDocInputAnswers)
                data["generalDocInputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocInputAnswers)) {
            data["feedbackDocInputAnswers"] = [];
            for (let item of this.feedbackDocInputAnswers)
                data["feedbackDocInputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocInputAnswers)) {
            data["workplaceDocInputAnswers"] = [];
            for (let item of this.workplaceDocInputAnswers)
                data["workplaceDocInputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocInputAnswers)) {
            data["assessmentGuideDocInputAnswers"] = [];
            for (let item of this.assessmentGuideDocInputAnswers)
                data["assessmentGuideDocInputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentInputAnswers)) {
            data["formativeAssessmentInputAnswers"] = [];
            for (let item of this.formativeAssessmentInputAnswers)
                data["formativeAssessmentInputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentInputAnswers)) {
            data["summativeAssessmentInputAnswers"] = [];
            for (let item of this.summativeAssessmentInputAnswers)
                data["summativeAssessmentInputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocInputAnswers)) {
            data["groupDocInputAnswers"] = [];
            for (let item of this.groupDocInputAnswers)
                data["groupDocInputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocInputAnswers)) {
            data["saqaDocInputAnswers"] = [];
            for (let item of this.saqaDocInputAnswers)
                data["saqaDocInputAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentGeneralDocQuestionAnswers)) {
            data["studentGeneralDocQuestionAnswers"] = [];
            for (let item of this.studentGeneralDocQuestionAnswers)
                data["studentGeneralDocQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentFeedbackDocQuestionAnswers)) {
            data["studentFeedbackDocQuestionAnswers"] = [];
            for (let item of this.studentFeedbackDocQuestionAnswers)
                data["studentFeedbackDocQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentWorkplaceDocQuestionAnswers)) {
            data["studentWorkplaceDocQuestionAnswers"] = [];
            for (let item of this.studentWorkplaceDocQuestionAnswers)
                data["studentWorkplaceDocQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentAssessmentGuideDocQuestionAnswers)) {
            data["studentAssessmentGuideDocQuestionAnswers"] = [];
            for (let item of this.studentAssessmentGuideDocQuestionAnswers)
                data["studentAssessmentGuideDocQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentSummativeQuestionAnswers)) {
            data["studentSummativeQuestionAnswers"] = [];
            for (let item of this.studentSummativeQuestionAnswers)
                data["studentSummativeQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentFormativeQuestionAnswers)) {
            data["studentFormativeQuestionAnswers"] = [];
            for (let item of this.studentFormativeQuestionAnswers)
                data["studentFormativeQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentSaqaDocQuestionAnswers)) {
            data["studentSaqaDocQuestionAnswers"] = [];
            for (let item of this.studentSaqaDocQuestionAnswers)
                data["studentSaqaDocQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentGroupGeneralDocQuestionAnswers)) {
            data["studentGroupGeneralDocQuestionAnswers"] = [];
            for (let item of this.studentGroupGeneralDocQuestionAnswers)
                data["studentGroupGeneralDocQuestionAnswers"].push(item.toJSON());
        }
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["programmePOEId"] = this.programmePOEId;
        data["programmePOE"] = this.programmePOE ? this.programmePOE.toJSON() : <any>undefined;
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        data["unlocked"] = this.unlocked;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOE extends IAuditableBaseEntity {
    scheduleDocs?: StudentPOEScheduleDoc[] | undefined;
    generalDocs?: StudentPOEGeneralDoc[] | undefined;
    feedbackDocs?: StudentPOEFeedbackDoc[] | undefined;
    workplaceDocs?: StudentPOEWorkplaceDoc[] | undefined;
    assessmentGuideDocs?: StudentPOEAssessmentGuideDoc[] | undefined;
    groups?: StudentPOEGroup[] | undefined;
    generalDocAnnotations?: StudentPOEGeneralDocAnnotation[] | undefined;
    feedbackDocAnnotations?: StudentPOEFeedbackDocAnnotation[] | undefined;
    workplaceDocAnnotations?: StudentPOEWorkplaceDocAnnotation[] | undefined;
    assessmentGuideDocAnnotations?: StudentPOEAssessmentGuideDocAnnotation[] | undefined;
    formativeAssessmentAnnotations?: StudentPOEGroupFormativeAssessmentAnnotation[] | undefined;
    summativeAssessmentAnnotations?: StudentPOEGroupSummativeAssessmentAnnotation[] | undefined;
    groupDocAnnotations?: StudentPOEGroupDocAnnotation[] | undefined;
    saqaDocAnnotations?: StudentPOEGroupSaqaDocAnnotation[] | undefined;
    scheduleAnnotations?: StudentPOEScheduleAnnotation[] | undefined;
    generalDocInputAnswers?: StudentPOEGeneralDocInputAnswer[] | undefined;
    feedbackDocInputAnswers?: StudentPOEFeedbackDocInputAnswer[] | undefined;
    workplaceDocInputAnswers?: StudentPOEWorkplaceDocInputAnswer[] | undefined;
    assessmentGuideDocInputAnswers?: StudentPOEAssessmentGuideDocInputAnswer[] | undefined;
    formativeAssessmentInputAnswers?: StudentPOEFormativeAssessmentInputAnswer[] | undefined;
    summativeAssessmentInputAnswers?: StudentPOESummativeAssessmentInputAnswer[] | undefined;
    groupDocInputAnswers?: StudentPOEGroupGeneralDocInputAnswer[] | undefined;
    saqaDocInputAnswers?: StudentPOESaqaDocInputAnswer[] | undefined;
    studentGeneralDocQuestionAnswers?: StudentGeneralDocQuestionAnswer[] | undefined;
    studentFeedbackDocQuestionAnswers?: StudentFeedbackDocQuestionAnswer[] | undefined;
    studentWorkplaceDocQuestionAnswers?: StudentWorkplaceDocQuestionAnswer[] | undefined;
    studentAssessmentGuideDocQuestionAnswers?: StudentAssessmentGuideDocQuestionAnswer[] | undefined;
    studentSummativeQuestionAnswers?: StudentSummativeQuestionAnswer[] | undefined;
    studentFormativeQuestionAnswers?: StudentFormativeQuestionAnswer[] | undefined;
    studentSaqaDocQuestionAnswers?: StudentSaqaDocQuestionAnswer[] | undefined;
    studentGroupGeneralDocQuestionAnswers?: StudentGroupGeneralDocQuestionAnswer[] | undefined;
    studentId?: number;
    student?: Student | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    programmePOEId?: number;
    programmePOE?: ProgrammePOE | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    unlocked?: boolean;
}

export class StudentPOEScheduleDoc extends FileEntity implements IStudentPOEScheduleDoc {
    useParentDoc?: boolean;
    annotations?: StudentPOEScheduleAnnotation[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
    studentPOEId?: number;
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number;
    parentDoc?: ProgrammePOEScheduleDocument | undefined;

    constructor(data?: IStudentPOEScheduleDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEScheduleAnnotation.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
            this.studentPOEId = _data["studentPOEId"];
            this.studentPOE = _data["studentPOE"] ? StudentPOE.fromJS(_data["studentPOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOEScheduleDocument.fromJS(_data["parentDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEScheduleDoc {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEScheduleDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        data["studentPOEId"] = this.studentPOEId;
        data["studentPOE"] = this.studentPOE ? this.studentPOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEScheduleDoc extends IFileEntity {
    useParentDoc?: boolean;
    annotations?: StudentPOEScheduleAnnotation[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
    studentPOEId?: number;
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number;
    parentDoc?: ProgrammePOEScheduleDocument | undefined;
}

export class ScheduleAnnotationOfStudentPOEScheduleDocAndStudentPOE extends POEAnnotationOfStudentPOE implements IScheduleAnnotationOfStudentPOEScheduleDocAndStudentPOE {
    scheduleId?: number;
    schedule?: StudentPOEScheduleDoc | undefined;

    constructor(data?: IScheduleAnnotationOfStudentPOEScheduleDocAndStudentPOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scheduleId = _data["scheduleId"];
            this.schedule = _data["schedule"] ? StudentPOEScheduleDoc.fromJS(_data["schedule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ScheduleAnnotationOfStudentPOEScheduleDocAndStudentPOE {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleAnnotationOfStudentPOEScheduleDocAndStudentPOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleId"] = this.scheduleId;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IScheduleAnnotationOfStudentPOEScheduleDocAndStudentPOE extends IPOEAnnotationOfStudentPOE {
    scheduleId?: number;
    schedule?: StudentPOEScheduleDoc | undefined;
}

export class StudentPOEScheduleAnnotation extends ScheduleAnnotationOfStudentPOEScheduleDocAndStudentPOE implements IStudentPOEScheduleAnnotation {
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEScheduleAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEScheduleAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEScheduleAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEScheduleAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEScheduleAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEScheduleAnnotation extends IScheduleAnnotationOfStudentPOEScheduleDocAndStudentPOE {
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEScheduleAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class ScheduleAnnotationOfProgrammePOEScheduleDocumentAndProgrammePOE extends POEAnnotationOfProgrammePOE implements IScheduleAnnotationOfProgrammePOEScheduleDocumentAndProgrammePOE {
    scheduleId?: number;
    schedule?: ProgrammePOEScheduleDocument | undefined;

    constructor(data?: IScheduleAnnotationOfProgrammePOEScheduleDocumentAndProgrammePOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scheduleId = _data["scheduleId"];
            this.schedule = _data["schedule"] ? ProgrammePOEScheduleDocument.fromJS(_data["schedule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ScheduleAnnotationOfProgrammePOEScheduleDocumentAndProgrammePOE {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleAnnotationOfProgrammePOEScheduleDocumentAndProgrammePOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleId"] = this.scheduleId;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IScheduleAnnotationOfProgrammePOEScheduleDocumentAndProgrammePOE extends IPOEAnnotationOfProgrammePOE {
    scheduleId?: number;
    schedule?: ProgrammePOEScheduleDocument | undefined;
}

export class ProgrammePOEScheduleAnnotation extends ScheduleAnnotationOfProgrammePOEScheduleDocumentAndProgrammePOE implements IProgrammePOEScheduleAnnotation {
    childrenAnnotations?: StudentPOEScheduleAnnotation[] | undefined;

    constructor(data?: IProgrammePOEScheduleAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEScheduleAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEScheduleAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEScheduleAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEScheduleAnnotation extends IScheduleAnnotationOfProgrammePOEScheduleDocumentAndProgrammePOE {
    childrenAnnotations?: StudentPOEScheduleAnnotation[] | undefined;
}

export class ProgrammePOEScheduleDocument extends FileEntity implements IProgrammePOEScheduleDocument {
    childrenDocs?: StudentPOEScheduleDoc[] | undefined;
    scheduleId?: number;
    schedule?: ProgrammePOESchedule | undefined;
    annotations?: ProgrammePOEScheduleAnnotation[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IProgrammePOEScheduleDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOEScheduleDoc.fromJS(item));
            }
            this.scheduleId = _data["scheduleId"];
            this.schedule = _data["schedule"] ? ProgrammePOESchedule.fromJS(_data["schedule"]) : <any>undefined;
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEScheduleAnnotation.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): ProgrammePOEScheduleDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEScheduleDocument();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        data["scheduleId"] = this.scheduleId;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEScheduleDocument extends IFileEntity {
    childrenDocs?: StudentPOEScheduleDoc[] | undefined;
    scheduleId?: number;
    schedule?: ProgrammePOESchedule | undefined;
    annotations?: ProgrammePOEScheduleAnnotation[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class ProgrammePOESchedule extends AuditableBaseEntity implements IProgrammePOESchedule {
    documents?: ProgrammePOEScheduleDocument[] | undefined;
    events?: ProgrammePOEScheduleEvent[] | undefined;
    programmePOEId?: number;
    programmePOE?: ProgrammePOE | undefined;

    constructor(data?: IProgrammePOESchedule) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ProgrammePOEScheduleDocument.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(ProgrammePOEScheduleEvent.fromJS(item));
            }
            this.programmePOEId = _data["programmePOEId"];
            this.programmePOE = _data["programmePOE"] ? ProgrammePOE.fromJS(_data["programmePOE"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammePOESchedule {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOESchedule();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        data["programmePOEId"] = this.programmePOEId;
        data["programmePOE"] = this.programmePOE ? this.programmePOE.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOESchedule extends IAuditableBaseEntity {
    documents?: ProgrammePOEScheduleDocument[] | undefined;
    events?: ProgrammePOEScheduleEvent[] | undefined;
    programmePOEId?: number;
    programmePOE?: ProgrammePOE | undefined;
}

export class ProgrammePOEScheduleEvent extends AuditableBaseEntity implements IProgrammePOEScheduleEvent {
    type?: POEScheduleEvents;
    title?: string | undefined;
    start?: Date;
    end?: Date;
    allDay?: boolean;
    poeGroupId?: number | undefined;
    poeGroup?: ProgrammePOEGroup | undefined;
    scheduleId?: number;
    schedule?: ProgrammePOESchedule | undefined;

    constructor(data?: IProgrammePOEScheduleEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.allDay = _data["allDay"];
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? ProgrammePOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.scheduleId = _data["scheduleId"];
            this.schedule = _data["schedule"] ? ProgrammePOESchedule.fromJS(_data["schedule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammePOEScheduleEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEScheduleEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["allDay"] = this.allDay;
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["scheduleId"] = this.scheduleId;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEScheduleEvent extends IAuditableBaseEntity {
    type?: POEScheduleEvents;
    title?: string | undefined;
    start?: Date;
    end?: Date;
    allDay?: boolean;
    poeGroupId?: number | undefined;
    poeGroup?: ProgrammePOEGroup | undefined;
    scheduleId?: number;
    schedule?: ProgrammePOESchedule | undefined;
}

export enum POEScheduleEvents {
    Induction = 0,
    Workplace = 1,
    ReAssessment = 2,
    SkillsProgrammeFormative = 3,
    SkillsProgrammeSummativeSubmission = 4,
    SkillsProgrammeSummativeFeedback = 5,
    SkillsProgrammeAssessmentPlan = 6,
    SkillsProgrammeModerationPlan = 7,
    Custom = 8,
}

export class ProgrammePOE extends AuditableBaseEntity implements IProgrammePOE {
    generalDocs?: ProgrammePOEGeneralDoc[] | undefined;
    feedbackDocs?: ProgrammePOEFeedbackDoc[] | undefined;
    workplaceDocs?: ProgrammePOEWorkplaceDoc[] | undefined;
    assessmentGuideDocs?: ProgrammePOEAssessmentGuideDoc[] | undefined;
    groups?: ProgrammePOEGroup[] | undefined;
    generalDocAnnotations?: ProgrammePOEGeneralDocAnnotation[] | undefined;
    feedbackDocAnnotations?: ProgrammePOEFeedbackDocAnnotation[] | undefined;
    workplaceDocAnnotations?: ProgrammePOEWorkplaceDocAnnotation[] | undefined;
    assessmentGuideDocAnnotations?: ProgrammePOEAssessmentGuideDocAnnotation[] | undefined;
    formativeAssessmentAnnotations?: ProgrammePOEGroupFormativeAssessmentAnnotation[] | undefined;
    summativeAssessmentAnnotations?: ProgrammePOEGroupSummativeAssessmentAnnotation[] | undefined;
    groupDocAnnotations?: ProgrammePOEGroupDocAnnotation[] | undefined;
    saqaDocAnnotations?: ProgrammePOEGroupSaqaDocAnnotation[] | undefined;
    scheduleAnnotations?: ProgrammePOEScheduleAnnotation[] | undefined;
    generalDocInputs?: ProgrammePOEGeneralDocInput[] | undefined;
    feedbackDocInputs?: ProgrammePOEFeedbackDocInput[] | undefined;
    workplaceDocInputs?: ProgrammePOEWorkplaceDocInput[] | undefined;
    assessmentGuideDocInputs?: ProgrammePOEAssessmentGuideDocInput[] | undefined;
    formativeAssessmentInputs?: ProgrammePOEFormativeAssessmentInput[] | undefined;
    summativeAssessmentInputs?: ProgrammePOESummativeAssessmentInput[] | undefined;
    saqaDocInputs?: ProgrammePOESaqaDocInput[] | undefined;
    groupDocInputs?: ProgrammePOEGroupGeneralDocInput[] | undefined;
    schedule?: ProgrammePOESchedule | undefined;
    studentPOEs?: StudentPOE[] | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    qualPOEId?: number;
    qualPOE?: QualPOE | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    unlocked?: boolean;

    constructor(data?: IProgrammePOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["generalDocs"])) {
                this.generalDocs = [] as any;
                for (let item of _data["generalDocs"])
                    this.generalDocs!.push(ProgrammePOEGeneralDoc.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(ProgrammePOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocs"])) {
                this.workplaceDocs = [] as any;
                for (let item of _data["workplaceDocs"])
                    this.workplaceDocs!.push(ProgrammePOEWorkplaceDoc.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocs"])) {
                this.assessmentGuideDocs = [] as any;
                for (let item of _data["assessmentGuideDocs"])
                    this.assessmentGuideDocs!.push(ProgrammePOEAssessmentGuideDoc.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ProgrammePOEGroup.fromJS(item));
            }
            if (Array.isArray(_data["generalDocAnnotations"])) {
                this.generalDocAnnotations = [] as any;
                for (let item of _data["generalDocAnnotations"])
                    this.generalDocAnnotations!.push(ProgrammePOEGeneralDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocAnnotations"])) {
                this.feedbackDocAnnotations = [] as any;
                for (let item of _data["feedbackDocAnnotations"])
                    this.feedbackDocAnnotations!.push(ProgrammePOEFeedbackDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocAnnotations"])) {
                this.workplaceDocAnnotations = [] as any;
                for (let item of _data["workplaceDocAnnotations"])
                    this.workplaceDocAnnotations!.push(ProgrammePOEWorkplaceDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocAnnotations"])) {
                this.assessmentGuideDocAnnotations = [] as any;
                for (let item of _data["assessmentGuideDocAnnotations"])
                    this.assessmentGuideDocAnnotations!.push(ProgrammePOEAssessmentGuideDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentAnnotations"])) {
                this.formativeAssessmentAnnotations = [] as any;
                for (let item of _data["formativeAssessmentAnnotations"])
                    this.formativeAssessmentAnnotations!.push(ProgrammePOEGroupFormativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentAnnotations"])) {
                this.summativeAssessmentAnnotations = [] as any;
                for (let item of _data["summativeAssessmentAnnotations"])
                    this.summativeAssessmentAnnotations!.push(ProgrammePOEGroupSummativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["groupDocAnnotations"])) {
                this.groupDocAnnotations = [] as any;
                for (let item of _data["groupDocAnnotations"])
                    this.groupDocAnnotations!.push(ProgrammePOEGroupDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocAnnotations"])) {
                this.saqaDocAnnotations = [] as any;
                for (let item of _data["saqaDocAnnotations"])
                    this.saqaDocAnnotations!.push(ProgrammePOEGroupSaqaDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["scheduleAnnotations"])) {
                this.scheduleAnnotations = [] as any;
                for (let item of _data["scheduleAnnotations"])
                    this.scheduleAnnotations!.push(ProgrammePOEScheduleAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["generalDocInputs"])) {
                this.generalDocInputs = [] as any;
                for (let item of _data["generalDocInputs"])
                    this.generalDocInputs!.push(ProgrammePOEGeneralDocInput.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocInputs"])) {
                this.feedbackDocInputs = [] as any;
                for (let item of _data["feedbackDocInputs"])
                    this.feedbackDocInputs!.push(ProgrammePOEFeedbackDocInput.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocInputs"])) {
                this.workplaceDocInputs = [] as any;
                for (let item of _data["workplaceDocInputs"])
                    this.workplaceDocInputs!.push(ProgrammePOEWorkplaceDocInput.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocInputs"])) {
                this.assessmentGuideDocInputs = [] as any;
                for (let item of _data["assessmentGuideDocInputs"])
                    this.assessmentGuideDocInputs!.push(ProgrammePOEAssessmentGuideDocInput.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentInputs"])) {
                this.formativeAssessmentInputs = [] as any;
                for (let item of _data["formativeAssessmentInputs"])
                    this.formativeAssessmentInputs!.push(ProgrammePOEFormativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentInputs"])) {
                this.summativeAssessmentInputs = [] as any;
                for (let item of _data["summativeAssessmentInputs"])
                    this.summativeAssessmentInputs!.push(ProgrammePOESummativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocInputs"])) {
                this.saqaDocInputs = [] as any;
                for (let item of _data["saqaDocInputs"])
                    this.saqaDocInputs!.push(ProgrammePOESaqaDocInput.fromJS(item));
            }
            if (Array.isArray(_data["groupDocInputs"])) {
                this.groupDocInputs = [] as any;
                for (let item of _data["groupDocInputs"])
                    this.groupDocInputs!.push(ProgrammePOEGroupGeneralDocInput.fromJS(item));
            }
            this.schedule = _data["schedule"] ? ProgrammePOESchedule.fromJS(_data["schedule"]) : <any>undefined;
            if (Array.isArray(_data["studentPOEs"])) {
                this.studentPOEs = [] as any;
                for (let item of _data["studentPOEs"])
                    this.studentPOEs!.push(StudentPOE.fromJS(item));
            }
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            this.qualPOEId = _data["qualPOEId"];
            this.qualPOE = _data["qualPOE"] ? QualPOE.fromJS(_data["qualPOE"]) : <any>undefined;
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            this.unlocked = _data["unlocked"];
        }
    }

    static override fromJS(data: any): ProgrammePOE {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generalDocs)) {
            data["generalDocs"] = [];
            for (let item of this.generalDocs)
                data["generalDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocs)) {
            data["workplaceDocs"] = [];
            for (let item of this.workplaceDocs)
                data["workplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocs)) {
            data["assessmentGuideDocs"] = [];
            for (let item of this.assessmentGuideDocs)
                data["assessmentGuideDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocAnnotations)) {
            data["generalDocAnnotations"] = [];
            for (let item of this.generalDocAnnotations)
                data["generalDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocAnnotations)) {
            data["feedbackDocAnnotations"] = [];
            for (let item of this.feedbackDocAnnotations)
                data["feedbackDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocAnnotations)) {
            data["workplaceDocAnnotations"] = [];
            for (let item of this.workplaceDocAnnotations)
                data["workplaceDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocAnnotations)) {
            data["assessmentGuideDocAnnotations"] = [];
            for (let item of this.assessmentGuideDocAnnotations)
                data["assessmentGuideDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentAnnotations)) {
            data["formativeAssessmentAnnotations"] = [];
            for (let item of this.formativeAssessmentAnnotations)
                data["formativeAssessmentAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentAnnotations)) {
            data["summativeAssessmentAnnotations"] = [];
            for (let item of this.summativeAssessmentAnnotations)
                data["summativeAssessmentAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocAnnotations)) {
            data["groupDocAnnotations"] = [];
            for (let item of this.groupDocAnnotations)
                data["groupDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocAnnotations)) {
            data["saqaDocAnnotations"] = [];
            for (let item of this.saqaDocAnnotations)
                data["saqaDocAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.scheduleAnnotations)) {
            data["scheduleAnnotations"] = [];
            for (let item of this.scheduleAnnotations)
                data["scheduleAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocInputs)) {
            data["generalDocInputs"] = [];
            for (let item of this.generalDocInputs)
                data["generalDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocInputs)) {
            data["feedbackDocInputs"] = [];
            for (let item of this.feedbackDocInputs)
                data["feedbackDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocInputs)) {
            data["workplaceDocInputs"] = [];
            for (let item of this.workplaceDocInputs)
                data["workplaceDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocInputs)) {
            data["assessmentGuideDocInputs"] = [];
            for (let item of this.assessmentGuideDocInputs)
                data["assessmentGuideDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentInputs)) {
            data["formativeAssessmentInputs"] = [];
            for (let item of this.formativeAssessmentInputs)
                data["formativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentInputs)) {
            data["summativeAssessmentInputs"] = [];
            for (let item of this.summativeAssessmentInputs)
                data["summativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocInputs)) {
            data["saqaDocInputs"] = [];
            for (let item of this.saqaDocInputs)
                data["saqaDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocInputs)) {
            data["groupDocInputs"] = [];
            for (let item of this.groupDocInputs)
                data["groupDocInputs"].push(item.toJSON());
        }
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        if (Array.isArray(this.studentPOEs)) {
            data["studentPOEs"] = [];
            for (let item of this.studentPOEs)
                data["studentPOEs"].push(item.toJSON());
        }
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["qualPOEId"] = this.qualPOEId;
        data["qualPOE"] = this.qualPOE ? this.qualPOE.toJSON() : <any>undefined;
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        data["unlocked"] = this.unlocked;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOE extends IAuditableBaseEntity {
    generalDocs?: ProgrammePOEGeneralDoc[] | undefined;
    feedbackDocs?: ProgrammePOEFeedbackDoc[] | undefined;
    workplaceDocs?: ProgrammePOEWorkplaceDoc[] | undefined;
    assessmentGuideDocs?: ProgrammePOEAssessmentGuideDoc[] | undefined;
    groups?: ProgrammePOEGroup[] | undefined;
    generalDocAnnotations?: ProgrammePOEGeneralDocAnnotation[] | undefined;
    feedbackDocAnnotations?: ProgrammePOEFeedbackDocAnnotation[] | undefined;
    workplaceDocAnnotations?: ProgrammePOEWorkplaceDocAnnotation[] | undefined;
    assessmentGuideDocAnnotations?: ProgrammePOEAssessmentGuideDocAnnotation[] | undefined;
    formativeAssessmentAnnotations?: ProgrammePOEGroupFormativeAssessmentAnnotation[] | undefined;
    summativeAssessmentAnnotations?: ProgrammePOEGroupSummativeAssessmentAnnotation[] | undefined;
    groupDocAnnotations?: ProgrammePOEGroupDocAnnotation[] | undefined;
    saqaDocAnnotations?: ProgrammePOEGroupSaqaDocAnnotation[] | undefined;
    scheduleAnnotations?: ProgrammePOEScheduleAnnotation[] | undefined;
    generalDocInputs?: ProgrammePOEGeneralDocInput[] | undefined;
    feedbackDocInputs?: ProgrammePOEFeedbackDocInput[] | undefined;
    workplaceDocInputs?: ProgrammePOEWorkplaceDocInput[] | undefined;
    assessmentGuideDocInputs?: ProgrammePOEAssessmentGuideDocInput[] | undefined;
    formativeAssessmentInputs?: ProgrammePOEFormativeAssessmentInput[] | undefined;
    summativeAssessmentInputs?: ProgrammePOESummativeAssessmentInput[] | undefined;
    saqaDocInputs?: ProgrammePOESaqaDocInput[] | undefined;
    groupDocInputs?: ProgrammePOEGroupGeneralDocInput[] | undefined;
    schedule?: ProgrammePOESchedule | undefined;
    studentPOEs?: StudentPOE[] | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    qualPOEId?: number;
    qualPOE?: QualPOE | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    unlocked?: boolean;
}

export class ProgrammePOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends POEDocumentEntity implements IProgrammePOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    programmePOE?: ProgrammePOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: QualPOEGeneralDoc | undefined;
    annotations?: ProgrammePOEGeneralDocAnnotation[] | undefined;
    inputs?: ProgrammePOEGeneralDocInput[] | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    childrenDocs?: StudentPOEGeneralDoc[] | undefined;

    constructor(data?: IProgrammePOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOE = _data["programmePOE"] ? ProgrammePOE.fromJS(_data["programmePOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? QualPOEGeneralDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEGeneralDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammePOEGeneralDocInput.fromJS(item));
            }
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOEGeneralDoc.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOE"] = this.programmePOE ? this.programmePOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IPOEDocumentEntity {
    programmePOE?: ProgrammePOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: QualPOEGeneralDoc | undefined;
    annotations?: ProgrammePOEGeneralDocAnnotation[] | undefined;
    inputs?: ProgrammePOEGeneralDocInput[] | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    childrenDocs?: StudentPOEGeneralDoc[] | undefined;
}

export class ProgrammePOEGeneralDoc extends ProgrammePOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IProgrammePOEGeneralDoc {

    constructor(data?: IProgrammePOEGeneralDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGeneralDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGeneralDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGeneralDoc extends IProgrammePOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class QualPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends POEDocumentEntity implements IQualPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    qualPOE?: QualPOE | undefined;
    childrenDocs?: ProgrammePOEGeneralDoc[] | undefined;
    inputs?: QualPOEGeneralDocInput[] | undefined;
    activities?: QualPOEGeneralDocActivity[] | undefined;

    constructor(data?: IQualPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualPOE = _data["qualPOE"] ? QualPOE.fromJS(_data["qualPOE"]) : <any>undefined;
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(ProgrammePOEGeneralDoc.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualPOEGeneralDocInput.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(QualPOEGeneralDocActivity.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualPOE"] = this.qualPOE ? this.qualPOE.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IPOEDocumentEntity {
    qualPOE?: QualPOE | undefined;
    childrenDocs?: ProgrammePOEGeneralDoc[] | undefined;
    inputs?: QualPOEGeneralDocInput[] | undefined;
    activities?: QualPOEGeneralDocActivity[] | undefined;
}

export class QualPOEGeneralDoc extends QualPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IQualPOEGeneralDoc {

    constructor(data?: IQualPOEGeneralDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGeneralDoc {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGeneralDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGeneralDoc extends IQualPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class QualPOE extends AuditableBaseEntity implements IQualPOE {
    generalDocs?: QualPOEGeneralDoc[] | undefined;
    feedbackDocs?: QualPOEFeedbackDoc[] | undefined;
    workplaceDocs?: QualPOEWorkplaceDoc[] | undefined;
    assessmentGuideDocs?: QualPOEAssessmentGuideDoc[] | undefined;
    groups?: QualPOEGroup[] | undefined;
    generalDocInputs?: QualPOEGeneralDocInput[] | undefined;
    feedbackDocInputs?: QualPOEFeedbackDocInput[] | undefined;
    workplaceDocInputs?: QualPOEWorkplaceDocInput[] | undefined;
    assessmentGuideDocInputs?: QualPOEAssessmentGuideDocInput[] | undefined;
    formativeAssessmentInputs?: QualPOEFormativeAssessmentInput[] | undefined;
    summativeAssessmentInputs?: QualPOESummativeAssessmentInput[] | undefined;
    saqaDocInputs?: QualPOESaqaDocInput[] | undefined;
    groupDocInputs?: QualPOEGroupGeneralDocInput[] | undefined;
    programmePOEs?: ProgrammePOE[] | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    unlocked?: boolean;

    constructor(data?: IQualPOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["generalDocs"])) {
                this.generalDocs = [] as any;
                for (let item of _data["generalDocs"])
                    this.generalDocs!.push(QualPOEGeneralDoc.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(QualPOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocs"])) {
                this.workplaceDocs = [] as any;
                for (let item of _data["workplaceDocs"])
                    this.workplaceDocs!.push(QualPOEWorkplaceDoc.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocs"])) {
                this.assessmentGuideDocs = [] as any;
                for (let item of _data["assessmentGuideDocs"])
                    this.assessmentGuideDocs!.push(QualPOEAssessmentGuideDoc.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(QualPOEGroup.fromJS(item));
            }
            if (Array.isArray(_data["generalDocInputs"])) {
                this.generalDocInputs = [] as any;
                for (let item of _data["generalDocInputs"])
                    this.generalDocInputs!.push(QualPOEGeneralDocInput.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocInputs"])) {
                this.feedbackDocInputs = [] as any;
                for (let item of _data["feedbackDocInputs"])
                    this.feedbackDocInputs!.push(QualPOEFeedbackDocInput.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocInputs"])) {
                this.workplaceDocInputs = [] as any;
                for (let item of _data["workplaceDocInputs"])
                    this.workplaceDocInputs!.push(QualPOEWorkplaceDocInput.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocInputs"])) {
                this.assessmentGuideDocInputs = [] as any;
                for (let item of _data["assessmentGuideDocInputs"])
                    this.assessmentGuideDocInputs!.push(QualPOEAssessmentGuideDocInput.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentInputs"])) {
                this.formativeAssessmentInputs = [] as any;
                for (let item of _data["formativeAssessmentInputs"])
                    this.formativeAssessmentInputs!.push(QualPOEFormativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentInputs"])) {
                this.summativeAssessmentInputs = [] as any;
                for (let item of _data["summativeAssessmentInputs"])
                    this.summativeAssessmentInputs!.push(QualPOESummativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocInputs"])) {
                this.saqaDocInputs = [] as any;
                for (let item of _data["saqaDocInputs"])
                    this.saqaDocInputs!.push(QualPOESaqaDocInput.fromJS(item));
            }
            if (Array.isArray(_data["groupDocInputs"])) {
                this.groupDocInputs = [] as any;
                for (let item of _data["groupDocInputs"])
                    this.groupDocInputs!.push(QualPOEGroupGeneralDocInput.fromJS(item));
            }
            if (Array.isArray(_data["programmePOEs"])) {
                this.programmePOEs = [] as any;
                for (let item of _data["programmePOEs"])
                    this.programmePOEs!.push(ProgrammePOE.fromJS(item));
            }
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            this.unlocked = _data["unlocked"];
        }
    }

    static override fromJS(data: any): QualPOE {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generalDocs)) {
            data["generalDocs"] = [];
            for (let item of this.generalDocs)
                data["generalDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocs)) {
            data["workplaceDocs"] = [];
            for (let item of this.workplaceDocs)
                data["workplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocs)) {
            data["assessmentGuideDocs"] = [];
            for (let item of this.assessmentGuideDocs)
                data["assessmentGuideDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocInputs)) {
            data["generalDocInputs"] = [];
            for (let item of this.generalDocInputs)
                data["generalDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocInputs)) {
            data["feedbackDocInputs"] = [];
            for (let item of this.feedbackDocInputs)
                data["feedbackDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocInputs)) {
            data["workplaceDocInputs"] = [];
            for (let item of this.workplaceDocInputs)
                data["workplaceDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocInputs)) {
            data["assessmentGuideDocInputs"] = [];
            for (let item of this.assessmentGuideDocInputs)
                data["assessmentGuideDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentInputs)) {
            data["formativeAssessmentInputs"] = [];
            for (let item of this.formativeAssessmentInputs)
                data["formativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentInputs)) {
            data["summativeAssessmentInputs"] = [];
            for (let item of this.summativeAssessmentInputs)
                data["summativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocInputs)) {
            data["saqaDocInputs"] = [];
            for (let item of this.saqaDocInputs)
                data["saqaDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocInputs)) {
            data["groupDocInputs"] = [];
            for (let item of this.groupDocInputs)
                data["groupDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOEs)) {
            data["programmePOEs"] = [];
            for (let item of this.programmePOEs)
                data["programmePOEs"].push(item.toJSON());
        }
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["unlocked"] = this.unlocked;
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOE extends IAuditableBaseEntity {
    generalDocs?: QualPOEGeneralDoc[] | undefined;
    feedbackDocs?: QualPOEFeedbackDoc[] | undefined;
    workplaceDocs?: QualPOEWorkplaceDoc[] | undefined;
    assessmentGuideDocs?: QualPOEAssessmentGuideDoc[] | undefined;
    groups?: QualPOEGroup[] | undefined;
    generalDocInputs?: QualPOEGeneralDocInput[] | undefined;
    feedbackDocInputs?: QualPOEFeedbackDocInput[] | undefined;
    workplaceDocInputs?: QualPOEWorkplaceDocInput[] | undefined;
    assessmentGuideDocInputs?: QualPOEAssessmentGuideDocInput[] | undefined;
    formativeAssessmentInputs?: QualPOEFormativeAssessmentInput[] | undefined;
    summativeAssessmentInputs?: QualPOESummativeAssessmentInput[] | undefined;
    saqaDocInputs?: QualPOESaqaDocInput[] | undefined;
    groupDocInputs?: QualPOEGroupGeneralDocInput[] | undefined;
    programmePOEs?: ProgrammePOE[] | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    unlocked?: boolean;
}

export class QualPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends POEDocumentEntity implements IQualPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    qualPOE?: QualPOE | undefined;
    childrenDocs?: ProgrammePOEFeedbackDoc[] | undefined;
    inputs?: QualPOEFeedbackDocInput[] | undefined;
    activities?: QualPOEFeedbackDocActivity[] | undefined;

    constructor(data?: IQualPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualPOE = _data["qualPOE"] ? QualPOE.fromJS(_data["qualPOE"]) : <any>undefined;
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(ProgrammePOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualPOEFeedbackDocInput.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(QualPOEFeedbackDocActivity.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualPOE"] = this.qualPOE ? this.qualPOE.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IPOEDocumentEntity {
    qualPOE?: QualPOE | undefined;
    childrenDocs?: ProgrammePOEFeedbackDoc[] | undefined;
    inputs?: QualPOEFeedbackDocInput[] | undefined;
    activities?: QualPOEFeedbackDocActivity[] | undefined;
}

export class QualPOEFeedbackDoc extends QualPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IQualPOEFeedbackDoc {
    isFISA?: boolean;
    isCompetencyChecklist?: boolean;
    poeGroupId?: number | undefined;
    qualPOEGroup?: QualPOEGroup | undefined;

    constructor(data?: IQualPOEFeedbackDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isFISA = _data["isFISA"];
            this.isCompetencyChecklist = _data["isCompetencyChecklist"];
            this.poeGroupId = _data["poeGroupId"];
            this.qualPOEGroup = _data["qualPOEGroup"] ? QualPOEGroup.fromJS(_data["qualPOEGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualPOEFeedbackDoc {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFeedbackDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFISA"] = this.isFISA;
        data["isCompetencyChecklist"] = this.isCompetencyChecklist;
        data["poeGroupId"] = this.poeGroupId;
        data["qualPOEGroup"] = this.qualPOEGroup ? this.qualPOEGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFeedbackDoc extends IQualPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    isFISA?: boolean;
    isCompetencyChecklist?: boolean;
    poeGroupId?: number | undefined;
    qualPOEGroup?: QualPOEGroup | undefined;
}

export abstract class QualPOEGroupEntityOfQualPOEGroupAndQualPOEAndQualPOEFormativeAssessmentAndQualPOESummativeAssessmentAndQualPOEGroupDocAndQualPOESaqaDocAndQualPOEFeedbackDocAndQualPOEGroupUnitStandardsAndQualPOEGroupKnowledgeModules extends AuditableBaseEntity implements IQualPOEGroupEntityOfQualPOEGroupAndQualPOEAndQualPOEFormativeAssessmentAndQualPOESummativeAssessmentAndQualPOEGroupDocAndQualPOESaqaDocAndQualPOEFeedbackDocAndQualPOEGroupUnitStandardsAndQualPOEGroupKnowledgeModules {
    name?: string | undefined;
    index?: number;
    poeId?: number;
    poe?: QualPOE | undefined;
    moduleType?: KnowledgeModuleType | undefined;
    formativeAssessments?: QualPOEFormativeAssessment[] | undefined;
    summativeAssessments?: QualPOESummativeAssessment[] | undefined;
    documents?: QualPOEGroupDoc[] | undefined;
    saqaDocs?: QualPOESaqaDoc[] | undefined;
    feedbackDocs?: QualPOEFeedbackDoc[] | undefined;
    unitStandards?: QualPOEGroupUnitStandards[] | undefined;
    knowledgeModules?: QualPOEGroupKnowledgeModules[] | undefined;

    constructor(data?: IQualPOEGroupEntityOfQualPOEGroupAndQualPOEAndQualPOEFormativeAssessmentAndQualPOESummativeAssessmentAndQualPOEGroupDocAndQualPOESaqaDocAndQualPOEFeedbackDocAndQualPOEGroupUnitStandardsAndQualPOEGroupKnowledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.index = _data["index"];
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
            this.moduleType = _data["moduleType"];
            if (Array.isArray(_data["formativeAssessments"])) {
                this.formativeAssessments = [] as any;
                for (let item of _data["formativeAssessments"])
                    this.formativeAssessments!.push(QualPOEFormativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessments"])) {
                this.summativeAssessments = [] as any;
                for (let item of _data["summativeAssessments"])
                    this.summativeAssessments!.push(QualPOESummativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(QualPOEGroupDoc.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocs"])) {
                this.saqaDocs = [] as any;
                for (let item of _data["saqaDocs"])
                    this.saqaDocs!.push(QualPOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(QualPOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["unitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["unitStandards"])
                    this.unitStandards!.push(QualPOEGroupUnitStandards.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeModules"])) {
                this.knowledgeModules = [] as any;
                for (let item of _data["knowledgeModules"])
                    this.knowledgeModules!.push(QualPOEGroupKnowledgeModules.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupEntityOfQualPOEGroupAndQualPOEAndQualPOEFormativeAssessmentAndQualPOESummativeAssessmentAndQualPOEGroupDocAndQualPOESaqaDocAndQualPOEFeedbackDocAndQualPOEGroupUnitStandardsAndQualPOEGroupKnowledgeModules {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualPOEGroupEntityOfQualPOEGroupAndQualPOEAndQualPOEFormativeAssessmentAndQualPOESummativeAssessmentAndQualPOEGroupDocAndQualPOESaqaDocAndQualPOEFeedbackDocAndQualPOEGroupUnitStandardsAndQualPOEGroupKnowledgeModules' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["index"] = this.index;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        data["moduleType"] = this.moduleType;
        if (Array.isArray(this.formativeAssessments)) {
            data["formativeAssessments"] = [];
            for (let item of this.formativeAssessments)
                data["formativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessments)) {
            data["summativeAssessments"] = [];
            for (let item of this.summativeAssessments)
                data["summativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocs)) {
            data["saqaDocs"] = [];
            for (let item of this.saqaDocs)
                data["saqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandards)) {
            data["unitStandards"] = [];
            for (let item of this.unitStandards)
                data["unitStandards"].push(item.toJSON());
        }
        if (Array.isArray(this.knowledgeModules)) {
            data["knowledgeModules"] = [];
            for (let item of this.knowledgeModules)
                data["knowledgeModules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupEntityOfQualPOEGroupAndQualPOEAndQualPOEFormativeAssessmentAndQualPOESummativeAssessmentAndQualPOEGroupDocAndQualPOESaqaDocAndQualPOEFeedbackDocAndQualPOEGroupUnitStandardsAndQualPOEGroupKnowledgeModules extends IAuditableBaseEntity {
    name?: string | undefined;
    index?: number;
    poeId?: number;
    poe?: QualPOE | undefined;
    moduleType?: KnowledgeModuleType | undefined;
    formativeAssessments?: QualPOEFormativeAssessment[] | undefined;
    summativeAssessments?: QualPOESummativeAssessment[] | undefined;
    documents?: QualPOEGroupDoc[] | undefined;
    saqaDocs?: QualPOESaqaDoc[] | undefined;
    feedbackDocs?: QualPOEFeedbackDoc[] | undefined;
    unitStandards?: QualPOEGroupUnitStandards[] | undefined;
    knowledgeModules?: QualPOEGroupKnowledgeModules[] | undefined;
}

export class QualPOEGroup extends QualPOEGroupEntityOfQualPOEGroupAndQualPOEAndQualPOEFormativeAssessmentAndQualPOESummativeAssessmentAndQualPOEGroupDocAndQualPOESaqaDocAndQualPOEFeedbackDocAndQualPOEGroupUnitStandardsAndQualPOEGroupKnowledgeModules implements IQualPOEGroup {
    allSaqaDocsAssigned?: boolean;
    childrenGroups?: ProgrammePOEGroup[] | undefined;
    learningMaterial?: QualificationLearningMaterial[] | undefined;
    formativeAssessmentInputs?: QualPOEFormativeAssessmentInput[] | undefined;
    summativeAssessmentInputs?: QualPOESummativeAssessmentInput[] | undefined;
    groupDocInputs?: QualPOEGroupGeneralDocInput[] | undefined;
    saqaDocInputs?: QualPOESaqaDocInput[] | undefined;

    constructor(data?: IQualPOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allSaqaDocsAssigned = _data["allSaqaDocsAssigned"];
            if (Array.isArray(_data["childrenGroups"])) {
                this.childrenGroups = [] as any;
                for (let item of _data["childrenGroups"])
                    this.childrenGroups!.push(ProgrammePOEGroup.fromJS(item));
            }
            if (Array.isArray(_data["learningMaterial"])) {
                this.learningMaterial = [] as any;
                for (let item of _data["learningMaterial"])
                    this.learningMaterial!.push(QualificationLearningMaterial.fromJS(item));
            }
            if (Array.isArray(_data["formativeAssessmentInputs"])) {
                this.formativeAssessmentInputs = [] as any;
                for (let item of _data["formativeAssessmentInputs"])
                    this.formativeAssessmentInputs!.push(QualPOEFormativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessmentInputs"])) {
                this.summativeAssessmentInputs = [] as any;
                for (let item of _data["summativeAssessmentInputs"])
                    this.summativeAssessmentInputs!.push(QualPOESummativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["groupDocInputs"])) {
                this.groupDocInputs = [] as any;
                for (let item of _data["groupDocInputs"])
                    this.groupDocInputs!.push(QualPOEGroupGeneralDocInput.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocInputs"])) {
                this.saqaDocInputs = [] as any;
                for (let item of _data["saqaDocInputs"])
                    this.saqaDocInputs!.push(QualPOESaqaDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allSaqaDocsAssigned"] = this.allSaqaDocsAssigned;
        if (Array.isArray(this.childrenGroups)) {
            data["childrenGroups"] = [];
            for (let item of this.childrenGroups)
                data["childrenGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.learningMaterial)) {
            data["learningMaterial"] = [];
            for (let item of this.learningMaterial)
                data["learningMaterial"].push(item.toJSON());
        }
        if (Array.isArray(this.formativeAssessmentInputs)) {
            data["formativeAssessmentInputs"] = [];
            for (let item of this.formativeAssessmentInputs)
                data["formativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessmentInputs)) {
            data["summativeAssessmentInputs"] = [];
            for (let item of this.summativeAssessmentInputs)
                data["summativeAssessmentInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.groupDocInputs)) {
            data["groupDocInputs"] = [];
            for (let item of this.groupDocInputs)
                data["groupDocInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocInputs)) {
            data["saqaDocInputs"] = [];
            for (let item of this.saqaDocInputs)
                data["saqaDocInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroup extends IQualPOEGroupEntityOfQualPOEGroupAndQualPOEAndQualPOEFormativeAssessmentAndQualPOESummativeAssessmentAndQualPOEGroupDocAndQualPOESaqaDocAndQualPOEFeedbackDocAndQualPOEGroupUnitStandardsAndQualPOEGroupKnowledgeModules {
    allSaqaDocsAssigned?: boolean;
    childrenGroups?: ProgrammePOEGroup[] | undefined;
    learningMaterial?: QualificationLearningMaterial[] | undefined;
    formativeAssessmentInputs?: QualPOEFormativeAssessmentInput[] | undefined;
    summativeAssessmentInputs?: QualPOESummativeAssessmentInput[] | undefined;
    groupDocInputs?: QualPOEGroupGeneralDocInput[] | undefined;
    saqaDocInputs?: QualPOESaqaDocInput[] | undefined;
}

export class QualificationLearningMaterial extends FileEntity implements IQualificationLearningMaterial {
    staffOnly?: boolean;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    qualPOEGroupId?: number | undefined;
    qualPOEGroup?: QualPOEGroup | undefined;

    constructor(data?: IQualificationLearningMaterial) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.staffOnly = _data["staffOnly"];
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            this.qualPOEGroupId = _data["qualPOEGroupId"];
            this.qualPOEGroup = _data["qualPOEGroup"] ? QualPOEGroup.fromJS(_data["qualPOEGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualificationLearningMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationLearningMaterial();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffOnly"] = this.staffOnly;
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["qualPOEGroupId"] = this.qualPOEGroupId;
        data["qualPOEGroup"] = this.qualPOEGroup ? this.qualPOEGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualificationLearningMaterial extends IFileEntity {
    staffOnly?: boolean;
    qualificationId?: number;
    qualification?: Qualification | undefined;
    qualPOEGroupId?: number | undefined;
    qualPOEGroup?: QualPOEGroup | undefined;
}

export class POEGroupInputOfQualPOESummativeAssessmentAndQualPOEAndQualPOEGroup extends Input implements IPOEGroupInputOfQualPOESummativeAssessmentAndQualPOEAndQualPOEGroup {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: QualPOESummativeAssessment | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;

    constructor(data?: IPOEGroupInputOfQualPOESummativeAssessmentAndQualPOEAndQualPOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? QualPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? QualPOESummativeAssessment.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupInputOfQualPOESummativeAssessmentAndQualPOEAndQualPOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new POEGroupInputOfQualPOESummativeAssessmentAndQualPOEAndQualPOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupInputOfQualPOESummativeAssessmentAndQualPOEAndQualPOEGroup extends IInput {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: QualPOESummativeAssessment | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;
}

export class QualPOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends POEGroupInputOfQualPOESummativeAssessmentAndQualPOEAndQualPOEGroup implements IQualPOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOESummativeAssessmentInput[] | undefined;

    constructor(data?: IQualPOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammePOESummativeAssessmentInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IPOEGroupInputOfQualPOESummativeAssessmentAndQualPOEAndQualPOEGroup {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOESummativeAssessmentInput[] | undefined;
}

export class QualPOESummativeAssessmentInput extends QualPOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IQualPOESummativeAssessmentInput {

    constructor(data?: IQualPOESummativeAssessmentInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESummativeAssessmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESummativeAssessmentInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESummativeAssessmentInput extends IQualPOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class POEGroupInputOfProgrammePOESummativeAssessmentAndProgrammePOEAndProgrammePOEGroup extends Input implements IPOEGroupInputOfProgrammePOESummativeAssessmentAndProgrammePOEAndProgrammePOEGroup {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: ProgrammePOESummativeAssessment | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEGroupInputOfProgrammePOESummativeAssessmentAndProgrammePOEAndProgrammePOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? ProgrammePOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? ProgrammePOESummativeAssessment.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupInputOfProgrammePOESummativeAssessmentAndProgrammePOEAndProgrammePOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new POEGroupInputOfProgrammePOESummativeAssessmentAndProgrammePOEAndProgrammePOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupInputOfProgrammePOESummativeAssessmentAndProgrammePOEAndProgrammePOEGroup extends IInput {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: ProgrammePOESummativeAssessment | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends POEGroupInputOfProgrammePOESummativeAssessmentAndProgrammePOEAndProgrammePOEGroup implements IProgrammePOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    studentInputAnswers?: StudentPOESummativeAssessmentInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOESummativeAssessmentInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammePOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentPOESummativeAssessmentInputAnswer.fromJS(item));
            }
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualPOESummativeAssessmentInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IPOEGroupInputOfProgrammePOESummativeAssessmentAndProgrammePOEAndProgrammePOEGroup {
    studentInputAnswers?: StudentPOESummativeAssessmentInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOESummativeAssessmentInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;
}

export class ProgrammePOESummativeAssessmentInput extends ProgrammePOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IProgrammePOESummativeAssessmentInput {

    constructor(data?: IProgrammePOESummativeAssessmentInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOESummativeAssessmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOESummativeAssessmentInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOESummativeAssessmentInput extends IProgrammePOEGroupInputOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class StudentPOEGroupInputAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends StudentAnswer implements IStudentPOEGroupInputAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: StudentPOESummativeAssessment | undefined;
    programmePOEGroupInputId?: number;
    programmePOEGroupInput?: ProgrammePOESummativeAssessmentInput | undefined;

    constructor(data?: IStudentPOEGroupInputAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? StudentPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? StudentPOESummativeAssessment.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.programmePOEGroupInputId = _data["programmePOEGroupInputId"];
            this.programmePOEGroupInput = _data["programmePOEGroupInput"] ? ProgrammePOESummativeAssessmentInput.fromJS(_data["programmePOEGroupInput"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEGroupInputAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupInputAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["programmePOEGroupInputId"] = this.programmePOEGroupInputId;
        data["programmePOEGroupInput"] = this.programmePOEGroupInput ? this.programmePOEGroupInput.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupInputAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IStudentAnswer {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: StudentPOESummativeAssessment | undefined;
    programmePOEGroupInputId?: number;
    programmePOEGroupInput?: ProgrammePOESummativeAssessmentInput | undefined;
}

export class StudentPOESummativeAssessmentInputAnswer extends StudentPOEGroupInputAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IStudentPOESummativeAssessmentInputAnswer {

    constructor(data?: IStudentPOESummativeAssessmentInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOESummativeAssessmentInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOESummativeAssessmentInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOESummativeAssessmentInputAnswer extends IStudentPOEGroupInputAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class StudentPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends POEGroupDocumentEntityOfStudentPOEGroup implements IStudentPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOESummativeAssessment | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGroupSummativeAssessmentAnnotation[] | undefined;
    inputAnswers?: StudentPOESummativeAssessmentInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IStudentPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOESummativeAssessment.fromJS(_data["parentDoc"]) : <any>undefined;
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEGroupSummativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentPOESummativeAssessmentInputAnswer.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): StudentPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IPOEGroupDocumentEntityOfStudentPOEGroup {
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOESummativeAssessment | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGroupSummativeAssessmentAnnotation[] | undefined;
    inputAnswers?: StudentPOESummativeAssessmentInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class StudentPOESummativeAssessment extends StudentPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IStudentPOESummativeAssessment {

    constructor(data?: IStudentPOESummativeAssessment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOESummativeAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOESummativeAssessment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOESummativeAssessment extends IStudentPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class ProgrammePOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends POEGroupDocumentEntityOfProgrammePOEGroup implements IProgrammePOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    parentDocId?: number | undefined;
    parentDoc?: QualPOESummativeAssessment | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    annotations?: ProgrammePOEGroupSummativeAssessmentAnnotation[] | undefined;
    childrenDocs?: StudentPOESummativeAssessment[] | undefined;
    inputs?: ProgrammePOESummativeAssessmentInput[] | undefined;

    constructor(data?: IProgrammePOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? QualPOESummativeAssessment.fromJS(_data["parentDoc"]) : <any>undefined;
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEGroupSummativeAssessmentAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOESummativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammePOESummativeAssessmentInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IPOEGroupDocumentEntityOfProgrammePOEGroup {
    parentDocId?: number | undefined;
    parentDoc?: QualPOESummativeAssessment | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    annotations?: ProgrammePOEGroupSummativeAssessmentAnnotation[] | undefined;
    childrenDocs?: StudentPOESummativeAssessment[] | undefined;
    inputs?: ProgrammePOESummativeAssessmentInput[] | undefined;
}

export class ProgrammePOESummativeAssessment extends ProgrammePOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IProgrammePOESummativeAssessment {

    constructor(data?: IProgrammePOESummativeAssessment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOESummativeAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOESummativeAssessment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOESummativeAssessment extends IProgrammePOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class QualPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends POEGroupDocumentEntityOfQualPOEGroup implements IQualPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    childrenDocs?: ProgrammePOESummativeAssessment[] | undefined;
    inputs?: QualPOESummativeAssessmentInput[] | undefined;
    activities?: QualPOESummativeAssessmentActivity[] | undefined;

    constructor(data?: IQualPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(ProgrammePOESummativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualPOESummativeAssessmentInput.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(QualPOESummativeAssessmentActivity.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IPOEGroupDocumentEntityOfQualPOEGroup {
    childrenDocs?: ProgrammePOESummativeAssessment[] | undefined;
    inputs?: QualPOESummativeAssessmentInput[] | undefined;
    activities?: QualPOESummativeAssessmentActivity[] | undefined;
}

export class QualPOESummativeAssessment extends QualPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IQualPOESummativeAssessment {

    constructor(data?: IQualPOESummativeAssessment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESummativeAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESummativeAssessment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESummativeAssessment extends IQualPOEGroupDocumentEntityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export abstract class QualGroupActivityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends AuditableBaseEntity implements IQualGroupActivityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOESummativeAssessmentQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipSummativeActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOESummativeAssessment | undefined;

    constructor(data?: IQualGroupActivityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(QualPOESummativeAssessmentQuestion.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipActivityStatus"])) {
                this.studentLearnershipActivityStatus = [] as any;
                for (let item of _data["studentLearnershipActivityStatus"])
                    this.studentLearnershipActivityStatus!.push(StudentLearnershipSummativeActivityStatus.fromJS(item));
            }
            this.qualPoeDocId = _data["qualPoeDocId"];
            this.qualPoeDoc = _data["qualPoeDoc"] ? QualPOESummativeAssessment.fromJS(_data["qualPoeDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualGroupActivityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupActivityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipActivityStatus)) {
            data["studentLearnershipActivityStatus"] = [];
            for (let item of this.studentLearnershipActivityStatus)
                data["studentLearnershipActivityStatus"].push(item.toJSON());
        }
        data["qualPoeDocId"] = this.qualPoeDocId;
        data["qualPoeDoc"] = this.qualPoeDoc ? this.qualPoeDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupActivityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IAuditableBaseEntity {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOESummativeAssessmentQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipSummativeActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOESummativeAssessment | undefined;
}

export class QualPOESummativeAssessmentActivity extends QualGroupActivityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IQualPOESummativeAssessmentActivity {

    constructor(data?: IQualPOESummativeAssessmentActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESummativeAssessmentActivity {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESummativeAssessmentActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESummativeAssessmentActivity extends IQualGroupActivityOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export abstract class QualGroupActivityQuestionOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends PageAndPosition implements IQualGroupActivityQuestionOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOESummativeAssessmentActivity | undefined;
    potentialAnswers?: QualPOESummativeAssessmentAnswer[] | undefined;
    studentQuestionAnswers?: StudentSummativeQuestionAnswer[] | undefined;

    constructor(data?: IQualGroupActivityQuestionOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.multiSelect = _data["multiSelect"];
            this.type = _data["type"];
            this.activity = _data["activity"] ? QualPOESummativeAssessmentActivity.fromJS(_data["activity"]) : <any>undefined;
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(QualPOESummativeAssessmentAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentSummativeQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualGroupActivityQuestionOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupActivityQuestionOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["multiSelect"] = this.multiSelect;
        data["type"] = this.type;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupActivityQuestionOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IPageAndPosition {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOESummativeAssessmentActivity | undefined;
    potentialAnswers?: QualPOESummativeAssessmentAnswer[] | undefined;
    studentQuestionAnswers?: StudentSummativeQuestionAnswer[] | undefined;
}

export class QualPOESummativeAssessmentQuestion extends QualGroupActivityQuestionOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IQualPOESummativeAssessmentQuestion {

    constructor(data?: IQualPOESummativeAssessmentQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESummativeAssessmentQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESummativeAssessmentQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESummativeAssessmentQuestion extends IQualGroupActivityQuestionOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export enum ActivityQuestionTypes {
    MultipleChoice = 0,
    Paragraph = 1,
}

export abstract class QualGroupPotentialAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends AuditableBaseEntity implements IQualGroupPotentialAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    questionId?: number;
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOESummativeAssessmentQuestion | undefined;
    studentQuestionAnswers?: StudentSummativeQuestionAnswer[] | undefined;

    constructor(data?: IQualGroupPotentialAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionId = _data["questionId"];
            this.answerText = _data["answerText"];
            this.isCorrect = _data["isCorrect"];
            this.marks = _data["marks"];
            this.activityQuestionId = _data["activityQuestionId"];
            this.activityQuestion = _data["activityQuestion"] ? QualPOESummativeAssessmentQuestion.fromJS(_data["activityQuestion"]) : <any>undefined;
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentSummativeQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualGroupPotentialAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupPotentialAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answerText"] = this.answerText;
        data["isCorrect"] = this.isCorrect;
        data["marks"] = this.marks;
        data["activityQuestionId"] = this.activityQuestionId;
        data["activityQuestion"] = this.activityQuestion ? this.activityQuestion.toJSON() : <any>undefined;
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupPotentialAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IAuditableBaseEntity {
    questionId?: number;
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOESummativeAssessmentQuestion | undefined;
    studentQuestionAnswers?: StudentSummativeQuestionAnswer[] | undefined;
}

export class QualPOESummativeAssessmentAnswer extends QualGroupPotentialAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IQualPOESummativeAssessmentAnswer {

    constructor(data?: IQualPOESummativeAssessmentAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESummativeAssessmentAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESummativeAssessmentAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESummativeAssessmentAnswer extends IQualGroupPotentialAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class StudentGroupQuestionAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends AuditableBaseEntity implements IStudentGroupQuestionAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOESummativeAssessmentQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOESummativeAssessmentAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;

    constructor(data?: IStudentGroupQuestionAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPoeId = _data["studentPoeId"];
            this.studentPoe = _data["studentPoe"] ? StudentPOE.fromJS(_data["studentPoe"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.question = _data["question"] ? QualPOESummativeAssessmentQuestion.fromJS(_data["question"]) : <any>undefined;
            this.answerId = _data["answerId"];
            this.answer = _data["answer"] ? QualPOESummativeAssessmentAnswer.fromJS(_data["answer"]) : <any>undefined;
            this.paragraphAnswer = _data["paragraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
        }
    }

    static override fromJS(data: any): StudentGroupQuestionAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentGroupQuestionAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPoeId"] = this.studentPoeId;
        data["studentPoe"] = this.studentPoe ? this.studentPoe.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["paragraphAnswer"] = this.paragraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentGroupQuestionAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IAuditableBaseEntity {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOESummativeAssessmentQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOESummativeAssessmentAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
}

export class StudentSummativeQuestionAnswer extends StudentGroupQuestionAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IStudentSummativeQuestionAnswer {

    constructor(data?: IStudentSummativeQuestionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentSummativeQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentSummativeQuestionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentSummativeQuestionAnswer extends IStudentGroupQuestionAnswerOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class StudentLearnershipGroupActivityStatusOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends AuditableBaseEntity implements IStudentLearnershipGroupActivityStatusOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOESummativeAssessmentActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;

    constructor(data?: IStudentLearnershipGroupActivityStatusOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? QualPOESummativeAssessmentActivity.fromJS(_data["activity"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static override fromJS(data: any): StudentLearnershipGroupActivityStatusOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipGroupActivityStatusOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipGroupActivityStatusOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IAuditableBaseEntity {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOESummativeAssessmentActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;
}

export class StudentLearnershipSummativeActivityStatus extends StudentLearnershipGroupActivityStatusOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IStudentLearnershipSummativeActivityStatus {

    constructor(data?: IStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipSummativeActivityStatus extends IStudentLearnershipGroupActivityStatusOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class POEDocumentType extends DocumentTypeEntity implements IPOEDocumentType {
    poeFolder?: POEFolders;
    qualPOEAssessmentGuideDocs?: QualPOEAssessmentGuideDoc[] | undefined;
    programmePOEAssessmentGuideDocs?: ProgrammePOEAssessmentGuideDoc[] | undefined;
    studentPOEAssessmentGuideDocs?: StudentPOEAssessmentGuideDoc[] | undefined;
    qualPOEFeedbackDocs?: QualPOEFeedbackDoc[] | undefined;
    programmePOEFeedbackDocs?: ProgrammePOEFeedbackDoc[] | undefined;
    studentPOEFeedbackDocs?: StudentPOEFeedbackDoc[] | undefined;
    qualPOEWorkplaceDocs?: QualPOEWorkplaceDoc[] | undefined;
    programmePOEWorkplaceDocs?: ProgrammePOEWorkplaceDoc[] | undefined;
    studentPOEWorkplaceDocs?: StudentPOEWorkplaceDoc[] | undefined;
    qualPOESummativeAssessments?: QualPOESummativeAssessment[] | undefined;
    programmePOESummativeAssessments?: ProgrammePOESummativeAssessment[] | undefined;
    studentPOESummativeAssessments?: StudentPOESummativeAssessment[] | undefined;
    qualPOESaqaDocs?: QualPOESaqaDoc[] | undefined;
    programmePOESaqaDocs?: ProgrammePOESaqaDoc[] | undefined;
    studentPOESaqaDocs?: StudentPOESaqaDoc[] | undefined;
    qualPOEGroupDocs?: QualPOEGroupDoc[] | undefined;
    programmePOEGroupDocs?: ProgrammePOEGroupDoc[] | undefined;
    studentPOEGroupDocs?: StudentPOEGroupDoc[] | undefined;
    qualPOEGeneralDocs?: QualPOEGeneralDoc[] | undefined;
    programmePOEGeneralDocs?: ProgrammePOEGeneralDoc[] | undefined;
    studentPOEGeneralDocs?: StudentPOEGeneralDoc[] | undefined;
    qualPOEFormativeAssessments?: QualPOEFormativeAssessment[] | undefined;
    programmePOEFormativeAssessments?: ProgrammePOEFormativeAssessment[] | undefined;
    studentPOEFormativeAssessments?: StudentPOEFormativeAssessment[] | undefined;

    constructor(data?: IPOEDocumentType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            if (Array.isArray(_data["qualPOEAssessmentGuideDocs"])) {
                this.qualPOEAssessmentGuideDocs = [] as any;
                for (let item of _data["qualPOEAssessmentGuideDocs"])
                    this.qualPOEAssessmentGuideDocs!.push(QualPOEAssessmentGuideDoc.fromJS(item));
            }
            if (Array.isArray(_data["programmePOEAssessmentGuideDocs"])) {
                this.programmePOEAssessmentGuideDocs = [] as any;
                for (let item of _data["programmePOEAssessmentGuideDocs"])
                    this.programmePOEAssessmentGuideDocs!.push(ProgrammePOEAssessmentGuideDoc.fromJS(item));
            }
            if (Array.isArray(_data["studentPOEAssessmentGuideDocs"])) {
                this.studentPOEAssessmentGuideDocs = [] as any;
                for (let item of _data["studentPOEAssessmentGuideDocs"])
                    this.studentPOEAssessmentGuideDocs!.push(StudentPOEAssessmentGuideDoc.fromJS(item));
            }
            if (Array.isArray(_data["qualPOEFeedbackDocs"])) {
                this.qualPOEFeedbackDocs = [] as any;
                for (let item of _data["qualPOEFeedbackDocs"])
                    this.qualPOEFeedbackDocs!.push(QualPOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["programmePOEFeedbackDocs"])) {
                this.programmePOEFeedbackDocs = [] as any;
                for (let item of _data["programmePOEFeedbackDocs"])
                    this.programmePOEFeedbackDocs!.push(ProgrammePOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["studentPOEFeedbackDocs"])) {
                this.studentPOEFeedbackDocs = [] as any;
                for (let item of _data["studentPOEFeedbackDocs"])
                    this.studentPOEFeedbackDocs!.push(StudentPOEFeedbackDoc.fromJS(item));
            }
            if (Array.isArray(_data["qualPOEWorkplaceDocs"])) {
                this.qualPOEWorkplaceDocs = [] as any;
                for (let item of _data["qualPOEWorkplaceDocs"])
                    this.qualPOEWorkplaceDocs!.push(QualPOEWorkplaceDoc.fromJS(item));
            }
            if (Array.isArray(_data["programmePOEWorkplaceDocs"])) {
                this.programmePOEWorkplaceDocs = [] as any;
                for (let item of _data["programmePOEWorkplaceDocs"])
                    this.programmePOEWorkplaceDocs!.push(ProgrammePOEWorkplaceDoc.fromJS(item));
            }
            if (Array.isArray(_data["studentPOEWorkplaceDocs"])) {
                this.studentPOEWorkplaceDocs = [] as any;
                for (let item of _data["studentPOEWorkplaceDocs"])
                    this.studentPOEWorkplaceDocs!.push(StudentPOEWorkplaceDoc.fromJS(item));
            }
            if (Array.isArray(_data["qualPOESummativeAssessments"])) {
                this.qualPOESummativeAssessments = [] as any;
                for (let item of _data["qualPOESummativeAssessments"])
                    this.qualPOESummativeAssessments!.push(QualPOESummativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["programmePOESummativeAssessments"])) {
                this.programmePOESummativeAssessments = [] as any;
                for (let item of _data["programmePOESummativeAssessments"])
                    this.programmePOESummativeAssessments!.push(ProgrammePOESummativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["studentPOESummativeAssessments"])) {
                this.studentPOESummativeAssessments = [] as any;
                for (let item of _data["studentPOESummativeAssessments"])
                    this.studentPOESummativeAssessments!.push(StudentPOESummativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["qualPOESaqaDocs"])) {
                this.qualPOESaqaDocs = [] as any;
                for (let item of _data["qualPOESaqaDocs"])
                    this.qualPOESaqaDocs!.push(QualPOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["programmePOESaqaDocs"])) {
                this.programmePOESaqaDocs = [] as any;
                for (let item of _data["programmePOESaqaDocs"])
                    this.programmePOESaqaDocs!.push(ProgrammePOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["studentPOESaqaDocs"])) {
                this.studentPOESaqaDocs = [] as any;
                for (let item of _data["studentPOESaqaDocs"])
                    this.studentPOESaqaDocs!.push(StudentPOESaqaDoc.fromJS(item));
            }
            if (Array.isArray(_data["qualPOEGroupDocs"])) {
                this.qualPOEGroupDocs = [] as any;
                for (let item of _data["qualPOEGroupDocs"])
                    this.qualPOEGroupDocs!.push(QualPOEGroupDoc.fromJS(item));
            }
            if (Array.isArray(_data["programmePOEGroupDocs"])) {
                this.programmePOEGroupDocs = [] as any;
                for (let item of _data["programmePOEGroupDocs"])
                    this.programmePOEGroupDocs!.push(ProgrammePOEGroupDoc.fromJS(item));
            }
            if (Array.isArray(_data["studentPOEGroupDocs"])) {
                this.studentPOEGroupDocs = [] as any;
                for (let item of _data["studentPOEGroupDocs"])
                    this.studentPOEGroupDocs!.push(StudentPOEGroupDoc.fromJS(item));
            }
            if (Array.isArray(_data["qualPOEGeneralDocs"])) {
                this.qualPOEGeneralDocs = [] as any;
                for (let item of _data["qualPOEGeneralDocs"])
                    this.qualPOEGeneralDocs!.push(QualPOEGeneralDoc.fromJS(item));
            }
            if (Array.isArray(_data["programmePOEGeneralDocs"])) {
                this.programmePOEGeneralDocs = [] as any;
                for (let item of _data["programmePOEGeneralDocs"])
                    this.programmePOEGeneralDocs!.push(ProgrammePOEGeneralDoc.fromJS(item));
            }
            if (Array.isArray(_data["studentPOEGeneralDocs"])) {
                this.studentPOEGeneralDocs = [] as any;
                for (let item of _data["studentPOEGeneralDocs"])
                    this.studentPOEGeneralDocs!.push(StudentPOEGeneralDoc.fromJS(item));
            }
            if (Array.isArray(_data["qualPOEFormativeAssessments"])) {
                this.qualPOEFormativeAssessments = [] as any;
                for (let item of _data["qualPOEFormativeAssessments"])
                    this.qualPOEFormativeAssessments!.push(QualPOEFormativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["programmePOEFormativeAssessments"])) {
                this.programmePOEFormativeAssessments = [] as any;
                for (let item of _data["programmePOEFormativeAssessments"])
                    this.programmePOEFormativeAssessments!.push(ProgrammePOEFormativeAssessment.fromJS(item));
            }
            if (Array.isArray(_data["studentPOEFormativeAssessments"])) {
                this.studentPOEFormativeAssessments = [] as any;
                for (let item of _data["studentPOEFormativeAssessments"])
                    this.studentPOEFormativeAssessments!.push(StudentPOEFormativeAssessment.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): POEDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new POEDocumentType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        if (Array.isArray(this.qualPOEAssessmentGuideDocs)) {
            data["qualPOEAssessmentGuideDocs"] = [];
            for (let item of this.qualPOEAssessmentGuideDocs)
                data["qualPOEAssessmentGuideDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOEAssessmentGuideDocs)) {
            data["programmePOEAssessmentGuideDocs"] = [];
            for (let item of this.programmePOEAssessmentGuideDocs)
                data["programmePOEAssessmentGuideDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOEAssessmentGuideDocs)) {
            data["studentPOEAssessmentGuideDocs"] = [];
            for (let item of this.studentPOEAssessmentGuideDocs)
                data["studentPOEAssessmentGuideDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.qualPOEFeedbackDocs)) {
            data["qualPOEFeedbackDocs"] = [];
            for (let item of this.qualPOEFeedbackDocs)
                data["qualPOEFeedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOEFeedbackDocs)) {
            data["programmePOEFeedbackDocs"] = [];
            for (let item of this.programmePOEFeedbackDocs)
                data["programmePOEFeedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOEFeedbackDocs)) {
            data["studentPOEFeedbackDocs"] = [];
            for (let item of this.studentPOEFeedbackDocs)
                data["studentPOEFeedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.qualPOEWorkplaceDocs)) {
            data["qualPOEWorkplaceDocs"] = [];
            for (let item of this.qualPOEWorkplaceDocs)
                data["qualPOEWorkplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOEWorkplaceDocs)) {
            data["programmePOEWorkplaceDocs"] = [];
            for (let item of this.programmePOEWorkplaceDocs)
                data["programmePOEWorkplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOEWorkplaceDocs)) {
            data["studentPOEWorkplaceDocs"] = [];
            for (let item of this.studentPOEWorkplaceDocs)
                data["studentPOEWorkplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.qualPOESummativeAssessments)) {
            data["qualPOESummativeAssessments"] = [];
            for (let item of this.qualPOESummativeAssessments)
                data["qualPOESummativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOESummativeAssessments)) {
            data["programmePOESummativeAssessments"] = [];
            for (let item of this.programmePOESummativeAssessments)
                data["programmePOESummativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOESummativeAssessments)) {
            data["studentPOESummativeAssessments"] = [];
            for (let item of this.studentPOESummativeAssessments)
                data["studentPOESummativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.qualPOESaqaDocs)) {
            data["qualPOESaqaDocs"] = [];
            for (let item of this.qualPOESaqaDocs)
                data["qualPOESaqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOESaqaDocs)) {
            data["programmePOESaqaDocs"] = [];
            for (let item of this.programmePOESaqaDocs)
                data["programmePOESaqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOESaqaDocs)) {
            data["studentPOESaqaDocs"] = [];
            for (let item of this.studentPOESaqaDocs)
                data["studentPOESaqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.qualPOEGroupDocs)) {
            data["qualPOEGroupDocs"] = [];
            for (let item of this.qualPOEGroupDocs)
                data["qualPOEGroupDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOEGroupDocs)) {
            data["programmePOEGroupDocs"] = [];
            for (let item of this.programmePOEGroupDocs)
                data["programmePOEGroupDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOEGroupDocs)) {
            data["studentPOEGroupDocs"] = [];
            for (let item of this.studentPOEGroupDocs)
                data["studentPOEGroupDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.qualPOEGeneralDocs)) {
            data["qualPOEGeneralDocs"] = [];
            for (let item of this.qualPOEGeneralDocs)
                data["qualPOEGeneralDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOEGeneralDocs)) {
            data["programmePOEGeneralDocs"] = [];
            for (let item of this.programmePOEGeneralDocs)
                data["programmePOEGeneralDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOEGeneralDocs)) {
            data["studentPOEGeneralDocs"] = [];
            for (let item of this.studentPOEGeneralDocs)
                data["studentPOEGeneralDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.qualPOEFormativeAssessments)) {
            data["qualPOEFormativeAssessments"] = [];
            for (let item of this.qualPOEFormativeAssessments)
                data["qualPOEFormativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.programmePOEFormativeAssessments)) {
            data["programmePOEFormativeAssessments"] = [];
            for (let item of this.programmePOEFormativeAssessments)
                data["programmePOEFormativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.studentPOEFormativeAssessments)) {
            data["studentPOEFormativeAssessments"] = [];
            for (let item of this.studentPOEFormativeAssessments)
                data["studentPOEFormativeAssessments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPOEDocumentType extends IDocumentTypeEntity {
    poeFolder?: POEFolders;
    qualPOEAssessmentGuideDocs?: QualPOEAssessmentGuideDoc[] | undefined;
    programmePOEAssessmentGuideDocs?: ProgrammePOEAssessmentGuideDoc[] | undefined;
    studentPOEAssessmentGuideDocs?: StudentPOEAssessmentGuideDoc[] | undefined;
    qualPOEFeedbackDocs?: QualPOEFeedbackDoc[] | undefined;
    programmePOEFeedbackDocs?: ProgrammePOEFeedbackDoc[] | undefined;
    studentPOEFeedbackDocs?: StudentPOEFeedbackDoc[] | undefined;
    qualPOEWorkplaceDocs?: QualPOEWorkplaceDoc[] | undefined;
    programmePOEWorkplaceDocs?: ProgrammePOEWorkplaceDoc[] | undefined;
    studentPOEWorkplaceDocs?: StudentPOEWorkplaceDoc[] | undefined;
    qualPOESummativeAssessments?: QualPOESummativeAssessment[] | undefined;
    programmePOESummativeAssessments?: ProgrammePOESummativeAssessment[] | undefined;
    studentPOESummativeAssessments?: StudentPOESummativeAssessment[] | undefined;
    qualPOESaqaDocs?: QualPOESaqaDoc[] | undefined;
    programmePOESaqaDocs?: ProgrammePOESaqaDoc[] | undefined;
    studentPOESaqaDocs?: StudentPOESaqaDoc[] | undefined;
    qualPOEGroupDocs?: QualPOEGroupDoc[] | undefined;
    programmePOEGroupDocs?: ProgrammePOEGroupDoc[] | undefined;
    studentPOEGroupDocs?: StudentPOEGroupDoc[] | undefined;
    qualPOEGeneralDocs?: QualPOEGeneralDoc[] | undefined;
    programmePOEGeneralDocs?: ProgrammePOEGeneralDoc[] | undefined;
    studentPOEGeneralDocs?: StudentPOEGeneralDoc[] | undefined;
    qualPOEFormativeAssessments?: QualPOEFormativeAssessment[] | undefined;
    programmePOEFormativeAssessments?: ProgrammePOEFormativeAssessment[] | undefined;
    studentPOEFormativeAssessments?: StudentPOEFormativeAssessment[] | undefined;
}

export enum POEFolders {
    General = 0,
    AssessmentGuide = 1,
    Feedback = 2,
    Workplace = 3,
    GroupFormativeAssessments = 4,
    GroupSummativeAssessments = 5,
    GroupSaqaDocs = 6,
    GroupGeneral = 7,
    Schedule = 8,
    KnowledgeModules = 9,
    PracticalModules = 10,
    WorkplaceModules = 11,
}

export class QualPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends POEDocumentEntity implements IQualPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    qualPOE?: QualPOE | undefined;
    childrenDocs?: ProgrammePOEAssessmentGuideDoc[] | undefined;
    inputs?: QualPOEAssessmentGuideDocInput[] | undefined;
    activities?: QualPOEAssessmentGuideDocActivity[] | undefined;

    constructor(data?: IQualPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualPOE = _data["qualPOE"] ? QualPOE.fromJS(_data["qualPOE"]) : <any>undefined;
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(ProgrammePOEAssessmentGuideDoc.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualPOEAssessmentGuideDocInput.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(QualPOEAssessmentGuideDocActivity.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualPOE"] = this.qualPOE ? this.qualPOE.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IPOEDocumentEntity {
    qualPOE?: QualPOE | undefined;
    childrenDocs?: ProgrammePOEAssessmentGuideDoc[] | undefined;
    inputs?: QualPOEAssessmentGuideDocInput[] | undefined;
    activities?: QualPOEAssessmentGuideDocActivity[] | undefined;
}

export class QualPOEAssessmentGuideDoc extends QualPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IQualPOEAssessmentGuideDoc {

    constructor(data?: IQualPOEAssessmentGuideDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEAssessmentGuideDoc {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEAssessmentGuideDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEAssessmentGuideDoc extends IQualPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class ProgrammePOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends POEDocumentEntity implements IProgrammePOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    programmePOE?: ProgrammePOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: QualPOEAssessmentGuideDoc | undefined;
    annotations?: ProgrammePOEAssessmentGuideDocAnnotation[] | undefined;
    inputs?: ProgrammePOEAssessmentGuideDocInput[] | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    childrenDocs?: StudentPOEAssessmentGuideDoc[] | undefined;

    constructor(data?: IProgrammePOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOE = _data["programmePOE"] ? ProgrammePOE.fromJS(_data["programmePOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? QualPOEAssessmentGuideDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEAssessmentGuideDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammePOEAssessmentGuideDocInput.fromJS(item));
            }
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOEAssessmentGuideDoc.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOE"] = this.programmePOE ? this.programmePOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IPOEDocumentEntity {
    programmePOE?: ProgrammePOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: QualPOEAssessmentGuideDoc | undefined;
    annotations?: ProgrammePOEAssessmentGuideDocAnnotation[] | undefined;
    inputs?: ProgrammePOEAssessmentGuideDocInput[] | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    childrenDocs?: StudentPOEAssessmentGuideDoc[] | undefined;
}

export class ProgrammePOEAssessmentGuideDoc extends ProgrammePOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IProgrammePOEAssessmentGuideDoc {

    constructor(data?: IProgrammePOEAssessmentGuideDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEAssessmentGuideDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEAssessmentGuideDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEAssessmentGuideDoc extends IProgrammePOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class ProgrammePOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends POEAnnotationOfProgrammePOE implements IProgrammePOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    programmePOEDocId?: number;
    programmePOEDoc?: ProgrammePOEAssessmentGuideDoc | undefined;
    childrenAnnotations?: StudentPOEAssessmentGuideDocAnnotation[] | undefined;

    constructor(data?: IProgrammePOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEDocId = _data["programmePOEDocId"];
            this.programmePOEDoc = _data["programmePOEDoc"] ? ProgrammePOEAssessmentGuideDoc.fromJS(_data["programmePOEDoc"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEAssessmentGuideDocAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEDocId"] = this.programmePOEDocId;
        data["programmePOEDoc"] = this.programmePOEDoc ? this.programmePOEDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IPOEAnnotationOfProgrammePOE {
    programmePOEDocId?: number;
    programmePOEDoc?: ProgrammePOEAssessmentGuideDoc | undefined;
    childrenAnnotations?: StudentPOEAssessmentGuideDocAnnotation[] | undefined;
}

export class ProgrammePOEAssessmentGuideDocAnnotation extends ProgrammePOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IProgrammePOEAssessmentGuideDocAnnotation {

    constructor(data?: IProgrammePOEAssessmentGuideDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEAssessmentGuideDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEAssessmentGuideDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEAssessmentGuideDocAnnotation extends IProgrammePOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class StudentPOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends POEAnnotationOfStudentPOE implements IStudentPOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    studentPOEDocId?: number;
    studentPOEDoc?: StudentPOEAssessmentGuideDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEAssessmentGuideDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEDocId = _data["studentPOEDocId"];
            this.studentPOEDoc = _data["studentPOEDoc"] ? StudentPOEAssessmentGuideDoc.fromJS(_data["studentPOEDoc"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEAssessmentGuideDocAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEDocId"] = this.studentPOEDocId;
        data["studentPOEDoc"] = this.studentPOEDoc ? this.studentPOEDoc.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IPOEAnnotationOfStudentPOE {
    studentPOEDocId?: number;
    studentPOEDoc?: StudentPOEAssessmentGuideDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEAssessmentGuideDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class StudentPOEAssessmentGuideDocAnnotation extends StudentPOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IStudentPOEAssessmentGuideDocAnnotation {

    constructor(data?: IStudentPOEAssessmentGuideDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEAssessmentGuideDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEAssessmentGuideDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEAssessmentGuideDocAnnotation extends IStudentPOEAnnotationOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class StudentPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends POEDocumentEntity implements IStudentPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEAssessmentGuideDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEAssessmentGuideDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEAssessmentGuideDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IStudentPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOE = _data["studentPOE"] ? StudentPOE.fromJS(_data["studentPOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOEAssessmentGuideDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEAssessmentGuideDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentPOEAssessmentGuideDocInputAnswer.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): StudentPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOE"] = this.studentPOE ? this.studentPOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IPOEDocumentEntity {
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEAssessmentGuideDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEAssessmentGuideDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEAssessmentGuideDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class StudentPOEAssessmentGuideDoc extends StudentPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IStudentPOEAssessmentGuideDoc {

    constructor(data?: IStudentPOEAssessmentGuideDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEAssessmentGuideDoc {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEAssessmentGuideDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEAssessmentGuideDoc extends IStudentPOEDocumentEntityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class StudentPOEInputAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends StudentAnswer implements IStudentPOEInputAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    poeDocId?: number;
    poeDoc?: StudentPOEAssessmentGuideDoc | undefined;
    programmePOEInputId?: number;
    programmePOEInput?: ProgrammePOEAssessmentGuideDocInput | undefined;

    constructor(data?: IStudentPOEInputAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? StudentPOEAssessmentGuideDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.programmePOEInputId = _data["programmePOEInputId"];
            this.programmePOEInput = _data["programmePOEInput"] ? ProgrammePOEAssessmentGuideDocInput.fromJS(_data["programmePOEInput"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEInputAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEInputAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["programmePOEInputId"] = this.programmePOEInputId;
        data["programmePOEInput"] = this.programmePOEInput ? this.programmePOEInput.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEInputAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IStudentAnswer {
    poeDocId?: number;
    poeDoc?: StudentPOEAssessmentGuideDoc | undefined;
    programmePOEInputId?: number;
    programmePOEInput?: ProgrammePOEAssessmentGuideDocInput | undefined;
}

export class StudentPOEAssessmentGuideDocInputAnswer extends StudentPOEInputAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IStudentPOEAssessmentGuideDocInputAnswer {

    constructor(data?: IStudentPOEAssessmentGuideDocInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEAssessmentGuideDocInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEAssessmentGuideDocInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEAssessmentGuideDocInputAnswer extends IStudentPOEInputAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class POEInputOfProgrammePOEAssessmentGuideDocAndProgrammePOE extends Input implements IPOEInputOfProgrammePOEAssessmentGuideDocAndProgrammePOE {
    poeDocId?: number;
    poeDoc?: ProgrammePOEAssessmentGuideDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEInputOfProgrammePOEAssessmentGuideDocAndProgrammePOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? ProgrammePOEAssessmentGuideDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEInputOfProgrammePOEAssessmentGuideDocAndProgrammePOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEInputOfProgrammePOEAssessmentGuideDocAndProgrammePOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEInputOfProgrammePOEAssessmentGuideDocAndProgrammePOE extends IInput {
    poeDocId?: number;
    poeDoc?: ProgrammePOEAssessmentGuideDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends POEInputOfProgrammePOEAssessmentGuideDocAndProgrammePOE implements IProgrammePOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    studentInputAnswers?: StudentPOEAssessmentGuideDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEAssessmentGuideDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammePOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentPOEAssessmentGuideDocInputAnswer.fromJS(item));
            }
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualPOEAssessmentGuideDocInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammePOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IPOEInputOfProgrammePOEAssessmentGuideDocAndProgrammePOE {
    studentInputAnswers?: StudentPOEAssessmentGuideDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEAssessmentGuideDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;
}

export class ProgrammePOEAssessmentGuideDocInput extends ProgrammePOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IProgrammePOEAssessmentGuideDocInput {

    constructor(data?: IProgrammePOEAssessmentGuideDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEAssessmentGuideDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEAssessmentGuideDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEAssessmentGuideDocInput extends IProgrammePOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class POEInputOfQualPOEAssessmentGuideDocAndQualPOE extends Input implements IPOEInputOfQualPOEAssessmentGuideDocAndQualPOE {
    poeDocId?: number;
    poeDoc?: QualPOEAssessmentGuideDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;

    constructor(data?: IPOEInputOfQualPOEAssessmentGuideDocAndQualPOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? QualPOEAssessmentGuideDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEInputOfQualPOEAssessmentGuideDocAndQualPOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEInputOfQualPOEAssessmentGuideDocAndQualPOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEInputOfQualPOEAssessmentGuideDocAndQualPOE extends IInput {
    poeDocId?: number;
    poeDoc?: QualPOEAssessmentGuideDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;
}

export class QualPOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends POEInputOfQualPOEAssessmentGuideDocAndQualPOE implements IQualPOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEAssessmentGuideDocInput[] | undefined;

    constructor(data?: IQualPOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammePOEAssessmentGuideDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IPOEInputOfQualPOEAssessmentGuideDocAndQualPOE {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEAssessmentGuideDocInput[] | undefined;
}

export class QualPOEAssessmentGuideDocInput extends QualPOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IQualPOEAssessmentGuideDocInput {

    constructor(data?: IQualPOEAssessmentGuideDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEAssessmentGuideDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEAssessmentGuideDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEAssessmentGuideDocInput extends IQualPOEInputOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export enum InputTypes {
    Text = 0,
    TextArea = 1,
    Number = 2,
    TelNumber = 3,
    Date = 4,
    Email = 5,
    Checkbox = 6,
    Gradebox = 7,
    ActivityTotal = 8,
}

export enum AutoFillInputTypes {
    IdNumber = 0,
    CellNumber = 1,
    FullName = 2,
    FirstName = 3,
    MiddleNames = 4,
    LastName = 5,
    DateOfBirth = 6,
    Email = 7,
    Address = 8,
    ModeratorNumber = 9,
    AssessorNumber = 10,
}

export enum AutoFillInputOwners {
    Student = 0,
    Mentor = 1,
    Facilitator = 2,
    Assessor = 3,
    Moderator = 4,
    Manager = 5,
}

export enum ActivityTotalInputFormats {
    LearnerTotal = 0,
    FractionWithPercentageAndCompetency = 1,
}

export enum AnnotationTypes {
    Tick = 0,
    Cross = 1,
    Date = 2,
    Signature = 3,
    Initials = 4,
    Text = 5,
}

export enum InitialsTypes {
    StudentInitials = 0,
    AssessorInitials = 1,
    ModeratorInitials = 2,
}

export abstract class QualActivityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends AuditableBaseEntity implements IQualActivityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEAssessmentGuideDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipAssessmentGuideDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEAssessmentGuideDoc | undefined;

    constructor(data?: IQualActivityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(QualPOEAssessmentGuideDocQuestion.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipActivityStatus"])) {
                this.studentLearnershipActivityStatus = [] as any;
                for (let item of _data["studentLearnershipActivityStatus"])
                    this.studentLearnershipActivityStatus!.push(StudentLearnershipAssessmentGuideDocActivityStatus.fromJS(item));
            }
            this.qualPoeDocId = _data["qualPoeDocId"];
            this.qualPoeDoc = _data["qualPoeDoc"] ? QualPOEAssessmentGuideDoc.fromJS(_data["qualPoeDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualActivityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualActivityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipActivityStatus)) {
            data["studentLearnershipActivityStatus"] = [];
            for (let item of this.studentLearnershipActivityStatus)
                data["studentLearnershipActivityStatus"].push(item.toJSON());
        }
        data["qualPoeDocId"] = this.qualPoeDocId;
        data["qualPoeDoc"] = this.qualPoeDoc ? this.qualPoeDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualActivityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IAuditableBaseEntity {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEAssessmentGuideDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipAssessmentGuideDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEAssessmentGuideDoc | undefined;
}

export class QualPOEAssessmentGuideDocActivity extends QualActivityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IQualPOEAssessmentGuideDocActivity {

    constructor(data?: IQualPOEAssessmentGuideDocActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEAssessmentGuideDocActivity {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEAssessmentGuideDocActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEAssessmentGuideDocActivity extends IQualActivityOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export abstract class QualActivityQuestionOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends PageAndPosition implements IQualActivityQuestionOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEAssessmentGuideDocActivity | undefined;
    potentialAnswers?: QualPOEAssessmentGuideDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentAssessmentGuideDocQuestionAnswer[] | undefined;

    constructor(data?: IQualActivityQuestionOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.multiSelect = _data["multiSelect"];
            this.type = _data["type"];
            this.activity = _data["activity"] ? QualPOEAssessmentGuideDocActivity.fromJS(_data["activity"]) : <any>undefined;
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(QualPOEAssessmentGuideDocAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentAssessmentGuideDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualActivityQuestionOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualActivityQuestionOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["multiSelect"] = this.multiSelect;
        data["type"] = this.type;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualActivityQuestionOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IPageAndPosition {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEAssessmentGuideDocActivity | undefined;
    potentialAnswers?: QualPOEAssessmentGuideDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentAssessmentGuideDocQuestionAnswer[] | undefined;
}

export class QualPOEAssessmentGuideDocQuestion extends QualActivityQuestionOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IQualPOEAssessmentGuideDocQuestion {

    constructor(data?: IQualPOEAssessmentGuideDocQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEAssessmentGuideDocQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEAssessmentGuideDocQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEAssessmentGuideDocQuestion extends IQualActivityQuestionOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export abstract class QualPotentialAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends AuditableBaseEntity implements IQualPotentialAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEAssessmentGuideDocQuestion | undefined;
    studentQuestionAnswers?: StudentAssessmentGuideDocQuestionAnswer[] | undefined;

    constructor(data?: IQualPotentialAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.answerText = _data["answerText"];
            this.isCorrect = _data["isCorrect"];
            this.marks = _data["marks"];
            this.activityQuestionId = _data["activityQuestionId"];
            this.activityQuestion = _data["activityQuestion"] ? QualPOEAssessmentGuideDocQuestion.fromJS(_data["activityQuestion"]) : <any>undefined;
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentAssessmentGuideDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPotentialAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualPotentialAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText;
        data["isCorrect"] = this.isCorrect;
        data["marks"] = this.marks;
        data["activityQuestionId"] = this.activityQuestionId;
        data["activityQuestion"] = this.activityQuestion ? this.activityQuestion.toJSON() : <any>undefined;
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPotentialAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IAuditableBaseEntity {
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEAssessmentGuideDocQuestion | undefined;
    studentQuestionAnswers?: StudentAssessmentGuideDocQuestionAnswer[] | undefined;
}

export class QualPOEAssessmentGuideDocAnswer extends QualPotentialAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IQualPOEAssessmentGuideDocAnswer {

    constructor(data?: IQualPOEAssessmentGuideDocAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEAssessmentGuideDocAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEAssessmentGuideDocAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEAssessmentGuideDocAnswer extends IQualPotentialAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class StudentQuestionAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends AuditableBaseEntity implements IStudentQuestionAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEAssessmentGuideDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEAssessmentGuideDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;

    constructor(data?: IStudentQuestionAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPoeId = _data["studentPoeId"];
            this.studentPoe = _data["studentPoe"] ? StudentPOE.fromJS(_data["studentPoe"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.question = _data["question"] ? QualPOEAssessmentGuideDocQuestion.fromJS(_data["question"]) : <any>undefined;
            this.answerId = _data["answerId"];
            this.answer = _data["answer"] ? QualPOEAssessmentGuideDocAnswer.fromJS(_data["answer"]) : <any>undefined;
            this.paragraphAnswer = _data["paragraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
        }
    }

    static override fromJS(data: any): StudentQuestionAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentQuestionAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPoeId"] = this.studentPoeId;
        data["studentPoe"] = this.studentPoe ? this.studentPoe.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["paragraphAnswer"] = this.paragraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentQuestionAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IAuditableBaseEntity {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEAssessmentGuideDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEAssessmentGuideDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
}

export class StudentAssessmentGuideDocQuestionAnswer extends StudentQuestionAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IStudentAssessmentGuideDocQuestionAnswer {

    constructor(data?: IStudentAssessmentGuideDocQuestionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentAssessmentGuideDocQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentAssessmentGuideDocQuestionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentAssessmentGuideDocQuestionAnswer extends IStudentQuestionAnswerOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class StudentLearnershipActivityStatusOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends AuditableBaseEntity implements IStudentLearnershipActivityStatusOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEAssessmentGuideDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;

    constructor(data?: IStudentLearnershipActivityStatusOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? QualPOEAssessmentGuideDocActivity.fromJS(_data["activity"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static override fromJS(data: any): StudentLearnershipActivityStatusOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipActivityStatusOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipActivityStatusOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus extends IAuditableBaseEntity {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEAssessmentGuideDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;
}

export class StudentLearnershipAssessmentGuideDocActivityStatus extends StudentLearnershipActivityStatusOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus implements IStudentLearnershipAssessmentGuideDocActivityStatus {

    constructor(data?: IStudentLearnershipAssessmentGuideDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentLearnershipAssessmentGuideDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipAssessmentGuideDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipAssessmentGuideDocActivityStatus extends IStudentLearnershipActivityStatusOfQualPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAndStudentPOEAssessmentGuideDocAndProgrammePOEAssessmentGuideDocAnnotationAndStudentPOEAssessmentGuideDocAnnotationAndQualPOEAssessmentGuideDocInputAndProgrammePOEAssessmentGuideDocInputAndStudentPOEAssessmentGuideDocInputAnswerAndQualPOEAssessmentGuideDocActivityAndQualPOEAssessmentGuideDocQuestionAndQualPOEAssessmentGuideDocAnswerAndStudentAssessmentGuideDocQuestionAnswerAndStudentLearnershipAssessmentGuideDocActivityStatus {
}

export class ProgrammePOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends POEDocumentEntity implements IProgrammePOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    programmePOE?: ProgrammePOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: QualPOEFeedbackDoc | undefined;
    annotations?: ProgrammePOEFeedbackDocAnnotation[] | undefined;
    inputs?: ProgrammePOEFeedbackDocInput[] | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    childrenDocs?: StudentPOEFeedbackDoc[] | undefined;

    constructor(data?: IProgrammePOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOE = _data["programmePOE"] ? ProgrammePOE.fromJS(_data["programmePOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? QualPOEFeedbackDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEFeedbackDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammePOEFeedbackDocInput.fromJS(item));
            }
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOEFeedbackDoc.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOE"] = this.programmePOE ? this.programmePOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IPOEDocumentEntity {
    programmePOE?: ProgrammePOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: QualPOEFeedbackDoc | undefined;
    annotations?: ProgrammePOEFeedbackDocAnnotation[] | undefined;
    inputs?: ProgrammePOEFeedbackDocInput[] | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    childrenDocs?: StudentPOEFeedbackDoc[] | undefined;
}

export class ProgrammePOEFeedbackDoc extends ProgrammePOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IProgrammePOEFeedbackDoc {
    isFISA?: boolean;
    isCompetencyChecklist?: boolean;
    poeGroupId?: number | undefined;
    programmePOEGroup?: ProgrammePOEGroup | undefined;

    constructor(data?: IProgrammePOEFeedbackDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isFISA = _data["isFISA"];
            this.isCompetencyChecklist = _data["isCompetencyChecklist"];
            this.poeGroupId = _data["poeGroupId"];
            this.programmePOEGroup = _data["programmePOEGroup"] ? ProgrammePOEGroup.fromJS(_data["programmePOEGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammePOEFeedbackDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEFeedbackDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFISA"] = this.isFISA;
        data["isCompetencyChecklist"] = this.isCompetencyChecklist;
        data["poeGroupId"] = this.poeGroupId;
        data["programmePOEGroup"] = this.programmePOEGroup ? this.programmePOEGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEFeedbackDoc extends IProgrammePOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    isFISA?: boolean;
    isCompetencyChecklist?: boolean;
    poeGroupId?: number | undefined;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
}

export class ProgrammePOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends POEAnnotationOfProgrammePOE implements IProgrammePOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    programmePOEDocId?: number;
    programmePOEDoc?: ProgrammePOEFeedbackDoc | undefined;
    childrenAnnotations?: StudentPOEFeedbackDocAnnotation[] | undefined;

    constructor(data?: IProgrammePOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEDocId = _data["programmePOEDocId"];
            this.programmePOEDoc = _data["programmePOEDoc"] ? ProgrammePOEFeedbackDoc.fromJS(_data["programmePOEDoc"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEFeedbackDocAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEDocId"] = this.programmePOEDocId;
        data["programmePOEDoc"] = this.programmePOEDoc ? this.programmePOEDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IPOEAnnotationOfProgrammePOE {
    programmePOEDocId?: number;
    programmePOEDoc?: ProgrammePOEFeedbackDoc | undefined;
    childrenAnnotations?: StudentPOEFeedbackDocAnnotation[] | undefined;
}

export class ProgrammePOEFeedbackDocAnnotation extends ProgrammePOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IProgrammePOEFeedbackDocAnnotation {

    constructor(data?: IProgrammePOEFeedbackDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEFeedbackDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEFeedbackDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEFeedbackDocAnnotation extends IProgrammePOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export class StudentPOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends POEAnnotationOfStudentPOE implements IStudentPOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    studentPOEDocId?: number;
    studentPOEDoc?: StudentPOEFeedbackDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEFeedbackDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEDocId = _data["studentPOEDocId"];
            this.studentPOEDoc = _data["studentPOEDoc"] ? StudentPOEFeedbackDoc.fromJS(_data["studentPOEDoc"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEFeedbackDocAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEDocId"] = this.studentPOEDocId;
        data["studentPOEDoc"] = this.studentPOEDoc ? this.studentPOEDoc.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IPOEAnnotationOfStudentPOE {
    studentPOEDocId?: number;
    studentPOEDoc?: StudentPOEFeedbackDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEFeedbackDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class StudentPOEFeedbackDocAnnotation extends StudentPOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IStudentPOEFeedbackDocAnnotation {

    constructor(data?: IStudentPOEFeedbackDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEFeedbackDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEFeedbackDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEFeedbackDocAnnotation extends IStudentPOEAnnotationOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export class StudentPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends POEDocumentEntity implements IStudentPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEFeedbackDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEFeedbackDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEFeedbackDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IStudentPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOE = _data["studentPOE"] ? StudentPOE.fromJS(_data["studentPOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOEFeedbackDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEFeedbackDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentPOEFeedbackDocInputAnswer.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): StudentPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOE"] = this.studentPOE ? this.studentPOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IPOEDocumentEntity {
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEFeedbackDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEFeedbackDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEFeedbackDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class StudentPOEFeedbackDoc extends StudentPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IStudentPOEFeedbackDoc {
    isFISA?: boolean;
    isCompetencyChecklist?: boolean;
    poeGroupId?: number | undefined;
    studentPOEGroup?: StudentPOEGroup | undefined;

    constructor(data?: IStudentPOEFeedbackDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isFISA = _data["isFISA"];
            this.isCompetencyChecklist = _data["isCompetencyChecklist"];
            this.poeGroupId = _data["poeGroupId"];
            this.studentPOEGroup = _data["studentPOEGroup"] ? StudentPOEGroup.fromJS(_data["studentPOEGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEFeedbackDoc {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEFeedbackDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFISA"] = this.isFISA;
        data["isCompetencyChecklist"] = this.isCompetencyChecklist;
        data["poeGroupId"] = this.poeGroupId;
        data["studentPOEGroup"] = this.studentPOEGroup ? this.studentPOEGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEFeedbackDoc extends IStudentPOEDocumentEntityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    isFISA?: boolean;
    isCompetencyChecklist?: boolean;
    poeGroupId?: number | undefined;
    studentPOEGroup?: StudentPOEGroup | undefined;
}

export class StudentPOEInputAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends StudentAnswer implements IStudentPOEInputAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    poeDocId?: number;
    poeDoc?: StudentPOEFeedbackDoc | undefined;
    programmePOEInputId?: number;
    programmePOEInput?: ProgrammePOEFeedbackDocInput | undefined;

    constructor(data?: IStudentPOEInputAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? StudentPOEFeedbackDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.programmePOEInputId = _data["programmePOEInputId"];
            this.programmePOEInput = _data["programmePOEInput"] ? ProgrammePOEFeedbackDocInput.fromJS(_data["programmePOEInput"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEInputAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEInputAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["programmePOEInputId"] = this.programmePOEInputId;
        data["programmePOEInput"] = this.programmePOEInput ? this.programmePOEInput.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEInputAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IStudentAnswer {
    poeDocId?: number;
    poeDoc?: StudentPOEFeedbackDoc | undefined;
    programmePOEInputId?: number;
    programmePOEInput?: ProgrammePOEFeedbackDocInput | undefined;
}

export class StudentPOEFeedbackDocInputAnswer extends StudentPOEInputAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IStudentPOEFeedbackDocInputAnswer {

    constructor(data?: IStudentPOEFeedbackDocInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEFeedbackDocInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEFeedbackDocInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEFeedbackDocInputAnswer extends IStudentPOEInputAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export class POEInputOfProgrammePOEFeedbackDocAndProgrammePOE extends Input implements IPOEInputOfProgrammePOEFeedbackDocAndProgrammePOE {
    poeDocId?: number;
    poeDoc?: ProgrammePOEFeedbackDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEInputOfProgrammePOEFeedbackDocAndProgrammePOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? ProgrammePOEFeedbackDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEInputOfProgrammePOEFeedbackDocAndProgrammePOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEInputOfProgrammePOEFeedbackDocAndProgrammePOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEInputOfProgrammePOEFeedbackDocAndProgrammePOE extends IInput {
    poeDocId?: number;
    poeDoc?: ProgrammePOEFeedbackDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends POEInputOfProgrammePOEFeedbackDocAndProgrammePOE implements IProgrammePOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    studentInputAnswers?: StudentPOEFeedbackDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEFeedbackDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammePOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentPOEFeedbackDocInputAnswer.fromJS(item));
            }
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualPOEFeedbackDocInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammePOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IPOEInputOfProgrammePOEFeedbackDocAndProgrammePOE {
    studentInputAnswers?: StudentPOEFeedbackDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEFeedbackDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;
}

export class ProgrammePOEFeedbackDocInput extends ProgrammePOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IProgrammePOEFeedbackDocInput {

    constructor(data?: IProgrammePOEFeedbackDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEFeedbackDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEFeedbackDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEFeedbackDocInput extends IProgrammePOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export class POEInputOfQualPOEFeedbackDocAndQualPOE extends Input implements IPOEInputOfQualPOEFeedbackDocAndQualPOE {
    poeDocId?: number;
    poeDoc?: QualPOEFeedbackDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;

    constructor(data?: IPOEInputOfQualPOEFeedbackDocAndQualPOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? QualPOEFeedbackDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEInputOfQualPOEFeedbackDocAndQualPOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEInputOfQualPOEFeedbackDocAndQualPOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEInputOfQualPOEFeedbackDocAndQualPOE extends IInput {
    poeDocId?: number;
    poeDoc?: QualPOEFeedbackDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;
}

export class QualPOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends POEInputOfQualPOEFeedbackDocAndQualPOE implements IQualPOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEFeedbackDocInput[] | undefined;

    constructor(data?: IQualPOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammePOEFeedbackDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IPOEInputOfQualPOEFeedbackDocAndQualPOE {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEFeedbackDocInput[] | undefined;
}

export class QualPOEFeedbackDocInput extends QualPOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IQualPOEFeedbackDocInput {

    constructor(data?: IQualPOEFeedbackDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFeedbackDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFeedbackDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFeedbackDocInput extends IQualPOEInputOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export class QualPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends POEDocumentEntity implements IQualPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    qualPOE?: QualPOE | undefined;
    childrenDocs?: ProgrammePOEWorkplaceDoc[] | undefined;
    inputs?: QualPOEWorkplaceDocInput[] | undefined;
    activities?: QualPOEWorkplaceDocActivity[] | undefined;

    constructor(data?: IQualPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualPOE = _data["qualPOE"] ? QualPOE.fromJS(_data["qualPOE"]) : <any>undefined;
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(ProgrammePOEWorkplaceDoc.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualPOEWorkplaceDocInput.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(QualPOEWorkplaceDocActivity.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualPOE"] = this.qualPOE ? this.qualPOE.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IPOEDocumentEntity {
    qualPOE?: QualPOE | undefined;
    childrenDocs?: ProgrammePOEWorkplaceDoc[] | undefined;
    inputs?: QualPOEWorkplaceDocInput[] | undefined;
    activities?: QualPOEWorkplaceDocActivity[] | undefined;
}

export class QualPOEWorkplaceDoc extends QualPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IQualPOEWorkplaceDoc {

    constructor(data?: IQualPOEWorkplaceDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEWorkplaceDoc {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEWorkplaceDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEWorkplaceDoc extends IQualPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class ProgrammePOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends POEDocumentEntity implements IProgrammePOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    programmePOE?: ProgrammePOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: QualPOEWorkplaceDoc | undefined;
    annotations?: ProgrammePOEWorkplaceDocAnnotation[] | undefined;
    inputs?: ProgrammePOEWorkplaceDocInput[] | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    childrenDocs?: StudentPOEWorkplaceDoc[] | undefined;

    constructor(data?: IProgrammePOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOE = _data["programmePOE"] ? ProgrammePOE.fromJS(_data["programmePOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? QualPOEWorkplaceDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEWorkplaceDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammePOEWorkplaceDocInput.fromJS(item));
            }
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOEWorkplaceDoc.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOE"] = this.programmePOE ? this.programmePOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IPOEDocumentEntity {
    programmePOE?: ProgrammePOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: QualPOEWorkplaceDoc | undefined;
    annotations?: ProgrammePOEWorkplaceDocAnnotation[] | undefined;
    inputs?: ProgrammePOEWorkplaceDocInput[] | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    childrenDocs?: StudentPOEWorkplaceDoc[] | undefined;
}

export class ProgrammePOEWorkplaceDoc extends ProgrammePOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IProgrammePOEWorkplaceDoc {

    constructor(data?: IProgrammePOEWorkplaceDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEWorkplaceDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEWorkplaceDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEWorkplaceDoc extends IProgrammePOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class ProgrammePOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends POEAnnotationOfProgrammePOE implements IProgrammePOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    programmePOEDocId?: number;
    programmePOEDoc?: ProgrammePOEWorkplaceDoc | undefined;
    childrenAnnotations?: StudentPOEWorkplaceDocAnnotation[] | undefined;

    constructor(data?: IProgrammePOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEDocId = _data["programmePOEDocId"];
            this.programmePOEDoc = _data["programmePOEDoc"] ? ProgrammePOEWorkplaceDoc.fromJS(_data["programmePOEDoc"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEWorkplaceDocAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEDocId"] = this.programmePOEDocId;
        data["programmePOEDoc"] = this.programmePOEDoc ? this.programmePOEDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IPOEAnnotationOfProgrammePOE {
    programmePOEDocId?: number;
    programmePOEDoc?: ProgrammePOEWorkplaceDoc | undefined;
    childrenAnnotations?: StudentPOEWorkplaceDocAnnotation[] | undefined;
}

export class ProgrammePOEWorkplaceDocAnnotation extends ProgrammePOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IProgrammePOEWorkplaceDocAnnotation {

    constructor(data?: IProgrammePOEWorkplaceDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEWorkplaceDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEWorkplaceDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEWorkplaceDocAnnotation extends IProgrammePOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class StudentPOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends POEAnnotationOfStudentPOE implements IStudentPOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    studentPOEDocId?: number;
    studentPOEDoc?: StudentPOEWorkplaceDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEWorkplaceDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEDocId = _data["studentPOEDocId"];
            this.studentPOEDoc = _data["studentPOEDoc"] ? StudentPOEWorkplaceDoc.fromJS(_data["studentPOEDoc"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEWorkplaceDocAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEDocId"] = this.studentPOEDocId;
        data["studentPOEDoc"] = this.studentPOEDoc ? this.studentPOEDoc.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IPOEAnnotationOfStudentPOE {
    studentPOEDocId?: number;
    studentPOEDoc?: StudentPOEWorkplaceDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEWorkplaceDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class StudentPOEWorkplaceDocAnnotation extends StudentPOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IStudentPOEWorkplaceDocAnnotation {

    constructor(data?: IStudentPOEWorkplaceDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEWorkplaceDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEWorkplaceDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEWorkplaceDocAnnotation extends IStudentPOEAnnotationOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class StudentPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends POEDocumentEntity implements IStudentPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEWorkplaceDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEWorkplaceDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEWorkplaceDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IStudentPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOE = _data["studentPOE"] ? StudentPOE.fromJS(_data["studentPOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOEWorkplaceDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEWorkplaceDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentPOEWorkplaceDocInputAnswer.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): StudentPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOE"] = this.studentPOE ? this.studentPOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IPOEDocumentEntity {
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEWorkplaceDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEWorkplaceDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEWorkplaceDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class StudentPOEWorkplaceDoc extends StudentPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IStudentPOEWorkplaceDoc {

    constructor(data?: IStudentPOEWorkplaceDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEWorkplaceDoc {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEWorkplaceDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEWorkplaceDoc extends IStudentPOEDocumentEntityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class StudentPOEInputAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends StudentAnswer implements IStudentPOEInputAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    poeDocId?: number;
    poeDoc?: StudentPOEWorkplaceDoc | undefined;
    programmePOEInputId?: number;
    programmePOEInput?: ProgrammePOEWorkplaceDocInput | undefined;

    constructor(data?: IStudentPOEInputAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? StudentPOEWorkplaceDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.programmePOEInputId = _data["programmePOEInputId"];
            this.programmePOEInput = _data["programmePOEInput"] ? ProgrammePOEWorkplaceDocInput.fromJS(_data["programmePOEInput"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEInputAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEInputAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["programmePOEInputId"] = this.programmePOEInputId;
        data["programmePOEInput"] = this.programmePOEInput ? this.programmePOEInput.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEInputAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IStudentAnswer {
    poeDocId?: number;
    poeDoc?: StudentPOEWorkplaceDoc | undefined;
    programmePOEInputId?: number;
    programmePOEInput?: ProgrammePOEWorkplaceDocInput | undefined;
}

export class StudentPOEWorkplaceDocInputAnswer extends StudentPOEInputAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IStudentPOEWorkplaceDocInputAnswer {

    constructor(data?: IStudentPOEWorkplaceDocInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEWorkplaceDocInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEWorkplaceDocInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEWorkplaceDocInputAnswer extends IStudentPOEInputAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class POEInputOfProgrammePOEWorkplaceDocAndProgrammePOE extends Input implements IPOEInputOfProgrammePOEWorkplaceDocAndProgrammePOE {
    poeDocId?: number;
    poeDoc?: ProgrammePOEWorkplaceDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEInputOfProgrammePOEWorkplaceDocAndProgrammePOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? ProgrammePOEWorkplaceDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEInputOfProgrammePOEWorkplaceDocAndProgrammePOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEInputOfProgrammePOEWorkplaceDocAndProgrammePOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEInputOfProgrammePOEWorkplaceDocAndProgrammePOE extends IInput {
    poeDocId?: number;
    poeDoc?: ProgrammePOEWorkplaceDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends POEInputOfProgrammePOEWorkplaceDocAndProgrammePOE implements IProgrammePOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    studentInputAnswers?: StudentPOEWorkplaceDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEWorkplaceDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammePOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentPOEWorkplaceDocInputAnswer.fromJS(item));
            }
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualPOEWorkplaceDocInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammePOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IPOEInputOfProgrammePOEWorkplaceDocAndProgrammePOE {
    studentInputAnswers?: StudentPOEWorkplaceDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEWorkplaceDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;
}

export class ProgrammePOEWorkplaceDocInput extends ProgrammePOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IProgrammePOEWorkplaceDocInput {

    constructor(data?: IProgrammePOEWorkplaceDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEWorkplaceDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEWorkplaceDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEWorkplaceDocInput extends IProgrammePOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class POEInputOfQualPOEWorkplaceDocAndQualPOE extends Input implements IPOEInputOfQualPOEWorkplaceDocAndQualPOE {
    poeDocId?: number;
    poeDoc?: QualPOEWorkplaceDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;

    constructor(data?: IPOEInputOfQualPOEWorkplaceDocAndQualPOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? QualPOEWorkplaceDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEInputOfQualPOEWorkplaceDocAndQualPOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEInputOfQualPOEWorkplaceDocAndQualPOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEInputOfQualPOEWorkplaceDocAndQualPOE extends IInput {
    poeDocId?: number;
    poeDoc?: QualPOEWorkplaceDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;
}

export class QualPOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends POEInputOfQualPOEWorkplaceDocAndQualPOE implements IQualPOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEWorkplaceDocInput[] | undefined;

    constructor(data?: IQualPOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammePOEWorkplaceDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IPOEInputOfQualPOEWorkplaceDocAndQualPOE {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEWorkplaceDocInput[] | undefined;
}

export class QualPOEWorkplaceDocInput extends QualPOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IQualPOEWorkplaceDocInput {

    constructor(data?: IQualPOEWorkplaceDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEWorkplaceDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEWorkplaceDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEWorkplaceDocInput extends IQualPOEInputOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export abstract class QualActivityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends AuditableBaseEntity implements IQualActivityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEWorkplaceDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipWorkplaceDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEWorkplaceDoc | undefined;

    constructor(data?: IQualActivityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(QualPOEWorkplaceDocQuestion.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipActivityStatus"])) {
                this.studentLearnershipActivityStatus = [] as any;
                for (let item of _data["studentLearnershipActivityStatus"])
                    this.studentLearnershipActivityStatus!.push(StudentLearnershipWorkplaceDocActivityStatus.fromJS(item));
            }
            this.qualPoeDocId = _data["qualPoeDocId"];
            this.qualPoeDoc = _data["qualPoeDoc"] ? QualPOEWorkplaceDoc.fromJS(_data["qualPoeDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualActivityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualActivityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipActivityStatus)) {
            data["studentLearnershipActivityStatus"] = [];
            for (let item of this.studentLearnershipActivityStatus)
                data["studentLearnershipActivityStatus"].push(item.toJSON());
        }
        data["qualPoeDocId"] = this.qualPoeDocId;
        data["qualPoeDoc"] = this.qualPoeDoc ? this.qualPoeDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualActivityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IAuditableBaseEntity {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEWorkplaceDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipWorkplaceDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEWorkplaceDoc | undefined;
}

export class QualPOEWorkplaceDocActivity extends QualActivityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IQualPOEWorkplaceDocActivity {

    constructor(data?: IQualPOEWorkplaceDocActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEWorkplaceDocActivity {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEWorkplaceDocActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEWorkplaceDocActivity extends IQualActivityOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export abstract class QualActivityQuestionOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends PageAndPosition implements IQualActivityQuestionOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEWorkplaceDocActivity | undefined;
    potentialAnswers?: QualPOEWorkplaceDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentWorkplaceDocQuestionAnswer[] | undefined;

    constructor(data?: IQualActivityQuestionOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.multiSelect = _data["multiSelect"];
            this.type = _data["type"];
            this.activity = _data["activity"] ? QualPOEWorkplaceDocActivity.fromJS(_data["activity"]) : <any>undefined;
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(QualPOEWorkplaceDocAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentWorkplaceDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualActivityQuestionOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualActivityQuestionOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["multiSelect"] = this.multiSelect;
        data["type"] = this.type;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualActivityQuestionOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IPageAndPosition {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEWorkplaceDocActivity | undefined;
    potentialAnswers?: QualPOEWorkplaceDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentWorkplaceDocQuestionAnswer[] | undefined;
}

export class QualPOEWorkplaceDocQuestion extends QualActivityQuestionOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IQualPOEWorkplaceDocQuestion {

    constructor(data?: IQualPOEWorkplaceDocQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEWorkplaceDocQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEWorkplaceDocQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEWorkplaceDocQuestion extends IQualActivityQuestionOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export abstract class QualPotentialAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends AuditableBaseEntity implements IQualPotentialAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEWorkplaceDocQuestion | undefined;
    studentQuestionAnswers?: StudentWorkplaceDocQuestionAnswer[] | undefined;

    constructor(data?: IQualPotentialAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.answerText = _data["answerText"];
            this.isCorrect = _data["isCorrect"];
            this.marks = _data["marks"];
            this.activityQuestionId = _data["activityQuestionId"];
            this.activityQuestion = _data["activityQuestion"] ? QualPOEWorkplaceDocQuestion.fromJS(_data["activityQuestion"]) : <any>undefined;
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentWorkplaceDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPotentialAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualPotentialAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText;
        data["isCorrect"] = this.isCorrect;
        data["marks"] = this.marks;
        data["activityQuestionId"] = this.activityQuestionId;
        data["activityQuestion"] = this.activityQuestion ? this.activityQuestion.toJSON() : <any>undefined;
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPotentialAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IAuditableBaseEntity {
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEWorkplaceDocQuestion | undefined;
    studentQuestionAnswers?: StudentWorkplaceDocQuestionAnswer[] | undefined;
}

export class QualPOEWorkplaceDocAnswer extends QualPotentialAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IQualPOEWorkplaceDocAnswer {

    constructor(data?: IQualPOEWorkplaceDocAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEWorkplaceDocAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEWorkplaceDocAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEWorkplaceDocAnswer extends IQualPotentialAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class StudentQuestionAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends AuditableBaseEntity implements IStudentQuestionAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEWorkplaceDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEWorkplaceDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;

    constructor(data?: IStudentQuestionAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPoeId = _data["studentPoeId"];
            this.studentPoe = _data["studentPoe"] ? StudentPOE.fromJS(_data["studentPoe"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.question = _data["question"] ? QualPOEWorkplaceDocQuestion.fromJS(_data["question"]) : <any>undefined;
            this.answerId = _data["answerId"];
            this.answer = _data["answer"] ? QualPOEWorkplaceDocAnswer.fromJS(_data["answer"]) : <any>undefined;
            this.paragraphAnswer = _data["paragraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
        }
    }

    static override fromJS(data: any): StudentQuestionAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentQuestionAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPoeId"] = this.studentPoeId;
        data["studentPoe"] = this.studentPoe ? this.studentPoe.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["paragraphAnswer"] = this.paragraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentQuestionAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IAuditableBaseEntity {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEWorkplaceDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEWorkplaceDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
}

export class StudentWorkplaceDocQuestionAnswer extends StudentQuestionAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IStudentWorkplaceDocQuestionAnswer {

    constructor(data?: IStudentWorkplaceDocQuestionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentWorkplaceDocQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentWorkplaceDocQuestionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentWorkplaceDocQuestionAnswer extends IStudentQuestionAnswerOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class StudentLearnershipActivityStatusOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends AuditableBaseEntity implements IStudentLearnershipActivityStatusOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEWorkplaceDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;

    constructor(data?: IStudentLearnershipActivityStatusOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? QualPOEWorkplaceDocActivity.fromJS(_data["activity"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static override fromJS(data: any): StudentLearnershipActivityStatusOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipActivityStatusOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipActivityStatusOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus extends IAuditableBaseEntity {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEWorkplaceDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;
}

export class StudentLearnershipWorkplaceDocActivityStatus extends StudentLearnershipActivityStatusOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus implements IStudentLearnershipWorkplaceDocActivityStatus {

    constructor(data?: IStudentLearnershipWorkplaceDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentLearnershipWorkplaceDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipWorkplaceDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipWorkplaceDocActivityStatus extends IStudentLearnershipActivityStatusOfQualPOEWorkplaceDocAndProgrammePOEWorkplaceDocAndStudentPOEWorkplaceDocAndProgrammePOEWorkplaceDocAnnotationAndStudentPOEWorkplaceDocAnnotationAndQualPOEWorkplaceDocInputAndProgrammePOEWorkplaceDocInputAndStudentPOEWorkplaceDocInputAnswerAndQualPOEWorkplaceDocActivityAndQualPOEWorkplaceDocQuestionAndQualPOEWorkplaceDocAnswerAndStudentWorkplaceDocQuestionAnswerAndStudentLearnershipWorkplaceDocActivityStatus {
}

export class StudentPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends POEGroupDocumentEntityOfStudentPOEGroup implements IStudentPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOESaqaDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGroupSaqaDocAnnotation[] | undefined;
    inputAnswers?: StudentPOESaqaDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IStudentPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOESaqaDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEGroupSaqaDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentPOESaqaDocInputAnswer.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): StudentPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IPOEGroupDocumentEntityOfStudentPOEGroup {
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOESaqaDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGroupSaqaDocAnnotation[] | undefined;
    inputAnswers?: StudentPOESaqaDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class StudentPOESaqaDoc extends StudentPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IStudentPOESaqaDoc {
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;

    constructor(data?: IStudentPOESaqaDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unitStandardId = _data["unitStandardId"];
            this.unitStandard = _data["unitStandard"] ? UnitStandard.fromJS(_data["unitStandard"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOESaqaDoc {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOESaqaDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitStandardId"] = this.unitStandardId;
        data["unitStandard"] = this.unitStandard ? this.unitStandard.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOESaqaDoc extends IStudentPOEGroupDocumentEntityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;
}

export class StudentPOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends POEAnnotationOfStudentPOE implements IStudentPOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    studentPOEGroupDocId?: number;
    studentPOEGroupDoc?: StudentPOESaqaDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGroupSaqaDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEGroupId = _data["studentPOEGroupId"];
            this.studentPOEGroup = _data["studentPOEGroup"] ? StudentPOEGroup.fromJS(_data["studentPOEGroup"]) : <any>undefined;
            this.studentPOEGroupDocId = _data["studentPOEGroupDocId"];
            this.studentPOEGroupDoc = _data["studentPOEGroupDoc"] ? StudentPOESaqaDoc.fromJS(_data["studentPOEGroupDoc"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEGroupSaqaDocAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEGroupId"] = this.studentPOEGroupId;
        data["studentPOEGroup"] = this.studentPOEGroup ? this.studentPOEGroup.toJSON() : <any>undefined;
        data["studentPOEGroupDocId"] = this.studentPOEGroupDocId;
        data["studentPOEGroupDoc"] = this.studentPOEGroupDoc ? this.studentPOEGroupDoc.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IPOEAnnotationOfStudentPOE {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    studentPOEGroupDocId?: number;
    studentPOEGroupDoc?: StudentPOESaqaDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGroupSaqaDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class StudentPOEGroupSaqaDocAnnotation extends StudentPOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IStudentPOEGroupSaqaDocAnnotation {

    constructor(data?: IStudentPOEGroupSaqaDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGroupSaqaDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupSaqaDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupSaqaDocAnnotation extends IStudentPOEGroupAnnotationOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export class StudentPOEGroupInputAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends StudentAnswer implements IStudentPOEGroupInputAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: StudentPOESaqaDoc | undefined;
    programmePOEGroupInputId?: number;
    programmePOEGroupInput?: ProgrammePOESaqaDocInput | undefined;

    constructor(data?: IStudentPOEGroupInputAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? StudentPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? StudentPOESaqaDoc.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.programmePOEGroupInputId = _data["programmePOEGroupInputId"];
            this.programmePOEGroupInput = _data["programmePOEGroupInput"] ? ProgrammePOESaqaDocInput.fromJS(_data["programmePOEGroupInput"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEGroupInputAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupInputAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["programmePOEGroupInputId"] = this.programmePOEGroupInputId;
        data["programmePOEGroupInput"] = this.programmePOEGroupInput ? this.programmePOEGroupInput.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupInputAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IStudentAnswer {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: StudentPOESaqaDoc | undefined;
    programmePOEGroupInputId?: number;
    programmePOEGroupInput?: ProgrammePOESaqaDocInput | undefined;
}

export class StudentPOESaqaDocInputAnswer extends StudentPOEGroupInputAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IStudentPOESaqaDocInputAnswer {

    constructor(data?: IStudentPOESaqaDocInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOESaqaDocInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOESaqaDocInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOESaqaDocInputAnswer extends IStudentPOEGroupInputAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export class POEGroupInputOfProgrammePOESaqaDocAndProgrammePOEAndProgrammePOEGroup extends Input implements IPOEGroupInputOfProgrammePOESaqaDocAndProgrammePOEAndProgrammePOEGroup {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: ProgrammePOESaqaDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEGroupInputOfProgrammePOESaqaDocAndProgrammePOEAndProgrammePOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? ProgrammePOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? ProgrammePOESaqaDoc.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupInputOfProgrammePOESaqaDocAndProgrammePOEAndProgrammePOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new POEGroupInputOfProgrammePOESaqaDocAndProgrammePOEAndProgrammePOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupInputOfProgrammePOESaqaDocAndProgrammePOEAndProgrammePOEGroup extends IInput {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: ProgrammePOESaqaDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends POEGroupInputOfProgrammePOESaqaDocAndProgrammePOEAndProgrammePOEGroup implements IProgrammePOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    studentInputAnswers?: StudentPOESaqaDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOESaqaDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammePOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentPOESaqaDocInputAnswer.fromJS(item));
            }
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualPOESaqaDocInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IPOEGroupInputOfProgrammePOESaqaDocAndProgrammePOEAndProgrammePOEGroup {
    studentInputAnswers?: StudentPOESaqaDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOESaqaDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;
}

export class ProgrammePOESaqaDocInput extends ProgrammePOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IProgrammePOESaqaDocInput {

    constructor(data?: IProgrammePOESaqaDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOESaqaDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOESaqaDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOESaqaDocInput extends IProgrammePOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export class POEGroupInputOfQualPOESaqaDocAndQualPOEAndQualPOEGroup extends Input implements IPOEGroupInputOfQualPOESaqaDocAndQualPOEAndQualPOEGroup {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: QualPOESaqaDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;

    constructor(data?: IPOEGroupInputOfQualPOESaqaDocAndQualPOEAndQualPOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? QualPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? QualPOESaqaDoc.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupInputOfQualPOESaqaDocAndQualPOEAndQualPOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new POEGroupInputOfQualPOESaqaDocAndQualPOEAndQualPOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupInputOfQualPOESaqaDocAndQualPOEAndQualPOEGroup extends IInput {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: QualPOESaqaDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;
}

export class QualPOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends POEGroupInputOfQualPOESaqaDocAndQualPOEAndQualPOEGroup implements IQualPOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOESaqaDocInput[] | undefined;

    constructor(data?: IQualPOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammePOESaqaDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IPOEGroupInputOfQualPOESaqaDocAndQualPOEAndQualPOEGroup {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOESaqaDocInput[] | undefined;
}

export class QualPOESaqaDocInput extends QualPOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IQualPOESaqaDocInput {

    constructor(data?: IQualPOESaqaDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESaqaDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESaqaDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESaqaDocInput extends IQualPOEGroupInputOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export class QualPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends POEGroupDocumentEntityOfQualPOEGroup implements IQualPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    childrenDocs?: ProgrammePOEGroupDoc[] | undefined;
    inputs?: QualPOEGroupGeneralDocInput[] | undefined;
    activities?: QualPOEGroupGeneralDocActivity[] | undefined;

    constructor(data?: IQualPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(ProgrammePOEGroupDoc.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(QualPOEGroupGeneralDocInput.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(QualPOEGroupGeneralDocActivity.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IPOEGroupDocumentEntityOfQualPOEGroup {
    childrenDocs?: ProgrammePOEGroupDoc[] | undefined;
    inputs?: QualPOEGroupGeneralDocInput[] | undefined;
    activities?: QualPOEGroupGeneralDocActivity[] | undefined;
}

export class QualPOEGroupDoc extends QualPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IQualPOEGroupDoc {

    constructor(data?: IQualPOEGroupDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGroupDoc {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupDoc extends IQualPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class ProgrammePOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends POEGroupDocumentEntityOfProgrammePOEGroup implements IProgrammePOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    parentDocId?: number | undefined;
    parentDoc?: QualPOEGroupDoc | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    annotations?: ProgrammePOEGroupDocAnnotation[] | undefined;
    childrenDocs?: StudentPOEGroupDoc[] | undefined;
    inputs?: ProgrammePOEGroupGeneralDocInput[] | undefined;

    constructor(data?: IProgrammePOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? QualPOEGroupDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ProgrammePOEGroupDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["childrenDocs"])) {
                this.childrenDocs = [] as any;
                for (let item of _data["childrenDocs"])
                    this.childrenDocs!.push(StudentPOEGroupDoc.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ProgrammePOEGroupGeneralDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.childrenDocs)) {
            data["childrenDocs"] = [];
            for (let item of this.childrenDocs)
                data["childrenDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IPOEGroupDocumentEntityOfProgrammePOEGroup {
    parentDocId?: number | undefined;
    parentDoc?: QualPOEGroupDoc | undefined;
    inheritedFromQualPOE?: boolean;
    useParentDoc?: boolean;
    annotations?: ProgrammePOEGroupDocAnnotation[] | undefined;
    childrenDocs?: StudentPOEGroupDoc[] | undefined;
    inputs?: ProgrammePOEGroupGeneralDocInput[] | undefined;
}

export class ProgrammePOEGroupDoc extends ProgrammePOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IProgrammePOEGroupDoc {

    constructor(data?: IProgrammePOEGroupDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGroupDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupDoc extends IProgrammePOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class ProgrammePOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends POEAnnotationOfProgrammePOE implements IProgrammePOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    programmePOEGroupDocId?: number;
    programmePOEGroupDoc?: ProgrammePOEGroupDoc | undefined;
    childrenAnnotations?: StudentPOEGroupDocAnnotation[] | undefined;

    constructor(data?: IProgrammePOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEGroupId = _data["programmePOEGroupId"];
            this.programmePOEGroup = _data["programmePOEGroup"] ? ProgrammePOEGroup.fromJS(_data["programmePOEGroup"]) : <any>undefined;
            this.programmePOEGroupDocId = _data["programmePOEGroupDocId"];
            this.programmePOEGroupDoc = _data["programmePOEGroupDoc"] ? ProgrammePOEGroupDoc.fromJS(_data["programmePOEGroupDoc"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEGroupDocAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEGroupId"] = this.programmePOEGroupId;
        data["programmePOEGroup"] = this.programmePOEGroup ? this.programmePOEGroup.toJSON() : <any>undefined;
        data["programmePOEGroupDocId"] = this.programmePOEGroupDocId;
        data["programmePOEGroupDoc"] = this.programmePOEGroupDoc ? this.programmePOEGroupDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IPOEAnnotationOfProgrammePOE {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    programmePOEGroupDocId?: number;
    programmePOEGroupDoc?: ProgrammePOEGroupDoc | undefined;
    childrenAnnotations?: StudentPOEGroupDocAnnotation[] | undefined;
}

export class ProgrammePOEGroupDocAnnotation extends ProgrammePOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IProgrammePOEGroupDocAnnotation {

    constructor(data?: IProgrammePOEGroupDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGroupDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupDocAnnotation extends IProgrammePOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class StudentPOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends POEAnnotationOfStudentPOE implements IStudentPOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    studentPOEGroupDocId?: number;
    studentPOEGroupDoc?: StudentPOEGroupDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGroupDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEGroupId = _data["studentPOEGroupId"];
            this.studentPOEGroup = _data["studentPOEGroup"] ? StudentPOEGroup.fromJS(_data["studentPOEGroup"]) : <any>undefined;
            this.studentPOEGroupDocId = _data["studentPOEGroupDocId"];
            this.studentPOEGroupDoc = _data["studentPOEGroupDoc"] ? StudentPOEGroupDoc.fromJS(_data["studentPOEGroupDoc"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEGroupDocAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEGroupId"] = this.studentPOEGroupId;
        data["studentPOEGroup"] = this.studentPOEGroup ? this.studentPOEGroup.toJSON() : <any>undefined;
        data["studentPOEGroupDocId"] = this.studentPOEGroupDocId;
        data["studentPOEGroupDoc"] = this.studentPOEGroupDoc ? this.studentPOEGroupDoc.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IPOEAnnotationOfStudentPOE {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    studentPOEGroupDocId?: number;
    studentPOEGroupDoc?: StudentPOEGroupDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGroupDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class StudentPOEGroupDocAnnotation extends StudentPOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IStudentPOEGroupDocAnnotation {

    constructor(data?: IStudentPOEGroupDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGroupDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupDocAnnotation extends IStudentPOEGroupAnnotationOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class StudentPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends POEGroupDocumentEntityOfStudentPOEGroup implements IStudentPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEGroupDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGroupDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEGroupGeneralDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IStudentPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOEGroupDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEGroupDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentPOEGroupGeneralDocInputAnswer.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): StudentPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IPOEGroupDocumentEntityOfStudentPOEGroup {
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEGroupDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGroupDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEGroupGeneralDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class StudentPOEGroupDoc extends StudentPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IStudentPOEGroupDoc {

    constructor(data?: IStudentPOEGroupDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGroupDoc {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupDoc extends IStudentPOEGroupDocumentEntityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class StudentPOEGroupInputAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends StudentAnswer implements IStudentPOEGroupInputAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: StudentPOEGroupDoc | undefined;
    programmePOEGroupInputId?: number;
    programmePOEGroupInput?: ProgrammePOEGroupGeneralDocInput | undefined;

    constructor(data?: IStudentPOEGroupInputAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? StudentPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? StudentPOEGroupDoc.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.programmePOEGroupInputId = _data["programmePOEGroupInputId"];
            this.programmePOEGroupInput = _data["programmePOEGroupInput"] ? ProgrammePOEGroupGeneralDocInput.fromJS(_data["programmePOEGroupInput"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEGroupInputAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupInputAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["programmePOEGroupInputId"] = this.programmePOEGroupInputId;
        data["programmePOEGroupInput"] = this.programmePOEGroupInput ? this.programmePOEGroupInput.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupInputAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IStudentAnswer {
    poeGroupId?: number;
    poeGroup?: StudentPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: StudentPOEGroupDoc | undefined;
    programmePOEGroupInputId?: number;
    programmePOEGroupInput?: ProgrammePOEGroupGeneralDocInput | undefined;
}

export class StudentPOEGroupGeneralDocInputAnswer extends StudentPOEGroupInputAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IStudentPOEGroupGeneralDocInputAnswer {

    constructor(data?: IStudentPOEGroupGeneralDocInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGroupGeneralDocInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupGeneralDocInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupGeneralDocInputAnswer extends IStudentPOEGroupInputAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class POEGroupInputOfProgrammePOEGroupDocAndProgrammePOEAndProgrammePOEGroup extends Input implements IPOEGroupInputOfProgrammePOEGroupDocAndProgrammePOEAndProgrammePOEGroup {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: ProgrammePOEGroupDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEGroupInputOfProgrammePOEGroupDocAndProgrammePOEAndProgrammePOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? ProgrammePOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? ProgrammePOEGroupDoc.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupInputOfProgrammePOEGroupDocAndProgrammePOEAndProgrammePOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new POEGroupInputOfProgrammePOEGroupDocAndProgrammePOEAndProgrammePOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupInputOfProgrammePOEGroupDocAndProgrammePOEAndProgrammePOEGroup extends IInput {
    poeGroupId?: number;
    poeGroup?: ProgrammePOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: ProgrammePOEGroupDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends POEGroupInputOfProgrammePOEGroupDocAndProgrammePOEAndProgrammePOEGroup implements IProgrammePOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    studentInputAnswers?: StudentPOEGroupGeneralDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEGroupGeneralDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammePOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentPOEGroupGeneralDocInputAnswer.fromJS(item));
            }
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualPOEGroupGeneralDocInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IPOEGroupInputOfProgrammePOEGroupDocAndProgrammePOEAndProgrammePOEGroup {
    studentInputAnswers?: StudentPOEGroupGeneralDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEGroupGeneralDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;
}

export class ProgrammePOEGroupGeneralDocInput extends ProgrammePOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IProgrammePOEGroupGeneralDocInput {

    constructor(data?: IProgrammePOEGroupGeneralDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGroupGeneralDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupGeneralDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupGeneralDocInput extends IProgrammePOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class POEGroupInputOfQualPOEGroupDocAndQualPOEAndQualPOEGroup extends Input implements IPOEGroupInputOfQualPOEGroupDocAndQualPOEAndQualPOEGroup {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: QualPOEGroupDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;

    constructor(data?: IPOEGroupInputOfQualPOEGroupDocAndQualPOEAndQualPOEGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeGroupId = _data["poeGroupId"];
            this.poeGroup = _data["poeGroup"] ? QualPOEGroup.fromJS(_data["poeGroup"]) : <any>undefined;
            this.poeGroupDocId = _data["poeGroupDocId"];
            this.poeGroupDoc = _data["poeGroupDoc"] ? QualPOEGroupDoc.fromJS(_data["poeGroupDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEGroupInputOfQualPOEGroupDocAndQualPOEAndQualPOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new POEGroupInputOfQualPOEGroupDocAndQualPOEAndQualPOEGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeGroupId"] = this.poeGroupId;
        data["poeGroup"] = this.poeGroup ? this.poeGroup.toJSON() : <any>undefined;
        data["poeGroupDocId"] = this.poeGroupDocId;
        data["poeGroupDoc"] = this.poeGroupDoc ? this.poeGroupDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEGroupInputOfQualPOEGroupDocAndQualPOEAndQualPOEGroup extends IInput {
    poeGroupId?: number;
    poeGroup?: QualPOEGroup | undefined;
    poeGroupDocId?: number;
    poeGroupDoc?: QualPOEGroupDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;
}

export class QualPOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends POEGroupInputOfQualPOEGroupDocAndQualPOEAndQualPOEGroup implements IQualPOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEGroupGeneralDocInput[] | undefined;

    constructor(data?: IQualPOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammePOEGroupGeneralDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IPOEGroupInputOfQualPOEGroupDocAndQualPOEAndQualPOEGroup {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEGroupGeneralDocInput[] | undefined;
}

export class QualPOEGroupGeneralDocInput extends QualPOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IQualPOEGroupGeneralDocInput {

    constructor(data?: IQualPOEGroupGeneralDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGroupGeneralDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupGeneralDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupGeneralDocInput extends IQualPOEGroupInputOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export abstract class QualGroupActivityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends AuditableBaseEntity implements IQualGroupActivityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEGroupGeneralDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipGroupGeneralDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEGroupDoc | undefined;

    constructor(data?: IQualGroupActivityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(QualPOEGroupGeneralDocQuestion.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipActivityStatus"])) {
                this.studentLearnershipActivityStatus = [] as any;
                for (let item of _data["studentLearnershipActivityStatus"])
                    this.studentLearnershipActivityStatus!.push(StudentLearnershipGroupGeneralDocActivityStatus.fromJS(item));
            }
            this.qualPoeDocId = _data["qualPoeDocId"];
            this.qualPoeDoc = _data["qualPoeDoc"] ? QualPOEGroupDoc.fromJS(_data["qualPoeDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualGroupActivityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupActivityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipActivityStatus)) {
            data["studentLearnershipActivityStatus"] = [];
            for (let item of this.studentLearnershipActivityStatus)
                data["studentLearnershipActivityStatus"].push(item.toJSON());
        }
        data["qualPoeDocId"] = this.qualPoeDocId;
        data["qualPoeDoc"] = this.qualPoeDoc ? this.qualPoeDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupActivityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IAuditableBaseEntity {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEGroupGeneralDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipGroupGeneralDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEGroupDoc | undefined;
}

export class QualPOEGroupGeneralDocActivity extends QualGroupActivityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IQualPOEGroupGeneralDocActivity {

    constructor(data?: IQualPOEGroupGeneralDocActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGroupGeneralDocActivity {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupGeneralDocActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupGeneralDocActivity extends IQualGroupActivityOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export abstract class QualGroupActivityQuestionOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends PageAndPosition implements IQualGroupActivityQuestionOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEGroupGeneralDocActivity | undefined;
    potentialAnswers?: QualPOEGroupGeneralDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentGroupGeneralDocQuestionAnswer[] | undefined;

    constructor(data?: IQualGroupActivityQuestionOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.multiSelect = _data["multiSelect"];
            this.type = _data["type"];
            this.activity = _data["activity"] ? QualPOEGroupGeneralDocActivity.fromJS(_data["activity"]) : <any>undefined;
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(QualPOEGroupGeneralDocAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentGroupGeneralDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualGroupActivityQuestionOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupActivityQuestionOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["multiSelect"] = this.multiSelect;
        data["type"] = this.type;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupActivityQuestionOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IPageAndPosition {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEGroupGeneralDocActivity | undefined;
    potentialAnswers?: QualPOEGroupGeneralDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentGroupGeneralDocQuestionAnswer[] | undefined;
}

export class QualPOEGroupGeneralDocQuestion extends QualGroupActivityQuestionOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IQualPOEGroupGeneralDocQuestion {

    constructor(data?: IQualPOEGroupGeneralDocQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGroupGeneralDocQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupGeneralDocQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupGeneralDocQuestion extends IQualGroupActivityQuestionOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export abstract class QualGroupPotentialAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends AuditableBaseEntity implements IQualGroupPotentialAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    questionId?: number;
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEGroupGeneralDocQuestion | undefined;
    studentQuestionAnswers?: StudentGroupGeneralDocQuestionAnswer[] | undefined;

    constructor(data?: IQualGroupPotentialAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionId = _data["questionId"];
            this.answerText = _data["answerText"];
            this.isCorrect = _data["isCorrect"];
            this.marks = _data["marks"];
            this.activityQuestionId = _data["activityQuestionId"];
            this.activityQuestion = _data["activityQuestion"] ? QualPOEGroupGeneralDocQuestion.fromJS(_data["activityQuestion"]) : <any>undefined;
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentGroupGeneralDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualGroupPotentialAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupPotentialAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answerText"] = this.answerText;
        data["isCorrect"] = this.isCorrect;
        data["marks"] = this.marks;
        data["activityQuestionId"] = this.activityQuestionId;
        data["activityQuestion"] = this.activityQuestion ? this.activityQuestion.toJSON() : <any>undefined;
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupPotentialAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IAuditableBaseEntity {
    questionId?: number;
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEGroupGeneralDocQuestion | undefined;
    studentQuestionAnswers?: StudentGroupGeneralDocQuestionAnswer[] | undefined;
}

export class QualPOEGroupGeneralDocAnswer extends QualGroupPotentialAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IQualPOEGroupGeneralDocAnswer {

    constructor(data?: IQualPOEGroupGeneralDocAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGroupGeneralDocAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupGeneralDocAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupGeneralDocAnswer extends IQualGroupPotentialAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class StudentGroupQuestionAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends AuditableBaseEntity implements IStudentGroupQuestionAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEGroupGeneralDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEGroupGeneralDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;

    constructor(data?: IStudentGroupQuestionAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPoeId = _data["studentPoeId"];
            this.studentPoe = _data["studentPoe"] ? StudentPOE.fromJS(_data["studentPoe"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.question = _data["question"] ? QualPOEGroupGeneralDocQuestion.fromJS(_data["question"]) : <any>undefined;
            this.answerId = _data["answerId"];
            this.answer = _data["answer"] ? QualPOEGroupGeneralDocAnswer.fromJS(_data["answer"]) : <any>undefined;
            this.paragraphAnswer = _data["paragraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
        }
    }

    static override fromJS(data: any): StudentGroupQuestionAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentGroupQuestionAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPoeId"] = this.studentPoeId;
        data["studentPoe"] = this.studentPoe ? this.studentPoe.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["paragraphAnswer"] = this.paragraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentGroupQuestionAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IAuditableBaseEntity {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEGroupGeneralDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEGroupGeneralDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
}

export class StudentGroupGeneralDocQuestionAnswer extends StudentGroupQuestionAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IStudentGroupGeneralDocQuestionAnswer {

    constructor(data?: IStudentGroupGeneralDocQuestionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentGroupGeneralDocQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentGroupGeneralDocQuestionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentGroupGeneralDocQuestionAnswer extends IStudentGroupQuestionAnswerOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class StudentLearnershipGroupActivityStatusOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends AuditableBaseEntity implements IStudentLearnershipGroupActivityStatusOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEGroupGeneralDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;

    constructor(data?: IStudentLearnershipGroupActivityStatusOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? QualPOEGroupGeneralDocActivity.fromJS(_data["activity"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static override fromJS(data: any): StudentLearnershipGroupActivityStatusOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipGroupActivityStatusOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipGroupActivityStatusOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus extends IAuditableBaseEntity {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEGroupGeneralDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;
}

export class StudentLearnershipGroupGeneralDocActivityStatus extends StudentLearnershipGroupActivityStatusOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus implements IStudentLearnershipGroupGeneralDocActivityStatus {

    constructor(data?: IStudentLearnershipGroupGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentLearnershipGroupGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipGroupGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipGroupGeneralDocActivityStatus extends IStudentLearnershipGroupActivityStatusOfQualPOEGroupDocAndProgrammePOEGroupDocAndStudentPOEGroupDocAndProgrammePOEGroupDocAnnotationAndStudentPOEGroupDocAnnotationAndQualPOEGroupGeneralDocInputAndProgrammePOEGroupGeneralDocInputAndStudentPOEGroupGeneralDocInputAnswerAndQualPOEGroupGeneralDocActivityAndQualPOEGroupGeneralDocQuestionAndQualPOEGroupGeneralDocAnswerAndStudentGroupGeneralDocQuestionAnswerAndStudentLearnershipGroupGeneralDocActivityStatus {
}

export class StudentPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends POEDocumentEntity implements IStudentPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEGeneralDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGeneralDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEGeneralDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;

    constructor(data?: IStudentPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOE = _data["studentPOE"] ? StudentPOE.fromJS(_data["studentPOE"]) : <any>undefined;
            this.parentDocId = _data["parentDocId"];
            this.parentDoc = _data["parentDoc"] ? ProgrammePOEGeneralDoc.fromJS(_data["parentDoc"]) : <any>undefined;
            this.useParentDoc = _data["useParentDoc"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(StudentPOEGeneralDocAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["inputAnswers"])) {
                this.inputAnswers = [] as any;
                for (let item of _data["inputAnswers"])
                    this.inputAnswers!.push(StudentPOEGeneralDocInputAnswer.fromJS(item));
            }
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
        }
    }

    static override fromJS(data: any): StudentPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOE"] = this.studentPOE ? this.studentPOE.toJSON() : <any>undefined;
        data["parentDocId"] = this.parentDocId;
        data["parentDoc"] = this.parentDoc ? this.parentDoc.toJSON() : <any>undefined;
        data["useParentDoc"] = this.useParentDoc;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        if (Array.isArray(this.inputAnswers)) {
            data["inputAnswers"] = [];
            for (let item of this.inputAnswers)
                data["inputAnswers"].push(item.toJSON());
        }
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IPOEDocumentEntity {
    studentPOE?: StudentPOE | undefined;
    parentDocId?: number | undefined;
    parentDoc?: ProgrammePOEGeneralDoc | undefined;
    useParentDoc?: boolean;
    annotations?: StudentPOEGeneralDocAnnotation[] | undefined;
    inputAnswers?: StudentPOEGeneralDocInputAnswer[] | undefined;
    studentAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
}

export class StudentPOEGeneralDoc extends StudentPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IStudentPOEGeneralDoc {

    constructor(data?: IStudentPOEGeneralDoc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGeneralDoc {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGeneralDoc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGeneralDoc extends IStudentPOEDocumentEntityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class StudentPOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends POEAnnotationOfStudentPOE implements IStudentPOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    studentPOEDocId?: number;
    studentPOEDoc?: StudentPOEGeneralDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGeneralDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEDocId = _data["studentPOEDocId"];
            this.studentPOEDoc = _data["studentPOEDoc"] ? StudentPOEGeneralDoc.fromJS(_data["studentPOEDoc"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEGeneralDocAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEDocId"] = this.studentPOEDocId;
        data["studentPOEDoc"] = this.studentPOEDoc ? this.studentPOEDoc.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IPOEAnnotationOfStudentPOE {
    studentPOEDocId?: number;
    studentPOEDoc?: StudentPOEGeneralDoc | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGeneralDocAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class StudentPOEGeneralDocAnnotation extends StudentPOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IStudentPOEGeneralDocAnnotation {

    constructor(data?: IStudentPOEGeneralDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGeneralDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGeneralDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGeneralDocAnnotation extends IStudentPOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class ProgrammePOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends POEAnnotationOfProgrammePOE implements IProgrammePOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    programmePOEDocId?: number;
    programmePOEDoc?: ProgrammePOEGeneralDoc | undefined;
    childrenAnnotations?: StudentPOEGeneralDocAnnotation[] | undefined;

    constructor(data?: IProgrammePOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEDocId = _data["programmePOEDocId"];
            this.programmePOEDoc = _data["programmePOEDoc"] ? ProgrammePOEGeneralDoc.fromJS(_data["programmePOEDoc"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEGeneralDocAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEDocId"] = this.programmePOEDocId;
        data["programmePOEDoc"] = this.programmePOEDoc ? this.programmePOEDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IPOEAnnotationOfProgrammePOE {
    programmePOEDocId?: number;
    programmePOEDoc?: ProgrammePOEGeneralDoc | undefined;
    childrenAnnotations?: StudentPOEGeneralDocAnnotation[] | undefined;
}

export class ProgrammePOEGeneralDocAnnotation extends ProgrammePOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IProgrammePOEGeneralDocAnnotation {

    constructor(data?: IProgrammePOEGeneralDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGeneralDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGeneralDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGeneralDocAnnotation extends IProgrammePOEAnnotationOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class StudentPOEInputAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends StudentAnswer implements IStudentPOEInputAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    poeDocId?: number;
    poeDoc?: StudentPOEGeneralDoc | undefined;
    programmePOEInputId?: number;
    programmePOEInput?: ProgrammePOEGeneralDocInput | undefined;

    constructor(data?: IStudentPOEInputAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? StudentPOEGeneralDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.programmePOEInputId = _data["programmePOEInputId"];
            this.programmePOEInput = _data["programmePOEInput"] ? ProgrammePOEGeneralDocInput.fromJS(_data["programmePOEInput"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEInputAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEInputAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["programmePOEInputId"] = this.programmePOEInputId;
        data["programmePOEInput"] = this.programmePOEInput ? this.programmePOEInput.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEInputAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IStudentAnswer {
    poeDocId?: number;
    poeDoc?: StudentPOEGeneralDoc | undefined;
    programmePOEInputId?: number;
    programmePOEInput?: ProgrammePOEGeneralDocInput | undefined;
}

export class StudentPOEGeneralDocInputAnswer extends StudentPOEInputAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IStudentPOEGeneralDocInputAnswer {

    constructor(data?: IStudentPOEGeneralDocInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGeneralDocInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGeneralDocInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGeneralDocInputAnswer extends IStudentPOEInputAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class POEInputOfProgrammePOEGeneralDocAndProgrammePOE extends Input implements IPOEInputOfProgrammePOEGeneralDocAndProgrammePOE {
    poeDocId?: number;
    poeDoc?: ProgrammePOEGeneralDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;

    constructor(data?: IPOEInputOfProgrammePOEGeneralDocAndProgrammePOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? ProgrammePOEGeneralDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? ProgrammePOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEInputOfProgrammePOEGeneralDocAndProgrammePOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEInputOfProgrammePOEGeneralDocAndProgrammePOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEInputOfProgrammePOEGeneralDocAndProgrammePOE extends IInput {
    poeDocId?: number;
    poeDoc?: ProgrammePOEGeneralDoc | undefined;
    poeId?: number;
    poe?: ProgrammePOE | undefined;
}

export class ProgrammePOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends POEInputOfProgrammePOEGeneralDocAndProgrammePOE implements IProgrammePOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    studentInputAnswers?: StudentPOEGeneralDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEGeneralDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammePOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentPOEGeneralDocInputAnswer.fromJS(item));
            }
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualPOEGeneralDocInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammePOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IPOEInputOfProgrammePOEGeneralDocAndProgrammePOE {
    studentInputAnswers?: StudentPOEGeneralDocInputAnswer[] | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualPOEGeneralDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    inheritedFromQualPOE?: boolean;
    value?: string | undefined;
}

export class ProgrammePOEGeneralDocInput extends ProgrammePOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IProgrammePOEGeneralDocInput {

    constructor(data?: IProgrammePOEGeneralDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGeneralDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGeneralDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGeneralDocInput extends IProgrammePOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class POEInputOfQualPOEGeneralDocAndQualPOE extends Input implements IPOEInputOfQualPOEGeneralDocAndQualPOE {
    poeDocId?: number;
    poeDoc?: QualPOEGeneralDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;

    constructor(data?: IPOEInputOfQualPOEGeneralDocAndQualPOE) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.poeDocId = _data["poeDocId"];
            this.poeDoc = _data["poeDoc"] ? QualPOEGeneralDoc.fromJS(_data["poeDoc"]) : <any>undefined;
            this.poeId = _data["poeId"];
            this.poe = _data["poe"] ? QualPOE.fromJS(_data["poe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): POEInputOfQualPOEGeneralDocAndQualPOE {
        data = typeof data === 'object' ? data : {};
        let result = new POEInputOfQualPOEGeneralDocAndQualPOE();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeDocId"] = this.poeDocId;
        data["poeDoc"] = this.poeDoc ? this.poeDoc.toJSON() : <any>undefined;
        data["poeId"] = this.poeId;
        data["poe"] = this.poe ? this.poe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEInputOfQualPOEGeneralDocAndQualPOE extends IInput {
    poeDocId?: number;
    poeDoc?: QualPOEGeneralDoc | undefined;
    poeId?: number;
    poe?: QualPOE | undefined;
}

export class QualPOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends POEInputOfQualPOEGeneralDocAndQualPOE implements IQualPOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEGeneralDocInput[] | undefined;

    constructor(data?: IQualPOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammePOEGeneralDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IPOEInputOfQualPOEGeneralDocAndQualPOE {
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammePOEGeneralDocInput[] | undefined;
}

export class QualPOEGeneralDocInput extends QualPOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IQualPOEGeneralDocInput {

    constructor(data?: IQualPOEGeneralDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGeneralDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGeneralDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGeneralDocInput extends IQualPOEInputOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class ProgrammePOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends POEAnnotationOfProgrammePOE implements IProgrammePOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    programmePOEGroupDocId?: number;
    programmePOEGroupDoc?: ProgrammePOESummativeAssessment | undefined;
    childrenAnnotations?: StudentPOEGroupSummativeAssessmentAnnotation[] | undefined;

    constructor(data?: IProgrammePOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEGroupId = _data["programmePOEGroupId"];
            this.programmePOEGroup = _data["programmePOEGroup"] ? ProgrammePOEGroup.fromJS(_data["programmePOEGroup"]) : <any>undefined;
            this.programmePOEGroupDocId = _data["programmePOEGroupDocId"];
            this.programmePOEGroupDoc = _data["programmePOEGroupDoc"] ? ProgrammePOESummativeAssessment.fromJS(_data["programmePOEGroupDoc"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEGroupSummativeAssessmentAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEGroupId"] = this.programmePOEGroupId;
        data["programmePOEGroup"] = this.programmePOEGroup ? this.programmePOEGroup.toJSON() : <any>undefined;
        data["programmePOEGroupDocId"] = this.programmePOEGroupDocId;
        data["programmePOEGroupDoc"] = this.programmePOEGroupDoc ? this.programmePOEGroupDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IPOEAnnotationOfProgrammePOE {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    programmePOEGroupDocId?: number;
    programmePOEGroupDoc?: ProgrammePOESummativeAssessment | undefined;
    childrenAnnotations?: StudentPOEGroupSummativeAssessmentAnnotation[] | undefined;
}

export class ProgrammePOEGroupSummativeAssessmentAnnotation extends ProgrammePOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IProgrammePOEGroupSummativeAssessmentAnnotation {

    constructor(data?: IProgrammePOEGroupSummativeAssessmentAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGroupSummativeAssessmentAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupSummativeAssessmentAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupSummativeAssessmentAnnotation extends IProgrammePOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export class StudentPOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends POEAnnotationOfStudentPOE implements IStudentPOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    studentPOEGroupDocId?: number;
    studentPOEGroupDoc?: StudentPOESummativeAssessment | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGroupSummativeAssessmentAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;

    constructor(data?: IStudentPOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEGroupId = _data["studentPOEGroupId"];
            this.studentPOEGroup = _data["studentPOEGroup"] ? StudentPOEGroup.fromJS(_data["studentPOEGroup"]) : <any>undefined;
            this.studentPOEGroupDocId = _data["studentPOEGroupDocId"];
            this.studentPOEGroupDoc = _data["studentPOEGroupDoc"] ? StudentPOESummativeAssessment.fromJS(_data["studentPOEGroupDoc"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammePOEGroupSummativeAssessmentAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromProgramePOE = _data["inheritedFromProgramePOE"];
        }
    }

    static override fromJS(data: any): StudentPOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEGroupId"] = this.studentPOEGroupId;
        data["studentPOEGroup"] = this.studentPOEGroup ? this.studentPOEGroup.toJSON() : <any>undefined;
        data["studentPOEGroupDocId"] = this.studentPOEGroupDocId;
        data["studentPOEGroupDoc"] = this.studentPOEGroupDoc ? this.studentPOEGroupDoc.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromProgramePOE"] = this.inheritedFromProgramePOE;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus extends IPOEAnnotationOfStudentPOE {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    studentPOEGroupDocId?: number;
    studentPOEGroupDoc?: StudentPOESummativeAssessment | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammePOEGroupSummativeAssessmentAnnotation | undefined;
    inheritedFromProgramePOE?: boolean;
}

export class StudentPOEGroupSummativeAssessmentAnnotation extends StudentPOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus implements IStudentPOEGroupSummativeAssessmentAnnotation {

    constructor(data?: IStudentPOEGroupSummativeAssessmentAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentPOEGroupSummativeAssessmentAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupSummativeAssessmentAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupSummativeAssessmentAnnotation extends IStudentPOEGroupAnnotationOfQualPOESummativeAssessmentAndProgrammePOESummativeAssessmentAndStudentPOESummativeAssessmentAndProgrammePOEGroupSummativeAssessmentAnnotationAndStudentPOEGroupSummativeAssessmentAnnotationAndQualPOESummativeAssessmentInputAndProgrammePOESummativeAssessmentInputAndStudentPOESummativeAssessmentInputAnswerAndQualPOESummativeAssessmentActivityAndQualPOESummativeAssessmentQuestionAndQualPOESummativeAssessmentAnswerAndStudentSummativeQuestionAnswerAndStudentLearnershipSummativeActivityStatus {
}

export enum KnowledgeModuleType {
    Knowledge = 0,
    Practical = 1,
    Workplace = 2,
}

export class QualPOEGroupUnitStandards extends AuditableBaseEntity implements IQualPOEGroupUnitStandards {
    qualPOEGroupId?: number;
    qualPOEGroup?: QualPOEGroup | undefined;
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;

    constructor(data?: IQualPOEGroupUnitStandards) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualPOEGroupId = _data["qualPOEGroupId"];
            this.qualPOEGroup = _data["qualPOEGroup"] ? QualPOEGroup.fromJS(_data["qualPOEGroup"]) : <any>undefined;
            this.unitStandardId = _data["unitStandardId"];
            this.unitStandard = _data["unitStandard"] ? UnitStandard.fromJS(_data["unitStandard"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualPOEGroupUnitStandards {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupUnitStandards();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualPOEGroupId"] = this.qualPOEGroupId;
        data["qualPOEGroup"] = this.qualPOEGroup ? this.qualPOEGroup.toJSON() : <any>undefined;
        data["unitStandardId"] = this.unitStandardId;
        data["unitStandard"] = this.unitStandard ? this.unitStandard.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupUnitStandards extends IAuditableBaseEntity {
    qualPOEGroupId?: number;
    qualPOEGroup?: QualPOEGroup | undefined;
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;
}

export class QualPOEGroupKnowledgeModules extends AuditableBaseEntity implements IQualPOEGroupKnowledgeModules {
    qualPOEGroupId?: number;
    qualPOEGroup?: QualPOEGroup | undefined;
    knowledgeModuleId?: number;
    knowledgeModule?: KnowledgeModule | undefined;

    constructor(data?: IQualPOEGroupKnowledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualPOEGroupId = _data["qualPOEGroupId"];
            this.qualPOEGroup = _data["qualPOEGroup"] ? QualPOEGroup.fromJS(_data["qualPOEGroup"]) : <any>undefined;
            this.knowledgeModuleId = _data["knowledgeModuleId"];
            this.knowledgeModule = _data["knowledgeModule"] ? KnowledgeModule.fromJS(_data["knowledgeModule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualPOEGroupKnowledgeModules {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGroupKnowledgeModules();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualPOEGroupId"] = this.qualPOEGroupId;
        data["qualPOEGroup"] = this.qualPOEGroup ? this.qualPOEGroup.toJSON() : <any>undefined;
        data["knowledgeModuleId"] = this.knowledgeModuleId;
        data["knowledgeModule"] = this.knowledgeModule ? this.knowledgeModule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGroupKnowledgeModules extends IAuditableBaseEntity {
    qualPOEGroupId?: number;
    qualPOEGroup?: QualPOEGroup | undefined;
    knowledgeModuleId?: number;
    knowledgeModule?: KnowledgeModule | undefined;
}

export class KnowledgeModule extends AuditableBaseEntity implements IKnowledgeModule {
    type?: KnowledgeModuleType;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
    qualGroups?: QualPOEGroupKnowledgeModules[] | undefined;
    programmeGroups?: ProgrammePOEGroupKnowledgeModules[] | undefined;
    studentGroups?: StudentPOEGroupKnowledgeModules[] | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;

    constructor(data?: IKnowledgeModule) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
            if (Array.isArray(_data["qualGroups"])) {
                this.qualGroups = [] as any;
                for (let item of _data["qualGroups"])
                    this.qualGroups!.push(QualPOEGroupKnowledgeModules.fromJS(item));
            }
            if (Array.isArray(_data["programmeGroups"])) {
                this.programmeGroups = [] as any;
                for (let item of _data["programmeGroups"])
                    this.programmeGroups!.push(ProgrammePOEGroupKnowledgeModules.fromJS(item));
            }
            if (Array.isArray(_data["studentGroups"])) {
                this.studentGroups = [] as any;
                for (let item of _data["studentGroups"])
                    this.studentGroups!.push(StudentPOEGroupKnowledgeModules.fromJS(item));
            }
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): KnowledgeModule {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeModule();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        if (Array.isArray(this.qualGroups)) {
            data["qualGroups"] = [];
            for (let item of this.qualGroups)
                data["qualGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.programmeGroups)) {
            data["programmeGroups"] = [];
            for (let item of this.programmeGroups)
                data["programmeGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.studentGroups)) {
            data["studentGroups"] = [];
            for (let item of this.studentGroups)
                data["studentGroups"].push(item.toJSON());
        }
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IKnowledgeModule extends IAuditableBaseEntity {
    type?: KnowledgeModuleType;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
    qualGroups?: QualPOEGroupKnowledgeModules[] | undefined;
    programmeGroups?: ProgrammePOEGroupKnowledgeModules[] | undefined;
    studentGroups?: StudentPOEGroupKnowledgeModules[] | undefined;
    qualificationId?: number;
    qualification?: Qualification | undefined;
}

export class ProgrammePOEGroupKnowledgeModules extends AuditableBaseEntity implements IProgrammePOEGroupKnowledgeModules {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    knowledgeModuleId?: number;
    knowledgeModule?: KnowledgeModule | undefined;

    constructor(data?: IProgrammePOEGroupKnowledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEGroupId = _data["programmePOEGroupId"];
            this.programmePOEGroup = _data["programmePOEGroup"] ? ProgrammePOEGroup.fromJS(_data["programmePOEGroup"]) : <any>undefined;
            this.knowledgeModuleId = _data["knowledgeModuleId"];
            this.knowledgeModule = _data["knowledgeModule"] ? KnowledgeModule.fromJS(_data["knowledgeModule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupKnowledgeModules {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupKnowledgeModules();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEGroupId"] = this.programmePOEGroupId;
        data["programmePOEGroup"] = this.programmePOEGroup ? this.programmePOEGroup.toJSON() : <any>undefined;
        data["knowledgeModuleId"] = this.knowledgeModuleId;
        data["knowledgeModule"] = this.knowledgeModule ? this.knowledgeModule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupKnowledgeModules extends IAuditableBaseEntity {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    knowledgeModuleId?: number;
    knowledgeModule?: KnowledgeModule | undefined;
}

export class StudentPOEGroupKnowledgeModules extends AuditableBaseEntity implements IStudentPOEGroupKnowledgeModules {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    knowledgeModuleId?: number;
    knowledgeModule?: KnowledgeModule | undefined;

    constructor(data?: IStudentPOEGroupKnowledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEGroupId = _data["studentPOEGroupId"];
            this.studentPOEGroup = _data["studentPOEGroup"] ? StudentPOEGroup.fromJS(_data["studentPOEGroup"]) : <any>undefined;
            this.knowledgeModuleId = _data["knowledgeModuleId"];
            this.knowledgeModule = _data["knowledgeModule"] ? KnowledgeModule.fromJS(_data["knowledgeModule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEGroupKnowledgeModules {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupKnowledgeModules();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEGroupId"] = this.studentPOEGroupId;
        data["studentPOEGroup"] = this.studentPOEGroup ? this.studentPOEGroup.toJSON() : <any>undefined;
        data["knowledgeModuleId"] = this.knowledgeModuleId;
        data["knowledgeModule"] = this.knowledgeModule ? this.knowledgeModule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupKnowledgeModules extends IAuditableBaseEntity {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    knowledgeModuleId?: number;
    knowledgeModule?: KnowledgeModule | undefined;
}

export abstract class QualActivityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends AuditableBaseEntity implements IQualActivityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEFeedbackDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipFeedbackDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEFeedbackDoc | undefined;

    constructor(data?: IQualActivityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(QualPOEFeedbackDocQuestion.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipActivityStatus"])) {
                this.studentLearnershipActivityStatus = [] as any;
                for (let item of _data["studentLearnershipActivityStatus"])
                    this.studentLearnershipActivityStatus!.push(StudentLearnershipFeedbackDocActivityStatus.fromJS(item));
            }
            this.qualPoeDocId = _data["qualPoeDocId"];
            this.qualPoeDoc = _data["qualPoeDoc"] ? QualPOEFeedbackDoc.fromJS(_data["qualPoeDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualActivityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualActivityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipActivityStatus)) {
            data["studentLearnershipActivityStatus"] = [];
            for (let item of this.studentLearnershipActivityStatus)
                data["studentLearnershipActivityStatus"].push(item.toJSON());
        }
        data["qualPoeDocId"] = this.qualPoeDocId;
        data["qualPoeDoc"] = this.qualPoeDoc ? this.qualPoeDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualActivityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IAuditableBaseEntity {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEFeedbackDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipFeedbackDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEFeedbackDoc | undefined;
}

export class QualPOEFeedbackDocActivity extends QualActivityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IQualPOEFeedbackDocActivity {

    constructor(data?: IQualPOEFeedbackDocActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFeedbackDocActivity {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFeedbackDocActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFeedbackDocActivity extends IQualActivityOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export abstract class QualActivityQuestionOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends PageAndPosition implements IQualActivityQuestionOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEFeedbackDocActivity | undefined;
    potentialAnswers?: QualPOEFeedbackDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentFeedbackDocQuestionAnswer[] | undefined;

    constructor(data?: IQualActivityQuestionOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.multiSelect = _data["multiSelect"];
            this.type = _data["type"];
            this.activity = _data["activity"] ? QualPOEFeedbackDocActivity.fromJS(_data["activity"]) : <any>undefined;
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(QualPOEFeedbackDocAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentFeedbackDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualActivityQuestionOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualActivityQuestionOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["multiSelect"] = this.multiSelect;
        data["type"] = this.type;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualActivityQuestionOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IPageAndPosition {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEFeedbackDocActivity | undefined;
    potentialAnswers?: QualPOEFeedbackDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentFeedbackDocQuestionAnswer[] | undefined;
}

export class QualPOEFeedbackDocQuestion extends QualActivityQuestionOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IQualPOEFeedbackDocQuestion {

    constructor(data?: IQualPOEFeedbackDocQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFeedbackDocQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFeedbackDocQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFeedbackDocQuestion extends IQualActivityQuestionOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export abstract class QualPotentialAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends AuditableBaseEntity implements IQualPotentialAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEFeedbackDocQuestion | undefined;
    studentQuestionAnswers?: StudentFeedbackDocQuestionAnswer[] | undefined;

    constructor(data?: IQualPotentialAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.answerText = _data["answerText"];
            this.isCorrect = _data["isCorrect"];
            this.marks = _data["marks"];
            this.activityQuestionId = _data["activityQuestionId"];
            this.activityQuestion = _data["activityQuestion"] ? QualPOEFeedbackDocQuestion.fromJS(_data["activityQuestion"]) : <any>undefined;
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentFeedbackDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPotentialAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualPotentialAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText;
        data["isCorrect"] = this.isCorrect;
        data["marks"] = this.marks;
        data["activityQuestionId"] = this.activityQuestionId;
        data["activityQuestion"] = this.activityQuestion ? this.activityQuestion.toJSON() : <any>undefined;
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPotentialAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IAuditableBaseEntity {
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEFeedbackDocQuestion | undefined;
    studentQuestionAnswers?: StudentFeedbackDocQuestionAnswer[] | undefined;
}

export class QualPOEFeedbackDocAnswer extends QualPotentialAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IQualPOEFeedbackDocAnswer {

    constructor(data?: IQualPOEFeedbackDocAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFeedbackDocAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFeedbackDocAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFeedbackDocAnswer extends IQualPotentialAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export class StudentQuestionAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends AuditableBaseEntity implements IStudentQuestionAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEFeedbackDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEFeedbackDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;

    constructor(data?: IStudentQuestionAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPoeId = _data["studentPoeId"];
            this.studentPoe = _data["studentPoe"] ? StudentPOE.fromJS(_data["studentPoe"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.question = _data["question"] ? QualPOEFeedbackDocQuestion.fromJS(_data["question"]) : <any>undefined;
            this.answerId = _data["answerId"];
            this.answer = _data["answer"] ? QualPOEFeedbackDocAnswer.fromJS(_data["answer"]) : <any>undefined;
            this.paragraphAnswer = _data["paragraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
        }
    }

    static override fromJS(data: any): StudentQuestionAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentQuestionAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPoeId"] = this.studentPoeId;
        data["studentPoe"] = this.studentPoe ? this.studentPoe.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["paragraphAnswer"] = this.paragraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentQuestionAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IAuditableBaseEntity {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEFeedbackDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEFeedbackDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
}

export class StudentFeedbackDocQuestionAnswer extends StudentQuestionAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IStudentFeedbackDocQuestionAnswer {

    constructor(data?: IStudentFeedbackDocQuestionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentFeedbackDocQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentFeedbackDocQuestionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentFeedbackDocQuestionAnswer extends IStudentQuestionAnswerOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export class StudentLearnershipActivityStatusOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends AuditableBaseEntity implements IStudentLearnershipActivityStatusOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEFeedbackDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;

    constructor(data?: IStudentLearnershipActivityStatusOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? QualPOEFeedbackDocActivity.fromJS(_data["activity"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static override fromJS(data: any): StudentLearnershipActivityStatusOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipActivityStatusOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipActivityStatusOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus extends IAuditableBaseEntity {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEFeedbackDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;
}

export class StudentLearnershipFeedbackDocActivityStatus extends StudentLearnershipActivityStatusOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus implements IStudentLearnershipFeedbackDocActivityStatus {

    constructor(data?: IStudentLearnershipFeedbackDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentLearnershipFeedbackDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipFeedbackDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipFeedbackDocActivityStatus extends IStudentLearnershipActivityStatusOfQualPOEFeedbackDocAndProgrammePOEFeedbackDocAndStudentPOEFeedbackDocAndProgrammePOEFeedbackDocAnnotationAndStudentPOEFeedbackDocAnnotationAndQualPOEFeedbackDocInputAndProgrammePOEFeedbackDocInputAndStudentPOEFeedbackDocInputAnswerAndQualPOEFeedbackDocActivityAndQualPOEFeedbackDocQuestionAndQualPOEFeedbackDocAnswerAndStudentFeedbackDocQuestionAnswerAndStudentLearnershipFeedbackDocActivityStatus {
}

export abstract class QualActivityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends AuditableBaseEntity implements IQualActivityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEGeneralDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipGeneralDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEGeneralDoc | undefined;

    constructor(data?: IQualActivityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(QualPOEGeneralDocQuestion.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipActivityStatus"])) {
                this.studentLearnershipActivityStatus = [] as any;
                for (let item of _data["studentLearnershipActivityStatus"])
                    this.studentLearnershipActivityStatus!.push(StudentLearnershipGeneralDocActivityStatus.fromJS(item));
            }
            this.qualPoeDocId = _data["qualPoeDocId"];
            this.qualPoeDoc = _data["qualPoeDoc"] ? QualPOEGeneralDoc.fromJS(_data["qualPoeDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualActivityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualActivityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipActivityStatus)) {
            data["studentLearnershipActivityStatus"] = [];
            for (let item of this.studentLearnershipActivityStatus)
                data["studentLearnershipActivityStatus"].push(item.toJSON());
        }
        data["qualPoeDocId"] = this.qualPoeDocId;
        data["qualPoeDoc"] = this.qualPoeDoc ? this.qualPoeDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualActivityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IAuditableBaseEntity {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEGeneralDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipGeneralDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEGeneralDoc | undefined;
}

export class QualPOEGeneralDocActivity extends QualActivityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IQualPOEGeneralDocActivity {

    constructor(data?: IQualPOEGeneralDocActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGeneralDocActivity {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGeneralDocActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGeneralDocActivity extends IQualActivityOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export abstract class QualActivityQuestionOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends PageAndPosition implements IQualActivityQuestionOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEGeneralDocActivity | undefined;
    potentialAnswers?: QualPOEGeneralDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentGeneralDocQuestionAnswer[] | undefined;

    constructor(data?: IQualActivityQuestionOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.multiSelect = _data["multiSelect"];
            this.type = _data["type"];
            this.activity = _data["activity"] ? QualPOEGeneralDocActivity.fromJS(_data["activity"]) : <any>undefined;
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(QualPOEGeneralDocAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentGeneralDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualActivityQuestionOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualActivityQuestionOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["multiSelect"] = this.multiSelect;
        data["type"] = this.type;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualActivityQuestionOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IPageAndPosition {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEGeneralDocActivity | undefined;
    potentialAnswers?: QualPOEGeneralDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentGeneralDocQuestionAnswer[] | undefined;
}

export class QualPOEGeneralDocQuestion extends QualActivityQuestionOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IQualPOEGeneralDocQuestion {

    constructor(data?: IQualPOEGeneralDocQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGeneralDocQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGeneralDocQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGeneralDocQuestion extends IQualActivityQuestionOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export abstract class QualPotentialAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends AuditableBaseEntity implements IQualPotentialAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEGeneralDocQuestion | undefined;
    studentQuestionAnswers?: StudentGeneralDocQuestionAnswer[] | undefined;

    constructor(data?: IQualPotentialAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.answerText = _data["answerText"];
            this.isCorrect = _data["isCorrect"];
            this.marks = _data["marks"];
            this.activityQuestionId = _data["activityQuestionId"];
            this.activityQuestion = _data["activityQuestion"] ? QualPOEGeneralDocQuestion.fromJS(_data["activityQuestion"]) : <any>undefined;
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentGeneralDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualPotentialAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualPotentialAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText;
        data["isCorrect"] = this.isCorrect;
        data["marks"] = this.marks;
        data["activityQuestionId"] = this.activityQuestionId;
        data["activityQuestion"] = this.activityQuestion ? this.activityQuestion.toJSON() : <any>undefined;
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualPotentialAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IAuditableBaseEntity {
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEGeneralDocQuestion | undefined;
    studentQuestionAnswers?: StudentGeneralDocQuestionAnswer[] | undefined;
}

export class QualPOEGeneralDocAnswer extends QualPotentialAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IQualPOEGeneralDocAnswer {

    constructor(data?: IQualPOEGeneralDocAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEGeneralDocAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEGeneralDocAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEGeneralDocAnswer extends IQualPotentialAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class StudentQuestionAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends AuditableBaseEntity implements IStudentQuestionAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEGeneralDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEGeneralDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;

    constructor(data?: IStudentQuestionAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPoeId = _data["studentPoeId"];
            this.studentPoe = _data["studentPoe"] ? StudentPOE.fromJS(_data["studentPoe"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.question = _data["question"] ? QualPOEGeneralDocQuestion.fromJS(_data["question"]) : <any>undefined;
            this.answerId = _data["answerId"];
            this.answer = _data["answer"] ? QualPOEGeneralDocAnswer.fromJS(_data["answer"]) : <any>undefined;
            this.paragraphAnswer = _data["paragraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
        }
    }

    static override fromJS(data: any): StudentQuestionAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentQuestionAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPoeId"] = this.studentPoeId;
        data["studentPoe"] = this.studentPoe ? this.studentPoe.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["paragraphAnswer"] = this.paragraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentQuestionAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IAuditableBaseEntity {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEGeneralDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEGeneralDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
}

export class StudentGeneralDocQuestionAnswer extends StudentQuestionAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IStudentGeneralDocQuestionAnswer {

    constructor(data?: IStudentGeneralDocQuestionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentGeneralDocQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentGeneralDocQuestionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentGeneralDocQuestionAnswer extends IStudentQuestionAnswerOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class StudentLearnershipActivityStatusOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends AuditableBaseEntity implements IStudentLearnershipActivityStatusOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEGeneralDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;

    constructor(data?: IStudentLearnershipActivityStatusOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? QualPOEGeneralDocActivity.fromJS(_data["activity"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static override fromJS(data: any): StudentLearnershipActivityStatusOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipActivityStatusOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipActivityStatusOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus extends IAuditableBaseEntity {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEGeneralDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;
}

export class StudentLearnershipGeneralDocActivityStatus extends StudentLearnershipActivityStatusOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus implements IStudentLearnershipGeneralDocActivityStatus {

    constructor(data?: IStudentLearnershipGeneralDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentLearnershipGeneralDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipGeneralDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipGeneralDocActivityStatus extends IStudentLearnershipActivityStatusOfQualPOEGeneralDocAndProgrammePOEGeneralDocAndStudentPOEGeneralDocAndProgrammePOEGeneralDocAnnotationAndStudentPOEGeneralDocAnnotationAndQualPOEGeneralDocInputAndProgrammePOEGeneralDocInputAndStudentPOEGeneralDocInputAnswerAndQualPOEGeneralDocActivityAndQualPOEGeneralDocQuestionAndQualPOEGeneralDocAnswerAndStudentGeneralDocQuestionAnswerAndStudentLearnershipGeneralDocActivityStatus {
}

export class ProgrammePOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends POEAnnotationOfProgrammePOE implements IProgrammePOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    programmePOEGroupDocId?: number;
    programmePOEGroupDoc?: ProgrammePOEFormativeAssessment | undefined;
    childrenAnnotations?: StudentPOEGroupFormativeAssessmentAnnotation[] | undefined;

    constructor(data?: IProgrammePOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEGroupId = _data["programmePOEGroupId"];
            this.programmePOEGroup = _data["programmePOEGroup"] ? ProgrammePOEGroup.fromJS(_data["programmePOEGroup"]) : <any>undefined;
            this.programmePOEGroupDocId = _data["programmePOEGroupDocId"];
            this.programmePOEGroupDoc = _data["programmePOEGroupDoc"] ? ProgrammePOEFormativeAssessment.fromJS(_data["programmePOEGroupDoc"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentPOEGroupFormativeAssessmentAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEGroupId"] = this.programmePOEGroupId;
        data["programmePOEGroup"] = this.programmePOEGroup ? this.programmePOEGroup.toJSON() : <any>undefined;
        data["programmePOEGroupDocId"] = this.programmePOEGroupDocId;
        data["programmePOEGroupDoc"] = this.programmePOEGroupDoc ? this.programmePOEGroupDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IPOEAnnotationOfProgrammePOE {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    programmePOEGroupDocId?: number;
    programmePOEGroupDoc?: ProgrammePOEFormativeAssessment | undefined;
    childrenAnnotations?: StudentPOEGroupFormativeAssessmentAnnotation[] | undefined;
}

export class ProgrammePOEGroupFormativeAssessmentAnnotation extends ProgrammePOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IProgrammePOEGroupFormativeAssessmentAnnotation {

    constructor(data?: IProgrammePOEGroupFormativeAssessmentAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProgrammePOEGroupFormativeAssessmentAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupFormativeAssessmentAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupFormativeAssessmentAnnotation extends IProgrammePOEGroupAnnotationOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class StudentGroupQuestionAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends AuditableBaseEntity implements IStudentGroupQuestionAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEFormativeAssessmentQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEFormativeAssessmentAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;

    constructor(data?: IStudentGroupQuestionAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPoeId = _data["studentPoeId"];
            this.studentPoe = _data["studentPoe"] ? StudentPOE.fromJS(_data["studentPoe"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.question = _data["question"] ? QualPOEFormativeAssessmentQuestion.fromJS(_data["question"]) : <any>undefined;
            this.answerId = _data["answerId"];
            this.answer = _data["answer"] ? QualPOEFormativeAssessmentAnswer.fromJS(_data["answer"]) : <any>undefined;
            this.paragraphAnswer = _data["paragraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
        }
    }

    static override fromJS(data: any): StudentGroupQuestionAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentGroupQuestionAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPoeId"] = this.studentPoeId;
        data["studentPoe"] = this.studentPoe ? this.studentPoe.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["paragraphAnswer"] = this.paragraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentGroupQuestionAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IAuditableBaseEntity {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOEFormativeAssessmentQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOEFormativeAssessmentAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
}

export class StudentFormativeQuestionAnswer extends StudentGroupQuestionAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IStudentFormativeQuestionAnswer {

    constructor(data?: IStudentFormativeQuestionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentFormativeQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentFormativeQuestionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentFormativeQuestionAnswer extends IStudentGroupQuestionAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export abstract class QualGroupActivityQuestionOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends PageAndPosition implements IQualGroupActivityQuestionOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEFormativeAssessmentActivity | undefined;
    potentialAnswers?: QualPOEFormativeAssessmentAnswer[] | undefined;
    studentQuestionAnswers?: StudentFormativeQuestionAnswer[] | undefined;

    constructor(data?: IQualGroupActivityQuestionOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.multiSelect = _data["multiSelect"];
            this.type = _data["type"];
            this.activity = _data["activity"] ? QualPOEFormativeAssessmentActivity.fromJS(_data["activity"]) : <any>undefined;
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(QualPOEFormativeAssessmentAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentFormativeQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualGroupActivityQuestionOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupActivityQuestionOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["multiSelect"] = this.multiSelect;
        data["type"] = this.type;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupActivityQuestionOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IPageAndPosition {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOEFormativeAssessmentActivity | undefined;
    potentialAnswers?: QualPOEFormativeAssessmentAnswer[] | undefined;
    studentQuestionAnswers?: StudentFormativeQuestionAnswer[] | undefined;
}

export class QualPOEFormativeAssessmentQuestion extends QualGroupActivityQuestionOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IQualPOEFormativeAssessmentQuestion {

    constructor(data?: IQualPOEFormativeAssessmentQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFormativeAssessmentQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFormativeAssessmentQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFormativeAssessmentQuestion extends IQualGroupActivityQuestionOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export abstract class QualGroupActivityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends AuditableBaseEntity implements IQualGroupActivityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEFormativeAssessmentQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipFormativeActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEFormativeAssessment | undefined;

    constructor(data?: IQualGroupActivityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(QualPOEFormativeAssessmentQuestion.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipActivityStatus"])) {
                this.studentLearnershipActivityStatus = [] as any;
                for (let item of _data["studentLearnershipActivityStatus"])
                    this.studentLearnershipActivityStatus!.push(StudentLearnershipFormativeActivityStatus.fromJS(item));
            }
            this.qualPoeDocId = _data["qualPoeDocId"];
            this.qualPoeDoc = _data["qualPoeDoc"] ? QualPOEFormativeAssessment.fromJS(_data["qualPoeDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualGroupActivityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupActivityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipActivityStatus)) {
            data["studentLearnershipActivityStatus"] = [];
            for (let item of this.studentLearnershipActivityStatus)
                data["studentLearnershipActivityStatus"].push(item.toJSON());
        }
        data["qualPoeDocId"] = this.qualPoeDocId;
        data["qualPoeDoc"] = this.qualPoeDoc ? this.qualPoeDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupActivityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IAuditableBaseEntity {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOEFormativeAssessmentQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipFormativeActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOEFormativeAssessment | undefined;
}

export class QualPOEFormativeAssessmentActivity extends QualGroupActivityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IQualPOEFormativeAssessmentActivity {

    constructor(data?: IQualPOEFormativeAssessmentActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFormativeAssessmentActivity {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFormativeAssessmentActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFormativeAssessmentActivity extends IQualGroupActivityOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class StudentLearnershipGroupActivityStatusOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends AuditableBaseEntity implements IStudentLearnershipGroupActivityStatusOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEFormativeAssessmentActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;

    constructor(data?: IStudentLearnershipGroupActivityStatusOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? QualPOEFormativeAssessmentActivity.fromJS(_data["activity"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static override fromJS(data: any): StudentLearnershipGroupActivityStatusOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipGroupActivityStatusOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipGroupActivityStatusOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IAuditableBaseEntity {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOEFormativeAssessmentActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;
}

export class StudentLearnershipFormativeActivityStatus extends StudentLearnershipGroupActivityStatusOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IStudentLearnershipFormativeActivityStatus {

    constructor(data?: IStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipFormativeActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipFormativeActivityStatus extends IStudentLearnershipGroupActivityStatusOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export abstract class QualGroupPotentialAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends AuditableBaseEntity implements IQualGroupPotentialAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
    questionId?: number;
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEFormativeAssessmentQuestion | undefined;
    studentQuestionAnswers?: StudentFormativeQuestionAnswer[] | undefined;

    constructor(data?: IQualGroupPotentialAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionId = _data["questionId"];
            this.answerText = _data["answerText"];
            this.isCorrect = _data["isCorrect"];
            this.marks = _data["marks"];
            this.activityQuestionId = _data["activityQuestionId"];
            this.activityQuestion = _data["activityQuestion"] ? QualPOEFormativeAssessmentQuestion.fromJS(_data["activityQuestion"]) : <any>undefined;
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentFormativeQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualGroupPotentialAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupPotentialAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answerText"] = this.answerText;
        data["isCorrect"] = this.isCorrect;
        data["marks"] = this.marks;
        data["activityQuestionId"] = this.activityQuestionId;
        data["activityQuestion"] = this.activityQuestion ? this.activityQuestion.toJSON() : <any>undefined;
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupPotentialAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus extends IAuditableBaseEntity {
    questionId?: number;
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOEFormativeAssessmentQuestion | undefined;
    studentQuestionAnswers?: StudentFormativeQuestionAnswer[] | undefined;
}

export class QualPOEFormativeAssessmentAnswer extends QualGroupPotentialAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus implements IQualPOEFormativeAssessmentAnswer {

    constructor(data?: IQualPOEFormativeAssessmentAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOEFormativeAssessmentAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOEFormativeAssessmentAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOEFormativeAssessmentAnswer extends IQualGroupPotentialAnswerOfQualPOEFormativeAssessmentAndProgrammePOEFormativeAssessmentAndStudentPOEFormativeAssessmentAndProgrammePOEGroupFormativeAssessmentAnnotationAndStudentPOEGroupFormativeAssessmentAnnotationAndQualPOEFormativeAssessmentInputAndProgrammePOEFormativeAssessmentInputAndStudentPOEFormativeAssessmentInputAnswerAndQualPOEFormativeAssessmentActivityAndQualPOEFormativeAssessmentQuestionAndQualPOEFormativeAssessmentAnswerAndStudentFormativeQuestionAnswerAndStudentLearnershipFormativeActivityStatus {
}

export class StudentGroupQuestionAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends AuditableBaseEntity implements IStudentGroupQuestionAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOESaqaDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOESaqaDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;

    constructor(data?: IStudentGroupQuestionAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPoeId = _data["studentPoeId"];
            this.studentPoe = _data["studentPoe"] ? StudentPOE.fromJS(_data["studentPoe"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.question = _data["question"] ? QualPOESaqaDocQuestion.fromJS(_data["question"]) : <any>undefined;
            this.answerId = _data["answerId"];
            this.answer = _data["answer"] ? QualPOESaqaDocAnswer.fromJS(_data["answer"]) : <any>undefined;
            this.paragraphAnswer = _data["paragraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
        }
    }

    static override fromJS(data: any): StudentGroupQuestionAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentGroupQuestionAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPoeId"] = this.studentPoeId;
        data["studentPoe"] = this.studentPoe ? this.studentPoe.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["paragraphAnswer"] = this.paragraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentGroupQuestionAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IAuditableBaseEntity {
    studentPoeId?: number;
    studentPoe?: StudentPOE | undefined;
    questionId?: number;
    question?: QualPOESaqaDocQuestion | undefined;
    answerId?: number | undefined;
    answer?: QualPOESaqaDocAnswer | undefined;
    paragraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
}

export class StudentSaqaDocQuestionAnswer extends StudentGroupQuestionAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IStudentSaqaDocQuestionAnswer {

    constructor(data?: IStudentSaqaDocQuestionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentSaqaDocQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentSaqaDocQuestionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentSaqaDocQuestionAnswer extends IStudentGroupQuestionAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export abstract class QualGroupActivityQuestionOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends PageAndPosition implements IQualGroupActivityQuestionOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOESaqaDocActivity | undefined;
    potentialAnswers?: QualPOESaqaDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentSaqaDocQuestionAnswer[] | undefined;

    constructor(data?: IQualGroupActivityQuestionOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.multiSelect = _data["multiSelect"];
            this.type = _data["type"];
            this.activity = _data["activity"] ? QualPOESaqaDocActivity.fromJS(_data["activity"]) : <any>undefined;
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(QualPOESaqaDocAnswer.fromJS(item));
            }
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentSaqaDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualGroupActivityQuestionOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupActivityQuestionOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["multiSelect"] = this.multiSelect;
        data["type"] = this.type;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupActivityQuestionOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IPageAndPosition {
    questionText?: string | undefined;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    multiSelect?: boolean;
    type?: ActivityQuestionTypes;
    activity?: QualPOESaqaDocActivity | undefined;
    potentialAnswers?: QualPOESaqaDocAnswer[] | undefined;
    studentQuestionAnswers?: StudentSaqaDocQuestionAnswer[] | undefined;
}

export class QualPOESaqaDocQuestion extends QualGroupActivityQuestionOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IQualPOESaqaDocQuestion {

    constructor(data?: IQualPOESaqaDocQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESaqaDocQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESaqaDocQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESaqaDocQuestion extends IQualGroupActivityQuestionOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export abstract class QualGroupActivityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends AuditableBaseEntity implements IQualGroupActivityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOESaqaDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipSaqaDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOESaqaDoc | undefined;

    constructor(data?: IQualGroupActivityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(QualPOESaqaDocQuestion.fromJS(item));
            }
            if (Array.isArray(_data["studentLearnershipActivityStatus"])) {
                this.studentLearnershipActivityStatus = [] as any;
                for (let item of _data["studentLearnershipActivityStatus"])
                    this.studentLearnershipActivityStatus!.push(StudentLearnershipSaqaDocActivityStatus.fromJS(item));
            }
            this.qualPoeDocId = _data["qualPoeDocId"];
            this.qualPoeDoc = _data["qualPoeDoc"] ? QualPOESaqaDoc.fromJS(_data["qualPoeDoc"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QualGroupActivityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupActivityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.studentLearnershipActivityStatus)) {
            data["studentLearnershipActivityStatus"] = [];
            for (let item of this.studentLearnershipActivityStatus)
                data["studentLearnershipActivityStatus"].push(item.toJSON());
        }
        data["qualPoeDocId"] = this.qualPoeDocId;
        data["qualPoeDoc"] = this.qualPoeDoc ? this.qualPoeDoc.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupActivityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IAuditableBaseEntity {
    name?: string | undefined;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: QualPOESaqaDocQuestion[] | undefined;
    studentLearnershipActivityStatus?: StudentLearnershipSaqaDocActivityStatus[] | undefined;
    qualPoeDocId?: number;
    qualPoeDoc?: QualPOESaqaDoc | undefined;
}

export class QualPOESaqaDocActivity extends QualGroupActivityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IQualPOESaqaDocActivity {

    constructor(data?: IQualPOESaqaDocActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESaqaDocActivity {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESaqaDocActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESaqaDocActivity extends IQualGroupActivityOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export class StudentLearnershipGroupActivityStatusOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends AuditableBaseEntity implements IStudentLearnershipGroupActivityStatusOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOESaqaDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;

    constructor(data?: IStudentLearnershipGroupActivityStatusOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? QualPOESaqaDocActivity.fromJS(_data["activity"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static override fromJS(data: any): StudentLearnershipGroupActivityStatusOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipGroupActivityStatusOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipGroupActivityStatusOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IAuditableBaseEntity {
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    activityId?: number;
    activity?: QualPOESaqaDocActivity | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number;
}

export class StudentLearnershipSaqaDocActivityStatus extends StudentLearnershipGroupActivityStatusOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IStudentLearnershipSaqaDocActivityStatus {

    constructor(data?: IStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipSaqaDocActivityStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipSaqaDocActivityStatus extends IStudentLearnershipGroupActivityStatusOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export abstract class QualGroupPotentialAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends AuditableBaseEntity implements IQualGroupPotentialAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
    questionId?: number;
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOESaqaDocQuestion | undefined;
    studentQuestionAnswers?: StudentSaqaDocQuestionAnswer[] | undefined;

    constructor(data?: IQualGroupPotentialAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionId = _data["questionId"];
            this.answerText = _data["answerText"];
            this.isCorrect = _data["isCorrect"];
            this.marks = _data["marks"];
            this.activityQuestionId = _data["activityQuestionId"];
            this.activityQuestion = _data["activityQuestion"] ? QualPOESaqaDocQuestion.fromJS(_data["activityQuestion"]) : <any>undefined;
            if (Array.isArray(_data["studentQuestionAnswers"])) {
                this.studentQuestionAnswers = [] as any;
                for (let item of _data["studentQuestionAnswers"])
                    this.studentQuestionAnswers!.push(StudentSaqaDocQuestionAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualGroupPotentialAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualGroupPotentialAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answerText"] = this.answerText;
        data["isCorrect"] = this.isCorrect;
        data["marks"] = this.marks;
        data["activityQuestionId"] = this.activityQuestionId;
        data["activityQuestion"] = this.activityQuestion ? this.activityQuestion.toJSON() : <any>undefined;
        if (Array.isArray(this.studentQuestionAnswers)) {
            data["studentQuestionAnswers"] = [];
            for (let item of this.studentQuestionAnswers)
                data["studentQuestionAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualGroupPotentialAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus extends IAuditableBaseEntity {
    questionId?: number;
    answerText?: string | undefined;
    isCorrect?: boolean;
    marks?: number;
    activityQuestionId?: number;
    activityQuestion?: QualPOESaqaDocQuestion | undefined;
    studentQuestionAnswers?: StudentSaqaDocQuestionAnswer[] | undefined;
}

export class QualPOESaqaDocAnswer extends QualGroupPotentialAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus implements IQualPOESaqaDocAnswer {

    constructor(data?: IQualPOESaqaDocAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): QualPOESaqaDocAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QualPOESaqaDocAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQualPOESaqaDocAnswer extends IQualGroupPotentialAnswerOfQualPOESaqaDocAndProgrammePOESaqaDocAndStudentPOESaqaDocAndProgrammePOEGroupSaqaDocAnnotationAndStudentPOEGroupSaqaDocAnnotationAndQualPOESaqaDocInputAndProgrammePOESaqaDocInputAndStudentPOESaqaDocInputAnswerAndQualPOESaqaDocActivityAndQualPOESaqaDocQuestionAndQualPOESaqaDocAnswerAndStudentSaqaDocQuestionAnswerAndStudentLearnershipSaqaDocActivityStatus {
}

export class StudentPOEGroupUnitStandards extends AuditableBaseEntity implements IStudentPOEGroupUnitStandards {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;

    constructor(data?: IStudentPOEGroupUnitStandards) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentPOEGroupId = _data["studentPOEGroupId"];
            this.studentPOEGroup = _data["studentPOEGroup"] ? StudentPOEGroup.fromJS(_data["studentPOEGroup"]) : <any>undefined;
            this.unitStandardId = _data["unitStandardId"];
            this.unitStandard = _data["unitStandard"] ? UnitStandard.fromJS(_data["unitStandard"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPOEGroupUnitStandards {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPOEGroupUnitStandards();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPOEGroupId"] = this.studentPOEGroupId;
        data["studentPOEGroup"] = this.studentPOEGroup ? this.studentPOEGroup.toJSON() : <any>undefined;
        data["unitStandardId"] = this.unitStandardId;
        data["unitStandard"] = this.unitStandard ? this.unitStandard.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPOEGroupUnitStandards extends IAuditableBaseEntity {
    studentPOEGroupId?: number;
    studentPOEGroup?: StudentPOEGroup | undefined;
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;
}

export class ProgrammePOEGroupUnitStandards extends AuditableBaseEntity implements IProgrammePOEGroupUnitStandards {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;

    constructor(data?: IProgrammePOEGroupUnitStandards) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programmePOEGroupId = _data["programmePOEGroupId"];
            this.programmePOEGroup = _data["programmePOEGroup"] ? ProgrammePOEGroup.fromJS(_data["programmePOEGroup"]) : <any>undefined;
            this.unitStandardId = _data["unitStandardId"];
            this.unitStandard = _data["unitStandard"] ? UnitStandard.fromJS(_data["unitStandard"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammePOEGroupUnitStandards {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammePOEGroupUnitStandards();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEGroupId"] = this.programmePOEGroupId;
        data["programmePOEGroup"] = this.programmePOEGroup ? this.programmePOEGroup.toJSON() : <any>undefined;
        data["unitStandardId"] = this.unitStandardId;
        data["unitStandard"] = this.unitStandard ? this.unitStandard.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammePOEGroupUnitStandards extends IAuditableBaseEntity {
    programmePOEGroupId?: number;
    programmePOEGroup?: ProgrammePOEGroup | undefined;
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;
}

export class CustomElective extends AuditableBaseEntity implements ICustomElective {
    learnershipId?: number;
    learnership?: Learnership | undefined;
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;

    constructor(data?: ICustomElective) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            this.unitStandardId = _data["unitStandardId"];
            this.unitStandard = _data["unitStandard"] ? UnitStandard.fromJS(_data["unitStandard"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CustomElective {
        data = typeof data === 'object' ? data : {};
        let result = new CustomElective();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        data["unitStandardId"] = this.unitStandardId;
        data["unitStandard"] = this.unitStandard ? this.unitStandard.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomElective extends IAuditableBaseEntity {
    learnershipId?: number;
    learnership?: Learnership | undefined;
    unitStandardId?: number;
    unitStandard?: UnitStandard | undefined;
}

export class SetaQualificationDetails extends AuditableBaseEntity implements ISetaQualificationDetails {
    setaFunctionary?: SETATypes;
    field?: SAQAFields;
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    qualificationId?: number;
    qualification?: Qualification | undefined;

    constructor(data?: ISetaQualificationDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.setaFunctionary = _data["setaFunctionary"];
            this.field = _data["field"];
            this.minCreditsCore = _data["minCreditsCore"];
            this.minCreditsFundamental = _data["minCreditsFundamental"];
            this.minCreditsElective = _data["minCreditsElective"];
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SetaQualificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SetaQualificationDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setaFunctionary"] = this.setaFunctionary;
        data["field"] = this.field;
        data["minCreditsCore"] = this.minCreditsCore;
        data["minCreditsFundamental"] = this.minCreditsFundamental;
        data["minCreditsElective"] = this.minCreditsElective;
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISetaQualificationDetails extends IAuditableBaseEntity {
    setaFunctionary?: SETATypes;
    field?: SAQAFields;
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    qualificationId?: number;
    qualification?: Qualification | undefined;
}

export enum SAQAFields {
    AgriNatureConservation = 0,
    CultureArts = 1,
    BusinessComsManagement = 2,
    ComStudiesLanguage = 3,
    EducationTrainingDevelopment = 4,
    ManufactureEngineerTech = 5,
    HumanSocialStudies = 6,
    LawMilitarySecurity = 7,
    HealthSocialServices = 8,
    MathPhysComputerLifeSci = 9,
    Services = 10,
    PhysicalPlanningConstrucuton = 11,
}

export class QualModeratorFile extends AuditableBaseEntity implements IQualModeratorFile {
    qualificationId?: number;
    qualification?: Qualification | undefined;
    programmeModeratorFiles?: ProgrammeModeratorFile[] | undefined;

    constructor(data?: IQualModeratorFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            if (Array.isArray(_data["programmeModeratorFiles"])) {
                this.programmeModeratorFiles = [] as any;
                for (let item of _data["programmeModeratorFiles"])
                    this.programmeModeratorFiles!.push(ProgrammeModeratorFile.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualModeratorFile {
        data = typeof data === 'object' ? data : {};
        let result = new QualModeratorFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        if (Array.isArray(this.programmeModeratorFiles)) {
            data["programmeModeratorFiles"] = [];
            for (let item of this.programmeModeratorFiles)
                data["programmeModeratorFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualModeratorFile extends IAuditableBaseEntity {
    qualificationId?: number;
    qualification?: Qualification | undefined;
    programmeModeratorFiles?: ProgrammeModeratorFile[] | undefined;
}

export class ProgrammeModeratorFile extends AuditableBaseEntity implements IProgrammeModeratorFile {
    qualificationId?: number;
    qualification?: Qualification | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    qualModeratorFileId?: number;
    qualModeratorFile?: QualModeratorFile | undefined;

    constructor(data?: IProgrammeModeratorFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            this.qualModeratorFileId = _data["qualModeratorFileId"];
            this.qualModeratorFile = _data["qualModeratorFile"] ? QualModeratorFile.fromJS(_data["qualModeratorFile"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammeModeratorFile {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammeModeratorFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        data["qualModeratorFileId"] = this.qualModeratorFileId;
        data["qualModeratorFile"] = this.qualModeratorFile ? this.qualModeratorFile.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammeModeratorFile extends IAuditableBaseEntity {
    qualificationId?: number;
    qualification?: Qualification | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    qualModeratorFileId?: number;
    qualModeratorFile?: QualModeratorFile | undefined;
}

export class QualAssessorFile extends AuditableBaseEntity implements IQualAssessorFile {
    qualificationId?: number;
    qualification?: Qualification | undefined;
    programmeAssessorFiles?: ProgrammeAssessorFile[] | undefined;

    constructor(data?: IQualAssessorFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            if (Array.isArray(_data["programmeAssessorFiles"])) {
                this.programmeAssessorFiles = [] as any;
                for (let item of _data["programmeAssessorFiles"])
                    this.programmeAssessorFiles!.push(ProgrammeAssessorFile.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualAssessorFile {
        data = typeof data === 'object' ? data : {};
        let result = new QualAssessorFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        if (Array.isArray(this.programmeAssessorFiles)) {
            data["programmeAssessorFiles"] = [];
            for (let item of this.programmeAssessorFiles)
                data["programmeAssessorFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualAssessorFile extends IAuditableBaseEntity {
    qualificationId?: number;
    qualification?: Qualification | undefined;
    programmeAssessorFiles?: ProgrammeAssessorFile[] | undefined;
}

export class ProgrammeAssessorFile extends AuditableBaseEntity implements IProgrammeAssessorFile {
    qualificationId?: number;
    qualification?: Qualification | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    qualAssessorFileId?: number;
    qualAssessorFile?: QualAssessorFile | undefined;

    constructor(data?: IProgrammeAssessorFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            this.qualAssessorFileId = _data["qualAssessorFileId"];
            this.qualAssessorFile = _data["qualAssessorFile"] ? QualAssessorFile.fromJS(_data["qualAssessorFile"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ProgrammeAssessorFile {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammeAssessorFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        data["qualAssessorFileId"] = this.qualAssessorFileId;
        data["qualAssessorFile"] = this.qualAssessorFile ? this.qualAssessorFile.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammeAssessorFile extends IAuditableBaseEntity {
    qualificationId?: number;
    qualification?: Qualification | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
    qualAssessorFileId?: number;
    qualAssessorFile?: QualAssessorFile | undefined;
}

export class QualificationDocInput extends Input implements IQualificationDocInput {
    generalQualificationDocumentId?: number;
    generalQualificationDocument?: GeneralQualificationDocument | undefined;
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammeDocInput[] | undefined;

    constructor(data?: IQualificationDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.generalQualificationDocumentId = _data["generalQualificationDocumentId"];
            this.generalQualificationDocument = _data["generalQualificationDocument"] ? GeneralQualificationDocument.fromJS(_data["generalQualificationDocument"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["childrenInputs"])) {
                this.childrenInputs = [] as any;
                for (let item of _data["childrenInputs"])
                    this.childrenInputs!.push(ProgrammeDocInput.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): QualificationDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalQualificationDocumentId"] = this.generalQualificationDocumentId;
        data["generalQualificationDocument"] = this.generalQualificationDocument ? this.generalQualificationDocument.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.childrenInputs)) {
            data["childrenInputs"] = [];
            for (let item of this.childrenInputs)
                data["childrenInputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualificationDocInput extends IInput {
    generalQualificationDocumentId?: number;
    generalQualificationDocument?: GeneralQualificationDocument | undefined;
    editableAtProgrammeLevel?: boolean;
    childrenInputs?: ProgrammeDocInput[] | undefined;
}

export class ProgrammeDocInput extends Input implements IProgrammeDocInput {
    studentInputAnswers?: StudentDocInputAnswer[] | undefined;
    generalLearnershipDocumentDocId?: number;
    generalLearnershipDocumentDoc?: GeneralLearnershipDocument | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualificationDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    value?: string | undefined;

    constructor(data?: IProgrammeDocInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentInputAnswers"])) {
                this.studentInputAnswers = [] as any;
                for (let item of _data["studentInputAnswers"])
                    this.studentInputAnswers!.push(StudentDocInputAnswer.fromJS(item));
            }
            this.generalLearnershipDocumentDocId = _data["generalLearnershipDocumentDocId"];
            this.generalLearnershipDocumentDoc = _data["generalLearnershipDocumentDoc"] ? GeneralLearnershipDocument.fromJS(_data["generalLearnershipDocumentDoc"]) : <any>undefined;
            this.parentInputId = _data["parentInputId"];
            this.parentInput = _data["parentInput"] ? QualificationDocInput.fromJS(_data["parentInput"]) : <any>undefined;
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ProgrammeDocInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammeDocInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentInputAnswers)) {
            data["studentInputAnswers"] = [];
            for (let item of this.studentInputAnswers)
                data["studentInputAnswers"].push(item.toJSON());
        }
        data["generalLearnershipDocumentDocId"] = this.generalLearnershipDocumentDocId;
        data["generalLearnershipDocumentDoc"] = this.generalLearnershipDocumentDoc ? this.generalLearnershipDocumentDoc.toJSON() : <any>undefined;
        data["parentInputId"] = this.parentInputId;
        data["parentInput"] = this.parentInput ? this.parentInput.toJSON() : <any>undefined;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammeDocInput extends IInput {
    studentInputAnswers?: StudentDocInputAnswer[] | undefined;
    generalLearnershipDocumentDocId?: number;
    generalLearnershipDocumentDoc?: GeneralLearnershipDocument | undefined;
    parentInputId?: number | undefined;
    parentInput?: QualificationDocInput | undefined;
    editableAtProgrammeLevel?: boolean;
    value?: string | undefined;
}

export class StudentDocInputAnswer extends AuditableBaseEntity implements IStudentDocInputAnswer {
    generalStudentDocumentId?: number;
    generalStudentDocument?: GeneralStudentDocument | undefined;
    programmeDocInputId?: number;
    programmeDocInput?: ProgrammeDocInput | undefined;
    value?: string | undefined;

    constructor(data?: IStudentDocInputAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.generalStudentDocumentId = _data["generalStudentDocumentId"];
            this.generalStudentDocument = _data["generalStudentDocument"] ? GeneralStudentDocument.fromJS(_data["generalStudentDocument"]) : <any>undefined;
            this.programmeDocInputId = _data["programmeDocInputId"];
            this.programmeDocInput = _data["programmeDocInput"] ? ProgrammeDocInput.fromJS(_data["programmeDocInput"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): StudentDocInputAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new StudentDocInputAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalStudentDocumentId"] = this.generalStudentDocumentId;
        data["generalStudentDocument"] = this.generalStudentDocument ? this.generalStudentDocument.toJSON() : <any>undefined;
        data["programmeDocInputId"] = this.programmeDocInputId;
        data["programmeDocInput"] = this.programmeDocInput ? this.programmeDocInput.toJSON() : <any>undefined;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentDocInputAnswer extends IAuditableBaseEntity {
    generalStudentDocumentId?: number;
    generalStudentDocument?: GeneralStudentDocument | undefined;
    programmeDocInputId?: number;
    programmeDocInput?: ProgrammeDocInput | undefined;
    value?: string | undefined;
}

export class ProgrammeDocAnnotation extends Annotation implements IProgrammeDocAnnotation {
    generalLearnershipDocumentId?: number;
    generalLearnershipDocument?: GeneralLearnershipDocument | undefined;
    childrenAnnotations?: StudentDocAnnotation[] | undefined;

    constructor(data?: IProgrammeDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.generalLearnershipDocumentId = _data["generalLearnershipDocumentId"];
            this.generalLearnershipDocument = _data["generalLearnershipDocument"] ? GeneralLearnershipDocument.fromJS(_data["generalLearnershipDocument"]) : <any>undefined;
            if (Array.isArray(_data["childrenAnnotations"])) {
                this.childrenAnnotations = [] as any;
                for (let item of _data["childrenAnnotations"])
                    this.childrenAnnotations!.push(StudentDocAnnotation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgrammeDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammeDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalLearnershipDocumentId"] = this.generalLearnershipDocumentId;
        data["generalLearnershipDocument"] = this.generalLearnershipDocument ? this.generalLearnershipDocument.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenAnnotations)) {
            data["childrenAnnotations"] = [];
            for (let item of this.childrenAnnotations)
                data["childrenAnnotations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammeDocAnnotation extends IAnnotation {
    generalLearnershipDocumentId?: number;
    generalLearnershipDocument?: GeneralLearnershipDocument | undefined;
    childrenAnnotations?: StudentDocAnnotation[] | undefined;
}

export class StudentDocAnnotation extends Annotation implements IStudentDocAnnotation {
    generalStudentDocumentId?: number;
    generalStudentDocument?: GeneralStudentDocument | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammeDocAnnotation | undefined;
    inheritedFromPrograme?: boolean | undefined;

    constructor(data?: IStudentDocAnnotation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.generalStudentDocumentId = _data["generalStudentDocumentId"];
            this.generalStudentDocument = _data["generalStudentDocument"] ? GeneralStudentDocument.fromJS(_data["generalStudentDocument"]) : <any>undefined;
            this.parentAnnotationId = _data["parentAnnotationId"];
            this.parentAnnotation = _data["parentAnnotation"] ? ProgrammeDocAnnotation.fromJS(_data["parentAnnotation"]) : <any>undefined;
            this.inheritedFromPrograme = _data["inheritedFromPrograme"];
        }
    }

    static override fromJS(data: any): StudentDocAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new StudentDocAnnotation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalStudentDocumentId"] = this.generalStudentDocumentId;
        data["generalStudentDocument"] = this.generalStudentDocument ? this.generalStudentDocument.toJSON() : <any>undefined;
        data["parentAnnotationId"] = this.parentAnnotationId;
        data["parentAnnotation"] = this.parentAnnotation ? this.parentAnnotation.toJSON() : <any>undefined;
        data["inheritedFromPrograme"] = this.inheritedFromPrograme;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentDocAnnotation extends IAnnotation {
    generalStudentDocumentId?: number;
    generalStudentDocument?: GeneralStudentDocument | undefined;
    parentAnnotationId?: number | undefined;
    parentAnnotation?: ProgrammeDocAnnotation | undefined;
    inheritedFromPrograme?: boolean | undefined;
}

export class LearnershipAttendanceRegisterItem extends AuditableBaseEntity implements ILearnershipAttendanceRegisterItem {
    date?: Date;
    attendanceType?: AttendanceTypes;
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    attendanceRegisterId?: number;
    attendanceRegister?: LearnershipAttendanceRegister | undefined;

    constructor(data?: ILearnershipAttendanceRegisterItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.attendanceType = _data["attendanceType"];
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
            this.attendanceRegisterId = _data["attendanceRegisterId"];
            this.attendanceRegister = _data["attendanceRegister"] ? LearnershipAttendanceRegister.fromJS(_data["attendanceRegister"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): LearnershipAttendanceRegisterItem {
        data = typeof data === 'object' ? data : {};
        let result = new LearnershipAttendanceRegisterItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["attendanceType"] = this.attendanceType;
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        data["attendanceRegisterId"] = this.attendanceRegisterId;
        data["attendanceRegister"] = this.attendanceRegister ? this.attendanceRegister.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILearnershipAttendanceRegisterItem extends IAuditableBaseEntity {
    date?: Date;
    attendanceType?: AttendanceTypes;
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
    attendanceRegisterId?: number;
    attendanceRegister?: LearnershipAttendanceRegister | undefined;
}

export enum AttendanceTypes {
    Default = 0,
    Present = 1,
    Absent = 2,
    ArrivedLate = 3,
    LeftEarly = 4,
    ArrivedLateAndLeftEarly = 5,
    OnLeave = 6,
    Sick = 7,
    PublicHoliday = 8,
    NotApplicable = 9,
    Terminated = 10,
    FamilyResponsibilitySickChild = 11,
    FamilyResponsibilityFuneral = 12,
    MaternityLeave = 13,
}

export class LearnershipAttendanceRegister extends AuditableBaseEntity implements ILearnershipAttendanceRegister {
    startDate?: Date;
    endDate?: Date;
    attendanceRegisterItems?: LearnershipAttendanceRegisterItem[] | undefined;
    learnershipGroups?: LearnershipAttendanceRegisterLearnershipGroup[] | undefined;
    physicalAttendanceRegister?: LearnershipAttendanceRegisterFile | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;

    constructor(data?: ILearnershipAttendanceRegister) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attendanceRegisterItems"])) {
                this.attendanceRegisterItems = [] as any;
                for (let item of _data["attendanceRegisterItems"])
                    this.attendanceRegisterItems!.push(LearnershipAttendanceRegisterItem.fromJS(item));
            }
            if (Array.isArray(_data["learnershipGroups"])) {
                this.learnershipGroups = [] as any;
                for (let item of _data["learnershipGroups"])
                    this.learnershipGroups!.push(LearnershipAttendanceRegisterLearnershipGroup.fromJS(item));
            }
            this.physicalAttendanceRegister = _data["physicalAttendanceRegister"] ? LearnershipAttendanceRegisterFile.fromJS(_data["physicalAttendanceRegister"]) : <any>undefined;
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): LearnershipAttendanceRegister {
        data = typeof data === 'object' ? data : {};
        let result = new LearnershipAttendanceRegister();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attendanceRegisterItems)) {
            data["attendanceRegisterItems"] = [];
            for (let item of this.attendanceRegisterItems)
                data["attendanceRegisterItems"].push(item.toJSON());
        }
        if (Array.isArray(this.learnershipGroups)) {
            data["learnershipGroups"] = [];
            for (let item of this.learnershipGroups)
                data["learnershipGroups"].push(item.toJSON());
        }
        data["physicalAttendanceRegister"] = this.physicalAttendanceRegister ? this.physicalAttendanceRegister.toJSON() : <any>undefined;
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILearnershipAttendanceRegister extends IAuditableBaseEntity {
    startDate?: Date;
    endDate?: Date;
    attendanceRegisterItems?: LearnershipAttendanceRegisterItem[] | undefined;
    learnershipGroups?: LearnershipAttendanceRegisterLearnershipGroup[] | undefined;
    physicalAttendanceRegister?: LearnershipAttendanceRegisterFile | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
}

export class LearnershipAttendanceRegisterLearnershipGroup extends BaseEntity implements ILearnershipAttendanceRegisterLearnershipGroup {
    learnershipGroupId?: number;
    learnershipGroup?: LearnershipGroup | undefined;
    learnershipAttendanceRegisterId?: number;
    learnershipAttendanceRegister?: LearnershipAttendanceRegister | undefined;

    constructor(data?: ILearnershipAttendanceRegisterLearnershipGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.learnershipGroupId = _data["learnershipGroupId"];
            this.learnershipGroup = _data["learnershipGroup"] ? LearnershipGroup.fromJS(_data["learnershipGroup"]) : <any>undefined;
            this.learnershipAttendanceRegisterId = _data["learnershipAttendanceRegisterId"];
            this.learnershipAttendanceRegister = _data["learnershipAttendanceRegister"] ? LearnershipAttendanceRegister.fromJS(_data["learnershipAttendanceRegister"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): LearnershipAttendanceRegisterLearnershipGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LearnershipAttendanceRegisterLearnershipGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipGroupId"] = this.learnershipGroupId;
        data["learnershipGroup"] = this.learnershipGroup ? this.learnershipGroup.toJSON() : <any>undefined;
        data["learnershipAttendanceRegisterId"] = this.learnershipAttendanceRegisterId;
        data["learnershipAttendanceRegister"] = this.learnershipAttendanceRegister ? this.learnershipAttendanceRegister.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILearnershipAttendanceRegisterLearnershipGroup extends IBaseEntity {
    learnershipGroupId?: number;
    learnershipGroup?: LearnershipGroup | undefined;
    learnershipAttendanceRegisterId?: number;
    learnershipAttendanceRegister?: LearnershipAttendanceRegister | undefined;
}

export class ProgrammeGroupEntity extends AuditableBaseEntity implements IProgrammeGroupEntity {
    name?: string | undefined;
    capacity?: number;

    constructor(data?: IProgrammeGroupEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.capacity = _data["capacity"];
        }
    }

    static override fromJS(data: any): ProgrammeGroupEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProgrammeGroupEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["capacity"] = this.capacity;
        super.toJSON(data);
        return data;
    }
}

export interface IProgrammeGroupEntity extends IAuditableBaseEntity {
    name?: string | undefined;
    capacity?: number;
}

export class LearnershipGroup extends ProgrammeGroupEntity implements ILearnershipGroup {
    students?: StudentLearnershipGroup[] | undefined;
    employers?: EmployerLearnershipGroup[] | undefined;
    attendanceRegisters?: LearnershipAttendanceRegisterLearnershipGroup[] | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;

    constructor(data?: ILearnershipGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(StudentLearnershipGroup.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(EmployerLearnershipGroup.fromJS(item));
            }
            if (Array.isArray(_data["attendanceRegisters"])) {
                this.attendanceRegisters = [] as any;
                for (let item of _data["attendanceRegisters"])
                    this.attendanceRegisters!.push(LearnershipAttendanceRegisterLearnershipGroup.fromJS(item));
            }
            this.learnershipId = _data["learnershipId"];
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): LearnershipGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LearnershipGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        if (Array.isArray(this.attendanceRegisters)) {
            data["attendanceRegisters"] = [];
            for (let item of this.attendanceRegisters)
                data["attendanceRegisters"].push(item.toJSON());
        }
        data["learnershipId"] = this.learnershipId;
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILearnershipGroup extends IProgrammeGroupEntity {
    students?: StudentLearnershipGroup[] | undefined;
    employers?: EmployerLearnershipGroup[] | undefined;
    attendanceRegisters?: LearnershipAttendanceRegisterLearnershipGroup[] | undefined;
    learnershipId?: number;
    learnership?: Learnership | undefined;
}

export class StudentLearnershipGroup extends AuditableBaseEntity implements IStudentLearnershipGroup {
    studentId?: number;
    student?: Student | undefined;
    learnershipGroupId?: number;
    learnershipGroup?: LearnershipGroup | undefined;

    constructor(data?: IStudentLearnershipGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.learnershipGroupId = _data["learnershipGroupId"];
            this.learnershipGroup = _data["learnershipGroup"] ? LearnershipGroup.fromJS(_data["learnershipGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentLearnershipGroup {
        data = typeof data === 'object' ? data : {};
        let result = new StudentLearnershipGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["learnershipGroupId"] = this.learnershipGroupId;
        data["learnershipGroup"] = this.learnershipGroup ? this.learnershipGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentLearnershipGroup extends IAuditableBaseEntity {
    studentId?: number;
    student?: Student | undefined;
    learnershipGroupId?: number;
    learnershipGroup?: LearnershipGroup | undefined;
}

export class EmployerLearnershipGroup extends AuditableBaseEntity implements IEmployerLearnershipGroup {
    employerRole?: EmployerRole;
    employerId?: number;
    employer?: Employer | undefined;
    learnershipGroupId?: number;
    learnershipGroup?: LearnershipGroup | undefined;

    constructor(data?: IEmployerLearnershipGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employerRole = _data["employerRole"];
            this.employerId = _data["employerId"];
            this.employer = _data["employer"] ? Employer.fromJS(_data["employer"]) : <any>undefined;
            this.learnershipGroupId = _data["learnershipGroupId"];
            this.learnershipGroup = _data["learnershipGroup"] ? LearnershipGroup.fromJS(_data["learnershipGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EmployerLearnershipGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerLearnershipGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerRole"] = this.employerRole;
        data["employerId"] = this.employerId;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["learnershipGroupId"] = this.learnershipGroupId;
        data["learnershipGroup"] = this.learnershipGroup ? this.learnershipGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployerLearnershipGroup extends IAuditableBaseEntity {
    employerRole?: EmployerRole;
    employerId?: number;
    employer?: Employer | undefined;
    learnershipGroupId?: number;
    learnershipGroup?: LearnershipGroup | undefined;
}

export enum EmployerRole {
    Lead = 0,
    Host = 1,
}

export class Employer extends AuditableBaseEntity implements IEmployer {
    setaRegisteredWith?: SETATypes | undefined;
    legalName?: string | undefined;
    tradingName?: string | undefined;
    registrationNumber?: string | undefined;
    sdlNumber?: string | undefined;
    telNumber?: string | undefined;
    email?: string | undefined;
    businessAddress?: EmployerBusinessAddress | undefined;
    postalAddress?: EmployerPostalAddress | undefined;
    contactPersons?: ContactPerson[] | undefined;
    learnershipGroups?: EmployerLearnershipGroup[] | undefined;
    internshipGroups?: EmployerInternshipGroup[] | undefined;

    constructor(data?: IEmployer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.setaRegisteredWith = _data["setaRegisteredWith"];
            this.legalName = _data["legalName"];
            this.tradingName = _data["tradingName"];
            this.registrationNumber = _data["registrationNumber"];
            this.sdlNumber = _data["sdlNumber"];
            this.telNumber = _data["telNumber"];
            this.email = _data["email"];
            this.businessAddress = _data["businessAddress"] ? EmployerBusinessAddress.fromJS(_data["businessAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? EmployerPostalAddress.fromJS(_data["postalAddress"]) : <any>undefined;
            if (Array.isArray(_data["contactPersons"])) {
                this.contactPersons = [] as any;
                for (let item of _data["contactPersons"])
                    this.contactPersons!.push(ContactPerson.fromJS(item));
            }
            if (Array.isArray(_data["learnershipGroups"])) {
                this.learnershipGroups = [] as any;
                for (let item of _data["learnershipGroups"])
                    this.learnershipGroups!.push(EmployerLearnershipGroup.fromJS(item));
            }
            if (Array.isArray(_data["internshipGroups"])) {
                this.internshipGroups = [] as any;
                for (let item of _data["internshipGroups"])
                    this.internshipGroups!.push(EmployerInternshipGroup.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Employer {
        data = typeof data === 'object' ? data : {};
        let result = new Employer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setaRegisteredWith"] = this.setaRegisteredWith;
        data["legalName"] = this.legalName;
        data["tradingName"] = this.tradingName;
        data["registrationNumber"] = this.registrationNumber;
        data["sdlNumber"] = this.sdlNumber;
        data["telNumber"] = this.telNumber;
        data["email"] = this.email;
        data["businessAddress"] = this.businessAddress ? this.businessAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.contactPersons)) {
            data["contactPersons"] = [];
            for (let item of this.contactPersons)
                data["contactPersons"].push(item.toJSON());
        }
        if (Array.isArray(this.learnershipGroups)) {
            data["learnershipGroups"] = [];
            for (let item of this.learnershipGroups)
                data["learnershipGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.internshipGroups)) {
            data["internshipGroups"] = [];
            for (let item of this.internshipGroups)
                data["internshipGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEmployer extends IAuditableBaseEntity {
    setaRegisteredWith?: SETATypes | undefined;
    legalName?: string | undefined;
    tradingName?: string | undefined;
    registrationNumber?: string | undefined;
    sdlNumber?: string | undefined;
    telNumber?: string | undefined;
    email?: string | undefined;
    businessAddress?: EmployerBusinessAddress | undefined;
    postalAddress?: EmployerPostalAddress | undefined;
    contactPersons?: ContactPerson[] | undefined;
    learnershipGroups?: EmployerLearnershipGroup[] | undefined;
    internshipGroups?: EmployerInternshipGroup[] | undefined;
}

export abstract class AddressEntity extends AuditableBaseEntity implements IAddressEntity {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;

    constructor(data?: IAddressEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.street = _data["street"];
            this.unit = _data["unit"];
            this.complex = _data["complex"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
        }
    }

    static override fromJS(data: any): AddressEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AddressEntity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["unit"] = this.unit;
        data["complex"] = this.complex;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        super.toJSON(data);
        return data;
    }
}

export interface IAddressEntity extends IAuditableBaseEntity {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
}

export class EmployerBusinessAddress extends AddressEntity implements IEmployerBusinessAddress {
    sameAsPostal?: boolean;

    constructor(data?: IEmployerBusinessAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sameAsPostal = _data["sameAsPostal"];
        }
    }

    static override fromJS(data: any): EmployerBusinessAddress {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerBusinessAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sameAsPostal"] = this.sameAsPostal;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployerBusinessAddress extends IAddressEntity {
    sameAsPostal?: boolean;
}

export enum Countries {
    Angola = 0,
    Botswana = 1,
    Mozambique = 2,
    Namibia = 3,
    Nigeria = 4,
    SouthAfrica = 5,
    Uganda = 6,
    Zimbabwe = 7,
    Zambia = 8,
    Other = 9,
}

export class EmployerPostalAddress extends AddressEntity implements IEmployerPostalAddress {

    constructor(data?: IEmployerPostalAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EmployerPostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPostalAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEmployerPostalAddress extends IAddressEntity {
}

export class ContactPerson extends AuditableBaseEntity implements IContactPerson {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    email?: string | undefined;
    employerId?: number;
    employer?: Employer | undefined;

    constructor(data?: IContactPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.contactNumber = _data["contactNumber"];
            this.email = _data["email"];
            this.employerId = _data["employerId"];
            this.employer = _data["employer"] ? Employer.fromJS(_data["employer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ContactPerson {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPerson();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["contactNumber"] = this.contactNumber;
        data["email"] = this.email;
        data["employerId"] = this.employerId;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IContactPerson extends IAuditableBaseEntity {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    email?: string | undefined;
    employerId?: number;
    employer?: Employer | undefined;
}

export class EmployerInternshipGroup extends AuditableBaseEntity implements IEmployerInternshipGroup {
    employerRole?: EmployerRole;
    employerId?: number;
    employer?: Employer | undefined;
    internshipGroupId?: number;
    internshipGroup?: InternshipGroup | undefined;

    constructor(data?: IEmployerInternshipGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employerRole = _data["employerRole"];
            this.employerId = _data["employerId"];
            this.employer = _data["employer"] ? Employer.fromJS(_data["employer"]) : <any>undefined;
            this.internshipGroupId = _data["internshipGroupId"];
            this.internshipGroup = _data["internshipGroup"] ? InternshipGroup.fromJS(_data["internshipGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EmployerInternshipGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerInternshipGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerRole"] = this.employerRole;
        data["employerId"] = this.employerId;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        data["internshipGroupId"] = this.internshipGroupId;
        data["internshipGroup"] = this.internshipGroup ? this.internshipGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployerInternshipGroup extends IAuditableBaseEntity {
    employerRole?: EmployerRole;
    employerId?: number;
    employer?: Employer | undefined;
    internshipGroupId?: number;
    internshipGroup?: InternshipGroup | undefined;
}

export class InternshipGroup extends ProgrammeGroupEntity implements IInternshipGroup {
    students?: StudentInternshipGroup[] | undefined;
    employers?: EmployerInternshipGroup[] | undefined;
    internshipId?: number;
    internship?: Internship | undefined;

    constructor(data?: IInternshipGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(StudentInternshipGroup.fromJS(item));
            }
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(EmployerInternshipGroup.fromJS(item));
            }
            this.internshipId = _data["internshipId"];
            this.internship = _data["internship"] ? Internship.fromJS(_data["internship"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): InternshipGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InternshipGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        data["internshipId"] = this.internshipId;
        data["internship"] = this.internship ? this.internship.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInternshipGroup extends IProgrammeGroupEntity {
    students?: StudentInternshipGroup[] | undefined;
    employers?: EmployerInternshipGroup[] | undefined;
    internshipId?: number;
    internship?: Internship | undefined;
}

export class StudentInternshipGroup extends AuditableBaseEntity implements IStudentInternshipGroup {
    studentId?: number;
    student?: Student | undefined;
    internshipGroupId?: number;
    internshipGroup?: InternshipGroup | undefined;

    constructor(data?: IStudentInternshipGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.internshipGroupId = _data["internshipGroupId"];
            this.internshipGroup = _data["internshipGroup"] ? InternshipGroup.fromJS(_data["internshipGroup"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentInternshipGroup {
        data = typeof data === 'object' ? data : {};
        let result = new StudentInternshipGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["internshipGroupId"] = this.internshipGroupId;
        data["internshipGroup"] = this.internshipGroup ? this.internshipGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentInternshipGroup extends IAuditableBaseEntity {
    studentId?: number;
    student?: Student | undefined;
    internshipGroupId?: number;
    internshipGroup?: InternshipGroup | undefined;
}

export class LearnershipAttendanceRegisterFile extends FileEntity implements ILearnershipAttendanceRegisterFile {
    learnershipAttendanceRegisterId?: number;
    learnershipAttendanceRegister?: LearnershipAttendanceRegister | undefined;
    fileContent?: string | undefined;

    constructor(data?: ILearnershipAttendanceRegisterFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.learnershipAttendanceRegisterId = _data["learnershipAttendanceRegisterId"];
            this.learnershipAttendanceRegister = _data["learnershipAttendanceRegister"] ? LearnershipAttendanceRegister.fromJS(_data["learnershipAttendanceRegister"]) : <any>undefined;
            this.fileContent = _data["fileContent"];
        }
    }

    static override fromJS(data: any): LearnershipAttendanceRegisterFile {
        data = typeof data === 'object' ? data : {};
        let result = new LearnershipAttendanceRegisterFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipAttendanceRegisterId"] = this.learnershipAttendanceRegisterId;
        data["learnershipAttendanceRegister"] = this.learnershipAttendanceRegister ? this.learnershipAttendanceRegister.toJSON() : <any>undefined;
        data["fileContent"] = this.fileContent;
        super.toJSON(data);
        return data;
    }
}

export interface ILearnershipAttendanceRegisterFile extends IFileEntity {
    learnershipAttendanceRegisterId?: number;
    learnershipAttendanceRegister?: LearnershipAttendanceRegister | undefined;
    fileContent?: string | undefined;
}

export class StudentCode extends AuditableBaseEntity implements IStudentCode {
    name?: string | undefined;
    filePath?: string | undefined;
    contentType?: string | undefined;
    type?: StudentCodeType;
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;

    constructor(data?: IStudentCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.filePath = _data["filePath"];
            this.contentType = _data["contentType"];
            this.type = _data["type"];
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentLearnership = _data["studentLearnership"] ? StudentLearnership.fromJS(_data["studentLearnership"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentCode {
        data = typeof data === 'object' ? data : {};
        let result = new StudentCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["filePath"] = this.filePath;
        data["contentType"] = this.contentType;
        data["type"] = this.type;
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentLearnership"] = this.studentLearnership ? this.studentLearnership.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentCode extends IAuditableBaseEntity {
    name?: string | undefined;
    filePath?: string | undefined;
    contentType?: string | undefined;
    type?: StudentCodeType;
    studentLearnershipId?: number;
    studentLearnership?: StudentLearnership | undefined;
}

export enum StudentCodeType {
    File = 0,
    Link = 1,
}

export class EmailNotification extends AuditableBaseEntity implements IEmailNotification {
    guid?: string | undefined;
    to?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    ccMails?: string | undefined;
    body?: string | undefined;
    sent?: Date | undefined;
    studentId?: number | undefined;
    student?: Student | undefined;
    staffId?: number | undefined;
    staff?: Staff | undefined;

    constructor(data?: IEmailNotification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.guid = _data["guid"];
            this.to = _data["to"];
            this.from = _data["from"];
            this.subject = _data["subject"];
            this.ccMails = _data["ccMails"];
            this.body = _data["body"];
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : <any>undefined;
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.staffId = _data["staffId"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EmailNotification {
        data = typeof data === 'object' ? data : {};
        let result = new EmailNotification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["to"] = this.to;
        data["from"] = this.from;
        data["subject"] = this.subject;
        data["ccMails"] = this.ccMails;
        data["body"] = this.body;
        data["sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["staffId"] = this.staffId;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailNotification extends IAuditableBaseEntity {
    guid?: string | undefined;
    to?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    ccMails?: string | undefined;
    body?: string | undefined;
    sent?: Date | undefined;
    studentId?: number | undefined;
    student?: Student | undefined;
    staffId?: number | undefined;
    staff?: Staff | undefined;
}

export class StudentPersonalFile extends FileEntity implements IStudentPersonalFile {
    docTypeId?: number;
    docType?: StudentDocumentType | undefined;
    studentId?: number;
    student?: Student | undefined;

    constructor(data?: IStudentPersonalFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? StudentDocumentType.fromJS(_data["docType"]) : <any>undefined;
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentPersonalFile {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPersonalFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentPersonalFile extends IFileEntity {
    docTypeId?: number;
    docType?: StudentDocumentType | undefined;
    studentId?: number;
    student?: Student | undefined;
}

export class StudentDocumentType extends DocumentTypeEntity implements IStudentDocumentType {
    studentPersonalFiles?: StudentPersonalFile[] | undefined;

    constructor(data?: IStudentDocumentType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["studentPersonalFiles"])) {
                this.studentPersonalFiles = [] as any;
                for (let item of _data["studentPersonalFiles"])
                    this.studentPersonalFiles!.push(StudentPersonalFile.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): StudentDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new StudentDocumentType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentPersonalFiles)) {
            data["studentPersonalFiles"] = [];
            for (let item of this.studentPersonalFiles)
                data["studentPersonalFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStudentDocumentType extends IDocumentTypeEntity {
    studentPersonalFiles?: StudentPersonalFile[] | undefined;
}

export class StudentInternshipAttendance extends AuditableBaseEntity implements IStudentInternshipAttendance {
    attendanceType?: AttendanceTypes;
    studentId?: number;
    student?: Student | undefined;
    attendanceRegisterId?: number;
    attendanceRegister?: InternshipAttendanceRegister | undefined;

    constructor(data?: IStudentInternshipAttendance) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attendanceType = _data["attendanceType"];
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.attendanceRegisterId = _data["attendanceRegisterId"];
            this.attendanceRegister = _data["attendanceRegister"] ? InternshipAttendanceRegister.fromJS(_data["attendanceRegister"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StudentInternshipAttendance {
        data = typeof data === 'object' ? data : {};
        let result = new StudentInternshipAttendance();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceType"] = this.attendanceType;
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["attendanceRegisterId"] = this.attendanceRegisterId;
        data["attendanceRegister"] = this.attendanceRegister ? this.attendanceRegister.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudentInternshipAttendance extends IAuditableBaseEntity {
    attendanceType?: AttendanceTypes;
    studentId?: number;
    student?: Student | undefined;
    attendanceRegisterId?: number;
    attendanceRegister?: InternshipAttendanceRegister | undefined;
}

export class InternshipAttendanceRegister extends AuditableBaseEntity implements IInternshipAttendanceRegister {
    date?: Date;
    studentAttendance?: StudentInternshipAttendance[] | undefined;
    physicalAttendanceRegisterId?: number | undefined;
    physicalAttendanceRegister?: InternshipAttendanceRegisterFile | undefined;
    internshipId?: number;
    internship?: Internship | undefined;

    constructor(data?: IInternshipAttendanceRegister) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["studentAttendance"])) {
                this.studentAttendance = [] as any;
                for (let item of _data["studentAttendance"])
                    this.studentAttendance!.push(StudentInternshipAttendance.fromJS(item));
            }
            this.physicalAttendanceRegisterId = _data["physicalAttendanceRegisterId"];
            this.physicalAttendanceRegister = _data["physicalAttendanceRegister"] ? InternshipAttendanceRegisterFile.fromJS(_data["physicalAttendanceRegister"]) : <any>undefined;
            this.internshipId = _data["internshipId"];
            this.internship = _data["internship"] ? Internship.fromJS(_data["internship"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): InternshipAttendanceRegister {
        data = typeof data === 'object' ? data : {};
        let result = new InternshipAttendanceRegister();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.studentAttendance)) {
            data["studentAttendance"] = [];
            for (let item of this.studentAttendance)
                data["studentAttendance"].push(item.toJSON());
        }
        data["physicalAttendanceRegisterId"] = this.physicalAttendanceRegisterId;
        data["physicalAttendanceRegister"] = this.physicalAttendanceRegister ? this.physicalAttendanceRegister.toJSON() : <any>undefined;
        data["internshipId"] = this.internshipId;
        data["internship"] = this.internship ? this.internship.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInternshipAttendanceRegister extends IAuditableBaseEntity {
    date?: Date;
    studentAttendance?: StudentInternshipAttendance[] | undefined;
    physicalAttendanceRegisterId?: number | undefined;
    physicalAttendanceRegister?: InternshipAttendanceRegisterFile | undefined;
    internshipId?: number;
    internship?: Internship | undefined;
}

export class InternshipAttendanceRegisterFile extends FileEntity implements IInternshipAttendanceRegisterFile {
    fromDate?: Date;
    toDate?: Date;
    attendanceRegisters?: InternshipAttendanceRegister[] | undefined;

    constructor(data?: IInternshipAttendanceRegisterFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attendanceRegisters"])) {
                this.attendanceRegisters = [] as any;
                for (let item of _data["attendanceRegisters"])
                    this.attendanceRegisters!.push(InternshipAttendanceRegister.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InternshipAttendanceRegisterFile {
        data = typeof data === 'object' ? data : {};
        let result = new InternshipAttendanceRegisterFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attendanceRegisters)) {
            data["attendanceRegisters"] = [];
            for (let item of this.attendanceRegisters)
                data["attendanceRegisters"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInternshipAttendanceRegisterFile extends IFileEntity {
    fromDate?: Date;
    toDate?: Date;
    attendanceRegisters?: InternshipAttendanceRegister[] | undefined;
}

export class Person extends AuditableBaseEntity implements IPerson {
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    streetAddress?: PersonStreetAddress | undefined;
    postalAddress?: PersonPostalAddress | undefined;
    staffMember?: Staff | undefined;
    student?: Student | undefined;
    accountId?: number;
    account?: Account | undefined;
    fullName?: string | undefined;

    constructor(data?: IPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.maidenName = _data["maidenName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.nationality = _data["nationality"];
            this.homeLanguage = _data["homeLanguage"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.whatsappNumber = _data["whatsappNumber"];
            this.cellNumber = _data["cellNumber"];
            this.email = _data["email"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinCellNumber = _data["nextOfKinCellNumber"];
            this.nextOfKinRelation = _data["nextOfKinRelation"];
            this.disability = _data["disability"];
            this.disabilityType = _data["disabilityType"];
            this.disabilityComment = _data["disabilityComment"];
            this.streetAddress = _data["streetAddress"] ? PersonStreetAddress.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? PersonPostalAddress.fromJS(_data["postalAddress"]) : <any>undefined;
            this.staffMember = _data["staffMember"] ? Staff.fromJS(_data["staffMember"]) : <any>undefined;
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.fullName = _data["fullName"];
        }
    }

    static override fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["maidenName"] = this.maidenName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["nationality"] = this.nationality;
        data["homeLanguage"] = this.homeLanguage;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["whatsappNumber"] = this.whatsappNumber;
        data["cellNumber"] = this.cellNumber;
        data["email"] = this.email;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinCellNumber"] = this.nextOfKinCellNumber;
        data["nextOfKinRelation"] = this.nextOfKinRelation;
        data["disability"] = this.disability;
        data["disabilityType"] = this.disabilityType;
        data["disabilityComment"] = this.disabilityComment;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : <any>undefined;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        super.toJSON(data);
        return data;
    }
}

export interface IPerson extends IAuditableBaseEntity {
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    streetAddress?: PersonStreetAddress | undefined;
    postalAddress?: PersonPostalAddress | undefined;
    staffMember?: Staff | undefined;
    student?: Student | undefined;
    accountId?: number;
    account?: Account | undefined;
    fullName?: string | undefined;
}

export enum Genders {
    Male = 0,
    Female = 1,
    Other = 2,
}

export enum Races {
    African = 0,
    White = 1,
    Colored = 2,
    Indian = 3,
    Other = 4,
}

export enum Nationalities {
    Angolan = 0,
    Botswanan = 1,
    Mozambican = 2,
    Namibian = 3,
    Nigerian = 4,
    SouthAfrican = 5,
    Ugandan = 6,
    Zimbabwean = 7,
    Zambian = 8,
    Other = 9,
}

export enum Languages {
    Afrikaans = 0,
    English = 1,
    Ndebele = 2,
    NorthernSotho = 3,
    Sesotho = 4,
    Swati = 5,
    Tsonga = 6,
    Tswana = 7,
    Venda = 8,
    Xhosa = 9,
    Zulu = 10,
    Pedi = 11,
    SouthAfricanSignLanguage = 12,
    Other = 13,
}

export enum IdTypes {
    SouthAfrican = 0,
    Passport = 1,
}

export class PersonStreetAddress extends AddressEntity implements IPersonStreetAddress {
    sameAsPostal?: boolean;
    personId?: number;
    person?: Person | undefined;

    constructor(data?: IPersonStreetAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sameAsPostal = _data["sameAsPostal"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): PersonStreetAddress {
        data = typeof data === 'object' ? data : {};
        let result = new PersonStreetAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sameAsPostal"] = this.sameAsPostal;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonStreetAddress extends IAddressEntity {
    sameAsPostal?: boolean;
    personId?: number;
    person?: Person | undefined;
}

export class PersonPostalAddress extends AddressEntity implements IPersonPostalAddress {
    personId?: number;
    person?: Person | undefined;

    constructor(data?: IPersonPostalAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): PersonPostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new PersonPostalAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonPostalAddress extends IAddressEntity {
    personId?: number;
    person?: Person | undefined;
}

export class Account extends AuditableBaseEntity implements IAccount {
    profileImage?: string | undefined;
    tenantId?: number;
    signatureSvg?: string | undefined;
    initialsSvg?: string | undefined;
    passwordHash?: string | undefined;
    dateJoined?: Date;
    acceptTerms?: boolean;
    role?: Roles;
    roles?: AccountRole[] | undefined;
    verificationToken?: string | undefined;
    registrationCompleted?: Date | undefined;
    isVerifiedAndRegistered?: boolean;
    resetToken?: string | undefined;
    resetTokenExpires?: Date | undefined;
    passwordReset?: Date | undefined;
    refreshTokens?: RefreshToken[] | undefined;
    customFields?: CustomField[] | undefined;
    announcements?: Announcement[] | undefined;
    internshipChatRoomMessages?: InternshipChatRoomMessage[] | undefined;
    learnershipChatRoomMessages?: LearnershipChatRoomMessage[] | undefined;
    wasImpersonatedBy?: LogInAsRequest[] | undefined;
    person?: Person | undefined;

    constructor(data?: IAccount) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.profileImage = _data["profileImage"];
            this.tenantId = _data["tenantId"];
            this.signatureSvg = _data["signatureSvg"];
            this.initialsSvg = _data["initialsSvg"];
            this.passwordHash = _data["passwordHash"];
            this.dateJoined = _data["dateJoined"] ? new Date(_data["dateJoined"].toString()) : <any>undefined;
            this.acceptTerms = _data["acceptTerms"];
            this.role = _data["role"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(AccountRole.fromJS(item));
            }
            this.verificationToken = _data["verificationToken"];
            this.registrationCompleted = _data["registrationCompleted"] ? new Date(_data["registrationCompleted"].toString()) : <any>undefined;
            this.isVerifiedAndRegistered = _data["isVerifiedAndRegistered"];
            this.resetToken = _data["resetToken"];
            this.resetTokenExpires = _data["resetTokenExpires"] ? new Date(_data["resetTokenExpires"].toString()) : <any>undefined;
            this.passwordReset = _data["passwordReset"] ? new Date(_data["passwordReset"].toString()) : <any>undefined;
            if (Array.isArray(_data["refreshTokens"])) {
                this.refreshTokens = [] as any;
                for (let item of _data["refreshTokens"])
                    this.refreshTokens!.push(RefreshToken.fromJS(item));
            }
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomField.fromJS(item));
            }
            if (Array.isArray(_data["announcements"])) {
                this.announcements = [] as any;
                for (let item of _data["announcements"])
                    this.announcements!.push(Announcement.fromJS(item));
            }
            if (Array.isArray(_data["internshipChatRoomMessages"])) {
                this.internshipChatRoomMessages = [] as any;
                for (let item of _data["internshipChatRoomMessages"])
                    this.internshipChatRoomMessages!.push(InternshipChatRoomMessage.fromJS(item));
            }
            if (Array.isArray(_data["learnershipChatRoomMessages"])) {
                this.learnershipChatRoomMessages = [] as any;
                for (let item of _data["learnershipChatRoomMessages"])
                    this.learnershipChatRoomMessages!.push(LearnershipChatRoomMessage.fromJS(item));
            }
            if (Array.isArray(_data["wasImpersonatedBy"])) {
                this.wasImpersonatedBy = [] as any;
                for (let item of _data["wasImpersonatedBy"])
                    this.wasImpersonatedBy!.push(LogInAsRequest.fromJS(item));
            }
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileImage"] = this.profileImage;
        data["tenantId"] = this.tenantId;
        data["signatureSvg"] = this.signatureSvg;
        data["initialsSvg"] = this.initialsSvg;
        data["passwordHash"] = this.passwordHash;
        data["dateJoined"] = this.dateJoined ? this.dateJoined.toISOString() : <any>undefined;
        data["acceptTerms"] = this.acceptTerms;
        data["role"] = this.role;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["verificationToken"] = this.verificationToken;
        data["registrationCompleted"] = this.registrationCompleted ? this.registrationCompleted.toISOString() : <any>undefined;
        data["isVerifiedAndRegistered"] = this.isVerifiedAndRegistered;
        data["resetToken"] = this.resetToken;
        data["resetTokenExpires"] = this.resetTokenExpires ? this.resetTokenExpires.toISOString() : <any>undefined;
        data["passwordReset"] = this.passwordReset ? this.passwordReset.toISOString() : <any>undefined;
        if (Array.isArray(this.refreshTokens)) {
            data["refreshTokens"] = [];
            for (let item of this.refreshTokens)
                data["refreshTokens"].push(item.toJSON());
        }
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        if (Array.isArray(this.announcements)) {
            data["announcements"] = [];
            for (let item of this.announcements)
                data["announcements"].push(item.toJSON());
        }
        if (Array.isArray(this.internshipChatRoomMessages)) {
            data["internshipChatRoomMessages"] = [];
            for (let item of this.internshipChatRoomMessages)
                data["internshipChatRoomMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.learnershipChatRoomMessages)) {
            data["learnershipChatRoomMessages"] = [];
            for (let item of this.learnershipChatRoomMessages)
                data["learnershipChatRoomMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.wasImpersonatedBy)) {
            data["wasImpersonatedBy"] = [];
            for (let item of this.wasImpersonatedBy)
                data["wasImpersonatedBy"].push(item.toJSON());
        }
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAccount extends IAuditableBaseEntity {
    profileImage?: string | undefined;
    tenantId?: number;
    signatureSvg?: string | undefined;
    initialsSvg?: string | undefined;
    passwordHash?: string | undefined;
    dateJoined?: Date;
    acceptTerms?: boolean;
    role?: Roles;
    roles?: AccountRole[] | undefined;
    verificationToken?: string | undefined;
    registrationCompleted?: Date | undefined;
    isVerifiedAndRegistered?: boolean;
    resetToken?: string | undefined;
    resetTokenExpires?: Date | undefined;
    passwordReset?: Date | undefined;
    refreshTokens?: RefreshToken[] | undefined;
    customFields?: CustomField[] | undefined;
    announcements?: Announcement[] | undefined;
    internshipChatRoomMessages?: InternshipChatRoomMessage[] | undefined;
    learnershipChatRoomMessages?: LearnershipChatRoomMessage[] | undefined;
    wasImpersonatedBy?: LogInAsRequest[] | undefined;
    person?: Person | undefined;
}

export class AccountRole extends AuditableBaseEntity implements IAccountRole {
    role?: AccountRoles;
    accountId?: number;
    account?: Account | undefined;

    constructor(data?: IAccountRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.role = _data["role"];
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AccountRole {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAccountRole extends IAuditableBaseEntity {
    role?: AccountRoles;
    accountId?: number;
    account?: Account | undefined;
}

export enum AccountRoles {
    TenantManager = 0,
    Administrator = 1,
    Manager = 2,
    Staff = 3,
    SetaVisitor = 4,
    Student = 5,
}

export class RefreshToken extends BaseEntity implements IRefreshToken {
    account?: Account | undefined;
    token?: string | undefined;
    expires?: Date;
    isExpired?: boolean;
    created?: Date;
    createdByIp?: string | undefined;
    revoked?: Date | undefined;
    revokedByIp?: string | undefined;
    replacedByToken?: string | undefined;
    isActive?: boolean;

    constructor(data?: IRefreshToken) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.token = _data["token"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
            this.isExpired = _data["isExpired"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdByIp = _data["createdByIp"];
            this.revoked = _data["revoked"] ? new Date(_data["revoked"].toString()) : <any>undefined;
            this.revokedByIp = _data["revokedByIp"];
            this.replacedByToken = _data["replacedByToken"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): RefreshToken {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshToken();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["token"] = this.token;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["isExpired"] = this.isExpired;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdByIp"] = this.createdByIp;
        data["revoked"] = this.revoked ? this.revoked.toISOString() : <any>undefined;
        data["revokedByIp"] = this.revokedByIp;
        data["replacedByToken"] = this.replacedByToken;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface IRefreshToken extends IBaseEntity {
    account?: Account | undefined;
    token?: string | undefined;
    expires?: Date;
    isExpired?: boolean;
    created?: Date;
    createdByIp?: string | undefined;
    revoked?: Date | undefined;
    revokedByIp?: string | undefined;
    replacedByToken?: string | undefined;
    isActive?: boolean;
}

export class CustomField extends AuditableBaseEntity implements ICustomField {
    fieldName?: string | undefined;
    fieldValue?: string | undefined;
    fieldType?: InputTypes;

    constructor(data?: ICustomField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.fieldValue = _data["fieldValue"];
            this.fieldType = _data["fieldType"];
        }
    }

    static override fromJS(data: any): CustomField {
        data = typeof data === 'object' ? data : {};
        let result = new CustomField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["fieldValue"] = this.fieldValue;
        data["fieldType"] = this.fieldType;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomField extends IAuditableBaseEntity {
    fieldName?: string | undefined;
    fieldValue?: string | undefined;
    fieldType?: InputTypes;
}

export class Announcement extends AuditableBaseEntity implements IAnnouncement {
    type?: AnnouncementMessageTypes;
    severity?: AnnouncementMessageSeverities;
    subject?: string | undefined;
    message?: string | undefined;
    sent?: Date;
    sentBy?: string | undefined;
    account?: Account | undefined;
    accountId?: number;
    attachments?: AnnouncementAttachment[] | undefined;

    constructor(data?: IAnnouncement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.severity = _data["severity"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : <any>undefined;
            this.sentBy = _data["sentBy"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AnnouncementAttachment.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Announcement {
        data = typeof data === 'object' ? data : {};
        let result = new Announcement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["severity"] = this.severity;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        data["sentBy"] = this.sentBy;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["accountId"] = this.accountId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAnnouncement extends IAuditableBaseEntity {
    type?: AnnouncementMessageTypes;
    severity?: AnnouncementMessageSeverities;
    subject?: string | undefined;
    message?: string | undefined;
    sent?: Date;
    sentBy?: string | undefined;
    account?: Account | undefined;
    accountId?: number;
    attachments?: AnnouncementAttachment[] | undefined;
}

export enum AnnouncementMessageTypes {
    General = 0,
    StaffAnnouncement = 1,
    StudentAnnouncement = 2,
}

export enum AnnouncementMessageSeverities {
    Standard = 0,
    Important = 1,
    Critical = 2,
}

export class AnnouncementAttachment extends FileEntity implements IAnnouncementAttachment {
    announcement?: Announcement | undefined;
    announcementId?: number;
    fileContent?: string | undefined;

    constructor(data?: IAnnouncementAttachment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.announcement = _data["announcement"] ? Announcement.fromJS(_data["announcement"]) : <any>undefined;
            this.announcementId = _data["announcementId"];
            this.fileContent = _data["fileContent"];
        }
    }

    static override fromJS(data: any): AnnouncementAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementAttachment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcement"] = this.announcement ? this.announcement.toJSON() : <any>undefined;
        data["announcementId"] = this.announcementId;
        data["fileContent"] = this.fileContent;
        super.toJSON(data);
        return data;
    }
}

export interface IAnnouncementAttachment extends IFileEntity {
    announcement?: Announcement | undefined;
    announcementId?: number;
    fileContent?: string | undefined;
}

export class ChatRoomMessageEntityOfInternshipChatRoom extends AuditableBaseEntity implements IChatRoomMessageEntityOfInternshipChatRoom {
    message?: string | undefined;
    sent?: Date;
    sentBy?: string | undefined;
    account?: Account | undefined;
    accountId?: number;
    chatRoom?: InternshipChatRoom | undefined;
    chatRoomId?: number;

    constructor(data?: IChatRoomMessageEntityOfInternshipChatRoom) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"];
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : <any>undefined;
            this.sentBy = _data["sentBy"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.accountId = _data["accountId"];
            this.chatRoom = _data["chatRoom"] ? InternshipChatRoom.fromJS(_data["chatRoom"]) : <any>undefined;
            this.chatRoomId = _data["chatRoomId"];
        }
    }

    static override fromJS(data: any): ChatRoomMessageEntityOfInternshipChatRoom {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomMessageEntityOfInternshipChatRoom();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        data["sentBy"] = this.sentBy;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["accountId"] = this.accountId;
        data["chatRoom"] = this.chatRoom ? this.chatRoom.toJSON() : <any>undefined;
        data["chatRoomId"] = this.chatRoomId;
        super.toJSON(data);
        return data;
    }
}

export interface IChatRoomMessageEntityOfInternshipChatRoom extends IAuditableBaseEntity {
    message?: string | undefined;
    sent?: Date;
    sentBy?: string | undefined;
    account?: Account | undefined;
    accountId?: number;
    chatRoom?: InternshipChatRoom | undefined;
    chatRoomId?: number;
}

export class InternshipChatRoomMessage extends ChatRoomMessageEntityOfInternshipChatRoom implements IInternshipChatRoomMessage {

    constructor(data?: IInternshipChatRoomMessage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InternshipChatRoomMessage {
        data = typeof data === 'object' ? data : {};
        let result = new InternshipChatRoomMessage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInternshipChatRoomMessage extends IChatRoomMessageEntityOfInternshipChatRoom {
}

export class ChatRoomEntityOfInternshipChatRoomMessage extends AuditableBaseEntity implements IChatRoomEntityOfInternshipChatRoomMessage {
    groupName?: string | undefined;
    messages?: InternshipChatRoomMessage[] | undefined;

    constructor(data?: IChatRoomEntityOfInternshipChatRoomMessage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(InternshipChatRoomMessage.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ChatRoomEntityOfInternshipChatRoomMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomEntityOfInternshipChatRoomMessage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IChatRoomEntityOfInternshipChatRoomMessage extends IAuditableBaseEntity {
    groupName?: string | undefined;
    messages?: InternshipChatRoomMessage[] | undefined;
}

export class InternshipChatRoom extends ChatRoomEntityOfInternshipChatRoomMessage implements IInternshipChatRoom {
    internship?: Internship | undefined;
    internshipId?: number;

    constructor(data?: IInternshipChatRoom) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.internship = _data["internship"] ? Internship.fromJS(_data["internship"]) : <any>undefined;
            this.internshipId = _data["internshipId"];
        }
    }

    static override fromJS(data: any): InternshipChatRoom {
        data = typeof data === 'object' ? data : {};
        let result = new InternshipChatRoom();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internship"] = this.internship ? this.internship.toJSON() : <any>undefined;
        data["internshipId"] = this.internshipId;
        super.toJSON(data);
        return data;
    }
}

export interface IInternshipChatRoom extends IChatRoomEntityOfInternshipChatRoomMessage {
    internship?: Internship | undefined;
    internshipId?: number;
}

export class ChatRoomMessageEntityOfLearnershipChatRoom extends AuditableBaseEntity implements IChatRoomMessageEntityOfLearnershipChatRoom {
    message?: string | undefined;
    sent?: Date;
    sentBy?: string | undefined;
    account?: Account | undefined;
    accountId?: number;
    chatRoom?: LearnershipChatRoom | undefined;
    chatRoomId?: number;

    constructor(data?: IChatRoomMessageEntityOfLearnershipChatRoom) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"];
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : <any>undefined;
            this.sentBy = _data["sentBy"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.accountId = _data["accountId"];
            this.chatRoom = _data["chatRoom"] ? LearnershipChatRoom.fromJS(_data["chatRoom"]) : <any>undefined;
            this.chatRoomId = _data["chatRoomId"];
        }
    }

    static override fromJS(data: any): ChatRoomMessageEntityOfLearnershipChatRoom {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomMessageEntityOfLearnershipChatRoom();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        data["sentBy"] = this.sentBy;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["accountId"] = this.accountId;
        data["chatRoom"] = this.chatRoom ? this.chatRoom.toJSON() : <any>undefined;
        data["chatRoomId"] = this.chatRoomId;
        super.toJSON(data);
        return data;
    }
}

export interface IChatRoomMessageEntityOfLearnershipChatRoom extends IAuditableBaseEntity {
    message?: string | undefined;
    sent?: Date;
    sentBy?: string | undefined;
    account?: Account | undefined;
    accountId?: number;
    chatRoom?: LearnershipChatRoom | undefined;
    chatRoomId?: number;
}

export class LearnershipChatRoomMessage extends ChatRoomMessageEntityOfLearnershipChatRoom implements ILearnershipChatRoomMessage {

    constructor(data?: ILearnershipChatRoomMessage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LearnershipChatRoomMessage {
        data = typeof data === 'object' ? data : {};
        let result = new LearnershipChatRoomMessage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILearnershipChatRoomMessage extends IChatRoomMessageEntityOfLearnershipChatRoom {
}

export class ChatRoomEntityOfLearnershipChatRoomMessage extends AuditableBaseEntity implements IChatRoomEntityOfLearnershipChatRoomMessage {
    groupName?: string | undefined;
    messages?: LearnershipChatRoomMessage[] | undefined;

    constructor(data?: IChatRoomEntityOfLearnershipChatRoomMessage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(LearnershipChatRoomMessage.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ChatRoomEntityOfLearnershipChatRoomMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRoomEntityOfLearnershipChatRoomMessage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IChatRoomEntityOfLearnershipChatRoomMessage extends IAuditableBaseEntity {
    groupName?: string | undefined;
    messages?: LearnershipChatRoomMessage[] | undefined;
}

export class LearnershipChatRoom extends ChatRoomEntityOfLearnershipChatRoomMessage implements ILearnershipChatRoom {
    learnership?: Learnership | undefined;
    learnershipId?: number;

    constructor(data?: ILearnershipChatRoom) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.learnership = _data["learnership"] ? Learnership.fromJS(_data["learnership"]) : <any>undefined;
            this.learnershipId = _data["learnershipId"];
        }
    }

    static override fromJS(data: any): LearnershipChatRoom {
        data = typeof data === 'object' ? data : {};
        let result = new LearnershipChatRoom();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnership"] = this.learnership ? this.learnership.toJSON() : <any>undefined;
        data["learnershipId"] = this.learnershipId;
        super.toJSON(data);
        return data;
    }
}

export interface ILearnershipChatRoom extends IChatRoomEntityOfLearnershipChatRoomMessage {
    learnership?: Learnership | undefined;
    learnershipId?: number;
}

export class LogInAsRequest extends AuditableBaseEntity implements ILogInAsRequest {
    type?: LogInAsType;
    loggedInAsId?: number;
    loggedInAs?: Account | undefined;

    constructor(data?: ILogInAsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.loggedInAsId = _data["loggedInAsId"];
            this.loggedInAs = _data["loggedInAs"] ? Account.fromJS(_data["loggedInAs"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): LogInAsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LogInAsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["loggedInAsId"] = this.loggedInAsId;
        data["loggedInAs"] = this.loggedInAs ? this.loggedInAs.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILogInAsRequest extends IAuditableBaseEntity {
    type?: LogInAsType;
    loggedInAsId?: number;
    loggedInAs?: Account | undefined;
}

export enum LogInAsType {
    LogInAsStudent = 0,
    LogInAsStaff = 1,
}

export class GeneralInternshipDocument extends FileEntity implements IGeneralInternshipDocument {
    docTypeId?: number;
    docType?: GeneralInternshipDocumentType | undefined;
    internshipId?: number;
    internship?: Internship | undefined;

    constructor(data?: IGeneralInternshipDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? GeneralInternshipDocumentType.fromJS(_data["docType"]) : <any>undefined;
            this.internshipId = _data["internshipId"];
            this.internship = _data["internship"] ? Internship.fromJS(_data["internship"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GeneralInternshipDocument {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInternshipDocument();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        data["internshipId"] = this.internshipId;
        data["internship"] = this.internship ? this.internship.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralInternshipDocument extends IFileEntity {
    docTypeId?: number;
    docType?: GeneralInternshipDocumentType | undefined;
    internshipId?: number;
    internship?: Internship | undefined;
}

export class GeneralInternshipDocumentType extends FileEntity implements IGeneralInternshipDocumentType {
    generalInternshipDocuments?: GeneralInternshipDocument[] | undefined;

    constructor(data?: IGeneralInternshipDocumentType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["generalInternshipDocuments"])) {
                this.generalInternshipDocuments = [] as any;
                for (let item of _data["generalInternshipDocuments"])
                    this.generalInternshipDocuments!.push(GeneralInternshipDocument.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GeneralInternshipDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInternshipDocumentType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generalInternshipDocuments)) {
            data["generalInternshipDocuments"] = [];
            for (let item of this.generalInternshipDocuments)
                data["generalInternshipDocuments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralInternshipDocumentType extends IFileEntity {
    generalInternshipDocuments?: GeneralInternshipDocument[] | undefined;
}

export class InternshipPlan extends AuditableBaseEntity implements IInternshipPlan {
    name?: string | undefined;
    description?: string | undefined;
    phases?: InternshipPhase[] | undefined;

    constructor(data?: IInternshipPlan) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["phases"])) {
                this.phases = [] as any;
                for (let item of _data["phases"])
                    this.phases!.push(InternshipPhase.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InternshipPlan {
        data = typeof data === 'object' ? data : {};
        let result = new InternshipPlan();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.phases)) {
            data["phases"] = [];
            for (let item of this.phases)
                data["phases"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInternshipPlan extends IAuditableBaseEntity {
    name?: string | undefined;
    description?: string | undefined;
    phases?: InternshipPhase[] | undefined;
}

export class InternshipPhase extends AuditableBaseEntity implements IInternshipPhase {
    name?: string | undefined;
    description?: string | undefined;
    duration?: number;
    tasks?: InternshipTask[] | undefined;
    internshipPlanId?: number;
    internshipPlan?: InternshipPlan | undefined;

    constructor(data?: IInternshipPhase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(InternshipTask.fromJS(item));
            }
            this.internshipPlanId = _data["internshipPlanId"];
            this.internshipPlan = _data["internshipPlan"] ? InternshipPlan.fromJS(_data["internshipPlan"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): InternshipPhase {
        data = typeof data === 'object' ? data : {};
        let result = new InternshipPhase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["duration"] = this.duration;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["internshipPlanId"] = this.internshipPlanId;
        data["internshipPlan"] = this.internshipPlan ? this.internshipPlan.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInternshipPhase extends IAuditableBaseEntity {
    name?: string | undefined;
    description?: string | undefined;
    duration?: number;
    tasks?: InternshipTask[] | undefined;
    internshipPlanId?: number;
    internshipPlan?: InternshipPlan | undefined;
}

export class InternshipTask extends AuditableBaseEntity implements IInternshipTask {
    name?: string | undefined;
    description?: string | undefined;
    duration?: number;
    internshipPhaseId?: number;
    phase?: InternshipPhase | undefined;

    constructor(data?: IInternshipTask) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.duration = _data["duration"];
            this.internshipPhaseId = _data["internshipPhaseId"];
            this.phase = _data["phase"] ? InternshipPhase.fromJS(_data["phase"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): InternshipTask {
        data = typeof data === 'object' ? data : {};
        let result = new InternshipTask();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["internshipPhaseId"] = this.internshipPhaseId;
        data["phase"] = this.phase ? this.phase.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInternshipTask extends IAuditableBaseEntity {
    name?: string | undefined;
    description?: string | undefined;
    duration?: number;
    internshipPhaseId?: number;
    phase?: InternshipPhase | undefined;
}

export class StaffPersonalFile extends FileEntity implements IStaffPersonalFile {
    docTypeId?: number;
    docType?: StaffDocumentType | undefined;
    staffId?: number;
    staff?: Staff | undefined;

    constructor(data?: IStaffPersonalFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? StaffDocumentType.fromJS(_data["docType"]) : <any>undefined;
            this.staffId = _data["staffId"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): StaffPersonalFile {
        data = typeof data === 'object' ? data : {};
        let result = new StaffPersonalFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        data["staffId"] = this.staffId;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStaffPersonalFile extends IFileEntity {
    docTypeId?: number;
    docType?: StaffDocumentType | undefined;
    staffId?: number;
    staff?: Staff | undefined;
}

export class StaffDocumentType extends DocumentTypeEntity implements IStaffDocumentType {
    staffPersonalFiles?: StaffPersonalFile[] | undefined;

    constructor(data?: IStaffDocumentType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["staffPersonalFiles"])) {
                this.staffPersonalFiles = [] as any;
                for (let item of _data["staffPersonalFiles"])
                    this.staffPersonalFiles!.push(StaffPersonalFile.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): StaffDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new StaffDocumentType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.staffPersonalFiles)) {
            data["staffPersonalFiles"] = [];
            for (let item of this.staffPersonalFiles)
                data["staffPersonalFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStaffDocumentType extends IDocumentTypeEntity {
    staffPersonalFiles?: StaffPersonalFile[] | undefined;
}

export class CreateAccreditedProviderCommand implements ICreateAccreditedProviderCommand {
    name?: string | undefined;
    accreditationNumber?: string | undefined;
    setaRegisteredWith?: SETATypes | undefined;
    isSeta?: boolean;

    constructor(data?: ICreateAccreditedProviderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accreditationNumber = _data["accreditationNumber"];
            this.setaRegisteredWith = _data["setaRegisteredWith"];
            this.isSeta = _data["isSeta"];
        }
    }

    static fromJS(data: any): CreateAccreditedProviderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccreditedProviderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accreditationNumber"] = this.accreditationNumber;
        data["setaRegisteredWith"] = this.setaRegisteredWith;
        data["isSeta"] = this.isSeta;
        return data;
    }
}

export interface ICreateAccreditedProviderCommand {
    name?: string | undefined;
    accreditationNumber?: string | undefined;
    setaRegisteredWith?: SETATypes | undefined;
    isSeta?: boolean;
}

export enum ChatRoomTypes {
    Learnership = 0,
    Internship = 1,
}

export class SendUserSpecificAnnouncementCommand implements ISendUserSpecificAnnouncementCommand {
    tenantId?: number;
    accountId?: number;
    message?: string | undefined;

    constructor(data?: ISendUserSpecificAnnouncementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.accountId = _data["accountId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendUserSpecificAnnouncementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendUserSpecificAnnouncementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["accountId"] = this.accountId;
        data["message"] = this.message;
        return data;
    }
}

export interface ISendUserSpecificAnnouncementCommand {
    tenantId?: number;
    accountId?: number;
    message?: string | undefined;
}

export class SendAnnouncementCommand implements ISendAnnouncementCommand {
    type?: AnnouncementMessageTypes;
    severity?: AnnouncementMessageSeverities;
    subject?: string | undefined;
    message?: string | undefined;
    attachments?: SendAnnouncementCommandAttachmentModel[] | undefined;

    constructor(data?: ISendAnnouncementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.severity = _data["severity"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(SendAnnouncementCommandAttachmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendAnnouncementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendAnnouncementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["severity"] = this.severity;
        data["subject"] = this.subject;
        data["message"] = this.message;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendAnnouncementCommand {
    type?: AnnouncementMessageTypes;
    severity?: AnnouncementMessageSeverities;
    subject?: string | undefined;
    message?: string | undefined;
    attachments?: SendAnnouncementCommandAttachmentModel[] | undefined;
}

export class SendAnnouncementCommandAttachmentModel implements ISendAnnouncementCommandAttachmentModel {
    base64File?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: ISendAnnouncementCommandAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64File = _data["base64File"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): SendAnnouncementCommandAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendAnnouncementCommandAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64File"] = this.base64File;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface ISendAnnouncementCommandAttachmentModel {
    base64File?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class SendInternshipGroupMessageCommand implements ISendInternshipGroupMessageCommand {
    groupName?: string | undefined;
    message?: ChatMessageDTO | undefined;

    constructor(data?: ISendInternshipGroupMessageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.message = _data["message"] ? ChatMessageDTO.fromJS(_data["message"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendInternshipGroupMessageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendInternshipGroupMessageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendInternshipGroupMessageCommand {
    groupName?: string | undefined;
    message?: ChatMessageDTO | undefined;
}

export class ChatMessageDTO implements IChatMessageDTO {
    id?: number;
    accountId?: number;
    message?: string | undefined;
    sent?: Date;
    sentBy?: string | undefined;

    constructor(data?: IChatMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.message = _data["message"];
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : <any>undefined;
            this.sentBy = _data["sentBy"];
        }
    }

    static fromJS(data: any): ChatMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["message"] = this.message;
        data["sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        data["sentBy"] = this.sentBy;
        return data;
    }
}

export interface IChatMessageDTO {
    id?: number;
    accountId?: number;
    message?: string | undefined;
    sent?: Date;
    sentBy?: string | undefined;
}

export class SendLearnershipGroupMessageCommand implements ISendLearnershipGroupMessageCommand {
    groupName?: string | undefined;
    message?: ChatMessageDTO | undefined;

    constructor(data?: ISendLearnershipGroupMessageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.message = _data["message"] ? ChatMessageDTO.fromJS(_data["message"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendLearnershipGroupMessageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendLearnershipGroupMessageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendLearnershipGroupMessageCommand {
    groupName?: string | undefined;
    message?: ChatMessageDTO | undefined;
}

export enum DocTypeCatagories {
    Staff = 0,
    Student = 1,
    PoeGeneral = 2,
    PoeWorkplace = 3,
    PoeAssessmentGuide = 4,
    PoeGroupGeneral = 5,
    PoeFormativeAssessment = 6,
    PoeSummativeAssessment = 7,
    Organizational = 8,
    GeneralQualAndLearnership = 9,
}

export class CreateDocumentTypeCommand implements ICreateDocumentTypeCommand {
    documentTypeCatagory?: DocTypeCatagories;
    documentType?: string | undefined;
    multipleAllowed?: boolean;

    constructor(data?: ICreateDocumentTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeCatagory = _data["documentTypeCatagory"];
            this.documentType = _data["documentType"];
            this.multipleAllowed = _data["multipleAllowed"];
        }
    }

    static fromJS(data: any): CreateDocumentTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeCatagory"] = this.documentTypeCatagory;
        data["documentType"] = this.documentType;
        data["multipleAllowed"] = this.multipleAllowed;
        return data;
    }
}

export interface ICreateDocumentTypeCommand {
    documentTypeCatagory?: DocTypeCatagories;
    documentType?: string | undefined;
    multipleAllowed?: boolean;
}

export abstract class CreateActiveEmployer implements ICreateActiveEmployer {
    active?: boolean;

    constructor(data?: ICreateActiveEmployer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CreateActiveEmployer {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateActiveEmployer' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        return data;
    }
}

export interface ICreateActiveEmployer {
    active?: boolean;
}

export class CreateEmployerCommand extends CreateActiveEmployer implements ICreateEmployerCommand {
    setaRegisteredWith?: SETATypes | undefined;
    legalName?: string | undefined;
    tradingName?: string | undefined;
    registrationNumber?: string | undefined;
    sdlNumber?: string | undefined;
    telNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    businessAddress?: CreateEmployerBusinessAddress | undefined;
    postalAddress?: CreateEmployerPostalAddress | undefined;
    contactPersons?: CreateContactPerson[] | undefined;

    constructor(data?: ICreateEmployerCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.setaRegisteredWith = _data["setaRegisteredWith"];
            this.legalName = _data["legalName"];
            this.tradingName = _data["tradingName"];
            this.registrationNumber = _data["registrationNumber"];
            this.sdlNumber = _data["sdlNumber"];
            this.telNumber = _data["telNumber"];
            this.faxNumber = _data["faxNumber"];
            this.email = _data["email"];
            this.businessAddress = _data["businessAddress"] ? CreateEmployerBusinessAddress.fromJS(_data["businessAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? CreateEmployerPostalAddress.fromJS(_data["postalAddress"]) : <any>undefined;
            if (Array.isArray(_data["contactPersons"])) {
                this.contactPersons = [] as any;
                for (let item of _data["contactPersons"])
                    this.contactPersons!.push(CreateContactPerson.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CreateEmployerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployerCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setaRegisteredWith"] = this.setaRegisteredWith;
        data["legalName"] = this.legalName;
        data["tradingName"] = this.tradingName;
        data["registrationNumber"] = this.registrationNumber;
        data["sdlNumber"] = this.sdlNumber;
        data["telNumber"] = this.telNumber;
        data["faxNumber"] = this.faxNumber;
        data["email"] = this.email;
        data["businessAddress"] = this.businessAddress ? this.businessAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.contactPersons)) {
            data["contactPersons"] = [];
            for (let item of this.contactPersons)
                data["contactPersons"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateEmployerCommand extends ICreateActiveEmployer {
    setaRegisteredWith?: SETATypes | undefined;
    legalName?: string | undefined;
    tradingName?: string | undefined;
    registrationNumber?: string | undefined;
    sdlNumber?: string | undefined;
    telNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    businessAddress?: CreateEmployerBusinessAddress | undefined;
    postalAddress?: CreateEmployerPostalAddress | undefined;
    contactPersons?: CreateContactPerson[] | undefined;
}

export abstract class CreateEmployerAddressDetails extends CreateActiveEmployer implements ICreateEmployerAddressDetails {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;

    constructor(data?: ICreateEmployerAddressDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.street = _data["street"];
            this.unit = _data["unit"];
            this.complex = _data["complex"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
        }
    }

    static override fromJS(data: any): CreateEmployerAddressDetails {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateEmployerAddressDetails' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["unit"] = this.unit;
        data["complex"] = this.complex;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateEmployerAddressDetails extends ICreateActiveEmployer {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
}

export class CreateEmployerBusinessAddress extends CreateEmployerAddressDetails implements ICreateEmployerBusinessAddress {
    sameAsPostal?: boolean;

    constructor(data?: ICreateEmployerBusinessAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sameAsPostal = _data["sameAsPostal"];
        }
    }

    static override fromJS(data: any): CreateEmployerBusinessAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployerBusinessAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sameAsPostal"] = this.sameAsPostal;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateEmployerBusinessAddress extends ICreateEmployerAddressDetails {
    sameAsPostal?: boolean;
}

export class CreateEmployerPostalAddress extends CreateEmployerAddressDetails implements ICreateEmployerPostalAddress {

    constructor(data?: ICreateEmployerPostalAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateEmployerPostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployerPostalAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateEmployerPostalAddress extends ICreateEmployerAddressDetails {
}

export class CreateContactPerson extends CreateActiveEmployer implements ICreateContactPerson {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICreateContactPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.cellNumber = _data["cellNumber"];
            this.email = _data["email"];
        }
    }

    static override fromJS(data: any): CreateContactPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactPerson();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["cellNumber"] = this.cellNumber;
        data["email"] = this.email;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateContactPerson extends ICreateActiveEmployer {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
}

export class CreateProductCommand implements ICreateProductCommand {
    name?: string | undefined;
    barcode?: string | undefined;
    description?: string | undefined;
    rate?: number;

    constructor(data?: ICreateProductCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.barcode = _data["barcode"];
            this.description = _data["description"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): CreateProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["barcode"] = this.barcode;
        data["description"] = this.description;
        data["rate"] = this.rate;
        return data;
    }
}

export interface ICreateProductCommand {
    name?: string | undefined;
    barcode?: string | undefined;
    description?: string | undefined;
    rate?: number;
}

export class UpdateProductCommand implements IUpdateProductCommand {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    rate?: number;

    constructor(data?: IUpdateProductCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): UpdateProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IUpdateProductCommand {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    rate?: number;
}

export class ResponseOfIEnumerableOfGetAllLearnershipsViewModel implements IResponseOfIEnumerableOfGetAllLearnershipsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetAllLearnershipsViewModel[] | undefined;

    constructor(data?: IResponseOfIEnumerableOfGetAllLearnershipsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetAllLearnershipsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfIEnumerableOfGetAllLearnershipsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIEnumerableOfGetAllLearnershipsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfIEnumerableOfGetAllLearnershipsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetAllLearnershipsViewModel[] | undefined;
}

export class GetAllLearnershipsViewModel implements IGetAllLearnershipsViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    contractNumber?: string | undefined;
    accreditedProvider?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    credits?: number;
    qualificationId?: number;
    groups?: GetAllLearnershipsGroupsViewModel[] | undefined;

    constructor(data?: IGetAllLearnershipsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.contractNumber = _data["contractNumber"];
            this.accreditedProvider = _data["accreditedProvider"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.credits = _data["credits"];
            this.qualificationId = _data["qualificationId"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GetAllLearnershipsGroupsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllLearnershipsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllLearnershipsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["contractNumber"] = this.contractNumber;
        data["accreditedProvider"] = this.accreditedProvider;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["credits"] = this.credits;
        data["qualificationId"] = this.qualificationId;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllLearnershipsViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    contractNumber?: string | undefined;
    accreditedProvider?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    credits?: number;
    qualificationId?: number;
    groups?: GetAllLearnershipsGroupsViewModel[] | undefined;
}

export class GetAllLearnershipsGroupsViewModel implements IGetAllLearnershipsGroupsViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    name?: string | undefined;
    capacity?: number;

    constructor(data?: IGetAllLearnershipsGroupsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.capacity = _data["capacity"];
        }
    }

    static fromJS(data: any): GetAllLearnershipsGroupsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllLearnershipsGroupsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["capacity"] = this.capacity;
        return data;
    }
}

export interface IGetAllLearnershipsGroupsViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    name?: string | undefined;
    capacity?: number;
}

export class ResponseOfLearnershipDto implements IResponseOfLearnershipDto {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: LearnershipDto | undefined;

    constructor(data?: IResponseOfLearnershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? LearnershipDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseOfLearnershipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLearnershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseOfLearnershipDto {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: LearnershipDto | undefined;
}

export class LearnershipDto implements ILearnershipDto {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    contractNumber?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    accreditedProviderId?: number;
    credits?: number;
    qualificationId?: number;
    groupCount?: number;
    chatRoomName?: string | undefined;

    constructor(data?: ILearnershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.contractNumber = _data["contractNumber"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.accreditedProviderId = _data["accreditedProviderId"];
            this.credits = _data["credits"];
            this.qualificationId = _data["qualificationId"];
            this.groupCount = _data["groupCount"];
            this.chatRoomName = _data["chatRoomName"];
        }
    }

    static fromJS(data: any): LearnershipDto {
        data = typeof data === 'object' ? data : {};
        let result = new LearnershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["contractNumber"] = this.contractNumber;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["accreditedProviderId"] = this.accreditedProviderId;
        data["credits"] = this.credits;
        data["qualificationId"] = this.qualificationId;
        data["groupCount"] = this.groupCount;
        data["chatRoomName"] = this.chatRoomName;
        return data;
    }
}

export interface ILearnershipDto {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    contractNumber?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    accreditedProviderId?: number;
    credits?: number;
    qualificationId?: number;
    groupCount?: number;
    chatRoomName?: string | undefined;
}

export class PaginationResponseOfLearnershipDto implements IPaginationResponseOfLearnershipDto {
    data?: LearnershipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfLearnershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LearnershipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfLearnershipDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfLearnershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfLearnershipDto {
    data?: LearnershipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class BaseFilter implements IBaseFilter {
    advancedSearch?: Search | undefined;
    keyword?: string | undefined;
    advancedFilter?: Filter | undefined;

    constructor(data?: IBaseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advancedSearch = _data["advancedSearch"] ? Search.fromJS(_data["advancedSearch"]) : <any>undefined;
            this.keyword = _data["keyword"];
            this.advancedFilter = _data["advancedFilter"] ? Filter.fromJS(_data["advancedFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new BaseFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advancedSearch"] = this.advancedSearch ? this.advancedSearch.toJSON() : <any>undefined;
        data["keyword"] = this.keyword;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseFilter {
    advancedSearch?: Search | undefined;
    keyword?: string | undefined;
    advancedFilter?: Filter | undefined;
}

export class PaginationFilter extends BaseFilter implements IPaginationFilter {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string[] | undefined;

    constructor(data?: IPaginationFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(item);
            }
        }
    }

    static override fromJS(data: any): PaginationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginationFilter extends IBaseFilter {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string[] | undefined;
}

export class SearchLearnershipsRequest extends PaginationFilter implements ISearchLearnershipsRequest {
    isActive?: string[] | undefined;

    constructor(data?: ISearchLearnershipsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["isActive"])) {
                this.isActive = [] as any;
                for (let item of _data["isActive"])
                    this.isActive!.push(item);
            }
        }
    }

    static override fromJS(data: any): SearchLearnershipsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLearnershipsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.isActive)) {
            data["isActive"] = [];
            for (let item of this.isActive)
                data["isActive"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchLearnershipsRequest extends IPaginationFilter {
    isActive?: string[] | undefined;
}

export class Search implements ISearch {
    fields?: string[] | undefined;
    keyword?: string | undefined;

    constructor(data?: ISearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): Search {
        data = typeof data === 'object' ? data : {};
        let result = new Search();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        data["keyword"] = this.keyword;
        return data;
    }
}

export interface ISearch {
    fields?: string[] | undefined;
    keyword?: string | undefined;
}

export class Filter implements IFilter {
    logic?: string | undefined;
    filters?: Filter[] | undefined;
    field?: string | undefined;
    operator?: string | undefined;
    value?: any | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logic = _data["logic"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logic"] = this.logic;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data;
    }
}

export interface IFilter {
    logic?: string | undefined;
    filters?: Filter[] | undefined;
    field?: string | undefined;
    operator?: string | undefined;
    value?: any | undefined;
}

export abstract class CreateActiveLearnership implements ICreateActiveLearnership {
    active?: boolean;

    constructor(data?: ICreateActiveLearnership) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CreateActiveLearnership {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateActiveLearnership' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        return data;
    }
}

export interface ICreateActiveLearnership {
    active?: boolean;
}

export class CreateLearnershipCommand extends CreateActiveLearnership implements ICreateLearnershipCommand {
    qualificationId?: number;
    name?: string | undefined;
    contractNumber?: string | undefined;
    credits?: number;
    accreditedProviderId?: number;
    startDate?: Date;
    endDate?: Date;
    customElectiveIds?: number[] | undefined;
    staff?: CreateLearnershipStaffMember[] | undefined;
    groups?: CreateLearnershipGroup[] | undefined;
    isDev?: boolean;

    constructor(data?: ICreateLearnershipCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.name = _data["name"];
            this.contractNumber = _data["contractNumber"];
            this.credits = _data["credits"];
            this.accreditedProviderId = _data["accreditedProviderId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["customElectiveIds"])) {
                this.customElectiveIds = [] as any;
                for (let item of _data["customElectiveIds"])
                    this.customElectiveIds!.push(item);
            }
            if (Array.isArray(_data["staff"])) {
                this.staff = [] as any;
                for (let item of _data["staff"])
                    this.staff!.push(CreateLearnershipStaffMember.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(CreateLearnershipGroup.fromJS(item));
            }
            this.isDev = _data["isDev"];
        }
    }

    static override fromJS(data: any): CreateLearnershipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLearnershipCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["name"] = this.name;
        data["contractNumber"] = this.contractNumber;
        data["credits"] = this.credits;
        data["accreditedProviderId"] = this.accreditedProviderId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.customElectiveIds)) {
            data["customElectiveIds"] = [];
            for (let item of this.customElectiveIds)
                data["customElectiveIds"].push(item);
        }
        if (Array.isArray(this.staff)) {
            data["staff"] = [];
            for (let item of this.staff)
                data["staff"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["isDev"] = this.isDev;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateLearnershipCommand extends ICreateActiveLearnership {
    qualificationId?: number;
    name?: string | undefined;
    contractNumber?: string | undefined;
    credits?: number;
    accreditedProviderId?: number;
    startDate?: Date;
    endDate?: Date;
    customElectiveIds?: number[] | undefined;
    staff?: CreateLearnershipStaffMember[] | undefined;
    groups?: CreateLearnershipGroup[] | undefined;
    isDev?: boolean;
}

export class CreateLearnershipStaffMember implements ICreateLearnershipStaffMember {
    lead?: boolean;
    staffId?: number;
    learnershipRole?: LearnershipStaffRoles;

    constructor(data?: ICreateLearnershipStaffMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lead = _data["lead"];
            this.staffId = _data["staffId"];
            this.learnershipRole = _data["learnershipRole"];
        }
    }

    static fromJS(data: any): CreateLearnershipStaffMember {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLearnershipStaffMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lead"] = this.lead;
        data["staffId"] = this.staffId;
        data["learnershipRole"] = this.learnershipRole;
        return data;
    }
}

export interface ICreateLearnershipStaffMember {
    lead?: boolean;
    staffId?: number;
    learnershipRole?: LearnershipStaffRoles;
}

export class CreateLearnershipGroup implements ICreateLearnershipGroup {
    name?: string | undefined;
    capacity?: number;
    leadEmployerId?: number;
    hostEmployerId?: number | undefined;

    constructor(data?: ICreateLearnershipGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.capacity = _data["capacity"];
            this.leadEmployerId = _data["leadEmployerId"];
            this.hostEmployerId = _data["hostEmployerId"];
        }
    }

    static fromJS(data: any): CreateLearnershipGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLearnershipGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["capacity"] = this.capacity;
        data["leadEmployerId"] = this.leadEmployerId;
        data["hostEmployerId"] = this.hostEmployerId;
        return data;
    }
}

export interface ICreateLearnershipGroup {
    name?: string | undefined;
    capacity?: number;
    leadEmployerId?: number;
    hostEmployerId?: number | undefined;
}

export class CreateLearnershipAttendanceRegisterCommand implements ICreateLearnershipAttendanceRegisterCommand {
    learnershipId?: number;
    learnershipGroupIds?: number[] | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: ICreateLearnershipAttendanceRegisterCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipId = _data["learnershipId"];
            if (Array.isArray(_data["learnershipGroupIds"])) {
                this.learnershipGroupIds = [] as any;
                for (let item of _data["learnershipGroupIds"])
                    this.learnershipGroupIds!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateLearnershipAttendanceRegisterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLearnershipAttendanceRegisterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        if (Array.isArray(this.learnershipGroupIds)) {
            data["learnershipGroupIds"] = [];
            for (let item of this.learnershipGroupIds)
                data["learnershipGroupIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateLearnershipAttendanceRegisterCommand {
    learnershipId?: number;
    learnershipGroupIds?: number[] | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class CreateLearnershipAttendanceRegisterFileCommand implements ICreateLearnershipAttendanceRegisterFileCommand {
    learnershipAttendanceRegisterId?: number;
    attendanceRegisterFile?: CreateDocumentDTO | undefined;

    constructor(data?: ICreateLearnershipAttendanceRegisterFileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipAttendanceRegisterId = _data["learnershipAttendanceRegisterId"];
            this.attendanceRegisterFile = _data["attendanceRegisterFile"] ? CreateDocumentDTO.fromJS(_data["attendanceRegisterFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateLearnershipAttendanceRegisterFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLearnershipAttendanceRegisterFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipAttendanceRegisterId"] = this.learnershipAttendanceRegisterId;
        data["attendanceRegisterFile"] = this.attendanceRegisterFile ? this.attendanceRegisterFile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateLearnershipAttendanceRegisterFileCommand {
    learnershipAttendanceRegisterId?: number;
    attendanceRegisterFile?: CreateDocumentDTO | undefined;
}

export class AddCandidatesToLearnershipCommand implements IAddCandidatesToLearnershipCommand {
    requestOrigin?: string | undefined;
    learnershipId?: number;
    learnershipGroupId?: number;
    candidateIds?: number[] | undefined;

    constructor(data?: IAddCandidatesToLearnershipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestOrigin = _data["requestOrigin"];
            this.learnershipId = _data["learnershipId"];
            this.learnershipGroupId = _data["learnershipGroupId"];
            if (Array.isArray(_data["candidateIds"])) {
                this.candidateIds = [] as any;
                for (let item of _data["candidateIds"])
                    this.candidateIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddCandidatesToLearnershipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCandidatesToLearnershipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestOrigin"] = this.requestOrigin;
        data["learnershipId"] = this.learnershipId;
        data["learnershipGroupId"] = this.learnershipGroupId;
        if (Array.isArray(this.candidateIds)) {
            data["candidateIds"] = [];
            for (let item of this.candidateIds)
                data["candidateIds"].push(item);
        }
        return data;
    }
}

export interface IAddCandidatesToLearnershipCommand {
    requestOrigin?: string | undefined;
    learnershipId?: number;
    learnershipGroupId?: number;
    candidateIds?: number[] | undefined;
}

export class EndLearnershipCommand implements IEndLearnershipCommand {
    learnershipId?: number;
    force?: boolean;

    constructor(data?: IEndLearnershipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipId = _data["learnershipId"];
            this.force = _data["force"];
        }
    }

    static fromJS(data: any): EndLearnershipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EndLearnershipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        data["force"] = this.force;
        return data;
    }
}

export interface IEndLearnershipCommand {
    learnershipId?: number;
    force?: boolean;
}

export class RemoveStudentFromLearnershipCommand implements IRemoveStudentFromLearnershipCommand {
    learnershipId?: number;
    studentId?: number;
    reasonLeft?: string | undefined;
    dateLeft?: Date;

    constructor(data?: IRemoveStudentFromLearnershipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipId = _data["learnershipId"];
            this.studentId = _data["studentId"];
            this.reasonLeft = _data["reasonLeft"];
            this.dateLeft = _data["dateLeft"] ? new Date(_data["dateLeft"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoveStudentFromLearnershipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveStudentFromLearnershipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        data["studentId"] = this.studentId;
        data["reasonLeft"] = this.reasonLeft;
        data["dateLeft"] = this.dateLeft ? this.dateLeft.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRemoveStudentFromLearnershipCommand {
    learnershipId?: number;
    studentId?: number;
    reasonLeft?: string | undefined;
    dateLeft?: Date;
}

export class RemoveStaffMemberFromLearnershipCommand implements IRemoveStaffMemberFromLearnershipCommand {
    learnershipId?: number;
    staffId?: number;
    reasonLeft?: string | undefined;
    dateLeft?: Date;
    role?: LearnershipStaffRoles;
    isLead?: boolean;

    constructor(data?: IRemoveStaffMemberFromLearnershipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipId = _data["learnershipId"];
            this.staffId = _data["staffId"];
            this.reasonLeft = _data["reasonLeft"];
            this.dateLeft = _data["dateLeft"] ? new Date(_data["dateLeft"].toString()) : <any>undefined;
            this.role = _data["role"];
            this.isLead = _data["isLead"];
        }
    }

    static fromJS(data: any): RemoveStaffMemberFromLearnershipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveStaffMemberFromLearnershipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        data["staffId"] = this.staffId;
        data["reasonLeft"] = this.reasonLeft;
        data["dateLeft"] = this.dateLeft ? this.dateLeft.toISOString() : <any>undefined;
        data["role"] = this.role;
        data["isLead"] = this.isLead;
        return data;
    }
}

export interface IRemoveStaffMemberFromLearnershipCommand {
    learnershipId?: number;
    staffId?: number;
    reasonLeft?: string | undefined;
    dateLeft?: Date;
    role?: LearnershipStaffRoles;
    isLead?: boolean;
}

export class AssignStaffToLearnershipCommand implements IAssignStaffToLearnershipCommand {
    learnershipId?: number;
    staffAssigments?: StaffLearnershipAssignments[] | undefined;

    constructor(data?: IAssignStaffToLearnershipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipId = _data["learnershipId"];
            if (Array.isArray(_data["staffAssigments"])) {
                this.staffAssigments = [] as any;
                for (let item of _data["staffAssigments"])
                    this.staffAssigments!.push(StaffLearnershipAssignments.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignStaffToLearnershipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignStaffToLearnershipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        if (Array.isArray(this.staffAssigments)) {
            data["staffAssigments"] = [];
            for (let item of this.staffAssigments)
                data["staffAssigments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignStaffToLearnershipCommand {
    learnershipId?: number;
    staffAssigments?: StaffLearnershipAssignments[] | undefined;
}

export class StaffLearnershipAssignments implements IStaffLearnershipAssignments {
    lead?: boolean;
    staffId?: number;
    learnershipRole?: LearnershipStaffRoles;

    constructor(data?: IStaffLearnershipAssignments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lead = _data["lead"];
            this.staffId = _data["staffId"];
            this.learnershipRole = _data["learnershipRole"];
        }
    }

    static fromJS(data: any): StaffLearnershipAssignments {
        data = typeof data === 'object' ? data : {};
        let result = new StaffLearnershipAssignments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lead"] = this.lead;
        data["staffId"] = this.staffId;
        data["learnershipRole"] = this.learnershipRole;
        return data;
    }
}

export interface IStaffLearnershipAssignments {
    lead?: boolean;
    staffId?: number;
    learnershipRole?: LearnershipStaffRoles;
}

export class ReinstateStudentIntoLearnershipCommand implements IReinstateStudentIntoLearnershipCommand {
    learnershipId?: number;
    studentId?: number;

    constructor(data?: IReinstateStudentIntoLearnershipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipId = _data["learnershipId"];
            this.studentId = _data["studentId"];
        }
    }

    static fromJS(data: any): ReinstateStudentIntoLearnershipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReinstateStudentIntoLearnershipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        data["studentId"] = this.studentId;
        return data;
    }
}

export interface IReinstateStudentIntoLearnershipCommand {
    learnershipId?: number;
    studentId?: number;
}

export class UpdateLearnershipAttendanceRegisterItemStatusCommand implements IUpdateLearnershipAttendanceRegisterItemStatusCommand {
    attendanceRegisterItemId?: number;
    statusType?: AttendanceTypes;

    constructor(data?: IUpdateLearnershipAttendanceRegisterItemStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceRegisterItemId = _data["attendanceRegisterItemId"];
            this.statusType = _data["statusType"];
        }
    }

    static fromJS(data: any): UpdateLearnershipAttendanceRegisterItemStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLearnershipAttendanceRegisterItemStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceRegisterItemId"] = this.attendanceRegisterItemId;
        data["statusType"] = this.statusType;
        return data;
    }
}

export interface IUpdateLearnershipAttendanceRegisterItemStatusCommand {
    attendanceRegisterItemId?: number;
    statusType?: AttendanceTypes;
}

export class UpdateLearnershipCommand implements IUpdateLearnershipCommand {
    id?: number;
    name?: string | undefined;
    contractNumber?: string | undefined;
    credits?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    customElectives?: number[] | undefined;

    constructor(data?: IUpdateLearnershipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.contractNumber = _data["contractNumber"];
            this.credits = _data["credits"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["customElectives"])) {
                this.customElectives = [] as any;
                for (let item of _data["customElectives"])
                    this.customElectives!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateLearnershipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLearnershipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["contractNumber"] = this.contractNumber;
        data["credits"] = this.credits;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.customElectives)) {
            data["customElectives"] = [];
            for (let item of this.customElectives)
                data["customElectives"].push(item);
        }
        return data;
    }
}

export interface IUpdateLearnershipCommand {
    id?: number;
    name?: string | undefined;
    contractNumber?: string | undefined;
    credits?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    customElectives?: number[] | undefined;
}

export class ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel implements IResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetCurrentStudentsLearnershipsViewModel[] | undefined;

    constructor(data?: IResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetCurrentStudentsLearnershipsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfGetCurrentStudentsLearnershipsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetCurrentStudentsLearnershipsViewModel[] | undefined;
}

export class GetCurrentStudentsLearnershipsViewModel implements IGetCurrentStudentsLearnershipsViewModel {
    current?: boolean;
    studentLearnershipId?: number;
    learnershipId?: number;
    studentId?: number;
    learnershipName?: string | undefined;
    start?: Date;
    end?: Date;
    isDev?: boolean;

    constructor(data?: IGetCurrentStudentsLearnershipsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current = _data["current"];
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.learnershipId = _data["learnershipId"];
            this.studentId = _data["studentId"];
            this.learnershipName = _data["learnershipName"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.isDev = _data["isDev"];
        }
    }

    static fromJS(data: any): GetCurrentStudentsLearnershipsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentStudentsLearnershipsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["learnershipId"] = this.learnershipId;
        data["studentId"] = this.studentId;
        data["learnershipName"] = this.learnershipName;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["isDev"] = this.isDev;
        return data;
    }
}

export interface IGetCurrentStudentsLearnershipsViewModel {
    current?: boolean;
    studentLearnershipId?: number;
    learnershipId?: number;
    studentId?: number;
    learnershipName?: string | undefined;
    start?: Date;
    end?: Date;
    isDev?: boolean;
}

export class ResponseOfICollectionOfSearchActivitiesViewModel implements IResponseOfICollectionOfSearchActivitiesViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: SearchActivitiesViewModel[] | undefined;

    constructor(data?: IResponseOfICollectionOfSearchActivitiesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SearchActivitiesViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfSearchActivitiesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfSearchActivitiesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfSearchActivitiesViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: SearchActivitiesViewModel[] | undefined;
}

export class SearchActivitiesViewModel implements ISearchActivitiesViewModel {
    id?: number;
    poeFolder?: POEFolders;
    activityName?: string | undefined;
    total?: number;
    fileName?: string | undefined;
    isSelected?: boolean;
    poeGroupName?: string | undefined;

    constructor(data?: ISearchActivitiesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.poeFolder = _data["poeFolder"];
            this.activityName = _data["activityName"];
            this.total = _data["total"];
            this.fileName = _data["fileName"];
            this.isSelected = _data["isSelected"];
            this.poeGroupName = _data["poeGroupName"];
        }
    }

    static fromJS(data: any): SearchActivitiesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchActivitiesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["poeFolder"] = this.poeFolder;
        data["activityName"] = this.activityName;
        data["total"] = this.total;
        data["fileName"] = this.fileName;
        data["isSelected"] = this.isSelected;
        data["poeGroupName"] = this.poeGroupName;
        return data;
    }
}

export interface ISearchActivitiesViewModel {
    id?: number;
    poeFolder?: POEFolders;
    activityName?: string | undefined;
    total?: number;
    fileName?: string | undefined;
    isSelected?: boolean;
    poeGroupName?: string | undefined;
}

export class SearchActivitiesRequest implements ISearchActivitiesRequest {
    qualPoeId?: number;

    constructor(data?: ISearchActivitiesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualPoeId = _data["qualPoeId"];
        }
    }

    static fromJS(data: any): SearchActivitiesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchActivitiesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualPoeId"] = this.qualPoeId;
        return data;
    }
}

export interface ISearchActivitiesRequest {
    qualPoeId?: number;
}

export class ResponseOfICollectionOfPoeActivityDto implements IResponseOfICollectionOfPoeActivityDto {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: PoeActivityDto[] | undefined;

    constructor(data?: IResponseOfICollectionOfPoeActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PoeActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfPoeActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfPoeActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfPoeActivityDto {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: PoeActivityDto[] | undefined;
}

export class PoeActivityDto implements IPoeActivityDto {
    id?: number;
    name?: string | undefined;
    poeDocId?: number;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: PoeQuestionDto[] | undefined;
    poeFolder?: POEFolders;

    constructor(data?: IPoeActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.poeDocId = _data["poeDocId"];
            this.totalInputId = _data["totalInputId"];
            this.total = _data["total"];
            if (Array.isArray(_data["activityQuestions"])) {
                this.activityQuestions = [] as any;
                for (let item of _data["activityQuestions"])
                    this.activityQuestions!.push(PoeQuestionDto.fromJS(item));
            }
            this.poeFolder = _data["poeFolder"];
        }
    }

    static fromJS(data: any): PoeActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoeActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["poeDocId"] = this.poeDocId;
        data["totalInputId"] = this.totalInputId;
        data["total"] = this.total;
        if (Array.isArray(this.activityQuestions)) {
            data["activityQuestions"] = [];
            for (let item of this.activityQuestions)
                data["activityQuestions"].push(item.toJSON());
        }
        data["poeFolder"] = this.poeFolder;
        return data;
    }
}

export interface IPoeActivityDto {
    id?: number;
    name?: string | undefined;
    poeDocId?: number;
    totalInputId?: number | undefined;
    total?: number;
    activityQuestions?: PoeQuestionDto[] | undefined;
    poeFolder?: POEFolders;
}

export class PoeQuestionDto implements IPoeQuestionDto {
    id?: number;
    page?: number;
    height?: number;
    width?: number;
    left?: number;
    top?: number;
    heightPercentage?: number;
    widthPercentage?: number;
    xPercentage?: number;
    yPercentage?: number;
    questionText?: string | undefined;
    multiSelect?: boolean;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    activityName?: string | undefined;
    type?: ActivityQuestionTypes;
    hasValidLocation?: boolean;
    potentialAnswers?: PoeAnswerDto[] | undefined;
    maxAttempts?: number;
    selectedAnswerId?: number | undefined;
    studentsParagraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
    activityStatus?: ActivityStatus;
    currentUserOwnsQuestion?: boolean;

    constructor(data?: IPoeQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.page = _data["page"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.left = _data["left"];
            this.top = _data["top"];
            this.heightPercentage = _data["heightPercentage"];
            this.widthPercentage = _data["widthPercentage"];
            this.xPercentage = _data["xPercentage"];
            this.yPercentage = _data["yPercentage"];
            this.questionText = _data["questionText"];
            this.multiSelect = _data["multiSelect"];
            this.marks = _data["marks"];
            this.image = _data["image"];
            this.activityId = _data["activityId"];
            this.activityName = _data["activityName"];
            this.type = _data["type"];
            this.hasValidLocation = _data["hasValidLocation"];
            if (Array.isArray(_data["potentialAnswers"])) {
                this.potentialAnswers = [] as any;
                for (let item of _data["potentialAnswers"])
                    this.potentialAnswers!.push(PoeAnswerDto.fromJS(item));
            }
            this.maxAttempts = _data["maxAttempts"];
            this.selectedAnswerId = _data["selectedAnswerId"];
            this.studentsParagraphAnswer = _data["studentsParagraphAnswer"];
            this.paragraphMarks = _data["paragraphMarks"];
            this.activityStatus = _data["activityStatus"];
            this.currentUserOwnsQuestion = _data["currentUserOwnsQuestion"];
        }
    }

    static fromJS(data: any): PoeQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoeQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["page"] = this.page;
        data["height"] = this.height;
        data["width"] = this.width;
        data["left"] = this.left;
        data["top"] = this.top;
        data["heightPercentage"] = this.heightPercentage;
        data["widthPercentage"] = this.widthPercentage;
        data["xPercentage"] = this.xPercentage;
        data["yPercentage"] = this.yPercentage;
        data["questionText"] = this.questionText;
        data["multiSelect"] = this.multiSelect;
        data["marks"] = this.marks;
        data["image"] = this.image;
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        data["type"] = this.type;
        data["hasValidLocation"] = this.hasValidLocation;
        if (Array.isArray(this.potentialAnswers)) {
            data["potentialAnswers"] = [];
            for (let item of this.potentialAnswers)
                data["potentialAnswers"].push(item.toJSON());
        }
        data["maxAttempts"] = this.maxAttempts;
        data["selectedAnswerId"] = this.selectedAnswerId;
        data["studentsParagraphAnswer"] = this.studentsParagraphAnswer;
        data["paragraphMarks"] = this.paragraphMarks;
        data["activityStatus"] = this.activityStatus;
        data["currentUserOwnsQuestion"] = this.currentUserOwnsQuestion;
        return data;
    }
}

export interface IPoeQuestionDto {
    id?: number;
    page?: number;
    height?: number;
    width?: number;
    left?: number;
    top?: number;
    heightPercentage?: number;
    widthPercentage?: number;
    xPercentage?: number;
    yPercentage?: number;
    questionText?: string | undefined;
    multiSelect?: boolean;
    marks?: number;
    image?: string | undefined;
    activityId?: number;
    activityName?: string | undefined;
    type?: ActivityQuestionTypes;
    hasValidLocation?: boolean;
    potentialAnswers?: PoeAnswerDto[] | undefined;
    maxAttempts?: number;
    selectedAnswerId?: number | undefined;
    studentsParagraphAnswer?: string | undefined;
    paragraphMarks?: number | undefined;
    activityStatus?: ActivityStatus;
    currentUserOwnsQuestion?: boolean;
}

export class PoeAnswerDto implements IPoeAnswerDto {
    id?: number;
    answerText?: string | undefined;
    marks?: number;
    isCorrect?: boolean;
    isSelected?: boolean;
    questionId?: number;

    constructor(data?: IPoeAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answerText = _data["answerText"];
            this.marks = _data["marks"];
            this.isCorrect = _data["isCorrect"];
            this.isSelected = _data["isSelected"];
            this.questionId = _data["questionId"];
        }
    }

    static fromJS(data: any): PoeAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoeAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answerText"] = this.answerText;
        data["marks"] = this.marks;
        data["isCorrect"] = this.isCorrect;
        data["isSelected"] = this.isSelected;
        data["questionId"] = this.questionId;
        return data;
    }
}

export interface IPoeAnswerDto {
    id?: number;
    answerText?: string | undefined;
    marks?: number;
    isCorrect?: boolean;
    isSelected?: boolean;
    questionId?: number;
}

export enum ActivityStatus {
    NotOpenYet = 0,
    Open = 1,
    Closed = 2,
    Marked = 3,
}

export class GetPoeActivitiesRequest implements IGetPoeActivitiesRequest {
    poeFolder?: POEFolders;
    poeType?: POETypes;
    docId?: number;

    constructor(data?: IGetPoeActivitiesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.poeType = _data["poeType"];
            this.docId = _data["docId"];
        }
    }

    static fromJS(data: any): GetPoeActivitiesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoeActivitiesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["poeType"] = this.poeType;
        data["docId"] = this.docId;
        return data;
    }
}

export interface IGetPoeActivitiesRequest {
    poeFolder?: POEFolders;
    poeType?: POETypes;
    docId?: number;
}

export enum POETypes {
    QualPOE = 0,
    ProgrammePOE = 1,
    StudentPOE = 2,
}

export class GetPoeActivitiesByLearnershipIdRequest implements IGetPoeActivitiesByLearnershipIdRequest {
    learnershipId?: number;

    constructor(data?: IGetPoeActivitiesByLearnershipIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipId = _data["learnershipId"];
        }
    }

    static fromJS(data: any): GetPoeActivitiesByLearnershipIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoeActivitiesByLearnershipIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        return data;
    }
}

export interface IGetPoeActivitiesByLearnershipIdRequest {
    learnershipId?: number;
}

export class ResponseOfICollectionOfPoeActivityWithLearnerStatusDto implements IResponseOfICollectionOfPoeActivityWithLearnerStatusDto {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: PoeActivityWithLearnerStatusDto[] | undefined;

    constructor(data?: IResponseOfICollectionOfPoeActivityWithLearnerStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PoeActivityWithLearnerStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfPoeActivityWithLearnerStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfPoeActivityWithLearnerStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfPoeActivityWithLearnerStatusDto {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: PoeActivityWithLearnerStatusDto[] | undefined;
}

export class PoeActivityWithLearnerStatusDto implements IPoeActivityWithLearnerStatusDto {
    activityId?: number;
    activityName?: string | undefined;
    fileName?: string | undefined;
    questionCount?: number;
    total?: number;
    poeFolder?: POEFolders;
    poeFolderName?: string | undefined;
    poeGroupName?: string | undefined;
    learnerStatuses?: LearnerActivityStatusDto[] | undefined;

    constructor(data?: IPoeActivityWithLearnerStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.activityName = _data["activityName"];
            this.fileName = _data["fileName"];
            this.questionCount = _data["questionCount"];
            this.total = _data["total"];
            this.poeFolder = _data["poeFolder"];
            this.poeFolderName = _data["poeFolderName"];
            this.poeGroupName = _data["poeGroupName"];
            if (Array.isArray(_data["learnerStatuses"])) {
                this.learnerStatuses = [] as any;
                for (let item of _data["learnerStatuses"])
                    this.learnerStatuses!.push(LearnerActivityStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PoeActivityWithLearnerStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoeActivityWithLearnerStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        data["fileName"] = this.fileName;
        data["questionCount"] = this.questionCount;
        data["total"] = this.total;
        data["poeFolder"] = this.poeFolder;
        data["poeFolderName"] = this.poeFolderName;
        data["poeGroupName"] = this.poeGroupName;
        if (Array.isArray(this.learnerStatuses)) {
            data["learnerStatuses"] = [];
            for (let item of this.learnerStatuses)
                data["learnerStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPoeActivityWithLearnerStatusDto {
    activityId?: number;
    activityName?: string | undefined;
    fileName?: string | undefined;
    questionCount?: number;
    total?: number;
    poeFolder?: POEFolders;
    poeFolderName?: string | undefined;
    poeGroupName?: string | undefined;
    learnerStatuses?: LearnerActivityStatusDto[] | undefined;
}

export class LearnerActivityStatusDto implements ILearnerActivityStatusDto {
    id?: number;
    studentLearnershipId?: number;
    studentId?: number;
    activityId?: number;
    learnerName?: string | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number | undefined;

    constructor(data?: ILearnerActivityStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentLearnershipId = _data["studentLearnershipId"];
            this.studentId = _data["studentId"];
            this.activityId = _data["activityId"];
            this.learnerName = _data["learnerName"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.markedOn = _data["markedOn"] ? new Date(_data["markedOn"].toString()) : <any>undefined;
            this.learnerTotal = _data["learnerTotal"];
        }
    }

    static fromJS(data: any): LearnerActivityStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new LearnerActivityStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentLearnershipId"] = this.studentLearnershipId;
        data["studentId"] = this.studentId;
        data["activityId"] = this.activityId;
        data["learnerName"] = this.learnerName;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["markedOn"] = this.markedOn ? this.markedOn.toISOString() : <any>undefined;
        data["learnerTotal"] = this.learnerTotal;
        return data;
    }
}

export interface ILearnerActivityStatusDto {
    id?: number;
    studentLearnershipId?: number;
    studentId?: number;
    activityId?: number;
    learnerName?: string | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    markedOn?: Date | undefined;
    learnerTotal?: number | undefined;
}

export class GetLearnerActivityStatusesByLearnershipIdRequest implements IGetLearnerActivityStatusesByLearnershipIdRequest {
    learnershipId?: number;

    constructor(data?: IGetLearnerActivityStatusesByLearnershipIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnershipId = _data["learnershipId"];
        }
    }

    static fromJS(data: any): GetLearnerActivityStatusesByLearnershipIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLearnerActivityStatusesByLearnershipIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnershipId"] = this.learnershipId;
        return data;
    }
}

export interface IGetLearnerActivityStatusesByLearnershipIdRequest {
    learnershipId?: number;
}

export class OpenAnActivityForAllLearnersRequest implements IOpenAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;

    constructor(data?: IOpenAnActivityForAllLearnersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.activityId = _data["activityId"];
            this.learnershipId = _data["learnershipId"];
        }
    }

    static fromJS(data: any): OpenAnActivityForAllLearnersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OpenAnActivityForAllLearnersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["activityId"] = this.activityId;
        data["learnershipId"] = this.learnershipId;
        return data;
    }
}

export interface IOpenAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;
}

export class ResetAnActivityForAllLearnersRequest implements IResetAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;

    constructor(data?: IResetAnActivityForAllLearnersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.activityId = _data["activityId"];
            this.learnershipId = _data["learnershipId"];
        }
    }

    static fromJS(data: any): ResetAnActivityForAllLearnersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAnActivityForAllLearnersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["activityId"] = this.activityId;
        data["learnershipId"] = this.learnershipId;
        return data;
    }
}

export interface IResetAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;
}

export class ReOpenAnActivityForAllLearnersRequest implements IReOpenAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;

    constructor(data?: IReOpenAnActivityForAllLearnersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.activityId = _data["activityId"];
            this.learnershipId = _data["learnershipId"];
        }
    }

    static fromJS(data: any): ReOpenAnActivityForAllLearnersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReOpenAnActivityForAllLearnersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["activityId"] = this.activityId;
        data["learnershipId"] = this.learnershipId;
        return data;
    }
}

export interface IReOpenAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;
}

export class CloseAnActivityForAllLearnersRequest implements ICloseAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;

    constructor(data?: ICloseAnActivityForAllLearnersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.activityId = _data["activityId"];
            this.learnershipId = _data["learnershipId"];
        }
    }

    static fromJS(data: any): CloseAnActivityForAllLearnersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloseAnActivityForAllLearnersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["activityId"] = this.activityId;
        data["learnershipId"] = this.learnershipId;
        return data;
    }
}

export interface ICloseAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;
}

export class MarkAnActivityForAllLearnersRequest implements IMarkAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;

    constructor(data?: IMarkAnActivityForAllLearnersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.activityId = _data["activityId"];
            this.learnershipId = _data["learnershipId"];
        }
    }

    static fromJS(data: any): MarkAnActivityForAllLearnersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAnActivityForAllLearnersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["activityId"] = this.activityId;
        data["learnershipId"] = this.learnershipId;
        return data;
    }
}

export interface IMarkAnActivityForAllLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;
}

export class OpenAnActivityForALearnerRequest implements IOpenAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;

    constructor(data?: IOpenAnActivityForALearnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.studentActivityStatusId = _data["studentActivityStatusId"];
        }
    }

    static fromJS(data: any): OpenAnActivityForALearnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OpenAnActivityForALearnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["studentActivityStatusId"] = this.studentActivityStatusId;
        return data;
    }
}

export interface IOpenAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;
}

export class ResetAnActivityForALearnerRequest implements IResetAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;

    constructor(data?: IResetAnActivityForALearnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.studentActivityStatusId = _data["studentActivityStatusId"];
        }
    }

    static fromJS(data: any): ResetAnActivityForALearnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAnActivityForALearnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["studentActivityStatusId"] = this.studentActivityStatusId;
        return data;
    }
}

export interface IResetAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;
}

export class ReOpenAnActivityForALearnerRequest implements IReOpenAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;

    constructor(data?: IReOpenAnActivityForALearnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.studentActivityStatusId = _data["studentActivityStatusId"];
        }
    }

    static fromJS(data: any): ReOpenAnActivityForALearnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReOpenAnActivityForALearnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["studentActivityStatusId"] = this.studentActivityStatusId;
        return data;
    }
}

export interface IReOpenAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;
}

export class CloseAnActivityForALearnerRequest implements ICloseAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;

    constructor(data?: ICloseAnActivityForALearnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.studentActivityStatusId = _data["studentActivityStatusId"];
        }
    }

    static fromJS(data: any): CloseAnActivityForALearnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloseAnActivityForALearnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["studentActivityStatusId"] = this.studentActivityStatusId;
        return data;
    }
}

export interface ICloseAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;
}

export class ResponseOfDecimal implements IResponseOfDecimal {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: number;

    constructor(data?: IResponseOfDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfDecimal {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: number;
}

export class MarkAnActivityForALearnerRequest implements IMarkAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;

    constructor(data?: IMarkAnActivityForALearnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.studentActivityStatusId = _data["studentActivityStatusId"];
        }
    }

    static fromJS(data: any): MarkAnActivityForALearnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAnActivityForALearnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["studentActivityStatusId"] = this.studentActivityStatusId;
        return data;
    }
}

export interface IMarkAnActivityForALearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;
}

export class CanMarkViewModel implements ICanMarkViewModel {
    canMark?: boolean;
    unMarkedQuestions?: UnMarkedQuestion[] | undefined;

    constructor(data?: ICanMarkViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canMark = _data["canMark"];
            if (Array.isArray(_data["unMarkedQuestions"])) {
                this.unMarkedQuestions = [] as any;
                for (let item of _data["unMarkedQuestions"])
                    this.unMarkedQuestions!.push(UnMarkedQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CanMarkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanMarkViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canMark"] = this.canMark;
        if (Array.isArray(this.unMarkedQuestions)) {
            data["unMarkedQuestions"] = [];
            for (let item of this.unMarkedQuestions)
                data["unMarkedQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICanMarkViewModel {
    canMark?: boolean;
    unMarkedQuestions?: UnMarkedQuestion[] | undefined;
}

export class UnMarkedQuestion implements IUnMarkedQuestion {
    activityName?: string | undefined;
    questionText?: string | undefined;

    constructor(data?: IUnMarkedQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityName = _data["activityName"];
            this.questionText = _data["questionText"];
        }
    }

    static fromJS(data: any): UnMarkedQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new UnMarkedQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityName"] = this.activityName;
        data["questionText"] = this.questionText;
        return data;
    }
}

export interface IUnMarkedQuestion {
    activityName?: string | undefined;
    questionText?: string | undefined;
}

export class CanMarkActivityForLearnerRequest implements ICanMarkActivityForLearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;

    constructor(data?: ICanMarkActivityForLearnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.studentActivityStatusId = _data["studentActivityStatusId"];
        }
    }

    static fromJS(data: any): CanMarkActivityForLearnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CanMarkActivityForLearnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["studentActivityStatusId"] = this.studentActivityStatusId;
        return data;
    }
}

export interface ICanMarkActivityForLearnerRequest {
    poeFolder?: POEFolders;
    studentActivityStatusId?: number;
}

export class CanMarkAllViewModel implements ICanMarkAllViewModel {
    learnerName?: string | undefined;
    canMark?: boolean;
    unMarkedQuestions?: UnMarkedQuestion[] | undefined;

    constructor(data?: ICanMarkAllViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learnerName = _data["learnerName"];
            this.canMark = _data["canMark"];
            if (Array.isArray(_data["unMarkedQuestions"])) {
                this.unMarkedQuestions = [] as any;
                for (let item of _data["unMarkedQuestions"])
                    this.unMarkedQuestions!.push(UnMarkedQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CanMarkAllViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanMarkAllViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["learnerName"] = this.learnerName;
        data["canMark"] = this.canMark;
        if (Array.isArray(this.unMarkedQuestions)) {
            data["unMarkedQuestions"] = [];
            for (let item of this.unMarkedQuestions)
                data["unMarkedQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICanMarkAllViewModel {
    learnerName?: string | undefined;
    canMark?: boolean;
    unMarkedQuestions?: UnMarkedQuestion[] | undefined;
}

export class CanMarkActivityForLearnersRequest implements ICanMarkActivityForLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;

    constructor(data?: ICanMarkActivityForLearnersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.activityId = _data["activityId"];
            this.learnershipId = _data["learnershipId"];
        }
    }

    static fromJS(data: any): CanMarkActivityForLearnersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CanMarkActivityForLearnersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["activityId"] = this.activityId;
        data["learnershipId"] = this.learnershipId;
        return data;
    }
}

export interface ICanMarkActivityForLearnersRequest {
    poeFolder?: POEFolders;
    activityId?: number;
    learnershipId?: number;
}

export class ResponseOfGetQualPOEByQualificationIdViewModel implements IResponseOfGetQualPOEByQualificationIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetQualPOEByQualificationIdViewModel | undefined;

    constructor(data?: IResponseOfGetQualPOEByQualificationIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? GetQualPOEByQualificationIdViewModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseOfGetQualPOEByQualificationIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfGetQualPOEByQualificationIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseOfGetQualPOEByQualificationIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetQualPOEByQualificationIdViewModel | undefined;
}

export class GetQualPOEByQualificationIdViewModel implements IGetQualPOEByQualificationIdViewModel {
    id?: number;
    qualificationId?: number;
    qualificationName?: string | undefined;
    active?: boolean;
    qualificationType?: QualificationType;
    groups?: GetQualPOEByQualificationIdGroupViewModel[] | undefined;
    generalDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    workplaceDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    assessmentGuideDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;

    constructor(data?: IGetQualPOEByQualificationIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationId = _data["qualificationId"];
            this.qualificationName = _data["qualificationName"];
            this.active = _data["active"];
            this.qualificationType = _data["qualificationType"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GetQualPOEByQualificationIdGroupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["generalDocs"])) {
                this.generalDocs = [] as any;
                for (let item of _data["generalDocs"])
                    this.generalDocs!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocs"])) {
                this.workplaceDocs = [] as any;
                for (let item of _data["workplaceDocs"])
                    this.workplaceDocs!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocs"])) {
                this.assessmentGuideDocs = [] as any;
                for (let item of _data["assessmentGuideDocs"])
                    this.assessmentGuideDocs!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQualPOEByQualificationIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualPOEByQualificationIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationId"] = this.qualificationId;
        data["qualificationName"] = this.qualificationName;
        data["active"] = this.active;
        data["qualificationType"] = this.qualificationType;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocs)) {
            data["generalDocs"] = [];
            for (let item of this.generalDocs)
                data["generalDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocs)) {
            data["workplaceDocs"] = [];
            for (let item of this.workplaceDocs)
                data["workplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocs)) {
            data["assessmentGuideDocs"] = [];
            for (let item of this.assessmentGuideDocs)
                data["assessmentGuideDocs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetQualPOEByQualificationIdViewModel {
    id?: number;
    qualificationId?: number;
    qualificationName?: string | undefined;
    active?: boolean;
    qualificationType?: QualificationType;
    groups?: GetQualPOEByQualificationIdGroupViewModel[] | undefined;
    generalDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    workplaceDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    assessmentGuideDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
}

export class GetQualPOEByQualificationIdGroupViewModel implements IGetQualPOEByQualificationIdGroupViewModel {
    id?: number;
    active?: boolean;
    allSaqaDocsAssigned?: boolean;
    name?: string | undefined;
    moduleType?: KnowledgeModuleType | undefined;
    index?: number;
    poeId?: number;
    formativeAssessments?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    summativeAssessments?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    documents?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    saqaDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    unitStandards?: GetQualPOEByQualificationIdgroupUnitStandardsViewModel[] | undefined;

    constructor(data?: IGetQualPOEByQualificationIdGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.allSaqaDocsAssigned = _data["allSaqaDocsAssigned"];
            this.name = _data["name"];
            this.moduleType = _data["moduleType"];
            this.index = _data["index"];
            this.poeId = _data["poeId"];
            if (Array.isArray(_data["formativeAssessments"])) {
                this.formativeAssessments = [] as any;
                for (let item of _data["formativeAssessments"])
                    this.formativeAssessments!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessments"])) {
                this.summativeAssessments = [] as any;
                for (let item of _data["summativeAssessments"])
                    this.summativeAssessments!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocs"])) {
                this.saqaDocs = [] as any;
                for (let item of _data["saqaDocs"])
                    this.saqaDocs!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(GetQualPOEByQualificationIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["unitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["unitStandards"])
                    this.unitStandards!.push(GetQualPOEByQualificationIdgroupUnitStandardsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQualPOEByQualificationIdGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualPOEByQualificationIdGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["allSaqaDocsAssigned"] = this.allSaqaDocsAssigned;
        data["name"] = this.name;
        data["moduleType"] = this.moduleType;
        data["index"] = this.index;
        data["poeId"] = this.poeId;
        if (Array.isArray(this.formativeAssessments)) {
            data["formativeAssessments"] = [];
            for (let item of this.formativeAssessments)
                data["formativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessments)) {
            data["summativeAssessments"] = [];
            for (let item of this.summativeAssessments)
                data["summativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocs)) {
            data["saqaDocs"] = [];
            for (let item of this.saqaDocs)
                data["saqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandards)) {
            data["unitStandards"] = [];
            for (let item of this.unitStandards)
                data["unitStandards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetQualPOEByQualificationIdGroupViewModel {
    id?: number;
    active?: boolean;
    allSaqaDocsAssigned?: boolean;
    name?: string | undefined;
    moduleType?: KnowledgeModuleType | undefined;
    index?: number;
    poeId?: number;
    formativeAssessments?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    summativeAssessments?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    documents?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    saqaDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetQualPOEByQualificationIdDocumentViewModel[] | undefined;
    unitStandards?: GetQualPOEByQualificationIdgroupUnitStandardsViewModel[] | undefined;
}

export class POEDocumentViewModel extends FileEntity implements IPOEDocumentViewModel {
    canBeDeletedByCurrentUser?: boolean;
    parentDocId?: number | undefined;
    poeId?: number | undefined;
    docTypeId?: number | undefined;
    docType?: POEDocumentType | undefined;
    poeGroupId?: number | undefined;
    isCompetencyChecklist?: boolean | undefined;
    isFISA?: boolean | undefined;
    unitStandardId?: number | undefined;

    constructor(data?: IPOEDocumentViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canBeDeletedByCurrentUser = _data["canBeDeletedByCurrentUser"];
            this.parentDocId = _data["parentDocId"];
            this.poeId = _data["poeId"];
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? POEDocumentType.fromJS(_data["docType"]) : <any>undefined;
            this.poeGroupId = _data["poeGroupId"];
            this.isCompetencyChecklist = _data["isCompetencyChecklist"];
            this.isFISA = _data["isFISA"];
            this.unitStandardId = _data["unitStandardId"];
        }
    }

    static override fromJS(data: any): POEDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new POEDocumentViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canBeDeletedByCurrentUser"] = this.canBeDeletedByCurrentUser;
        data["parentDocId"] = this.parentDocId;
        data["poeId"] = this.poeId;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        data["poeGroupId"] = this.poeGroupId;
        data["isCompetencyChecklist"] = this.isCompetencyChecklist;
        data["isFISA"] = this.isFISA;
        data["unitStandardId"] = this.unitStandardId;
        super.toJSON(data);
        return data;
    }
}

export interface IPOEDocumentViewModel extends IFileEntity {
    canBeDeletedByCurrentUser?: boolean;
    parentDocId?: number | undefined;
    poeId?: number | undefined;
    docTypeId?: number | undefined;
    docType?: POEDocumentType | undefined;
    poeGroupId?: number | undefined;
    isCompetencyChecklist?: boolean | undefined;
    isFISA?: boolean | undefined;
    unitStandardId?: number | undefined;
}

export class GetQualPOEByQualificationIdDocumentViewModel extends POEDocumentViewModel implements IGetQualPOEByQualificationIdDocumentViewModel {

    constructor(data?: IGetQualPOEByQualificationIdDocumentViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetQualPOEByQualificationIdDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualPOEByQualificationIdDocumentViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetQualPOEByQualificationIdDocumentViewModel extends IPOEDocumentViewModel {
}

export class GetQualPOEByQualificationIdgroupUnitStandardsViewModel implements IGetQualPOEByQualificationIdgroupUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    unitStandardId?: number;
    qualPOEGroupId?: number;

    constructor(data?: IGetQualPOEByQualificationIdgroupUnitStandardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.unitStandardId = _data["unitStandardId"];
            this.qualPOEGroupId = _data["qualPOEGroupId"];
        }
    }

    static fromJS(data: any): GetQualPOEByQualificationIdgroupUnitStandardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualPOEByQualificationIdgroupUnitStandardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["unitStandardId"] = this.unitStandardId;
        data["qualPOEGroupId"] = this.qualPOEGroupId;
        return data;
    }
}

export interface IGetQualPOEByQualificationIdgroupUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    unitStandardId?: number;
    qualPOEGroupId?: number;
}

export class ResponseOfGetProgrammePOEByProgrammeIdViewModel implements IResponseOfGetProgrammePOEByProgrammeIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetProgrammePOEByProgrammeIdViewModel | undefined;

    constructor(data?: IResponseOfGetProgrammePOEByProgrammeIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? GetProgrammePOEByProgrammeIdViewModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseOfGetProgrammePOEByProgrammeIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfGetProgrammePOEByProgrammeIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseOfGetProgrammePOEByProgrammeIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetProgrammePOEByProgrammeIdViewModel | undefined;
}

export class GetProgrammePOEByProgrammeIdViewModel implements IGetProgrammePOEByProgrammeIdViewModel {
    id?: number;
    qualificationId?: number;
    learnershipId?: number;
    qualPOEId?: number;
    qualificationName?: string | undefined;
    qualificationType?: QualificationType;
    programmeName?: string | undefined;
    active?: boolean;
    groups?: GetProgrammePOEByProgrammeIdGroupViewModel[] | undefined;
    generalDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    workplaceDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    assessmentGuideDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;

    constructor(data?: IGetProgrammePOEByProgrammeIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationId = _data["qualificationId"];
            this.learnershipId = _data["learnershipId"];
            this.qualPOEId = _data["qualPOEId"];
            this.qualificationName = _data["qualificationName"];
            this.qualificationType = _data["qualificationType"];
            this.programmeName = _data["programmeName"];
            this.active = _data["active"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GetProgrammePOEByProgrammeIdGroupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["generalDocs"])) {
                this.generalDocs = [] as any;
                for (let item of _data["generalDocs"])
                    this.generalDocs!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocs"])) {
                this.workplaceDocs = [] as any;
                for (let item of _data["workplaceDocs"])
                    this.workplaceDocs!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocs"])) {
                this.assessmentGuideDocs = [] as any;
                for (let item of _data["assessmentGuideDocs"])
                    this.assessmentGuideDocs!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProgrammePOEByProgrammeIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgrammePOEByProgrammeIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationId"] = this.qualificationId;
        data["learnershipId"] = this.learnershipId;
        data["qualPOEId"] = this.qualPOEId;
        data["qualificationName"] = this.qualificationName;
        data["qualificationType"] = this.qualificationType;
        data["programmeName"] = this.programmeName;
        data["active"] = this.active;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocs)) {
            data["generalDocs"] = [];
            for (let item of this.generalDocs)
                data["generalDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocs)) {
            data["workplaceDocs"] = [];
            for (let item of this.workplaceDocs)
                data["workplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocs)) {
            data["assessmentGuideDocs"] = [];
            for (let item of this.assessmentGuideDocs)
                data["assessmentGuideDocs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProgrammePOEByProgrammeIdViewModel {
    id?: number;
    qualificationId?: number;
    learnershipId?: number;
    qualPOEId?: number;
    qualificationName?: string | undefined;
    qualificationType?: QualificationType;
    programmeName?: string | undefined;
    active?: boolean;
    groups?: GetProgrammePOEByProgrammeIdGroupViewModel[] | undefined;
    generalDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    workplaceDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    assessmentGuideDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
}

export class GetProgrammePOEByProgrammeIdGroupViewModel implements IGetProgrammePOEByProgrammeIdGroupViewModel {
    id?: number;
    parentGroupId?: number;
    active?: boolean;
    moduleType?: KnowledgeModuleType | undefined;
    name?: string | undefined;
    index?: number;
    poeId?: number;
    formativeAssessments?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    summativeAssessments?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    documents?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    saqaDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    unitStandards?: GetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel[] | undefined;

    constructor(data?: IGetProgrammePOEByProgrammeIdGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentGroupId = _data["parentGroupId"];
            this.active = _data["active"];
            this.moduleType = _data["moduleType"];
            this.name = _data["name"];
            this.index = _data["index"];
            this.poeId = _data["poeId"];
            if (Array.isArray(_data["formativeAssessments"])) {
                this.formativeAssessments = [] as any;
                for (let item of _data["formativeAssessments"])
                    this.formativeAssessments!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessments"])) {
                this.summativeAssessments = [] as any;
                for (let item of _data["summativeAssessments"])
                    this.summativeAssessments!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocs"])) {
                this.saqaDocs = [] as any;
                for (let item of _data["saqaDocs"])
                    this.saqaDocs!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(GetProgrammePOEByProgrammeIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["unitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["unitStandards"])
                    this.unitStandards!.push(GetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProgrammePOEByProgrammeIdGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgrammePOEByProgrammeIdGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentGroupId"] = this.parentGroupId;
        data["active"] = this.active;
        data["moduleType"] = this.moduleType;
        data["name"] = this.name;
        data["index"] = this.index;
        data["poeId"] = this.poeId;
        if (Array.isArray(this.formativeAssessments)) {
            data["formativeAssessments"] = [];
            for (let item of this.formativeAssessments)
                data["formativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessments)) {
            data["summativeAssessments"] = [];
            for (let item of this.summativeAssessments)
                data["summativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocs)) {
            data["saqaDocs"] = [];
            for (let item of this.saqaDocs)
                data["saqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandards)) {
            data["unitStandards"] = [];
            for (let item of this.unitStandards)
                data["unitStandards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProgrammePOEByProgrammeIdGroupViewModel {
    id?: number;
    parentGroupId?: number;
    active?: boolean;
    moduleType?: KnowledgeModuleType | undefined;
    name?: string | undefined;
    index?: number;
    poeId?: number;
    formativeAssessments?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    summativeAssessments?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    documents?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    saqaDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetProgrammePOEByProgrammeIdDocumentViewModel[] | undefined;
    unitStandards?: GetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel[] | undefined;
}

export class GetProgrammePOEByProgrammeIdDocumentViewModel extends POEDocumentViewModel implements IGetProgrammePOEByProgrammeIdDocumentViewModel {

    constructor(data?: IGetProgrammePOEByProgrammeIdDocumentViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetProgrammePOEByProgrammeIdDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgrammePOEByProgrammeIdDocumentViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetProgrammePOEByProgrammeIdDocumentViewModel extends IPOEDocumentViewModel {
}

export class GetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel implements IGetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    unitStandardId?: number;
    programmePOEGroupId?: number;

    constructor(data?: IGetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.unitStandardId = _data["unitStandardId"];
            this.programmePOEGroupId = _data["programmePOEGroupId"];
        }
    }

    static fromJS(data: any): GetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["unitStandardId"] = this.unitStandardId;
        data["programmePOEGroupId"] = this.programmePOEGroupId;
        return data;
    }
}

export interface IGetProgrammePOEByProgrammeIdgroupUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    unitStandardId?: number;
    programmePOEGroupId?: number;
}

export class ResponseOfGetStudentPOEByIdViewModel implements IResponseOfGetStudentPOEByIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetStudentPOEByIdViewModel | undefined;

    constructor(data?: IResponseOfGetStudentPOEByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? GetStudentPOEByIdViewModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseOfGetStudentPOEByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfGetStudentPOEByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseOfGetStudentPOEByIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetStudentPOEByIdViewModel | undefined;
}

export class GetStudentPOEByIdViewModel implements IGetStudentPOEByIdViewModel {
    id?: number;
    qualificationId?: number;
    learnershipId?: number;
    studentId?: number;
    programmePOEId?: number;
    qualificationName?: string | undefined;
    qualificationType?: QualificationType;
    programmeName?: string | undefined;
    studentName?: string | undefined;
    studentIdNumber?: string | undefined;
    active?: boolean;
    unlocked?: boolean;
    groups?: GetStudentPOEByIdGroupViewModel[] | undefined;
    scheduleDocs?: GetStudentPOEScheduleByIdViewModel[] | undefined;
    generalDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    workplaceDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    assessmentGuideDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;

    constructor(data?: IGetStudentPOEByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationId = _data["qualificationId"];
            this.learnershipId = _data["learnershipId"];
            this.studentId = _data["studentId"];
            this.programmePOEId = _data["programmePOEId"];
            this.qualificationName = _data["qualificationName"];
            this.qualificationType = _data["qualificationType"];
            this.programmeName = _data["programmeName"];
            this.studentName = _data["studentName"];
            this.studentIdNumber = _data["studentIdNumber"];
            this.active = _data["active"];
            this.unlocked = _data["unlocked"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GetStudentPOEByIdGroupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["scheduleDocs"])) {
                this.scheduleDocs = [] as any;
                for (let item of _data["scheduleDocs"])
                    this.scheduleDocs!.push(GetStudentPOEScheduleByIdViewModel.fromJS(item));
            }
            if (Array.isArray(_data["generalDocs"])) {
                this.generalDocs = [] as any;
                for (let item of _data["generalDocs"])
                    this.generalDocs!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["workplaceDocs"])) {
                this.workplaceDocs = [] as any;
                for (let item of _data["workplaceDocs"])
                    this.workplaceDocs!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["assessmentGuideDocs"])) {
                this.assessmentGuideDocs = [] as any;
                for (let item of _data["assessmentGuideDocs"])
                    this.assessmentGuideDocs!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStudentPOEByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentPOEByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationId"] = this.qualificationId;
        data["learnershipId"] = this.learnershipId;
        data["studentId"] = this.studentId;
        data["programmePOEId"] = this.programmePOEId;
        data["qualificationName"] = this.qualificationName;
        data["qualificationType"] = this.qualificationType;
        data["programmeName"] = this.programmeName;
        data["studentName"] = this.studentName;
        data["studentIdNumber"] = this.studentIdNumber;
        data["active"] = this.active;
        data["unlocked"] = this.unlocked;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.scheduleDocs)) {
            data["scheduleDocs"] = [];
            for (let item of this.scheduleDocs)
                data["scheduleDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.generalDocs)) {
            data["generalDocs"] = [];
            for (let item of this.generalDocs)
                data["generalDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceDocs)) {
            data["workplaceDocs"] = [];
            for (let item of this.workplaceDocs)
                data["workplaceDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentGuideDocs)) {
            data["assessmentGuideDocs"] = [];
            for (let item of this.assessmentGuideDocs)
                data["assessmentGuideDocs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStudentPOEByIdViewModel {
    id?: number;
    qualificationId?: number;
    learnershipId?: number;
    studentId?: number;
    programmePOEId?: number;
    qualificationName?: string | undefined;
    qualificationType?: QualificationType;
    programmeName?: string | undefined;
    studentName?: string | undefined;
    studentIdNumber?: string | undefined;
    active?: boolean;
    unlocked?: boolean;
    groups?: GetStudentPOEByIdGroupViewModel[] | undefined;
    scheduleDocs?: GetStudentPOEScheduleByIdViewModel[] | undefined;
    generalDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    workplaceDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    assessmentGuideDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
}

export class GetStudentPOEByIdGroupViewModel implements IGetStudentPOEByIdGroupViewModel {
    id?: number;
    parentGroupId?: number;
    active?: boolean;
    name?: string | undefined;
    index?: number;
    poeId?: number;
    moduleType?: KnowledgeModuleType | undefined;
    formativeAssessments?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    summativeAssessments?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    documents?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    saqaDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    unitStandards?: GetStudentPOEByIdgroupUnitStandardsViewModel[] | undefined;

    constructor(data?: IGetStudentPOEByIdGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentGroupId = _data["parentGroupId"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.index = _data["index"];
            this.poeId = _data["poeId"];
            this.moduleType = _data["moduleType"];
            if (Array.isArray(_data["formativeAssessments"])) {
                this.formativeAssessments = [] as any;
                for (let item of _data["formativeAssessments"])
                    this.formativeAssessments!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["summativeAssessments"])) {
                this.summativeAssessments = [] as any;
                for (let item of _data["summativeAssessments"])
                    this.summativeAssessments!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["saqaDocs"])) {
                this.saqaDocs = [] as any;
                for (let item of _data["saqaDocs"])
                    this.saqaDocs!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["feedbackDocs"])) {
                this.feedbackDocs = [] as any;
                for (let item of _data["feedbackDocs"])
                    this.feedbackDocs!.push(GetStudentPOEByIdDocumentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["unitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["unitStandards"])
                    this.unitStandards!.push(GetStudentPOEByIdgroupUnitStandardsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStudentPOEByIdGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentPOEByIdGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentGroupId"] = this.parentGroupId;
        data["active"] = this.active;
        data["name"] = this.name;
        data["index"] = this.index;
        data["poeId"] = this.poeId;
        data["moduleType"] = this.moduleType;
        if (Array.isArray(this.formativeAssessments)) {
            data["formativeAssessments"] = [];
            for (let item of this.formativeAssessments)
                data["formativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.summativeAssessments)) {
            data["summativeAssessments"] = [];
            for (let item of this.summativeAssessments)
                data["summativeAssessments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.saqaDocs)) {
            data["saqaDocs"] = [];
            for (let item of this.saqaDocs)
                data["saqaDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbackDocs)) {
            data["feedbackDocs"] = [];
            for (let item of this.feedbackDocs)
                data["feedbackDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandards)) {
            data["unitStandards"] = [];
            for (let item of this.unitStandards)
                data["unitStandards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStudentPOEByIdGroupViewModel {
    id?: number;
    parentGroupId?: number;
    active?: boolean;
    name?: string | undefined;
    index?: number;
    poeId?: number;
    moduleType?: KnowledgeModuleType | undefined;
    formativeAssessments?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    summativeAssessments?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    documents?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    saqaDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    feedbackDocs?: GetStudentPOEByIdDocumentViewModel[] | undefined;
    unitStandards?: GetStudentPOEByIdgroupUnitStandardsViewModel[] | undefined;
}

export class GetStudentPOEByIdDocumentViewModel extends POEDocumentViewModel implements IGetStudentPOEByIdDocumentViewModel {

    constructor(data?: IGetStudentPOEByIdDocumentViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetStudentPOEByIdDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentPOEByIdDocumentViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetStudentPOEByIdDocumentViewModel extends IPOEDocumentViewModel {
}

export class GetStudentPOEByIdgroupUnitStandardsViewModel implements IGetStudentPOEByIdgroupUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    unitStandardId?: number;
    studentPOEGroupId?: number;

    constructor(data?: IGetStudentPOEByIdgroupUnitStandardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.unitStandardId = _data["unitStandardId"];
            this.studentPOEGroupId = _data["studentPOEGroupId"];
        }
    }

    static fromJS(data: any): GetStudentPOEByIdgroupUnitStandardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentPOEByIdgroupUnitStandardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["unitStandardId"] = this.unitStandardId;
        data["studentPOEGroupId"] = this.studentPOEGroupId;
        return data;
    }
}

export interface IGetStudentPOEByIdgroupUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    unitStandardId?: number;
    studentPOEGroupId?: number;
}

export class GetStudentPOEScheduleByIdViewModel implements IGetStudentPOEScheduleByIdViewModel {

    constructor(data?: IGetStudentPOEScheduleByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetStudentPOEScheduleByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentPOEScheduleByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetStudentPOEScheduleByIdViewModel {
}

export class ResponseOfICollectionOfGetPOEInputsViewModel implements IResponseOfICollectionOfGetPOEInputsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetPOEInputsViewModel[] | undefined;

    constructor(data?: IResponseOfICollectionOfGetPOEInputsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetPOEInputsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfGetPOEInputsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfGetPOEInputsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfGetPOEInputsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetPOEInputsViewModel[] | undefined;
}

export class GetPOEInputsViewModel implements IGetPOEInputsViewModel {
    id?: number;
    parentInputId?: number | undefined;
    name?: string | undefined;
    value?: string | undefined;
    inheritedFromQualPOE?: boolean | undefined;
    ownerId?: number;
    height?: number;
    width?: number;
    left?: number;
    top?: number;
    page?: number;
    required?: boolean;
    disabled?: boolean;
    maxLength?: number | undefined;
    type?: InputTypes;
    autoFillType?: AutoFillInputTypes | undefined;
    autoFillInputOwner?: AutoFillInputOwners | undefined;
    editableAtProgrammeLevel?: boolean;
    associatedActivities?: AssociatedActivityDto[] | undefined;
    activityTotalInputFormat?: ActivityTotalInputFormats | undefined;

    constructor(data?: IGetPOEInputsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentInputId = _data["parentInputId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.inheritedFromQualPOE = _data["inheritedFromQualPOE"];
            this.ownerId = _data["ownerId"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.left = _data["left"];
            this.top = _data["top"];
            this.page = _data["page"];
            this.required = _data["required"];
            this.disabled = _data["disabled"];
            this.maxLength = _data["maxLength"];
            this.type = _data["type"];
            this.autoFillType = _data["autoFillType"];
            this.autoFillInputOwner = _data["autoFillInputOwner"];
            this.editableAtProgrammeLevel = _data["editableAtProgrammeLevel"];
            if (Array.isArray(_data["associatedActivities"])) {
                this.associatedActivities = [] as any;
                for (let item of _data["associatedActivities"])
                    this.associatedActivities!.push(AssociatedActivityDto.fromJS(item));
            }
            this.activityTotalInputFormat = _data["activityTotalInputFormat"];
        }
    }

    static fromJS(data: any): GetPOEInputsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPOEInputsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentInputId"] = this.parentInputId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["inheritedFromQualPOE"] = this.inheritedFromQualPOE;
        data["ownerId"] = this.ownerId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["left"] = this.left;
        data["top"] = this.top;
        data["page"] = this.page;
        data["required"] = this.required;
        data["disabled"] = this.disabled;
        data["maxLength"] = this.maxLength;
        data["type"] = this.type;
        data["autoFillType"] = this.autoFillType;
        data["autoFillInputOwner"] = this.autoFillInputOwner;
        data["editableAtProgrammeLevel"] = this.editableAtProgrammeLevel;
        if (Array.isArray(this.associatedActivities)) {
            data["associatedActivities"] = [];
            for (let item of this.associatedActivities)
                data["associatedActivities"].push(item.toJSON());
        }
        data["activityTotalInputFormat"] = this.activityTotalInputFormat;
        return data;
    }
}

export interface IGetPOEInputsViewModel {
    id?: number;
    parentInputId?: number | undefined;
    name?: string | undefined;
    value?: string | undefined;
    inheritedFromQualPOE?: boolean | undefined;
    ownerId?: number;
    height?: number;
    width?: number;
    left?: number;
    top?: number;
    page?: number;
    required?: boolean;
    disabled?: boolean;
    maxLength?: number | undefined;
    type?: InputTypes;
    autoFillType?: AutoFillInputTypes | undefined;
    autoFillInputOwner?: AutoFillInputOwners | undefined;
    editableAtProgrammeLevel?: boolean;
    associatedActivities?: AssociatedActivityDto[] | undefined;
    activityTotalInputFormat?: ActivityTotalInputFormats | undefined;
}

export class AssociatedActivityDto implements IAssociatedActivityDto {
    activityIds?: number[] | undefined;
    poeFolder?: POEFolders;

    constructor(data?: IAssociatedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
            this.poeFolder = _data["poeFolder"];
        }
    }

    static fromJS(data: any): AssociatedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        data["poeFolder"] = this.poeFolder;
        return data;
    }
}

export interface IAssociatedActivityDto {
    activityIds?: number[] | undefined;
    poeFolder?: POEFolders;
}

export class ResponseOfICollectionOfPoeQuestionDto implements IResponseOfICollectionOfPoeQuestionDto {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: PoeQuestionDto[] | undefined;

    constructor(data?: IResponseOfICollectionOfPoeQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PoeQuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfPoeQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfPoeQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfPoeQuestionDto {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: PoeQuestionDto[] | undefined;
}

export class FixPOECommand implements IFixPOECommand {
    docId?: number;
    pageHeight?: number;
    pageWidth?: number;
    poeType?: POETypes;
    poeFolder?: POEFolders;

    constructor(data?: IFixPOECommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.pageHeight = _data["pageHeight"];
            this.pageWidth = _data["pageWidth"];
            this.poeType = _data["poeType"];
            this.poeFolder = _data["poeFolder"];
        }
    }

    static fromJS(data: any): FixPOECommand {
        data = typeof data === 'object' ? data : {};
        let result = new FixPOECommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["pageHeight"] = this.pageHeight;
        data["pageWidth"] = this.pageWidth;
        data["poeType"] = this.poeType;
        data["poeFolder"] = this.poeFolder;
        return data;
    }
}

export interface IFixPOECommand {
    docId?: number;
    pageHeight?: number;
    pageWidth?: number;
    poeType?: POETypes;
    poeFolder?: POEFolders;
}

export class CreateQualPOEGroupsCommand implements ICreateQualPOEGroupsCommand {
    qualificationId?: number;
    groups?: CreateQualPOEGroup[] | undefined;

    constructor(data?: ICreateQualPOEGroupsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(CreateQualPOEGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateQualPOEGroupsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualPOEGroupsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateQualPOEGroupsCommand {
    qualificationId?: number;
    groups?: CreateQualPOEGroup[] | undefined;
}

export class CreateQualPOEGroup implements ICreateQualPOEGroup {
    name?: string | undefined;
    index?: number;
    unitStandardIds?: number[] | undefined;

    constructor(data?: ICreateQualPOEGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.index = _data["index"];
            if (Array.isArray(_data["unitStandardIds"])) {
                this.unitStandardIds = [] as any;
                for (let item of _data["unitStandardIds"])
                    this.unitStandardIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateQualPOEGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualPOEGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["index"] = this.index;
        if (Array.isArray(this.unitStandardIds)) {
            data["unitStandardIds"] = [];
            for (let item of this.unitStandardIds)
                data["unitStandardIds"].push(item);
        }
        return data;
    }
}

export interface ICreateQualPOEGroup {
    name?: string | undefined;
    index?: number;
    unitStandardIds?: number[] | undefined;
}

export class AddProgrammePOEScheduleEventCommand implements IAddProgrammePOEScheduleEventCommand {
    programmePOEId?: number;
    event?: AddEventCommandModel | undefined;

    constructor(data?: IAddProgrammePOEScheduleEventCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programmePOEId = _data["programmePOEId"];
            this.event = _data["event"] ? AddEventCommandModel.fromJS(_data["event"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddProgrammePOEScheduleEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddProgrammePOEScheduleEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEId"] = this.programmePOEId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddProgrammePOEScheduleEventCommand {
    programmePOEId?: number;
    event?: AddEventCommandModel | undefined;
}

export class AddEventCommandModel implements IAddEventCommandModel {
    title?: string | undefined;
    start?: Date;
    end?: Date;
    allDay?: boolean;
    type?: POEScheduleEvents;
    poeGroupId?: number | undefined;

    constructor(data?: IAddEventCommandModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.allDay = _data["allDay"];
            this.type = _data["type"];
            this.poeGroupId = _data["poeGroupId"];
        }
    }

    static fromJS(data: any): AddEventCommandModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddEventCommandModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["allDay"] = this.allDay;
        data["type"] = this.type;
        data["poeGroupId"] = this.poeGroupId;
        return data;
    }
}

export interface IAddEventCommandModel {
    title?: string | undefined;
    start?: Date;
    end?: Date;
    allDay?: boolean;
    type?: POEScheduleEvents;
    poeGroupId?: number | undefined;
}

export class UnlockPOECommand implements IUnlockPOECommand {
    id?: number;

    constructor(data?: IUnlockPOECommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UnlockPOECommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockPOECommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUnlockPOECommand {
    id?: number;
}

export class LockPOECommand implements ILockPOECommand {
    id?: number;

    constructor(data?: ILockPOECommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LockPOECommand {
        data = typeof data === 'object' ? data : {};
        let result = new LockPOECommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ILockPOECommand {
    id?: number;
}

export class SaveQualPOEInputDataCommand implements ISaveQualPOEInputDataCommand {
    poeFolder?: POEFolders;
    qualPOEDocId?: number;

    constructor(data?: ISaveQualPOEInputDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poeFolder = _data["poeFolder"];
            this.qualPOEDocId = _data["qualPOEDocId"];
        }
    }

    static fromJS(data: any): SaveQualPOEInputDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveQualPOEInputDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poeFolder"] = this.poeFolder;
        data["qualPOEDocId"] = this.qualPOEDocId;
        return data;
    }
}

export interface ISaveQualPOEInputDataCommand {
    poeFolder?: POEFolders;
    qualPOEDocId?: number;
}

export class UpdateProgrammePOEScheduleEventsCommand implements IUpdateProgrammePOEScheduleEventsCommand {
    programmePOEId?: number;
    id?: string | undefined;
    title?: string | undefined;
    start?: Date;
    end?: Date;
    allDay?: boolean;
    type?: POEScheduleEvents;
    poeGroupId?: number | undefined;

    constructor(data?: IUpdateProgrammePOEScheduleEventsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programmePOEId = _data["programmePOEId"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.allDay = _data["allDay"];
            this.type = _data["type"];
            this.poeGroupId = _data["poeGroupId"];
        }
    }

    static fromJS(data: any): UpdateProgrammePOEScheduleEventsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProgrammePOEScheduleEventsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programmePOEId"] = this.programmePOEId;
        data["id"] = this.id;
        data["title"] = this.title;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["allDay"] = this.allDay;
        data["type"] = this.type;
        data["poeGroupId"] = this.poeGroupId;
        return data;
    }
}

export interface IUpdateProgrammePOEScheduleEventsCommand {
    programmePOEId?: number;
    id?: string | undefined;
    title?: string | undefined;
    start?: Date;
    end?: Date;
    allDay?: boolean;
    type?: POEScheduleEvents;
    poeGroupId?: number | undefined;
}

export class SavePOEDocumentChangesByIdCommand implements ISavePOEDocumentChangesByIdCommand {
    docId?: number;
    poeFolder?: POEFolders;
    poeType?: POETypes;
    studentAutoInitialCompleted?: boolean | undefined;
    facilitatorAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
    documentAutoFillCompleted?: boolean | undefined;

    constructor(data?: ISavePOEDocumentChangesByIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.poeFolder = _data["poeFolder"];
            this.poeType = _data["poeType"];
            this.studentAutoInitialCompleted = _data["studentAutoInitialCompleted"];
            this.facilitatorAutoInitialCompleted = _data["facilitatorAutoInitialCompleted"];
            this.moderatorAutoInitialCompleted = _data["moderatorAutoInitialCompleted"];
            this.assesorAutoInitialCompleted = _data["assesorAutoInitialCompleted"];
            this.documentAutoFillCompleted = _data["documentAutoFillCompleted"];
        }
    }

    static fromJS(data: any): SavePOEDocumentChangesByIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SavePOEDocumentChangesByIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["poeFolder"] = this.poeFolder;
        data["poeType"] = this.poeType;
        data["studentAutoInitialCompleted"] = this.studentAutoInitialCompleted;
        data["facilitatorAutoInitialCompleted"] = this.facilitatorAutoInitialCompleted;
        data["moderatorAutoInitialCompleted"] = this.moderatorAutoInitialCompleted;
        data["assesorAutoInitialCompleted"] = this.assesorAutoInitialCompleted;
        data["documentAutoFillCompleted"] = this.documentAutoFillCompleted;
        return data;
    }
}

export interface ISavePOEDocumentChangesByIdCommand {
    docId?: number;
    poeFolder?: POEFolders;
    poeType?: POETypes;
    studentAutoInitialCompleted?: boolean | undefined;
    facilitatorAutoInitialCompleted?: boolean | undefined;
    moderatorAutoInitialCompleted?: boolean | undefined;
    assesorAutoInitialCompleted?: boolean | undefined;
    documentAutoFillCompleted?: boolean | undefined;
}

export class ResponseOfIEnumerableOfGetAllQualificationsViewModel implements IResponseOfIEnumerableOfGetAllQualificationsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetAllQualificationsViewModel[] | undefined;

    constructor(data?: IResponseOfIEnumerableOfGetAllQualificationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetAllQualificationsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfIEnumerableOfGetAllQualificationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIEnumerableOfGetAllQualificationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfIEnumerableOfGetAllQualificationsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetAllQualificationsViewModel[] | undefined;
}

export class GetAllQualificationsViewModel implements IGetAllQualificationsViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    saqaId?: number;
    title?: string | undefined;
    setaFunctionary?: SETATypes;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    field?: SAQAFields;
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    type?: QualificationType;

    constructor(data?: IGetAllQualificationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.saqaId = _data["saqaId"];
            this.title = _data["title"];
            this.setaFunctionary = _data["setaFunctionary"];
            this.purpose = _data["purpose"];
            this.nqfLevel = _data["nqfLevel"];
            this.minimumCredits = _data["minimumCredits"];
            this.field = _data["field"];
            this.minCreditsCore = _data["minCreditsCore"];
            this.minCreditsFundamental = _data["minCreditsFundamental"];
            this.minCreditsElective = _data["minCreditsElective"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetAllQualificationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllQualificationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["saqaId"] = this.saqaId;
        data["title"] = this.title;
        data["setaFunctionary"] = this.setaFunctionary;
        data["purpose"] = this.purpose;
        data["nqfLevel"] = this.nqfLevel;
        data["minimumCredits"] = this.minimumCredits;
        data["field"] = this.field;
        data["minCreditsCore"] = this.minCreditsCore;
        data["minCreditsFundamental"] = this.minCreditsFundamental;
        data["minCreditsElective"] = this.minCreditsElective;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetAllQualificationsViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    saqaId?: number;
    title?: string | undefined;
    setaFunctionary?: SETATypes;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    field?: SAQAFields;
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    type?: QualificationType;
}

export class ResponseOfLearningMaterialResponse implements IResponseOfLearningMaterialResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: LearningMaterialResponse | undefined;

    constructor(data?: IResponseOfLearningMaterialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? LearningMaterialResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseOfLearningMaterialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfLearningMaterialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseOfLearningMaterialResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: LearningMaterialResponse | undefined;
}

export class LearningMaterialResponse implements ILearningMaterialResponse {
    type?: QualificationType;
    groups?: LearningMaterialGroupViewModel[] | undefined;

    constructor(data?: ILearningMaterialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(LearningMaterialGroupViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LearningMaterialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LearningMaterialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILearningMaterialResponse {
    type?: QualificationType;
    groups?: LearningMaterialGroupViewModel[] | undefined;
}

export class LearningMaterialGroupViewModel implements ILearningMaterialGroupViewModel {
    moduleType?: KnowledgeModuleType | undefined;
    id?: number;
    name?: string | undefined;
    documents?: GetQualificationLearningMaterialViewModel[] | undefined;

    constructor(data?: ILearningMaterialGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleType = _data["moduleType"];
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GetQualificationLearningMaterialViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LearningMaterialGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LearningMaterialGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleType"] = this.moduleType;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILearningMaterialGroupViewModel {
    moduleType?: KnowledgeModuleType | undefined;
    id?: number;
    name?: string | undefined;
    documents?: GetQualificationLearningMaterialViewModel[] | undefined;
}

export class GetQualificationLearningMaterialViewModel implements IGetQualificationLearningMaterialViewModel {
    id?: number;
    active?: boolean;
    staffOnly?: boolean;
    qualPOEGroupId?: number | undefined;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IGetQualificationLearningMaterialViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.staffOnly = _data["staffOnly"];
            this.qualPOEGroupId = _data["qualPOEGroupId"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): GetQualificationLearningMaterialViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualificationLearningMaterialViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["staffOnly"] = this.staffOnly;
        data["qualPOEGroupId"] = this.qualPOEGroupId;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IGetQualificationLearningMaterialViewModel {
    id?: number;
    active?: boolean;
    staffOnly?: boolean;
    qualPOEGroupId?: number | undefined;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel implements IResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetQualificationLearningMaterialForStudentViewModel[] | undefined;

    constructor(data?: IResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetQualificationLearningMaterialForStudentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfGetQualificationLearningMaterialForStudentViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetQualificationLearningMaterialForStudentViewModel[] | undefined;
}

export class GetQualificationLearningMaterialForStudentViewModel implements IGetQualificationLearningMaterialForStudentViewModel {
    id?: number;
    active?: boolean;
    qualPOEGroupId?: number | undefined;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IGetQualificationLearningMaterialForStudentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.qualPOEGroupId = _data["qualPOEGroupId"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): GetQualificationLearningMaterialForStudentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetQualificationLearningMaterialForStudentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["qualPOEGroupId"] = this.qualPOEGroupId;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IGetQualificationLearningMaterialForStudentViewModel {
    id?: number;
    active?: boolean;
    qualPOEGroupId?: number | undefined;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel implements IResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetUnitStandardsByQualificationIdViewModel[] | undefined;

    constructor(data?: IResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetUnitStandardsByQualificationIdViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfIEnumerableOfGetUnitStandardsByQualificationIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetUnitStandardsByQualificationIdViewModel[] | undefined;
}

export class GetUnitStandardsByQualificationIdViewModel implements IGetUnitStandardsByQualificationIdViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    qualificationId?: number;
    type?: UnitStandardType;
    unitStandardNumber?: number;
    prevUnitStandardNumber?: number | undefined;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;

    constructor(data?: IGetUnitStandardsByQualificationIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.type = _data["type"];
            this.unitStandardNumber = _data["unitStandardNumber"];
            this.prevUnitStandardNumber = _data["prevUnitStandardNumber"];
            this.title = _data["title"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
        }
    }

    static fromJS(data: any): GetUnitStandardsByQualificationIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnitStandardsByQualificationIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["type"] = this.type;
        data["unitStandardNumber"] = this.unitStandardNumber;
        data["prevUnitStandardNumber"] = this.prevUnitStandardNumber;
        data["title"] = this.title;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        return data;
    }
}

export interface IGetUnitStandardsByQualificationIdViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    qualificationId?: number;
    type?: UnitStandardType;
    unitStandardNumber?: number;
    prevUnitStandardNumber?: number | undefined;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
}

export class ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel implements IResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetAllQualificationsAndUnitStandardsViewModel[] | undefined;

    constructor(data?: IResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetAllQualificationsAndUnitStandardsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfIEnumerableOfGetAllQualificationsAndUnitStandardsViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetAllQualificationsAndUnitStandardsViewModel[] | undefined;
}

export class GetAllQualificationsAndUnitStandardsViewModel implements IGetAllQualificationsAndUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    saqaId?: number;
    title?: string | undefined;
    setaFunctionary?: SETATypes;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    field?: SAQAFields;
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    unitStandards?: GetUnitStandardsViewModel[] | undefined;
    type?: QualificationType;

    constructor(data?: IGetAllQualificationsAndUnitStandardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.saqaId = _data["saqaId"];
            this.title = _data["title"];
            this.setaFunctionary = _data["setaFunctionary"];
            this.purpose = _data["purpose"];
            this.nqfLevel = _data["nqfLevel"];
            this.minimumCredits = _data["minimumCredits"];
            this.field = _data["field"];
            this.minCreditsCore = _data["minCreditsCore"];
            this.minCreditsFundamental = _data["minCreditsFundamental"];
            this.minCreditsElective = _data["minCreditsElective"];
            if (Array.isArray(_data["unitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["unitStandards"])
                    this.unitStandards!.push(GetUnitStandardsViewModel.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetAllQualificationsAndUnitStandardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllQualificationsAndUnitStandardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["saqaId"] = this.saqaId;
        data["title"] = this.title;
        data["setaFunctionary"] = this.setaFunctionary;
        data["purpose"] = this.purpose;
        data["nqfLevel"] = this.nqfLevel;
        data["minimumCredits"] = this.minimumCredits;
        data["field"] = this.field;
        data["minCreditsCore"] = this.minCreditsCore;
        data["minCreditsFundamental"] = this.minCreditsFundamental;
        data["minCreditsElective"] = this.minCreditsElective;
        if (Array.isArray(this.unitStandards)) {
            data["unitStandards"] = [];
            for (let item of this.unitStandards)
                data["unitStandards"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data;
    }
}

export interface IGetAllQualificationsAndUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    saqaId?: number;
    title?: string | undefined;
    setaFunctionary?: SETATypes;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    field?: SAQAFields;
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    unitStandards?: GetUnitStandardsViewModel[] | undefined;
    type?: QualificationType;
}

export class GetUnitStandardsViewModel implements IGetUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    type?: UnitStandardType;
    unitStandardNumber?: number;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
    qualificationId?: number;

    constructor(data?: IGetUnitStandardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.type = _data["type"];
            this.unitStandardNumber = _data["unitStandardNumber"];
            this.title = _data["title"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
            this.qualificationId = _data["qualificationId"];
        }
    }

    static fromJS(data: any): GetUnitStandardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnitStandardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["type"] = this.type;
        data["unitStandardNumber"] = this.unitStandardNumber;
        data["title"] = this.title;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        data["qualificationId"] = this.qualificationId;
        return data;
    }
}

export interface IGetUnitStandardsViewModel {
    id?: number;
    active?: boolean;
    type?: UnitStandardType;
    unitStandardNumber?: number;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
    qualificationId?: number;
}

export class ResponseOfQualification implements IResponseOfQualification {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: Qualification | undefined;

    constructor(data?: IResponseOfQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? Qualification.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseOfQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseOfQualification {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: Qualification | undefined;
}

export class PaginationResponseOfQualificationDto implements IPaginationResponseOfQualificationDto {
    data?: QualificationDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QualificationDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfQualificationDto {
    data?: QualificationDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class QualificationDto implements IQualificationDto {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    type?: QualificationType;
    saqaId?: number;
    title?: string | undefined;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;

    constructor(data?: IQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.saqaId = _data["saqaId"];
            this.title = _data["title"];
            this.purpose = _data["purpose"];
            this.nqfLevel = _data["nqfLevel"];
            this.minimumCredits = _data["minimumCredits"];
        }
    }

    static fromJS(data: any): QualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["saqaId"] = this.saqaId;
        data["title"] = this.title;
        data["purpose"] = this.purpose;
        data["nqfLevel"] = this.nqfLevel;
        data["minimumCredits"] = this.minimumCredits;
        return data;
    }
}

export interface IQualificationDto {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    type?: QualificationType;
    saqaId?: number;
    title?: string | undefined;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
}

export class SearchQualificationsRequest extends PaginationFilter implements ISearchQualificationsRequest {
    types?: QualificationType[] | undefined;
    isActive?: string[] | undefined;

    constructor(data?: ISearchQualificationsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["isActive"])) {
                this.isActive = [] as any;
                for (let item of _data["isActive"])
                    this.isActive!.push(item);
            }
        }
    }

    static override fromJS(data: any): SearchQualificationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQualificationsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.isActive)) {
            data["isActive"] = [];
            for (let item of this.isActive)
                data["isActive"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchQualificationsRequest extends IPaginationFilter {
    types?: QualificationType[] | undefined;
    isActive?: string[] | undefined;
}

export class ResponseOfInteger implements IResponseOfInteger {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: number;

    constructor(data?: IResponseOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfInteger {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: number;
}

export abstract class CreateCommand implements ICreateCommand {
    active?: boolean;

    constructor(data?: ICreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CreateCommand {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateCommand' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        return data;
    }
}

export interface ICreateCommand {
    active?: boolean;
}

export class CreateQualificationCommand extends CreateCommand implements ICreateQualificationCommand {
    title?: string | undefined;
    saqaId?: number;
    setaFunctionary?: SETATypes;
    field?: SAQAFields;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    unitStandards?: CreateUnitStandards | undefined;

    constructor(data?: ICreateQualificationCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.saqaId = _data["saqaId"];
            this.setaFunctionary = _data["setaFunctionary"];
            this.field = _data["field"];
            this.purpose = _data["purpose"];
            this.nqfLevel = _data["nqfLevel"];
            this.minimumCredits = _data["minimumCredits"];
            this.unitStandards = _data["unitStandards"] ? CreateUnitStandards.fromJS(_data["unitStandards"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateQualificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualificationCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["saqaId"] = this.saqaId;
        data["setaFunctionary"] = this.setaFunctionary;
        data["field"] = this.field;
        data["purpose"] = this.purpose;
        data["nqfLevel"] = this.nqfLevel;
        data["minimumCredits"] = this.minimumCredits;
        data["unitStandards"] = this.unitStandards ? this.unitStandards.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateQualificationCommand extends ICreateCommand {
    title?: string | undefined;
    saqaId?: number;
    setaFunctionary?: SETATypes;
    field?: SAQAFields;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    unitStandards?: CreateUnitStandards | undefined;
}

export class CreateUnitStandards extends CreateCommand implements ICreateUnitStandards {
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    unitStandardsCore?: CreateUnitStandard[] | undefined;
    unitStandardsFundamental?: CreateUnitStandard[] | undefined;
    unitStandardsElective?: CreateUnitStandard[] | undefined;

    constructor(data?: ICreateUnitStandards) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minCreditsCore = _data["minCreditsCore"];
            this.minCreditsFundamental = _data["minCreditsFundamental"];
            this.minCreditsElective = _data["minCreditsElective"];
            if (Array.isArray(_data["unitStandardsCore"])) {
                this.unitStandardsCore = [] as any;
                for (let item of _data["unitStandardsCore"])
                    this.unitStandardsCore!.push(CreateUnitStandard.fromJS(item));
            }
            if (Array.isArray(_data["unitStandardsFundamental"])) {
                this.unitStandardsFundamental = [] as any;
                for (let item of _data["unitStandardsFundamental"])
                    this.unitStandardsFundamental!.push(CreateUnitStandard.fromJS(item));
            }
            if (Array.isArray(_data["unitStandardsElective"])) {
                this.unitStandardsElective = [] as any;
                for (let item of _data["unitStandardsElective"])
                    this.unitStandardsElective!.push(CreateUnitStandard.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CreateUnitStandards {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUnitStandards();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minCreditsCore"] = this.minCreditsCore;
        data["minCreditsFundamental"] = this.minCreditsFundamental;
        data["minCreditsElective"] = this.minCreditsElective;
        if (Array.isArray(this.unitStandardsCore)) {
            data["unitStandardsCore"] = [];
            for (let item of this.unitStandardsCore)
                data["unitStandardsCore"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandardsFundamental)) {
            data["unitStandardsFundamental"] = [];
            for (let item of this.unitStandardsFundamental)
                data["unitStandardsFundamental"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandardsElective)) {
            data["unitStandardsElective"] = [];
            for (let item of this.unitStandardsElective)
                data["unitStandardsElective"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUnitStandards extends ICreateCommand {
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    unitStandardsCore?: CreateUnitStandard[] | undefined;
    unitStandardsFundamental?: CreateUnitStandard[] | undefined;
    unitStandardsElective?: CreateUnitStandard[] | undefined;
}

export class CreateUnitStandard extends CreateCommand implements ICreateUnitStandard {
    tempId?: number;
    unitStandardNumber?: number;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;

    constructor(data?: ICreateUnitStandard) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tempId = _data["tempId"];
            this.unitStandardNumber = _data["unitStandardNumber"];
            this.title = _data["title"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
        }
    }

    static override fromJS(data: any): CreateUnitStandard {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUnitStandard();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tempId"] = this.tempId;
        data["unitStandardNumber"] = this.unitStandardNumber;
        data["title"] = this.title;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUnitStandard extends ICreateCommand {
    tempId?: number;
    unitStandardNumber?: number;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
}

export class CreateQctoQualificationCommand implements ICreateQctoQualificationCommand {
    active?: boolean;
    title?: string | undefined;
    saqaId?: number;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    knowledgeModules?: CreateKnowledgeModules | undefined;

    constructor(data?: ICreateQctoQualificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.title = _data["title"];
            this.saqaId = _data["saqaId"];
            this.purpose = _data["purpose"];
            this.nqfLevel = _data["nqfLevel"];
            this.minimumCredits = _data["minimumCredits"];
            this.knowledgeModules = _data["knowledgeModules"] ? CreateKnowledgeModules.fromJS(_data["knowledgeModules"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateQctoQualificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQctoQualificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["title"] = this.title;
        data["saqaId"] = this.saqaId;
        data["purpose"] = this.purpose;
        data["nqfLevel"] = this.nqfLevel;
        data["minimumCredits"] = this.minimumCredits;
        data["knowledgeModules"] = this.knowledgeModules ? this.knowledgeModules.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateQctoQualificationCommand {
    active?: boolean;
    title?: string | undefined;
    saqaId?: number;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    knowledgeModules?: CreateKnowledgeModules | undefined;
}

export class CreateKnowledgeModules implements ICreateKnowledgeModules {
    standardKnowledgeModules?: CreateKnowledgeModule[] | undefined;
    practicalKnowledgeModules?: CreateKnowledgeModule[] | undefined;
    workplaceKnowledgeModules?: CreateKnowledgeModule[] | undefined;

    constructor(data?: ICreateKnowledgeModules) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardKnowledgeModules"])) {
                this.standardKnowledgeModules = [] as any;
                for (let item of _data["standardKnowledgeModules"])
                    this.standardKnowledgeModules!.push(CreateKnowledgeModule.fromJS(item));
            }
            if (Array.isArray(_data["practicalKnowledgeModules"])) {
                this.practicalKnowledgeModules = [] as any;
                for (let item of _data["practicalKnowledgeModules"])
                    this.practicalKnowledgeModules!.push(CreateKnowledgeModule.fromJS(item));
            }
            if (Array.isArray(_data["workplaceKnowledgeModules"])) {
                this.workplaceKnowledgeModules = [] as any;
                for (let item of _data["workplaceKnowledgeModules"])
                    this.workplaceKnowledgeModules!.push(CreateKnowledgeModule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateKnowledgeModules {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKnowledgeModules();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardKnowledgeModules)) {
            data["standardKnowledgeModules"] = [];
            for (let item of this.standardKnowledgeModules)
                data["standardKnowledgeModules"].push(item.toJSON());
        }
        if (Array.isArray(this.practicalKnowledgeModules)) {
            data["practicalKnowledgeModules"] = [];
            for (let item of this.practicalKnowledgeModules)
                data["practicalKnowledgeModules"].push(item.toJSON());
        }
        if (Array.isArray(this.workplaceKnowledgeModules)) {
            data["workplaceKnowledgeModules"] = [];
            for (let item of this.workplaceKnowledgeModules)
                data["workplaceKnowledgeModules"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateKnowledgeModules {
    standardKnowledgeModules?: CreateKnowledgeModule[] | undefined;
    practicalKnowledgeModules?: CreateKnowledgeModule[] | undefined;
    workplaceKnowledgeModules?: CreateKnowledgeModule[] | undefined;
}

export class CreateKnowledgeModule implements ICreateKnowledgeModule {
    active?: boolean;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;

    constructor(data?: ICreateKnowledgeModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.title = _data["title"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
        }
    }

    static fromJS(data: any): CreateKnowledgeModule {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKnowledgeModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["title"] = this.title;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        return data;
    }
}

export interface ICreateKnowledgeModule {
    active?: boolean;
    title?: string | undefined;
    nqfLevel?: number;
    credits?: number;
}

export class UpdateQualificationCommand implements IUpdateQualificationCommand {
    id?: number;
    active?: boolean;
    title?: string | undefined;
    saqaId?: number;
    purpose?: string | undefined;
    field?: number | undefined;
    setaFunctionary?: number | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    unitStandards?: UpdateUnitStandards | undefined;

    constructor(data?: IUpdateQualificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.title = _data["title"];
            this.saqaId = _data["saqaId"];
            this.purpose = _data["purpose"];
            this.field = _data["field"];
            this.setaFunctionary = _data["setaFunctionary"];
            this.nqfLevel = _data["nqfLevel"];
            this.minimumCredits = _data["minimumCredits"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.unitStandards = _data["unitStandards"] ? UpdateUnitStandards.fromJS(_data["unitStandards"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateQualificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["title"] = this.title;
        data["saqaId"] = this.saqaId;
        data["purpose"] = this.purpose;
        data["field"] = this.field;
        data["setaFunctionary"] = this.setaFunctionary;
        data["nqfLevel"] = this.nqfLevel;
        data["minimumCredits"] = this.minimumCredits;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["unitStandards"] = this.unitStandards ? this.unitStandards.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateQualificationCommand {
    id?: number;
    active?: boolean;
    title?: string | undefined;
    saqaId?: number;
    purpose?: string | undefined;
    field?: number | undefined;
    setaFunctionary?: number | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    unitStandards?: UpdateUnitStandards | undefined;
}

export class UpdateUnitStandards implements IUpdateUnitStandards {
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    unitStandardsCore?: UpdateUnitStandardsCore[] | undefined;
    unitStandardsFundamental?: UpdateUnitStandardsFundamental[] | undefined;
    unitStandardsElective?: UpdateUnitStandardsElective[] | undefined;

    constructor(data?: IUpdateUnitStandards) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minCreditsCore = _data["minCreditsCore"];
            this.minCreditsFundamental = _data["minCreditsFundamental"];
            this.minCreditsElective = _data["minCreditsElective"];
            if (Array.isArray(_data["unitStandardsCore"])) {
                this.unitStandardsCore = [] as any;
                for (let item of _data["unitStandardsCore"])
                    this.unitStandardsCore!.push(UpdateUnitStandardsCore.fromJS(item));
            }
            if (Array.isArray(_data["unitStandardsFundamental"])) {
                this.unitStandardsFundamental = [] as any;
                for (let item of _data["unitStandardsFundamental"])
                    this.unitStandardsFundamental!.push(UpdateUnitStandardsFundamental.fromJS(item));
            }
            if (Array.isArray(_data["unitStandardsElective"])) {
                this.unitStandardsElective = [] as any;
                for (let item of _data["unitStandardsElective"])
                    this.unitStandardsElective!.push(UpdateUnitStandardsElective.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUnitStandards {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnitStandards();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minCreditsCore"] = this.minCreditsCore;
        data["minCreditsFundamental"] = this.minCreditsFundamental;
        data["minCreditsElective"] = this.minCreditsElective;
        if (Array.isArray(this.unitStandardsCore)) {
            data["unitStandardsCore"] = [];
            for (let item of this.unitStandardsCore)
                data["unitStandardsCore"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandardsFundamental)) {
            data["unitStandardsFundamental"] = [];
            for (let item of this.unitStandardsFundamental)
                data["unitStandardsFundamental"].push(item.toJSON());
        }
        if (Array.isArray(this.unitStandardsElective)) {
            data["unitStandardsElective"] = [];
            for (let item of this.unitStandardsElective)
                data["unitStandardsElective"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateUnitStandards {
    minCreditsCore?: number;
    minCreditsFundamental?: number;
    minCreditsElective?: number;
    unitStandardsCore?: UpdateUnitStandardsCore[] | undefined;
    unitStandardsFundamental?: UpdateUnitStandardsFundamental[] | undefined;
    unitStandardsElective?: UpdateUnitStandardsElective[] | undefined;
}

export class UpdateUnitStandardsCore implements IUpdateUnitStandardsCore {
    id?: number | undefined;
    active?: boolean;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    unitStandardNumber?: number;
    nqfLevel?: number;
    credits?: number;
    title?: string | undefined;

    constructor(data?: IUpdateUnitStandardsCore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.unitStandardNumber = _data["unitStandardNumber"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateUnitStandardsCore {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnitStandardsCore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["unitStandardNumber"] = this.unitStandardNumber;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateUnitStandardsCore {
    id?: number | undefined;
    active?: boolean;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    unitStandardNumber?: number;
    nqfLevel?: number;
    credits?: number;
    title?: string | undefined;
}

export class UpdateUnitStandardsFundamental implements IUpdateUnitStandardsFundamental {
    id?: number | undefined;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    active?: boolean;
    unitStandardNumber?: number;
    nqfLevel?: number;
    credits?: number;
    title?: string | undefined;

    constructor(data?: IUpdateUnitStandardsFundamental) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.active = _data["active"];
            this.unitStandardNumber = _data["unitStandardNumber"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateUnitStandardsFundamental {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnitStandardsFundamental();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["active"] = this.active;
        data["unitStandardNumber"] = this.unitStandardNumber;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateUnitStandardsFundamental {
    id?: number | undefined;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    active?: boolean;
    unitStandardNumber?: number;
    nqfLevel?: number;
    credits?: number;
    title?: string | undefined;
}

export class UpdateUnitStandardsElective implements IUpdateUnitStandardsElective {
    id?: number | undefined;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    active?: boolean;
    unitStandardNumber?: number;
    nqfLevel?: number;
    credits?: number;
    title?: string | undefined;

    constructor(data?: IUpdateUnitStandardsElective) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.active = _data["active"];
            this.unitStandardNumber = _data["unitStandardNumber"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateUnitStandardsElective {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnitStandardsElective();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["active"] = this.active;
        data["unitStandardNumber"] = this.unitStandardNumber;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateUnitStandardsElective {
    id?: number | undefined;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    active?: boolean;
    unitStandardNumber?: number;
    nqfLevel?: number;
    credits?: number;
    title?: string | undefined;
}

export class UpdateQctoQualificationCommand implements IUpdateQctoQualificationCommand {
    id?: number;
    active?: boolean;
    title?: string | undefined;
    saqaId?: number;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    modules?: UpdateKnowledgeModules | undefined;

    constructor(data?: IUpdateQctoQualificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.title = _data["title"];
            this.saqaId = _data["saqaId"];
            this.purpose = _data["purpose"];
            this.nqfLevel = _data["nqfLevel"];
            this.minimumCredits = _data["minimumCredits"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.modules = _data["modules"] ? UpdateKnowledgeModules.fromJS(_data["modules"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateQctoQualificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQctoQualificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["title"] = this.title;
        data["saqaId"] = this.saqaId;
        data["purpose"] = this.purpose;
        data["nqfLevel"] = this.nqfLevel;
        data["minimumCredits"] = this.minimumCredits;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["modules"] = this.modules ? this.modules.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateQctoQualificationCommand {
    id?: number;
    active?: boolean;
    title?: string | undefined;
    saqaId?: number;
    purpose?: string | undefined;
    nqfLevel?: number;
    minimumCredits?: number;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    modules?: UpdateKnowledgeModules | undefined;
}

export class UpdateKnowledgeModules implements IUpdateKnowledgeModules {
    modulesKnowledge?: UpdateStandardKnwoledgeModules[] | undefined;
    modulesPractical?: UpdatePracticalKnwoledgeModules[] | undefined;
    modulesWorkplace?: UpdateWorkplaceKnwoledgeModules[] | undefined;

    constructor(data?: IUpdateKnowledgeModules) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modulesKnowledge"])) {
                this.modulesKnowledge = [] as any;
                for (let item of _data["modulesKnowledge"])
                    this.modulesKnowledge!.push(UpdateStandardKnwoledgeModules.fromJS(item));
            }
            if (Array.isArray(_data["modulesPractical"])) {
                this.modulesPractical = [] as any;
                for (let item of _data["modulesPractical"])
                    this.modulesPractical!.push(UpdatePracticalKnwoledgeModules.fromJS(item));
            }
            if (Array.isArray(_data["modulesWorkplace"])) {
                this.modulesWorkplace = [] as any;
                for (let item of _data["modulesWorkplace"])
                    this.modulesWorkplace!.push(UpdateWorkplaceKnwoledgeModules.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateKnowledgeModules {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKnowledgeModules();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modulesKnowledge)) {
            data["modulesKnowledge"] = [];
            for (let item of this.modulesKnowledge)
                data["modulesKnowledge"].push(item.toJSON());
        }
        if (Array.isArray(this.modulesPractical)) {
            data["modulesPractical"] = [];
            for (let item of this.modulesPractical)
                data["modulesPractical"].push(item.toJSON());
        }
        if (Array.isArray(this.modulesWorkplace)) {
            data["modulesWorkplace"] = [];
            for (let item of this.modulesWorkplace)
                data["modulesWorkplace"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateKnowledgeModules {
    modulesKnowledge?: UpdateStandardKnwoledgeModules[] | undefined;
    modulesPractical?: UpdatePracticalKnwoledgeModules[] | undefined;
    modulesWorkplace?: UpdateWorkplaceKnwoledgeModules[] | undefined;
}

export class UpdateKnowledgeModule implements IUpdateKnowledgeModule {
    id?: number | undefined;
    active?: boolean;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    nqfLevel?: number;
    credits?: number;
    title?: string | undefined;

    constructor(data?: IUpdateKnowledgeModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.nqfLevel = _data["nqfLevel"];
            this.credits = _data["credits"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateKnowledgeModule {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKnowledgeModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["nqfLevel"] = this.nqfLevel;
        data["credits"] = this.credits;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateKnowledgeModule {
    id?: number | undefined;
    active?: boolean;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    nqfLevel?: number;
    credits?: number;
    title?: string | undefined;
}

export class UpdateStandardKnwoledgeModules extends UpdateKnowledgeModule implements IUpdateStandardKnwoledgeModules {

    constructor(data?: IUpdateStandardKnwoledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateStandardKnwoledgeModules {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStandardKnwoledgeModules();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStandardKnwoledgeModules extends IUpdateKnowledgeModule {
}

export class UpdatePracticalKnwoledgeModules extends UpdateKnowledgeModule implements IUpdatePracticalKnwoledgeModules {

    constructor(data?: IUpdatePracticalKnwoledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdatePracticalKnwoledgeModules {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePracticalKnwoledgeModules();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePracticalKnwoledgeModules extends IUpdateKnowledgeModule {
}

export class UpdateWorkplaceKnwoledgeModules extends UpdateKnowledgeModule implements IUpdateWorkplaceKnwoledgeModules {

    constructor(data?: IUpdateWorkplaceKnwoledgeModules) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateWorkplaceKnwoledgeModules {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkplaceKnwoledgeModules();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateWorkplaceKnwoledgeModules extends IUpdateKnowledgeModule {
}

export class ChartSeriesDtoOfStringAndStringAndInteger implements IChartSeriesDtoOfStringAndStringAndInteger {
    name?: string | undefined;
    series?: ChartDtoOfStringAndInteger[] | undefined;

    constructor(data?: IChartSeriesDtoOfStringAndStringAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(ChartDtoOfStringAndInteger.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChartSeriesDtoOfStringAndStringAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSeriesDtoOfStringAndStringAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChartSeriesDtoOfStringAndStringAndInteger {
    name?: string | undefined;
    series?: ChartDtoOfStringAndInteger[] | undefined;
}

export class GetStackedStudentsByAgeResponse extends ChartSeriesDtoOfStringAndStringAndInteger implements IGetStackedStudentsByAgeResponse {

    constructor(data?: IGetStackedStudentsByAgeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetStackedStudentsByAgeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStackedStudentsByAgeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetStackedStudentsByAgeResponse extends IChartSeriesDtoOfStringAndStringAndInteger {
}

export class ChartDtoOfStringAndInteger implements IChartDtoOfStringAndInteger {
    name?: string | undefined;
    value?: number;

    constructor(data?: IChartDtoOfStringAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ChartDtoOfStringAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDtoOfStringAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IChartDtoOfStringAndInteger {
    name?: string | undefined;
    value?: number;
}

export class GetStackedStudentsByAgeRequest implements IGetStackedStudentsByAgeRequest {
    learnershipIds?: number[] | undefined;

    constructor(data?: IGetStackedStudentsByAgeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["learnershipIds"])) {
                this.learnershipIds = [] as any;
                for (let item of _data["learnershipIds"])
                    this.learnershipIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetStackedStudentsByAgeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStackedStudentsByAgeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.learnershipIds)) {
            data["learnershipIds"] = [];
            for (let item of this.learnershipIds)
                data["learnershipIds"].push(item);
        }
        return data;
    }
}

export interface IGetStackedStudentsByAgeRequest {
    learnershipIds?: number[] | undefined;
}

export class GetPieChartRatingsResponse extends ChartDtoOfStringAndInteger implements IGetPieChartRatingsResponse {

    constructor(data?: IGetPieChartRatingsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetPieChartRatingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPieChartRatingsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetPieChartRatingsResponse extends IChartDtoOfStringAndInteger {
}

export class GetPieChartRatingsRequest implements IGetPieChartRatingsRequest {
    learnershipIds?: number[] | undefined;

    constructor(data?: IGetPieChartRatingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["learnershipIds"])) {
                this.learnershipIds = [] as any;
                for (let item of _data["learnershipIds"])
                    this.learnershipIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPieChartRatingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPieChartRatingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.learnershipIds)) {
            data["learnershipIds"] = [];
            for (let item of this.learnershipIds)
                data["learnershipIds"].push(item);
        }
        return data;
    }
}

export interface IGetPieChartRatingsRequest {
    learnershipIds?: number[] | undefined;
}

export class ChartSeriesDtoOfStringAndStringAndDecimal implements IChartSeriesDtoOfStringAndStringAndDecimal {
    name?: string | undefined;
    series?: ChartDtoOfStringAndDecimal[] | undefined;

    constructor(data?: IChartSeriesDtoOfStringAndStringAndDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(ChartDtoOfStringAndDecimal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChartSeriesDtoOfStringAndStringAndDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSeriesDtoOfStringAndStringAndDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChartSeriesDtoOfStringAndStringAndDecimal {
    name?: string | undefined;
    series?: ChartDtoOfStringAndDecimal[] | undefined;
}

export class GetLineGraphAttendanceResponse extends ChartSeriesDtoOfStringAndStringAndDecimal implements IGetLineGraphAttendanceResponse {

    constructor(data?: IGetLineGraphAttendanceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetLineGraphAttendanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLineGraphAttendanceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetLineGraphAttendanceResponse extends IChartSeriesDtoOfStringAndStringAndDecimal {
}

export class ChartDtoOfStringAndDecimal implements IChartDtoOfStringAndDecimal {
    name?: string | undefined;
    value?: number;

    constructor(data?: IChartDtoOfStringAndDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ChartDtoOfStringAndDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDtoOfStringAndDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IChartDtoOfStringAndDecimal {
    name?: string | undefined;
    value?: number;
}

export class GetLineGraphAttendanceRequest implements IGetLineGraphAttendanceRequest {
    learnershipIds?: number[] | undefined;
    year?: number;
    combineLines?: boolean;

    constructor(data?: IGetLineGraphAttendanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["learnershipIds"])) {
                this.learnershipIds = [] as any;
                for (let item of _data["learnershipIds"])
                    this.learnershipIds!.push(item);
            }
            this.year = _data["year"];
            this.combineLines = _data["combineLines"];
        }
    }

    static fromJS(data: any): GetLineGraphAttendanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLineGraphAttendanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.learnershipIds)) {
            data["learnershipIds"] = [];
            for (let item of this.learnershipIds)
                data["learnershipIds"].push(item);
        }
        data["year"] = this.year;
        data["combineLines"] = this.combineLines;
        return data;
    }
}

export interface IGetLineGraphAttendanceRequest {
    learnershipIds?: number[] | undefined;
    year?: number;
    combineLines?: boolean;
}

export class ExportReportRequest implements IExportReportRequest {
    type?: ReportExportType;
    learnershipIds?: number[] | undefined;
    learnershipId?: number;
    races?: Races[] | undefined;
    genders?: Genders[] | undefined;
    ages?: string[] | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IExportReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["learnershipIds"])) {
                this.learnershipIds = [] as any;
                for (let item of _data["learnershipIds"])
                    this.learnershipIds!.push(item);
            }
            this.learnershipId = _data["learnershipId"];
            if (Array.isArray(_data["races"])) {
                this.races = [] as any;
                for (let item of _data["races"])
                    this.races!.push(item);
            }
            if (Array.isArray(_data["genders"])) {
                this.genders = [] as any;
                for (let item of _data["genders"])
                    this.genders!.push(item);
            }
            if (Array.isArray(_data["ages"])) {
                this.ages = [] as any;
                for (let item of _data["ages"])
                    this.ages!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.learnershipIds)) {
            data["learnershipIds"] = [];
            for (let item of this.learnershipIds)
                data["learnershipIds"].push(item);
        }
        data["learnershipId"] = this.learnershipId;
        if (Array.isArray(this.races)) {
            data["races"] = [];
            for (let item of this.races)
                data["races"].push(item);
        }
        if (Array.isArray(this.genders)) {
            data["genders"] = [];
            for (let item of this.genders)
                data["genders"].push(item);
        }
        if (Array.isArray(this.ages)) {
            data["ages"] = [];
            for (let item of this.ages)
                data["ages"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExportReportRequest {
    type?: ReportExportType;
    learnershipIds?: number[] | undefined;
    learnershipId?: number;
    races?: Races[] | undefined;
    genders?: Genders[] | undefined;
    ages?: string[] | undefined;
    startDate?: Date;
    endDate?: Date;
}

export enum ReportExportType {
    Learner = 0,
    Attendance = 1,
    Learnership = 2,
    Employer = 3,
}

export class PaginationResponseOfStaffDto implements IPaginationResponseOfStaffDto {
    data?: StaffDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StaffDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfStaffDto {
    data?: StaffDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class StaffDto implements IStaffDto {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    types?: StaffTypes[] | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    accountId?: number;

    constructor(data?: IStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.maidenName = _data["maidenName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.nationality = _data["nationality"];
            this.homeLanguage = _data["homeLanguage"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.whatsappNumber = _data["whatsappNumber"];
            this.cellNumber = _data["cellNumber"];
            this.email = _data["email"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): StaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["maidenName"] = this.maidenName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["nationality"] = this.nationality;
        data["homeLanguage"] = this.homeLanguage;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["whatsappNumber"] = this.whatsappNumber;
        data["cellNumber"] = this.cellNumber;
        data["email"] = this.email;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IStaffDto {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    types?: StaffTypes[] | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    accountId?: number;
}

export class SearchStaffRequest extends PaginationFilter implements ISearchStaffRequest {
    types?: StaffTypes[] | undefined;

    constructor(data?: ISearchStaffRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static override fromJS(data: any): SearchStaffRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStaffRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchStaffRequest extends IPaginationFilter {
    types?: StaffTypes[] | undefined;
}

export abstract class CreateActiveStaffMember implements ICreateActiveStaffMember {
    active?: boolean;

    constructor(data?: ICreateActiveStaffMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CreateActiveStaffMember {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateActiveStaffMember' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        return data;
    }
}

export interface ICreateActiveStaffMember {
    active?: boolean;
}

export class CreateStaffMemberCommand extends CreateActiveStaffMember implements ICreateStaffMemberCommand {
    requestOrigin?: string | undefined;
    dateJoined?: Date;
    types?: StaffTypes[] | undefined;
    moderatorNumber?: string | undefined;
    assessorNumber?: string | undefined;
    person?: CreateStaffMemberPerson | undefined;

    constructor(data?: ICreateStaffMemberCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestOrigin = _data["requestOrigin"];
            this.dateJoined = _data["dateJoined"] ? new Date(_data["dateJoined"].toString()) : <any>undefined;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.moderatorNumber = _data["moderatorNumber"];
            this.assessorNumber = _data["assessorNumber"];
            this.person = _data["person"] ? CreateStaffMemberPerson.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateStaffMemberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffMemberCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestOrigin"] = this.requestOrigin;
        data["dateJoined"] = this.dateJoined ? this.dateJoined.toISOString() : <any>undefined;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["moderatorNumber"] = this.moderatorNumber;
        data["assessorNumber"] = this.assessorNumber;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateStaffMemberCommand extends ICreateActiveStaffMember {
    requestOrigin?: string | undefined;
    dateJoined?: Date;
    types?: StaffTypes[] | undefined;
    moderatorNumber?: string | undefined;
    assessorNumber?: string | undefined;
    person?: CreateStaffMemberPerson | undefined;
}

export class CreateStaffMemberPerson implements ICreateStaffMemberPerson {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    maidenName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    title?: Titles;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    idType?: IdTypes;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    homeLanguage?: Languages;
    cellNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    isAdmin?: boolean;
    streetAddress?: CreateStaffMemberStreetAddress | undefined;
    postalAddress?: CreateStaffMemberPostalAddress | undefined;

    constructor(data?: ICreateStaffMemberPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.maidenName = _data["maidenName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.title = _data["title"];
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.nationality = _data["nationality"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.homeLanguage = _data["homeLanguage"];
            this.cellNumber = _data["cellNumber"];
            this.whatsappNumber = _data["whatsappNumber"];
            this.altNumber = _data["altNumber"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinCellNumber = _data["nextOfKinCellNumber"];
            this.nextOfKinRelation = _data["nextOfKinRelation"];
            this.disability = _data["disability"];
            this.disabilityType = _data["disabilityType"];
            this.disabilityComment = _data["disabilityComment"];
            this.isAdmin = _data["isAdmin"];
            this.streetAddress = _data["streetAddress"] ? CreateStaffMemberStreetAddress.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? CreateStaffMemberPostalAddress.fromJS(_data["postalAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateStaffMemberPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffMemberPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["maidenName"] = this.maidenName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["title"] = this.title;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["nationality"] = this.nationality;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["homeLanguage"] = this.homeLanguage;
        data["cellNumber"] = this.cellNumber;
        data["whatsappNumber"] = this.whatsappNumber;
        data["altNumber"] = this.altNumber;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinCellNumber"] = this.nextOfKinCellNumber;
        data["nextOfKinRelation"] = this.nextOfKinRelation;
        data["disability"] = this.disability;
        data["disabilityType"] = this.disabilityType;
        data["disabilityComment"] = this.disabilityComment;
        data["isAdmin"] = this.isAdmin;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateStaffMemberPerson {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    maidenName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    title?: Titles;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    idType?: IdTypes;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    homeLanguage?: Languages;
    cellNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    isAdmin?: boolean;
    streetAddress?: CreateStaffMemberStreetAddress | undefined;
    postalAddress?: CreateStaffMemberPostalAddress | undefined;
}

export abstract class CreateStaffMemberAddressDetails extends CreateActiveStaffMember implements ICreateStaffMemberAddressDetails {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;

    constructor(data?: ICreateStaffMemberAddressDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.street = _data["street"];
            this.unit = _data["unit"];
            this.complex = _data["complex"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
        }
    }

    static override fromJS(data: any): CreateStaffMemberAddressDetails {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateStaffMemberAddressDetails' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["unit"] = this.unit;
        data["complex"] = this.complex;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateStaffMemberAddressDetails extends ICreateActiveStaffMember {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
}

export class CreateStaffMemberStreetAddress extends CreateStaffMemberAddressDetails implements ICreateStaffMemberStreetAddress {
    sameAsPostal?: boolean;

    constructor(data?: ICreateStaffMemberStreetAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sameAsPostal = _data["sameAsPostal"];
        }
    }

    static override fromJS(data: any): CreateStaffMemberStreetAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffMemberStreetAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sameAsPostal"] = this.sameAsPostal;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateStaffMemberStreetAddress extends ICreateStaffMemberAddressDetails {
    sameAsPostal?: boolean;
}

export class CreateStaffMemberPostalAddress extends CreateStaffMemberAddressDetails implements ICreateStaffMemberPostalAddress {

    constructor(data?: ICreateStaffMemberPostalAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateStaffMemberPostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffMemberPostalAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateStaffMemberPostalAddress extends ICreateStaffMemberAddressDetails {
}

export class UpdateStaffMemberCommand implements IUpdateStaffMemberCommand {
    origin?: string | undefined;
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    moderatorNumber?: string | undefined;
    assessorNumber?: string | undefined;
    types?: StaffTypes[] | undefined;
    accountId?: number;
    personId?: number;
    person?: UpdateStaffMemberPersonDetails | undefined;

    constructor(data?: IUpdateStaffMemberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"];
            this.id = _data["id"];
            this.active = _data["active"];
            this.state = _data["state"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.moderatorNumber = _data["moderatorNumber"];
            this.assessorNumber = _data["assessorNumber"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.accountId = _data["accountId"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? UpdateStaffMemberPersonDetails.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateStaffMemberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffMemberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin;
        data["id"] = this.id;
        data["active"] = this.active;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["moderatorNumber"] = this.moderatorNumber;
        data["assessorNumber"] = this.assessorNumber;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["accountId"] = this.accountId;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateStaffMemberCommand {
    origin?: string | undefined;
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    moderatorNumber?: string | undefined;
    assessorNumber?: string | undefined;
    types?: StaffTypes[] | undefined;
    accountId?: number;
    personId?: number;
    person?: UpdateStaffMemberPersonDetails | undefined;
}

export class UpdateStaffMemberPersonDetails implements IUpdateStaffMemberPersonDetails {
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    accountId?: number;
    streetAddress?: UpdateStaffMemberPersonStreetAddress | undefined;
    postalAddress?: UpdateStaffMemberPersonPostalAddress | undefined;

    constructor(data?: IUpdateStaffMemberPersonDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.state = _data["state"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.maidenName = _data["maidenName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.nationality = _data["nationality"];
            this.homeLanguage = _data["homeLanguage"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.whatsappNumber = _data["whatsappNumber"];
            this.altNumber = _data["altNumber"];
            this.cellNumber = _data["cellNumber"];
            this.email = _data["email"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinCellNumber = _data["nextOfKinCellNumber"];
            this.nextOfKinRelation = _data["nextOfKinRelation"];
            this.disability = _data["disability"];
            this.disabilityType = _data["disabilityType"];
            this.disabilityComment = _data["disabilityComment"];
            this.accountId = _data["accountId"];
            this.streetAddress = _data["streetAddress"] ? UpdateStaffMemberPersonStreetAddress.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? UpdateStaffMemberPersonPostalAddress.fromJS(_data["postalAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateStaffMemberPersonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffMemberPersonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["maidenName"] = this.maidenName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["nationality"] = this.nationality;
        data["homeLanguage"] = this.homeLanguage;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["whatsappNumber"] = this.whatsappNumber;
        data["altNumber"] = this.altNumber;
        data["cellNumber"] = this.cellNumber;
        data["email"] = this.email;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinCellNumber"] = this.nextOfKinCellNumber;
        data["nextOfKinRelation"] = this.nextOfKinRelation;
        data["disability"] = this.disability;
        data["disabilityType"] = this.disabilityType;
        data["disabilityComment"] = this.disabilityComment;
        data["accountId"] = this.accountId;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateStaffMemberPersonDetails {
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    accountId?: number;
    streetAddress?: UpdateStaffMemberPersonStreetAddress | undefined;
    postalAddress?: UpdateStaffMemberPersonPostalAddress | undefined;
}

export abstract class UpdateStaffMemberPersonAddress implements IUpdateStaffMemberPersonAddress {
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
    personId?: number;

    constructor(data?: IUpdateStaffMemberPersonAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.state = _data["state"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.street = _data["street"];
            this.unit = _data["unit"];
            this.complex = _data["complex"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): UpdateStaffMemberPersonAddress {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UpdateStaffMemberPersonAddress' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["street"] = this.street;
        data["unit"] = this.unit;
        data["complex"] = this.complex;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IUpdateStaffMemberPersonAddress {
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
    personId?: number;
}

export class UpdateStaffMemberPersonStreetAddress extends UpdateStaffMemberPersonAddress implements IUpdateStaffMemberPersonStreetAddress {
    sameAsPostal?: boolean;

    constructor(data?: IUpdateStaffMemberPersonStreetAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sameAsPostal = _data["sameAsPostal"];
        }
    }

    static override fromJS(data: any): UpdateStaffMemberPersonStreetAddress {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffMemberPersonStreetAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sameAsPostal"] = this.sameAsPostal;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStaffMemberPersonStreetAddress extends IUpdateStaffMemberPersonAddress {
    sameAsPostal?: boolean;
}

export class UpdateStaffMemberPersonPostalAddress extends UpdateStaffMemberPersonAddress implements IUpdateStaffMemberPersonPostalAddress {

    constructor(data?: IUpdateStaffMemberPersonPostalAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateStaffMemberPersonPostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffMemberPersonPostalAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStaffMemberPersonPostalAddress extends IUpdateStaffMemberPersonAddress {
}

export class ResponseOfICollectionOfStudentCode implements IResponseOfICollectionOfStudentCode {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: StudentCode[] | undefined;

    constructor(data?: IResponseOfICollectionOfStudentCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfStudentCode {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfStudentCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfStudentCode {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: StudentCode[] | undefined;
}

export class PostStudentLinkCommand implements IPostStudentLinkCommand {
    studentLearnershipId?: number;
    links?: PostStudentLink[] | undefined;

    constructor(data?: IPostStudentLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentLearnershipId = _data["studentLearnershipId"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(PostStudentLink.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostStudentLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PostStudentLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentLearnershipId"] = this.studentLearnershipId;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostStudentLinkCommand {
    studentLearnershipId?: number;
    links?: PostStudentLink[] | undefined;
}

export class PostStudentLink implements IPostStudentLink {
    name?: string | undefined;
    filePath?: string | undefined;
    type?: StudentCodeType;

    constructor(data?: IPostStudentLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.filePath = _data["filePath"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PostStudentLink {
        data = typeof data === 'object' ? data : {};
        let result = new PostStudentLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["filePath"] = this.filePath;
        data["type"] = this.type;
        return data;
    }
}

export interface IPostStudentLink {
    name?: string | undefined;
    filePath?: string | undefined;
    type?: StudentCodeType;
}

export class ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel implements IResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetGeneralStudentDocsByStudentLearnershipIdViewModel[] | undefined;

    constructor(data?: IResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetGeneralStudentDocsByStudentLearnershipIdViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseOfICollectionOfGetGeneralStudentDocsByStudentLearnershipIdViewModel {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: GetGeneralStudentDocsByStudentLearnershipIdViewModel[] | undefined;
}

export class GetGeneralStudentDocsByStudentLearnershipIdViewModel implements IGetGeneralStudentDocsByStudentLearnershipIdViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    docTypeId?: number;
    docType?: GetStudentLearnershipGeneralDocTypeViewModel | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IGetGeneralStudentDocsByStudentLearnershipIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"] ? GetStudentLearnershipGeneralDocTypeViewModel.fromJS(_data["docType"]) : <any>undefined;
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): GetGeneralStudentDocsByStudentLearnershipIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStudentDocsByStudentLearnershipIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType ? this.docType.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IGetGeneralStudentDocsByStudentLearnershipIdViewModel {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    docTypeId?: number;
    docType?: GetStudentLearnershipGeneralDocTypeViewModel | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class GetStudentLearnershipGeneralDocTypeViewModel implements IGetStudentLearnershipGeneralDocTypeViewModel {
    id?: number;
    active?: boolean;
    documentType?: string | undefined;
    multipleAllowed?: boolean;

    constructor(data?: IGetStudentLearnershipGeneralDocTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.documentType = _data["documentType"];
            this.multipleAllowed = _data["multipleAllowed"];
        }
    }

    static fromJS(data: any): GetStudentLearnershipGeneralDocTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentLearnershipGeneralDocTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["documentType"] = this.documentType;
        data["multipleAllowed"] = this.multipleAllowed;
        return data;
    }
}

export interface IGetStudentLearnershipGeneralDocTypeViewModel {
    id?: number;
    active?: boolean;
    documentType?: string | undefined;
    multipleAllowed?: boolean;
}

export class PaginationResponseOfStudentDto implements IPaginationResponseOfStudentDto {
    data?: StudentDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfStudentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfStudentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfStudentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfStudentDto {
    data?: StudentDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class StudentDto implements IStudentDto {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    type?: StudentTypes;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    accountId?: number;

    constructor(data?: IStudentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.maidenName = _data["maidenName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.nationality = _data["nationality"];
            this.homeLanguage = _data["homeLanguage"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.whatsappNumber = _data["whatsappNumber"];
            this.cellNumber = _data["cellNumber"];
            this.email = _data["email"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): StudentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["maidenName"] = this.maidenName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["nationality"] = this.nationality;
        data["homeLanguage"] = this.homeLanguage;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["whatsappNumber"] = this.whatsappNumber;
        data["cellNumber"] = this.cellNumber;
        data["email"] = this.email;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IStudentDto {
    id?: number;
    active?: boolean;
    createdBy?: number | undefined;
    created?: Date;
    type?: StudentTypes;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    accountId?: number;
}

export class SearchStudentsRequest extends PaginationFilter implements ISearchStudentsRequest {
    types?: StudentTypes[] | undefined;

    constructor(data?: ISearchStudentsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static override fromJS(data: any): SearchStudentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStudentsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchStudentsRequest extends IPaginationFilter {
    types?: StudentTypes[] | undefined;
}

export abstract class CreateActiveStudent implements ICreateActiveStudent {
    active?: boolean;

    constructor(data?: ICreateActiveStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CreateActiveStudent {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateActiveStudent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        return data;
    }
}

export interface ICreateActiveStudent {
    active?: boolean;
}

export class CreateStudentCommand extends CreateActiveStudent implements ICreateStudentCommand {
    requestOrigin?: string | undefined;
    internshipId?: number | undefined;
    internshipGroupId?: number | undefined;
    learnershipId?: number | undefined;
    learnershipGroupId?: number | undefined;
    type?: StudentTypes;
    dateJoined?: Date;
    person?: CreateStudentPerson | undefined;

    constructor(data?: ICreateStudentCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestOrigin = _data["requestOrigin"];
            this.internshipId = _data["internshipId"];
            this.internshipGroupId = _data["internshipGroupId"];
            this.learnershipId = _data["learnershipId"];
            this.learnershipGroupId = _data["learnershipGroupId"];
            this.type = _data["type"];
            this.dateJoined = _data["dateJoined"] ? new Date(_data["dateJoined"].toString()) : <any>undefined;
            this.person = _data["person"] ? CreateStudentPerson.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateStudentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudentCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestOrigin"] = this.requestOrigin;
        data["internshipId"] = this.internshipId;
        data["internshipGroupId"] = this.internshipGroupId;
        data["learnershipId"] = this.learnershipId;
        data["learnershipGroupId"] = this.learnershipGroupId;
        data["type"] = this.type;
        data["dateJoined"] = this.dateJoined ? this.dateJoined.toISOString() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateStudentCommand extends ICreateActiveStudent {
    requestOrigin?: string | undefined;
    internshipId?: number | undefined;
    internshipGroupId?: number | undefined;
    learnershipId?: number | undefined;
    learnershipGroupId?: number | undefined;
    type?: StudentTypes;
    dateJoined?: Date;
    person?: CreateStudentPerson | undefined;
}

export class CreateStudentPerson implements ICreateStudentPerson {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    maidenName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    title?: Titles;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    idType?: IdTypes;
    idNumber?: string | undefined;
    homeLanguage?: Languages;
    cellNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    streetAddress?: CreateStudentStreetAddress | undefined;
    postalAddress?: CreateStudentPostalAddress | undefined;

    constructor(data?: ICreateStudentPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.maidenName = _data["maidenName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.title = _data["title"];
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.nationality = _data["nationality"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.homeLanguage = _data["homeLanguage"];
            this.cellNumber = _data["cellNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.whatsappNumber = _data["whatsappNumber"];
            this.altNumber = _data["altNumber"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinCellNumber = _data["nextOfKinCellNumber"];
            this.nextOfKinRelation = _data["nextOfKinRelation"];
            this.disability = _data["disability"];
            this.disabilityType = _data["disabilityType"];
            this.disabilityComment = _data["disabilityComment"];
            this.streetAddress = _data["streetAddress"] ? CreateStudentStreetAddress.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? CreateStudentPostalAddress.fromJS(_data["postalAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateStudentPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudentPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["maidenName"] = this.maidenName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["title"] = this.title;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["nationality"] = this.nationality;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["homeLanguage"] = this.homeLanguage;
        data["cellNumber"] = this.cellNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["whatsappNumber"] = this.whatsappNumber;
        data["altNumber"] = this.altNumber;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinCellNumber"] = this.nextOfKinCellNumber;
        data["nextOfKinRelation"] = this.nextOfKinRelation;
        data["disability"] = this.disability;
        data["disabilityType"] = this.disabilityType;
        data["disabilityComment"] = this.disabilityComment;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateStudentPerson {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    maidenName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    title?: Titles;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    idType?: IdTypes;
    idNumber?: string | undefined;
    homeLanguage?: Languages;
    cellNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    streetAddress?: CreateStudentStreetAddress | undefined;
    postalAddress?: CreateStudentPostalAddress | undefined;
}

export abstract class CreateStudentAddressDetails extends CreateActiveStudent implements ICreateStudentAddressDetails {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;

    constructor(data?: ICreateStudentAddressDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.street = _data["street"];
            this.unit = _data["unit"];
            this.complex = _data["complex"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
        }
    }

    static override fromJS(data: any): CreateStudentAddressDetails {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateStudentAddressDetails' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["unit"] = this.unit;
        data["complex"] = this.complex;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateStudentAddressDetails extends ICreateActiveStudent {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
}

export class CreateStudentStreetAddress extends CreateStudentAddressDetails implements ICreateStudentStreetAddress {
    sameAsPostal?: boolean;

    constructor(data?: ICreateStudentStreetAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sameAsPostal = _data["sameAsPostal"];
        }
    }

    static override fromJS(data: any): CreateStudentStreetAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudentStreetAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sameAsPostal"] = this.sameAsPostal;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateStudentStreetAddress extends ICreateStudentAddressDetails {
    sameAsPostal?: boolean;
}

export class CreateStudentPostalAddress extends CreateStudentAddressDetails implements ICreateStudentPostalAddress {

    constructor(data?: ICreateStudentPostalAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateStudentPostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudentPostalAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateStudentPostalAddress extends ICreateStudentAddressDetails {
}

export abstract class RegisterActiveCandidate implements IRegisterActiveCandidate {
    active?: boolean;

    constructor(data?: IRegisterActiveCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): RegisterActiveCandidate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RegisterActiveCandidate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        return data;
    }
}

export interface IRegisterActiveCandidate {
    active?: boolean;
}

export class RegisterCandidateCommand extends RegisterActiveCandidate implements IRegisterCandidateCommand {
    tenantId?: number;
    requestOrigin?: string | undefined;
    type?: StudentTypes;
    dateJoined?: Date;
    person?: RegisterCandidatePerson | undefined;

    constructor(data?: IRegisterCandidateCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.requestOrigin = _data["requestOrigin"];
            this.type = _data["type"];
            this.dateJoined = _data["dateJoined"] ? new Date(_data["dateJoined"].toString()) : <any>undefined;
            this.person = _data["person"] ? RegisterCandidatePerson.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): RegisterCandidateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCandidateCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["requestOrigin"] = this.requestOrigin;
        data["type"] = this.type;
        data["dateJoined"] = this.dateJoined ? this.dateJoined.toISOString() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRegisterCandidateCommand extends IRegisterActiveCandidate {
    tenantId?: number;
    requestOrigin?: string | undefined;
    type?: StudentTypes;
    dateJoined?: Date;
    person?: RegisterCandidatePerson | undefined;
}

export class RegisterCandidatePerson implements IRegisterCandidatePerson {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    maidenName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    title?: Titles;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    idType?: IdTypes;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    homeLanguage?: Languages;
    cellNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    streetAddress?: RegisterCandidateStreetAddress | undefined;
    postalAddress?: RegisterCandidatePostalAddress | undefined;

    constructor(data?: IRegisterCandidatePerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.maidenName = _data["maidenName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.title = _data["title"];
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.nationality = _data["nationality"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.homeLanguage = _data["homeLanguage"];
            this.cellNumber = _data["cellNumber"];
            this.whatsappNumber = _data["whatsappNumber"];
            this.altNumber = _data["altNumber"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinCellNumber = _data["nextOfKinCellNumber"];
            this.nextOfKinRelation = _data["nextOfKinRelation"];
            this.disability = _data["disability"];
            this.disabilityType = _data["disabilityType"];
            this.disabilityComment = _data["disabilityComment"];
            this.streetAddress = _data["streetAddress"] ? RegisterCandidateStreetAddress.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? RegisterCandidatePostalAddress.fromJS(_data["postalAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterCandidatePerson {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCandidatePerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["maidenName"] = this.maidenName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["title"] = this.title;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["nationality"] = this.nationality;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["homeLanguage"] = this.homeLanguage;
        data["cellNumber"] = this.cellNumber;
        data["whatsappNumber"] = this.whatsappNumber;
        data["altNumber"] = this.altNumber;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinCellNumber"] = this.nextOfKinCellNumber;
        data["nextOfKinRelation"] = this.nextOfKinRelation;
        data["disability"] = this.disability;
        data["disabilityType"] = this.disabilityType;
        data["disabilityComment"] = this.disabilityComment;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRegisterCandidatePerson {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    maidenName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    title?: Titles;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    idType?: IdTypes;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    homeLanguage?: Languages;
    cellNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    streetAddress?: RegisterCandidateStreetAddress | undefined;
    postalAddress?: RegisterCandidatePostalAddress | undefined;
}

export abstract class RegisterCandidateAddressDetails extends RegisterActiveCandidate implements IRegisterCandidateAddressDetails {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;

    constructor(data?: IRegisterCandidateAddressDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.street = _data["street"];
            this.unit = _data["unit"];
            this.complex = _data["complex"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
        }
    }

    static override fromJS(data: any): RegisterCandidateAddressDetails {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RegisterCandidateAddressDetails' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["unit"] = this.unit;
        data["complex"] = this.complex;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        super.toJSON(data);
        return data;
    }
}

export interface IRegisterCandidateAddressDetails extends IRegisterActiveCandidate {
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
}

export class RegisterCandidateStreetAddress extends RegisterCandidateAddressDetails implements IRegisterCandidateStreetAddress {
    sameAsPostal?: boolean;

    constructor(data?: IRegisterCandidateStreetAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sameAsPostal = _data["sameAsPostal"];
        }
    }

    static override fromJS(data: any): RegisterCandidateStreetAddress {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCandidateStreetAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sameAsPostal"] = this.sameAsPostal;
        super.toJSON(data);
        return data;
    }
}

export interface IRegisterCandidateStreetAddress extends IRegisterCandidateAddressDetails {
    sameAsPostal?: boolean;
}

export class RegisterCandidatePostalAddress extends RegisterCandidateAddressDetails implements IRegisterCandidatePostalAddress {

    constructor(data?: IRegisterCandidatePostalAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RegisterCandidatePostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCandidatePostalAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRegisterCandidatePostalAddress extends IRegisterCandidateAddressDetails {
}

export class RegisterCandidateAsStudentCommand implements IRegisterCandidateAsStudentCommand {
    requestOrigin?: string | undefined;
    id?: number;
    internshipId?: number | undefined;
    internshipGroupId?: number | undefined;
    learnershipId?: number | undefined;
    learnershipGroupId?: number | undefined;
    type?: StudentTypes;

    constructor(data?: IRegisterCandidateAsStudentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestOrigin = _data["requestOrigin"];
            this.id = _data["id"];
            this.internshipId = _data["internshipId"];
            this.internshipGroupId = _data["internshipGroupId"];
            this.learnershipId = _data["learnershipId"];
            this.learnershipGroupId = _data["learnershipGroupId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RegisterCandidateAsStudentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCandidateAsStudentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestOrigin"] = this.requestOrigin;
        data["id"] = this.id;
        data["internshipId"] = this.internshipId;
        data["internshipGroupId"] = this.internshipGroupId;
        data["learnershipId"] = this.learnershipId;
        data["learnershipGroupId"] = this.learnershipGroupId;
        data["type"] = this.type;
        return data;
    }
}

export interface IRegisterCandidateAsStudentCommand {
    requestOrigin?: string | undefined;
    id?: number;
    internshipId?: number | undefined;
    internshipGroupId?: number | undefined;
    learnershipId?: number | undefined;
    learnershipGroupId?: number | undefined;
    type?: StudentTypes;
}

export class UpdateStudentCommand implements IUpdateStudentCommand {
    origin?: string | undefined;
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    type?: StudentTypes;
    accountId?: number;
    personId?: number;
    person?: UpdateStudentPersonDetails | undefined;

    constructor(data?: IUpdateStudentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"];
            this.id = _data["id"];
            this.active = _data["active"];
            this.state = _data["state"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.accountId = _data["accountId"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? UpdateStudentPersonDetails.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateStudentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin;
        data["id"] = this.id;
        data["active"] = this.active;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["accountId"] = this.accountId;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateStudentCommand {
    origin?: string | undefined;
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    type?: StudentTypes;
    accountId?: number;
    personId?: number;
    person?: UpdateStudentPersonDetails | undefined;
}

export class UpdateStudentPersonDetails implements IUpdateStudentPersonDetails {
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    accountId?: number;
    streetAddress?: UpdateStudentPersonStreetAddress | undefined;
    postalAddress?: UpdateStudentPersonPostalAddress | undefined;

    constructor(data?: IUpdateStudentPersonDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.state = _data["state"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.maidenName = _data["maidenName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.nationality = _data["nationality"];
            this.homeLanguage = _data["homeLanguage"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.whatsappNumber = _data["whatsappNumber"];
            this.altNumber = _data["altNumber"];
            this.cellNumber = _data["cellNumber"];
            this.email = _data["email"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinCellNumber = _data["nextOfKinCellNumber"];
            this.nextOfKinRelation = _data["nextOfKinRelation"];
            this.disability = _data["disability"];
            this.disabilityType = _data["disabilityType"];
            this.disabilityComment = _data["disabilityComment"];
            this.accountId = _data["accountId"];
            this.streetAddress = _data["streetAddress"] ? UpdateStudentPersonStreetAddress.fromJS(_data["streetAddress"]) : <any>undefined;
            this.postalAddress = _data["postalAddress"] ? UpdateStudentPersonPostalAddress.fromJS(_data["postalAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateStudentPersonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentPersonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["maidenName"] = this.maidenName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["nationality"] = this.nationality;
        data["homeLanguage"] = this.homeLanguage;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["whatsappNumber"] = this.whatsappNumber;
        data["altNumber"] = this.altNumber;
        data["cellNumber"] = this.cellNumber;
        data["email"] = this.email;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinCellNumber"] = this.nextOfKinCellNumber;
        data["nextOfKinRelation"] = this.nextOfKinRelation;
        data["disability"] = this.disability;
        data["disabilityType"] = this.disabilityType;
        data["disabilityComment"] = this.disabilityComment;
        data["accountId"] = this.accountId;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateStudentPersonDetails {
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    dateOfBirth?: Date;
    gender?: Genders;
    race?: Races;
    nationality?: Nationalities;
    homeLanguage?: Languages;
    idType?: IdTypes;
    idNumber?: string | undefined;
    whatsappNumber?: string | undefined;
    altNumber?: string | undefined;
    cellNumber?: string | undefined;
    email?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinCellNumber?: string | undefined;
    nextOfKinRelation?: string | undefined;
    disability?: boolean;
    disabilityType?: string | undefined;
    disabilityComment?: string | undefined;
    accountId?: number;
    streetAddress?: UpdateStudentPersonStreetAddress | undefined;
    postalAddress?: UpdateStudentPersonPostalAddress | undefined;
}

export abstract class UpdateStudentPersonAddress implements IUpdateStudentPersonAddress {
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
    personId?: number;

    constructor(data?: IUpdateStudentPersonAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.state = _data["state"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.street = _data["street"];
            this.unit = _data["unit"];
            this.complex = _data["complex"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): UpdateStudentPersonAddress {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UpdateStudentPersonAddress' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["street"] = this.street;
        data["unit"] = this.unit;
        data["complex"] = this.complex;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IUpdateStudentPersonAddress {
    id?: number;
    active?: boolean;
    state?: ObjectState;
    created?: Date;
    createdBy?: number | undefined;
    lastModifiedBy?: number | undefined;
    lastModified?: Date | undefined;
    street?: string | undefined;
    unit?: string | undefined;
    complex?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: Countries;
    postCode?: string | undefined;
    personId?: number;
}

export class UpdateStudentPersonStreetAddress extends UpdateStudentPersonAddress implements IUpdateStudentPersonStreetAddress {
    sameAsPostal?: boolean;

    constructor(data?: IUpdateStudentPersonStreetAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sameAsPostal = _data["sameAsPostal"];
        }
    }

    static override fromJS(data: any): UpdateStudentPersonStreetAddress {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentPersonStreetAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sameAsPostal"] = this.sameAsPostal;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStudentPersonStreetAddress extends IUpdateStudentPersonAddress {
    sameAsPostal?: boolean;
}

export class UpdateStudentPersonPostalAddress extends UpdateStudentPersonAddress implements IUpdateStudentPersonPostalAddress {

    constructor(data?: IUpdateStudentPersonPostalAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateStudentPersonPostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentPersonPostalAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStudentPersonPostalAddress extends IUpdateStudentPersonAddress {
}

export class GetConfirmRegistrationInfoByTokenRequest implements IGetConfirmRegistrationInfoByTokenRequest {
    token!: string;

    constructor(data?: IGetConfirmRegistrationInfoByTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetConfirmRegistrationInfoByTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfirmRegistrationInfoByTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IGetConfirmRegistrationInfoByTokenRequest {
    token: string;
}

export class ConfirmRegistrationCommand implements IConfirmRegistrationCommand {
    accountId?: number;
    tenantId?: number;
    ipAddress?: string | undefined;
    token?: string | undefined;
    initialsSvg?: string | undefined;
    acceptTerms?: boolean;
    signatureSvg?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    profileImage?: string | undefined;

    constructor(data?: IConfirmRegistrationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.tenantId = _data["tenantId"];
            this.ipAddress = _data["ipAddress"];
            this.token = _data["token"];
            this.initialsSvg = _data["initialsSvg"];
            this.acceptTerms = _data["acceptTerms"];
            this.signatureSvg = _data["signatureSvg"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.profileImage = _data["profileImage"];
        }
    }

    static fromJS(data: any): ConfirmRegistrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmRegistrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["tenantId"] = this.tenantId;
        data["ipAddress"] = this.ipAddress;
        data["token"] = this.token;
        data["initialsSvg"] = this.initialsSvg;
        data["acceptTerms"] = this.acceptTerms;
        data["signatureSvg"] = this.signatureSvg;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["profileImage"] = this.profileImage;
        return data;
    }
}

export interface IConfirmRegistrationCommand {
    accountId?: number;
    tenantId?: number;
    ipAddress?: string | undefined;
    token?: string | undefined;
    initialsSvg?: string | undefined;
    acceptTerms?: boolean;
    signatureSvg?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    profileImage?: string | undefined;
}

export class GetResetPasswordInfoRequest implements IGetResetPasswordInfoRequest {
    token!: string;

    constructor(data?: IGetResetPasswordInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetResetPasswordInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetResetPasswordInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IGetResetPasswordInfoRequest {
    token: string;
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    accountId?: number;
    tenantId?: number;
    ipAddress?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.tenantId = _data["tenantId"];
            this.ipAddress = _data["ipAddress"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["tenantId"] = this.tenantId;
        data["ipAddress"] = this.ipAddress;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IResetPasswordCommand {
    accountId?: number;
    tenantId?: number;
    ipAddress?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class AuthenticateRequest implements IAuthenticateRequest {
    email!: string;
    password!: string;

    constructor(data?: IAuthenticateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthenticateRequest {
    email: string;
    password: string;
}

export class AuthenticateByTenantRequest extends AuthenticateRequest implements IAuthenticateByTenantRequest {
    tenantId!: number;

    constructor(data?: IAuthenticateByTenantRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static override fromJS(data: any): AuthenticateByTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateByTenantRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        super.toJSON(data);
        return data;
    }
}

export interface IAuthenticateByTenantRequest extends IAuthenticateRequest {
    tenantId: number;
}

export class ResponseOfAuthenticateResponse implements IResponseOfAuthenticateResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: AuthenticateResponse | undefined;

    constructor(data?: IResponseOfAuthenticateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.data = _data["data"] ? AuthenticateResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseOfAuthenticateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthenticateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseOfAuthenticateResponse {
    succeeded?: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
    data?: AuthenticateResponse | undefined;
}

export class LogInAsUserRequest implements ILogInAsUserRequest {
    tenantId!: number;
    accountId!: number;

    constructor(data?: ILogInAsUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): LogInAsUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LogInAsUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface ILogInAsUserRequest {
    tenantId: number;
    accountId: number;
}

export class RegisterTenantRequest implements IRegisterTenantRequest {
    name?: string | undefined;
    subDomainName?: string | undefined;
    superAdminTitle?: Titles;
    superAdminEmail?: string | undefined;
    superAdminFirstName?: string | undefined;
    superAdminMiddleNames?: string | undefined;
    superAdminLastName?: string | undefined;

    constructor(data?: IRegisterTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.subDomainName = _data["subDomainName"];
            this.superAdminTitle = _data["superAdminTitle"];
            this.superAdminEmail = _data["superAdminEmail"];
            this.superAdminFirstName = _data["superAdminFirstName"];
            this.superAdminMiddleNames = _data["superAdminMiddleNames"];
            this.superAdminLastName = _data["superAdminLastName"];
        }
    }

    static fromJS(data: any): RegisterTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["subDomainName"] = this.subDomainName;
        data["superAdminTitle"] = this.superAdminTitle;
        data["superAdminEmail"] = this.superAdminEmail;
        data["superAdminFirstName"] = this.superAdminFirstName;
        data["superAdminMiddleNames"] = this.superAdminMiddleNames;
        data["superAdminLastName"] = this.superAdminLastName;
        return data;
    }
}

export interface IRegisterTenantRequest {
    name?: string | undefined;
    subDomainName?: string | undefined;
    superAdminTitle?: Titles;
    superAdminEmail?: string | undefined;
    superAdminFirstName?: string | undefined;
    superAdminMiddleNames?: string | undefined;
    superAdminLastName?: string | undefined;
}

export class ResendVerificationEmailCommand implements IResendVerificationEmailCommand {
    email?: string | undefined;
    origin?: string | undefined;

    constructor(data?: IResendVerificationEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): ResendVerificationEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerificationEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IResendVerificationEmailCommand {
    email?: string | undefined;
    origin?: string | undefined;
}

export class CreateSetaVisitorCommand implements ICreateSetaVisitorCommand {
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ICreateSetaVisitorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateSetaVisitorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSetaVisitorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateSetaVisitorCommand {
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
}

export class CreateVisitorTesterCommand implements ICreateVisitorTesterCommand {
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ICreateVisitorTesterCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateVisitorTesterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVisitorTesterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateVisitorTesterCommand {
    title?: Titles;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

}